import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: any; output: any; }
  date: { input: string; output: string; }
  jsonb: { input: object; output: object; }
  numeric: { input: number; output: number; }
  timestamptz: { input: string; output: string; }
  uuid: { input: string; output: string; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type OrganizationCourse = {
  __typename?: 'OrganizationCourse';
  archived: Scalars['Boolean']['output'];
  assignmentTypeWeights: Array<OrganizationCourseAssignmentTypeWeights>;
  color: Scalars['String']['output'];
  credits?: Maybe<Scalars['numeric']['output']>;
  defaultDaysOfTheWeek?: Maybe<Scalars['jsonb']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gradeYears?: Maybe<Scalars['jsonb']['output']>;
  gradingStyle: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  introduction?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberOfDaysPerWeek: Scalars['Int']['output'];
  numberOfWeeks: Scalars['Int']['output'];
  picture?: Maybe<Scalars['String']['output']>;
  subjects?: Maybe<Scalars['jsonb']['output']>;
  useAssignmentTypeWeights?: Maybe<Scalars['Boolean']['output']>;
};

export type OrganizationCourseAssignmentTypeWeights = {
  __typename?: 'OrganizationCourseAssignmentTypeWeights';
  assignmentType?: Maybe<Scalars['String']['output']>;
  customAssignmentType?: Maybe<OrganizationCourseCustomAssignmnetType>;
  id: Scalars['uuid']['output'];
  sortOrder: Scalars['Int']['output'];
  weight: Scalars['numeric']['output'];
};

export type OrganizationCourseCustomAssignmnetType = {
  __typename?: 'OrganizationCourseCustomAssignmnetType';
  color: Scalars['String']['output'];
  created: Scalars['timestamptz']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "assignment_type" */
export type Assignment_Type = {
  __typename?: 'assignment_type';
  value: Scalars['String']['output'];
};

/** aggregated selection of "assignment_type" */
export type Assignment_Type_Aggregate = {
  __typename?: 'assignment_type_aggregate';
  aggregate?: Maybe<Assignment_Type_Aggregate_Fields>;
  nodes: Array<Assignment_Type>;
};

/** aggregate fields of "assignment_type" */
export type Assignment_Type_Aggregate_Fields = {
  __typename?: 'assignment_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Assignment_Type_Max_Fields>;
  min?: Maybe<Assignment_Type_Min_Fields>;
};


/** aggregate fields of "assignment_type" */
export type Assignment_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assignment_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "assignment_type". All fields are combined with a logical 'AND'. */
export type Assignment_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Assignment_Type_Bool_Exp>>;
  _not?: InputMaybe<Assignment_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Assignment_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "assignment_type" */
export enum Assignment_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  AssignmentTypePkey = 'assignment_type_pkey'
}

export enum Assignment_Type_Enum {
  Homework = 'HOMEWORK',
  Lab = 'LAB',
  Other = 'OTHER',
  Paper = 'PAPER',
  Quiz = 'QUIZ',
  Test = 'TEST'
}

/** Boolean expression to compare columns of type "assignment_type_enum". All fields are combined with logical 'AND'. */
export type Assignment_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Assignment_Type_Enum>;
  _in?: InputMaybe<Array<Assignment_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Assignment_Type_Enum>;
  _nin?: InputMaybe<Array<Assignment_Type_Enum>>;
};

/** input type for inserting data into table "assignment_type" */
export type Assignment_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Assignment_Type_Max_Fields = {
  __typename?: 'assignment_type_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Assignment_Type_Min_Fields = {
  __typename?: 'assignment_type_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "assignment_type" */
export type Assignment_Type_Mutation_Response = {
  __typename?: 'assignment_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assignment_Type>;
};

/** on_conflict condition type for table "assignment_type" */
export type Assignment_Type_On_Conflict = {
  constraint: Assignment_Type_Constraint;
  update_columns?: Array<Assignment_Type_Update_Column>;
  where?: InputMaybe<Assignment_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "assignment_type". */
export type Assignment_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assignment_type */
export type Assignment_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "assignment_type" */
export enum Assignment_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "assignment_type" */
export type Assignment_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "assignment_type" */
export type Assignment_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assignment_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assignment_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "assignment_type" */
export enum Assignment_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Assignment_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assignment_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assignment_Type_Bool_Exp;
};

/** columns and relationships of "assignment_type_weights" */
export type Assignment_Type_Weights = {
  __typename?: 'assignment_type_weights';
  assignmentType?: Maybe<Assignment_Type_Enum>;
  /** An object relationship */
  course: Courses;
  course_id: Scalars['uuid']['output'];
  created: Scalars['timestamptz']['output'];
  /** An object relationship */
  customAssignmentType?: Maybe<Custom_Assignment_Types>;
  customAssignmentTypeId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  weight: Scalars['numeric']['output'];
};

/** aggregated selection of "assignment_type_weights" */
export type Assignment_Type_Weights_Aggregate = {
  __typename?: 'assignment_type_weights_aggregate';
  aggregate?: Maybe<Assignment_Type_Weights_Aggregate_Fields>;
  nodes: Array<Assignment_Type_Weights>;
};

export type Assignment_Type_Weights_Aggregate_Bool_Exp = {
  count?: InputMaybe<Assignment_Type_Weights_Aggregate_Bool_Exp_Count>;
};

export type Assignment_Type_Weights_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Assignment_Type_Weights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "assignment_type_weights" */
export type Assignment_Type_Weights_Aggregate_Fields = {
  __typename?: 'assignment_type_weights_aggregate_fields';
  avg?: Maybe<Assignment_Type_Weights_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Assignment_Type_Weights_Max_Fields>;
  min?: Maybe<Assignment_Type_Weights_Min_Fields>;
  stddev?: Maybe<Assignment_Type_Weights_Stddev_Fields>;
  stddev_pop?: Maybe<Assignment_Type_Weights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assignment_Type_Weights_Stddev_Samp_Fields>;
  sum?: Maybe<Assignment_Type_Weights_Sum_Fields>;
  var_pop?: Maybe<Assignment_Type_Weights_Var_Pop_Fields>;
  var_samp?: Maybe<Assignment_Type_Weights_Var_Samp_Fields>;
  variance?: Maybe<Assignment_Type_Weights_Variance_Fields>;
};


/** aggregate fields of "assignment_type_weights" */
export type Assignment_Type_Weights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assignment_Type_Weights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "assignment_type_weights" */
export type Assignment_Type_Weights_Aggregate_Order_By = {
  avg?: InputMaybe<Assignment_Type_Weights_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assignment_Type_Weights_Max_Order_By>;
  min?: InputMaybe<Assignment_Type_Weights_Min_Order_By>;
  stddev?: InputMaybe<Assignment_Type_Weights_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Assignment_Type_Weights_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Assignment_Type_Weights_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Assignment_Type_Weights_Sum_Order_By>;
  var_pop?: InputMaybe<Assignment_Type_Weights_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Assignment_Type_Weights_Var_Samp_Order_By>;
  variance?: InputMaybe<Assignment_Type_Weights_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "assignment_type_weights" */
export type Assignment_Type_Weights_Arr_Rel_Insert_Input = {
  data: Array<Assignment_Type_Weights_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assignment_Type_Weights_On_Conflict>;
};

/** aggregate avg on columns */
export type Assignment_Type_Weights_Avg_Fields = {
  __typename?: 'assignment_type_weights_avg_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Avg_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "assignment_type_weights". All fields are combined with a logical 'AND'. */
export type Assignment_Type_Weights_Bool_Exp = {
  _and?: InputMaybe<Array<Assignment_Type_Weights_Bool_Exp>>;
  _not?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
  _or?: InputMaybe<Array<Assignment_Type_Weights_Bool_Exp>>;
  assignmentType?: InputMaybe<Assignment_Type_Enum_Comparison_Exp>;
  course?: InputMaybe<Courses_Bool_Exp>;
  course_id?: InputMaybe<Uuid_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  customAssignmentType?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
  customAssignmentTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sortOrder?: InputMaybe<Int_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  weight?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "assignment_type_weights" */
export enum Assignment_Type_Weights_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssignmentTypeWeightsPkey = 'assignment_type_weights_pkey'
}

/** input type for incrementing numeric columns in table "assignment_type_weights" */
export type Assignment_Type_Weights_Inc_Input = {
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "assignment_type_weights" */
export type Assignment_Type_Weights_Insert_Input = {
  assignmentType?: InputMaybe<Assignment_Type_Enum>;
  course?: InputMaybe<Courses_Obj_Rel_Insert_Input>;
  course_id?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customAssignmentType?: InputMaybe<Custom_Assignment_Types_Obj_Rel_Insert_Input>;
  customAssignmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  weight?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Assignment_Type_Weights_Max_Fields = {
  __typename?: 'assignment_type_weights_max_fields';
  course_id?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  customAssignmentTypeId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  weight?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Max_Order_By = {
  course_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  customAssignmentTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assignment_Type_Weights_Min_Fields = {
  __typename?: 'assignment_type_weights_min_fields';
  course_id?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  customAssignmentTypeId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  weight?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Min_Order_By = {
  course_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  customAssignmentTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assignment_type_weights" */
export type Assignment_Type_Weights_Mutation_Response = {
  __typename?: 'assignment_type_weights_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assignment_Type_Weights>;
};

/** on_conflict condition type for table "assignment_type_weights" */
export type Assignment_Type_Weights_On_Conflict = {
  constraint: Assignment_Type_Weights_Constraint;
  update_columns?: Array<Assignment_Type_Weights_Update_Column>;
  where?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
};

/** Ordering options when selecting data from "assignment_type_weights". */
export type Assignment_Type_Weights_Order_By = {
  assignmentType?: InputMaybe<Order_By>;
  course?: InputMaybe<Courses_Order_By>;
  course_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  customAssignmentType?: InputMaybe<Custom_Assignment_Types_Order_By>;
  customAssignmentTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assignment_type_weights */
export type Assignment_Type_Weights_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "assignment_type_weights" */
export enum Assignment_Type_Weights_Select_Column {
  /** column name */
  AssignmentType = 'assignmentType',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Created = 'created',
  /** column name */
  CustomAssignmentTypeId = 'customAssignmentTypeId',
  /** column name */
  Id = 'id',
  /** column name */
  SortOrder = 'sortOrder',
  /** column name */
  Updated = 'updated',
  /** column name */
  Weight = 'weight'
}

/** input type for updating data in table "assignment_type_weights" */
export type Assignment_Type_Weights_Set_Input = {
  assignmentType?: InputMaybe<Assignment_Type_Enum>;
  course_id?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customAssignmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  weight?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Assignment_Type_Weights_Stddev_Fields = {
  __typename?: 'assignment_type_weights_stddev_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Stddev_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Assignment_Type_Weights_Stddev_Pop_Fields = {
  __typename?: 'assignment_type_weights_stddev_pop_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Stddev_Pop_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Assignment_Type_Weights_Stddev_Samp_Fields = {
  __typename?: 'assignment_type_weights_stddev_samp_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Stddev_Samp_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assignment_type_weights" */
export type Assignment_Type_Weights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assignment_Type_Weights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assignment_Type_Weights_Stream_Cursor_Value_Input = {
  assignmentType?: InputMaybe<Assignment_Type_Enum>;
  course_id?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customAssignmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  weight?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Assignment_Type_Weights_Sum_Fields = {
  __typename?: 'assignment_type_weights_sum_fields';
  sortOrder?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Sum_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** update columns of table "assignment_type_weights" */
export enum Assignment_Type_Weights_Update_Column {
  /** column name */
  AssignmentType = 'assignmentType',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Created = 'created',
  /** column name */
  CustomAssignmentTypeId = 'customAssignmentTypeId',
  /** column name */
  Id = 'id',
  /** column name */
  SortOrder = 'sortOrder',
  /** column name */
  Updated = 'updated',
  /** column name */
  Weight = 'weight'
}

export type Assignment_Type_Weights_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Assignment_Type_Weights_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assignment_Type_Weights_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assignment_Type_Weights_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Assignment_Type_Weights_Var_Pop_Fields = {
  __typename?: 'assignment_type_weights_var_pop_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Var_Pop_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Assignment_Type_Weights_Var_Samp_Fields = {
  __typename?: 'assignment_type_weights_var_samp_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Var_Samp_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Assignment_Type_Weights_Variance_Fields = {
  __typename?: 'assignment_type_weights_variance_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "assignment_type_weights" */
export type Assignment_Type_Weights_Variance_Order_By = {
  sortOrder?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** columns and relationships of "assignments" */
export type Assignments = {
  __typename?: 'assignments';
  assignmentType?: Maybe<Assignment_Type_Enum>;
  /** An array relationship */
  attachments: Array<Files>;
  /** An aggregate relationship */
  attachments_aggregate: Files_Aggregate;
  /** An object relationship */
  course: Courses;
  courseId: Scalars['uuid']['output'];
  created: Scalars['timestamptz']['output'];
  /** An object relationship */
  customAssignmentType?: Maybe<Custom_Assignment_Types>;
  customAssignmentTypeId?: Maybe<Scalars['uuid']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  graded: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  parrotRequest?: Maybe<Parrot_Requests>;
  parrotRequestId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  studentAssignments: Array<Student_Assignments>;
  /** An aggregate relationship */
  studentAssignments_aggregate: Student_Assignments_Aggregate;
  teachersNote?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  visible: Scalars['Boolean']['output'];
  week?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "assignments" */
export type AssignmentsAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "assignments" */
export type AssignmentsAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "assignments" */
export type AssignmentsStudentAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


/** columns and relationships of "assignments" */
export type AssignmentsStudentAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};

/** aggregated selection of "assignments" */
export type Assignments_Aggregate = {
  __typename?: 'assignments_aggregate';
  aggregate?: Maybe<Assignments_Aggregate_Fields>;
  nodes: Array<Assignments>;
};

export type Assignments_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Assignments_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Assignments_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Assignments_Aggregate_Bool_Exp_Count>;
};

export type Assignments_Aggregate_Bool_Exp_Bool_And = {
  arguments: Assignments_Select_Column_Assignments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assignments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Assignments_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Assignments_Select_Column_Assignments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assignments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Assignments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Assignments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assignments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "assignments" */
export type Assignments_Aggregate_Fields = {
  __typename?: 'assignments_aggregate_fields';
  avg?: Maybe<Assignments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Assignments_Max_Fields>;
  min?: Maybe<Assignments_Min_Fields>;
  stddev?: Maybe<Assignments_Stddev_Fields>;
  stddev_pop?: Maybe<Assignments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assignments_Stddev_Samp_Fields>;
  sum?: Maybe<Assignments_Sum_Fields>;
  var_pop?: Maybe<Assignments_Var_Pop_Fields>;
  var_samp?: Maybe<Assignments_Var_Samp_Fields>;
  variance?: Maybe<Assignments_Variance_Fields>;
};


/** aggregate fields of "assignments" */
export type Assignments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assignments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "assignments" */
export type Assignments_Aggregate_Order_By = {
  avg?: InputMaybe<Assignments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assignments_Max_Order_By>;
  min?: InputMaybe<Assignments_Min_Order_By>;
  stddev?: InputMaybe<Assignments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Assignments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Assignments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Assignments_Sum_Order_By>;
  var_pop?: InputMaybe<Assignments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Assignments_Var_Samp_Order_By>;
  variance?: InputMaybe<Assignments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "assignments" */
export type Assignments_Arr_Rel_Insert_Input = {
  data: Array<Assignments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assignments_On_Conflict>;
};

/** aggregate avg on columns */
export type Assignments_Avg_Fields = {
  __typename?: 'assignments_avg_fields';
  day?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  week?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "assignments" */
export type Assignments_Avg_Order_By = {
  day?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "assignments". All fields are combined with a logical 'AND'. */
export type Assignments_Bool_Exp = {
  _and?: InputMaybe<Array<Assignments_Bool_Exp>>;
  _not?: InputMaybe<Assignments_Bool_Exp>;
  _or?: InputMaybe<Array<Assignments_Bool_Exp>>;
  assignmentType?: InputMaybe<Assignment_Type_Enum_Comparison_Exp>;
  attachments?: InputMaybe<Files_Bool_Exp>;
  attachments_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp>;
  course?: InputMaybe<Courses_Bool_Exp>;
  courseId?: InputMaybe<Uuid_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  customAssignmentType?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
  customAssignmentTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  day?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  graded?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parrotRequest?: InputMaybe<Parrot_Requests_Bool_Exp>;
  parrotRequestId?: InputMaybe<Uuid_Comparison_Exp>;
  studentAssignments?: InputMaybe<Student_Assignments_Bool_Exp>;
  studentAssignments_aggregate?: InputMaybe<Student_Assignments_Aggregate_Bool_Exp>;
  teachersNote?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  visible?: InputMaybe<Boolean_Comparison_Exp>;
  week?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "assignments" */
export enum Assignments_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssignmentsPkey = 'assignments_pkey'
}

/** input type for incrementing numeric columns in table "assignments" */
export type Assignments_Inc_Input = {
  day?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "assignments" */
export type Assignments_Insert_Input = {
  assignmentType?: InputMaybe<Assignment_Type_Enum>;
  attachments?: InputMaybe<Files_Arr_Rel_Insert_Input>;
  course?: InputMaybe<Courses_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customAssignmentType?: InputMaybe<Custom_Assignment_Types_Obj_Rel_Insert_Input>;
  customAssignmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  graded?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parrotRequest?: InputMaybe<Parrot_Requests_Obj_Rel_Insert_Input>;
  parrotRequestId?: InputMaybe<Scalars['uuid']['input']>;
  studentAssignments?: InputMaybe<Student_Assignments_Arr_Rel_Insert_Input>;
  teachersNote?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Assignments_Max_Fields = {
  __typename?: 'assignments_max_fields';
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  customAssignmentTypeId?: Maybe<Scalars['uuid']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parrotRequestId?: Maybe<Scalars['uuid']['output']>;
  teachersNote?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  week?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "assignments" */
export type Assignments_Max_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  customAssignmentTypeId?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parrotRequestId?: InputMaybe<Order_By>;
  teachersNote?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assignments_Min_Fields = {
  __typename?: 'assignments_min_fields';
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  customAssignmentTypeId?: Maybe<Scalars['uuid']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parrotRequestId?: Maybe<Scalars['uuid']['output']>;
  teachersNote?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  week?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "assignments" */
export type Assignments_Min_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  customAssignmentTypeId?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parrotRequestId?: InputMaybe<Order_By>;
  teachersNote?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assignments" */
export type Assignments_Mutation_Response = {
  __typename?: 'assignments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assignments>;
};

/** input type for inserting object relation for remote table "assignments" */
export type Assignments_Obj_Rel_Insert_Input = {
  data: Assignments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Assignments_On_Conflict>;
};

/** on_conflict condition type for table "assignments" */
export type Assignments_On_Conflict = {
  constraint: Assignments_Constraint;
  update_columns?: Array<Assignments_Update_Column>;
  where?: InputMaybe<Assignments_Bool_Exp>;
};

/** Ordering options when selecting data from "assignments". */
export type Assignments_Order_By = {
  assignmentType?: InputMaybe<Order_By>;
  attachments_aggregate?: InputMaybe<Files_Aggregate_Order_By>;
  course?: InputMaybe<Courses_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  customAssignmentType?: InputMaybe<Custom_Assignment_Types_Order_By>;
  customAssignmentTypeId?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  graded?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parrotRequest?: InputMaybe<Parrot_Requests_Order_By>;
  parrotRequestId?: InputMaybe<Order_By>;
  studentAssignments_aggregate?: InputMaybe<Student_Assignments_Aggregate_Order_By>;
  teachersNote?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  visible?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assignments */
export type Assignments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "assignments" */
export enum Assignments_Select_Column {
  /** column name */
  AssignmentType = 'assignmentType',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Created = 'created',
  /** column name */
  CustomAssignmentTypeId = 'customAssignmentTypeId',
  /** column name */
  Day = 'day',
  /** column name */
  Description = 'description',
  /** column name */
  Duration = 'duration',
  /** column name */
  Graded = 'graded',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParrotRequestId = 'parrotRequestId',
  /** column name */
  TeachersNote = 'teachersNote',
  /** column name */
  Updated = 'updated',
  /** column name */
  Visible = 'visible',
  /** column name */
  Week = 'week'
}

/** select "assignments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "assignments" */
export enum Assignments_Select_Column_Assignments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Graded = 'graded',
  /** column name */
  Visible = 'visible'
}

/** select "assignments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "assignments" */
export enum Assignments_Select_Column_Assignments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Graded = 'graded',
  /** column name */
  Visible = 'visible'
}

/** input type for updating data in table "assignments" */
export type Assignments_Set_Input = {
  assignmentType?: InputMaybe<Assignment_Type_Enum>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customAssignmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  graded?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parrotRequestId?: InputMaybe<Scalars['uuid']['input']>;
  teachersNote?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Assignments_Stddev_Fields = {
  __typename?: 'assignments_stddev_fields';
  day?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  week?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "assignments" */
export type Assignments_Stddev_Order_By = {
  day?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Assignments_Stddev_Pop_Fields = {
  __typename?: 'assignments_stddev_pop_fields';
  day?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  week?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "assignments" */
export type Assignments_Stddev_Pop_Order_By = {
  day?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Assignments_Stddev_Samp_Fields = {
  __typename?: 'assignments_stddev_samp_fields';
  day?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  week?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "assignments" */
export type Assignments_Stddev_Samp_Order_By = {
  day?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assignments" */
export type Assignments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assignments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assignments_Stream_Cursor_Value_Input = {
  assignmentType?: InputMaybe<Assignment_Type_Enum>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customAssignmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  graded?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parrotRequestId?: InputMaybe<Scalars['uuid']['input']>;
  teachersNote?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Assignments_Sum_Fields = {
  __typename?: 'assignments_sum_fields';
  day?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  week?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "assignments" */
export type Assignments_Sum_Order_By = {
  day?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** update columns of table "assignments" */
export enum Assignments_Update_Column {
  /** column name */
  AssignmentType = 'assignmentType',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Created = 'created',
  /** column name */
  CustomAssignmentTypeId = 'customAssignmentTypeId',
  /** column name */
  Day = 'day',
  /** column name */
  Description = 'description',
  /** column name */
  Duration = 'duration',
  /** column name */
  Graded = 'graded',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParrotRequestId = 'parrotRequestId',
  /** column name */
  TeachersNote = 'teachersNote',
  /** column name */
  Updated = 'updated',
  /** column name */
  Visible = 'visible',
  /** column name */
  Week = 'week'
}

export type Assignments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Assignments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assignments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assignments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Assignments_Var_Pop_Fields = {
  __typename?: 'assignments_var_pop_fields';
  day?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  week?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "assignments" */
export type Assignments_Var_Pop_Order_By = {
  day?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Assignments_Var_Samp_Fields = {
  __typename?: 'assignments_var_samp_fields';
  day?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  week?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "assignments" */
export type Assignments_Var_Samp_Order_By = {
  day?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Assignments_Variance_Fields = {
  __typename?: 'assignments_variance_fields';
  day?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  week?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "assignments" */
export type Assignments_Variance_Order_By = {
  day?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  week?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "comments" */
export type Comments = {
  __typename?: 'comments';
  content: Scalars['String']['output'];
  created: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  studentAccount?: Maybe<Student_Accounts>;
  studentAccountId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  studentAssignment?: Maybe<Student_Assignments>;
  studentAssignmentId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  teacher?: Maybe<Teachers>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated: Scalars['timestamptz']['output'];
};

/** aggregated selection of "comments" */
export type Comments_Aggregate = {
  __typename?: 'comments_aggregate';
  aggregate?: Maybe<Comments_Aggregate_Fields>;
  nodes: Array<Comments>;
};

export type Comments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Comments_Aggregate_Bool_Exp_Count>;
};

export type Comments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Comments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "comments" */
export type Comments_Aggregate_Fields = {
  __typename?: 'comments_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Comments_Max_Fields>;
  min?: Maybe<Comments_Min_Fields>;
};


/** aggregate fields of "comments" */
export type Comments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "comments" */
export type Comments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Comments_Max_Order_By>;
  min?: InputMaybe<Comments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "comments" */
export type Comments_Arr_Rel_Insert_Input = {
  data: Array<Comments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "comments". All fields are combined with a logical 'AND'. */
export type Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Comments_Bool_Exp>>;
  _not?: InputMaybe<Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Comments_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  studentAccount?: InputMaybe<Student_Accounts_Bool_Exp>;
  studentAccountId?: InputMaybe<String_Comparison_Exp>;
  studentAssignment?: InputMaybe<Student_Assignments_Bool_Exp>;
  studentAssignmentId?: InputMaybe<Uuid_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "comments" */
export enum Comments_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommentsPkey = 'comments_pkey'
}

/** input type for inserting data into table "comments" */
export type Comments_Insert_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  studentAccount?: InputMaybe<Student_Accounts_Obj_Rel_Insert_Input>;
  studentAccountId?: InputMaybe<Scalars['String']['input']>;
  studentAssignment?: InputMaybe<Student_Assignments_Obj_Rel_Insert_Input>;
  studentAssignmentId?: InputMaybe<Scalars['uuid']['input']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Comments_Max_Fields = {
  __typename?: 'comments_max_fields';
  content?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  studentAccountId?: Maybe<Scalars['String']['output']>;
  studentAssignmentId?: Maybe<Scalars['uuid']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "comments" */
export type Comments_Max_Order_By = {
  content?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  studentAccountId?: InputMaybe<Order_By>;
  studentAssignmentId?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Comments_Min_Fields = {
  __typename?: 'comments_min_fields';
  content?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  studentAccountId?: Maybe<Scalars['String']['output']>;
  studentAssignmentId?: Maybe<Scalars['uuid']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "comments" */
export type Comments_Min_Order_By = {
  content?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  studentAccountId?: InputMaybe<Order_By>;
  studentAssignmentId?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "comments" */
export type Comments_Mutation_Response = {
  __typename?: 'comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Comments>;
};

/** on_conflict condition type for table "comments" */
export type Comments_On_Conflict = {
  constraint: Comments_Constraint;
  update_columns?: Array<Comments_Update_Column>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "comments". */
export type Comments_Order_By = {
  content?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  studentAccount?: InputMaybe<Student_Accounts_Order_By>;
  studentAccountId?: InputMaybe<Order_By>;
  studentAssignment?: InputMaybe<Student_Assignments_Order_By>;
  studentAssignmentId?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: comments */
export type Comments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "comments" */
export enum Comments_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  StudentAccountId = 'studentAccountId',
  /** column name */
  StudentAssignmentId = 'studentAssignmentId',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "comments" */
export type Comments_Set_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  studentAccountId?: InputMaybe<Scalars['String']['input']>;
  studentAssignmentId?: InputMaybe<Scalars['uuid']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "comments" */
export type Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Comments_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  studentAccountId?: InputMaybe<Scalars['String']['input']>;
  studentAssignmentId?: InputMaybe<Scalars['uuid']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "comments" */
export enum Comments_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  StudentAccountId = 'studentAccountId',
  /** column name */
  StudentAssignmentId = 'studentAssignmentId',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

export type Comments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Comments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Comments_Bool_Exp;
};

/** columns and relationships of "courses" */
export type Courses = {
  __typename?: 'courses';
  archived: Scalars['Boolean']['output'];
  /** An array relationship */
  assignmentTypeWeights: Array<Assignment_Type_Weights>;
  /** An aggregate relationship */
  assignmentTypeWeights_aggregate: Assignment_Type_Weights_Aggregate;
  /** An array relationship */
  assignments: Array<Assignments>;
  /** An aggregate relationship */
  assignments_aggregate: Assignments_Aggregate;
  color: Scalars['String']['output'];
  created: Scalars['timestamptz']['output'];
  credits?: Maybe<Scalars['numeric']['output']>;
  defaultDaysOfTheWeek?: Maybe<Scalars['jsonb']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gradeYears?: Maybe<Scalars['jsonb']['output']>;
  gradingStyle: Grading_Style_Enum;
  id: Scalars['uuid']['output'];
  /** The ID of the Organization that originally created this course and the teacherimported from */
  importedFromOrganizationId?: Maybe<Scalars['uuid']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberOfDaysPerWeek: Scalars['Int']['output'];
  numberOfWeeks: Scalars['Int']['output'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  parrotRequests: Array<Parrot_Requests>;
  /** An aggregate relationship */
  parrotRequests_aggregate: Parrot_Requests_Aggregate;
  picture?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  studentCourses: Array<Student_Courses>;
  /** An aggregate relationship */
  studentCourses_aggregate: Student_Courses_Aggregate;
  subject?: Maybe<Scalars['String']['output']>;
  subjects?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  teacher?: Maybe<Teachers>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  useAssignmentTypeWeights?: Maybe<Scalars['Boolean']['output']>;
};


/** columns and relationships of "courses" */
export type CoursesAssignmentTypeWeightsArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Weights_Order_By>>;
  where?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesAssignmentTypeWeights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Weights_Order_By>>;
  where?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignments_Order_By>>;
  where?: InputMaybe<Assignments_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignments_Order_By>>;
  where?: InputMaybe<Assignments_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesDefaultDaysOfTheWeekArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "courses" */
export type CoursesGradeYearsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "courses" */
export type CoursesParrotRequestsArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Requests_Order_By>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesParrotRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Requests_Order_By>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesStudentCoursesArgs = {
  distinct_on?: InputMaybe<Array<Student_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Courses_Order_By>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesStudentCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Courses_Order_By>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


/** columns and relationships of "courses" */
export type CoursesSubjectsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "courses" */
export type Courses_Aggregate = {
  __typename?: 'courses_aggregate';
  aggregate?: Maybe<Courses_Aggregate_Fields>;
  nodes: Array<Courses>;
};

export type Courses_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Courses_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Courses_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Courses_Aggregate_Bool_Exp_Count>;
};

export type Courses_Aggregate_Bool_Exp_Bool_And = {
  arguments: Courses_Select_Column_Courses_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Courses_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Courses_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Courses_Select_Column_Courses_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Courses_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Courses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Courses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Courses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "courses" */
export type Courses_Aggregate_Fields = {
  __typename?: 'courses_aggregate_fields';
  avg?: Maybe<Courses_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Courses_Max_Fields>;
  min?: Maybe<Courses_Min_Fields>;
  stddev?: Maybe<Courses_Stddev_Fields>;
  stddev_pop?: Maybe<Courses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Courses_Stddev_Samp_Fields>;
  sum?: Maybe<Courses_Sum_Fields>;
  var_pop?: Maybe<Courses_Var_Pop_Fields>;
  var_samp?: Maybe<Courses_Var_Samp_Fields>;
  variance?: Maybe<Courses_Variance_Fields>;
};


/** aggregate fields of "courses" */
export type Courses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Courses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "courses" */
export type Courses_Aggregate_Order_By = {
  avg?: InputMaybe<Courses_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Courses_Max_Order_By>;
  min?: InputMaybe<Courses_Min_Order_By>;
  stddev?: InputMaybe<Courses_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Courses_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Courses_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Courses_Sum_Order_By>;
  var_pop?: InputMaybe<Courses_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Courses_Var_Samp_Order_By>;
  variance?: InputMaybe<Courses_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Courses_Append_Input = {
  defaultDaysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  gradeYears?: InputMaybe<Scalars['jsonb']['input']>;
  subjects?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "courses" */
export type Courses_Arr_Rel_Insert_Input = {
  data: Array<Courses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Courses_On_Conflict>;
};

/** aggregate avg on columns */
export type Courses_Avg_Fields = {
  __typename?: 'courses_avg_fields';
  credits?: Maybe<Scalars['Float']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  numberOfWeeks?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "courses" */
export type Courses_Avg_Order_By = {
  credits?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "courses". All fields are combined with a logical 'AND'. */
export type Courses_Bool_Exp = {
  _and?: InputMaybe<Array<Courses_Bool_Exp>>;
  _not?: InputMaybe<Courses_Bool_Exp>;
  _or?: InputMaybe<Array<Courses_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  assignmentTypeWeights?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
  assignmentTypeWeights_aggregate?: InputMaybe<Assignment_Type_Weights_Aggregate_Bool_Exp>;
  assignments?: InputMaybe<Assignments_Bool_Exp>;
  assignments_aggregate?: InputMaybe<Assignments_Aggregate_Bool_Exp>;
  color?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  credits?: InputMaybe<Numeric_Comparison_Exp>;
  defaultDaysOfTheWeek?: InputMaybe<Jsonb_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  gradeYears?: InputMaybe<Jsonb_Comparison_Exp>;
  gradingStyle?: InputMaybe<Grading_Style_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  importedFromOrganizationId?: InputMaybe<Uuid_Comparison_Exp>;
  introduction?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  numberOfDaysPerWeek?: InputMaybe<Int_Comparison_Exp>;
  numberOfWeeks?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
  parrotRequests?: InputMaybe<Parrot_Requests_Bool_Exp>;
  parrotRequests_aggregate?: InputMaybe<Parrot_Requests_Aggregate_Bool_Exp>;
  picture?: InputMaybe<String_Comparison_Exp>;
  studentCourses?: InputMaybe<Student_Courses_Bool_Exp>;
  studentCourses_aggregate?: InputMaybe<Student_Courses_Aggregate_Bool_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  subjects?: InputMaybe<Jsonb_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  useAssignmentTypeWeights?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "courses" */
export enum Courses_Constraint {
  /** unique or primary key constraint on columns "id" */
  CoursesPkey = 'courses_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Courses_Delete_At_Path_Input = {
  defaultDaysOfTheWeek?: InputMaybe<Array<Scalars['String']['input']>>;
  gradeYears?: InputMaybe<Array<Scalars['String']['input']>>;
  subjects?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Courses_Delete_Elem_Input = {
  defaultDaysOfTheWeek?: InputMaybe<Scalars['Int']['input']>;
  gradeYears?: InputMaybe<Scalars['Int']['input']>;
  subjects?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Courses_Delete_Key_Input = {
  defaultDaysOfTheWeek?: InputMaybe<Scalars['String']['input']>;
  gradeYears?: InputMaybe<Scalars['String']['input']>;
  subjects?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "courses" */
export type Courses_Inc_Input = {
  credits?: InputMaybe<Scalars['numeric']['input']>;
  numberOfDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  numberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "courses" */
export type Courses_Insert_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assignmentTypeWeights?: InputMaybe<Assignment_Type_Weights_Arr_Rel_Insert_Input>;
  assignments?: InputMaybe<Assignments_Arr_Rel_Insert_Input>;
  color?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  credits?: InputMaybe<Scalars['numeric']['input']>;
  defaultDaysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gradeYears?: InputMaybe<Scalars['jsonb']['input']>;
  gradingStyle?: InputMaybe<Grading_Style_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** The ID of the Organization that originally created this course and the teacherimported from */
  importedFromOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  numberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  parrotRequests?: InputMaybe<Parrot_Requests_Arr_Rel_Insert_Input>;
  picture?: InputMaybe<Scalars['String']['input']>;
  studentCourses?: InputMaybe<Student_Courses_Arr_Rel_Insert_Input>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subjects?: InputMaybe<Scalars['jsonb']['input']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  useAssignmentTypeWeights?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Courses_Max_Fields = {
  __typename?: 'courses_max_fields';
  color?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  credits?: Maybe<Scalars['numeric']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** The ID of the Organization that originally created this course and the teacherimported from */
  importedFromOrganizationId?: Maybe<Scalars['uuid']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Int']['output']>;
  numberOfWeeks?: Maybe<Scalars['Int']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "courses" */
export type Courses_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The ID of the Organization that originally created this course and the teacherimported from */
  importedFromOrganizationId?: InputMaybe<Order_By>;
  introduction?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Courses_Min_Fields = {
  __typename?: 'courses_min_fields';
  color?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  credits?: Maybe<Scalars['numeric']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** The ID of the Organization that originally created this course and the teacherimported from */
  importedFromOrganizationId?: Maybe<Scalars['uuid']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Int']['output']>;
  numberOfWeeks?: Maybe<Scalars['Int']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "courses" */
export type Courses_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The ID of the Organization that originally created this course and the teacherimported from */
  importedFromOrganizationId?: InputMaybe<Order_By>;
  introduction?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "courses" */
export type Courses_Mutation_Response = {
  __typename?: 'courses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Courses>;
};

/** input type for inserting object relation for remote table "courses" */
export type Courses_Obj_Rel_Insert_Input = {
  data: Courses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Courses_On_Conflict>;
};

/** on_conflict condition type for table "courses" */
export type Courses_On_Conflict = {
  constraint: Courses_Constraint;
  update_columns?: Array<Courses_Update_Column>;
  where?: InputMaybe<Courses_Bool_Exp>;
};

/** Ordering options when selecting data from "courses". */
export type Courses_Order_By = {
  archived?: InputMaybe<Order_By>;
  assignmentTypeWeights_aggregate?: InputMaybe<Assignment_Type_Weights_Aggregate_Order_By>;
  assignments_aggregate?: InputMaybe<Assignments_Aggregate_Order_By>;
  color?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  defaultDaysOfTheWeek?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  gradeYears?: InputMaybe<Order_By>;
  gradingStyle?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  importedFromOrganizationId?: InputMaybe<Order_By>;
  introduction?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  parrotRequests_aggregate?: InputMaybe<Parrot_Requests_Aggregate_Order_By>;
  picture?: InputMaybe<Order_By>;
  studentCourses_aggregate?: InputMaybe<Student_Courses_Aggregate_Order_By>;
  subject?: InputMaybe<Order_By>;
  subjects?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  useAssignmentTypeWeights?: InputMaybe<Order_By>;
};

/** primary key columns input for table: courses */
export type Courses_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Courses_Prepend_Input = {
  defaultDaysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  gradeYears?: InputMaybe<Scalars['jsonb']['input']>;
  subjects?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "courses" */
export enum Courses_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Color = 'color',
  /** column name */
  Created = 'created',
  /** column name */
  Credits = 'credits',
  /** column name */
  DefaultDaysOfTheWeek = 'defaultDaysOfTheWeek',
  /** column name */
  Description = 'description',
  /** column name */
  GradeYears = 'gradeYears',
  /** column name */
  GradingStyle = 'gradingStyle',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedFromOrganizationId = 'importedFromOrganizationId',
  /** column name */
  Introduction = 'introduction',
  /** column name */
  Name = 'name',
  /** column name */
  NumberOfDaysPerWeek = 'numberOfDaysPerWeek',
  /** column name */
  NumberOfWeeks = 'numberOfWeeks',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Picture = 'picture',
  /** column name */
  Subject = 'subject',
  /** column name */
  Subjects = 'subjects',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated',
  /** column name */
  UseAssignmentTypeWeights = 'useAssignmentTypeWeights'
}

/** select "courses_aggregate_bool_exp_bool_and_arguments_columns" columns of table "courses" */
export enum Courses_Select_Column_Courses_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  UseAssignmentTypeWeights = 'useAssignmentTypeWeights'
}

/** select "courses_aggregate_bool_exp_bool_or_arguments_columns" columns of table "courses" */
export enum Courses_Select_Column_Courses_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Archived = 'archived',
  /** column name */
  UseAssignmentTypeWeights = 'useAssignmentTypeWeights'
}

/** input type for updating data in table "courses" */
export type Courses_Set_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  credits?: InputMaybe<Scalars['numeric']['input']>;
  defaultDaysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gradeYears?: InputMaybe<Scalars['jsonb']['input']>;
  gradingStyle?: InputMaybe<Grading_Style_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** The ID of the Organization that originally created this course and the teacherimported from */
  importedFromOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  numberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subjects?: InputMaybe<Scalars['jsonb']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  useAssignmentTypeWeights?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Courses_Stddev_Fields = {
  __typename?: 'courses_stddev_fields';
  credits?: Maybe<Scalars['Float']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  numberOfWeeks?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "courses" */
export type Courses_Stddev_Order_By = {
  credits?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Courses_Stddev_Pop_Fields = {
  __typename?: 'courses_stddev_pop_fields';
  credits?: Maybe<Scalars['Float']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  numberOfWeeks?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "courses" */
export type Courses_Stddev_Pop_Order_By = {
  credits?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Courses_Stddev_Samp_Fields = {
  __typename?: 'courses_stddev_samp_fields';
  credits?: Maybe<Scalars['Float']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  numberOfWeeks?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "courses" */
export type Courses_Stddev_Samp_Order_By = {
  credits?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "courses" */
export type Courses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Courses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Courses_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  credits?: InputMaybe<Scalars['numeric']['input']>;
  defaultDaysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gradeYears?: InputMaybe<Scalars['jsonb']['input']>;
  gradingStyle?: InputMaybe<Grading_Style_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** The ID of the Organization that originally created this course and the teacherimported from */
  importedFromOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  numberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subjects?: InputMaybe<Scalars['jsonb']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  useAssignmentTypeWeights?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Courses_Sum_Fields = {
  __typename?: 'courses_sum_fields';
  credits?: Maybe<Scalars['numeric']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Int']['output']>;
  numberOfWeeks?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "courses" */
export type Courses_Sum_Order_By = {
  credits?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
};

/** update columns of table "courses" */
export enum Courses_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Color = 'color',
  /** column name */
  Created = 'created',
  /** column name */
  Credits = 'credits',
  /** column name */
  DefaultDaysOfTheWeek = 'defaultDaysOfTheWeek',
  /** column name */
  Description = 'description',
  /** column name */
  GradeYears = 'gradeYears',
  /** column name */
  GradingStyle = 'gradingStyle',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedFromOrganizationId = 'importedFromOrganizationId',
  /** column name */
  Introduction = 'introduction',
  /** column name */
  Name = 'name',
  /** column name */
  NumberOfDaysPerWeek = 'numberOfDaysPerWeek',
  /** column name */
  NumberOfWeeks = 'numberOfWeeks',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Picture = 'picture',
  /** column name */
  Subject = 'subject',
  /** column name */
  Subjects = 'subjects',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated',
  /** column name */
  UseAssignmentTypeWeights = 'useAssignmentTypeWeights'
}

export type Courses_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Courses_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Courses_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Courses_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Courses_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Courses_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Courses_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Courses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Courses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Courses_Var_Pop_Fields = {
  __typename?: 'courses_var_pop_fields';
  credits?: Maybe<Scalars['Float']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  numberOfWeeks?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "courses" */
export type Courses_Var_Pop_Order_By = {
  credits?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Courses_Var_Samp_Fields = {
  __typename?: 'courses_var_samp_fields';
  credits?: Maybe<Scalars['Float']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  numberOfWeeks?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "courses" */
export type Courses_Var_Samp_Order_By = {
  credits?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Courses_Variance_Fields = {
  __typename?: 'courses_variance_fields';
  credits?: Maybe<Scalars['Float']['output']>;
  numberOfDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  numberOfWeeks?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "courses" */
export type Courses_Variance_Order_By = {
  credits?: InputMaybe<Order_By>;
  numberOfDaysPerWeek?: InputMaybe<Order_By>;
  numberOfWeeks?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "custom_assignment_types" */
export type Custom_Assignment_Types = {
  __typename?: 'custom_assignment_types';
  color: Scalars['String']['output'];
  created: Scalars['timestamptz']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  teacher?: Maybe<Teachers>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated: Scalars['timestamptz']['output'];
};

/** aggregated selection of "custom_assignment_types" */
export type Custom_Assignment_Types_Aggregate = {
  __typename?: 'custom_assignment_types_aggregate';
  aggregate?: Maybe<Custom_Assignment_Types_Aggregate_Fields>;
  nodes: Array<Custom_Assignment_Types>;
};

/** aggregate fields of "custom_assignment_types" */
export type Custom_Assignment_Types_Aggregate_Fields = {
  __typename?: 'custom_assignment_types_aggregate_fields';
  avg?: Maybe<Custom_Assignment_Types_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Custom_Assignment_Types_Max_Fields>;
  min?: Maybe<Custom_Assignment_Types_Min_Fields>;
  stddev?: Maybe<Custom_Assignment_Types_Stddev_Fields>;
  stddev_pop?: Maybe<Custom_Assignment_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Custom_Assignment_Types_Stddev_Samp_Fields>;
  sum?: Maybe<Custom_Assignment_Types_Sum_Fields>;
  var_pop?: Maybe<Custom_Assignment_Types_Var_Pop_Fields>;
  var_samp?: Maybe<Custom_Assignment_Types_Var_Samp_Fields>;
  variance?: Maybe<Custom_Assignment_Types_Variance_Fields>;
};


/** aggregate fields of "custom_assignment_types" */
export type Custom_Assignment_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Custom_Assignment_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Custom_Assignment_Types_Avg_Fields = {
  __typename?: 'custom_assignment_types_avg_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "custom_assignment_types". All fields are combined with a logical 'AND'. */
export type Custom_Assignment_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Custom_Assignment_Types_Bool_Exp>>;
  _not?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Assignment_Types_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
  sortOrder?: InputMaybe<Int_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "custom_assignment_types" */
export enum Custom_Assignment_Types_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssignmentTypesPkey = 'assignment_types_pkey'
}

/** input type for incrementing numeric columns in table "custom_assignment_types" */
export type Custom_Assignment_Types_Inc_Input = {
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "custom_assignment_types" */
export type Custom_Assignment_Types_Insert_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Custom_Assignment_Types_Max_Fields = {
  __typename?: 'custom_assignment_types_max_fields';
  color?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Custom_Assignment_Types_Min_Fields = {
  __typename?: 'custom_assignment_types_min_fields';
  color?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "custom_assignment_types" */
export type Custom_Assignment_Types_Mutation_Response = {
  __typename?: 'custom_assignment_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Assignment_Types>;
};

/** input type for inserting object relation for remote table "custom_assignment_types" */
export type Custom_Assignment_Types_Obj_Rel_Insert_Input = {
  data: Custom_Assignment_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Custom_Assignment_Types_On_Conflict>;
};

/** on_conflict condition type for table "custom_assignment_types" */
export type Custom_Assignment_Types_On_Conflict = {
  constraint: Custom_Assignment_Types_Constraint;
  update_columns?: Array<Custom_Assignment_Types_Update_Column>;
  where?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "custom_assignment_types". */
export type Custom_Assignment_Types_Order_By = {
  color?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  sortOrder?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: custom_assignment_types */
export type Custom_Assignment_Types_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "custom_assignment_types" */
export enum Custom_Assignment_Types_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Created = 'created',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  SortOrder = 'sortOrder',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "custom_assignment_types" */
export type Custom_Assignment_Types_Set_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Custom_Assignment_Types_Stddev_Fields = {
  __typename?: 'custom_assignment_types_stddev_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Custom_Assignment_Types_Stddev_Pop_Fields = {
  __typename?: 'custom_assignment_types_stddev_pop_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Custom_Assignment_Types_Stddev_Samp_Fields = {
  __typename?: 'custom_assignment_types_stddev_samp_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "custom_assignment_types" */
export type Custom_Assignment_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Assignment_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Assignment_Types_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Custom_Assignment_Types_Sum_Fields = {
  __typename?: 'custom_assignment_types_sum_fields';
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "custom_assignment_types" */
export enum Custom_Assignment_Types_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Created = 'created',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  SortOrder = 'sortOrder',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

export type Custom_Assignment_Types_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Custom_Assignment_Types_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Custom_Assignment_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Custom_Assignment_Types_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Custom_Assignment_Types_Var_Pop_Fields = {
  __typename?: 'custom_assignment_types_var_pop_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Custom_Assignment_Types_Var_Samp_Fields = {
  __typename?: 'custom_assignment_types_var_samp_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Custom_Assignment_Types_Variance_Fields = {
  __typename?: 'custom_assignment_types_variance_fields';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "customers" */
export type Customers = {
  __typename?: 'customers';
  created: Scalars['timestamptz']['output'];
  extendedTrial: Scalars['Boolean']['output'];
  freeTrialEnd: Scalars['timestamptz']['output'];
  id: Scalars['String']['output'];
  organizationSubscriptionExpiration?: Maybe<Scalars['timestamptz']['output']>;
  parrotCredits: Scalars['Int']['output'];
  planTier: Plan_Tier_Enum;
  subscriptionStatus?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  teacher: Teachers;
  teacherId: Scalars['String']['output'];
  updated: Scalars['timestamptz']['output'];
};

/** aggregated selection of "customers" */
export type Customers_Aggregate = {
  __typename?: 'customers_aggregate';
  aggregate?: Maybe<Customers_Aggregate_Fields>;
  nodes: Array<Customers>;
};

/** aggregate fields of "customers" */
export type Customers_Aggregate_Fields = {
  __typename?: 'customers_aggregate_fields';
  avg?: Maybe<Customers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Customers_Max_Fields>;
  min?: Maybe<Customers_Min_Fields>;
  stddev?: Maybe<Customers_Stddev_Fields>;
  stddev_pop?: Maybe<Customers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customers_Stddev_Samp_Fields>;
  sum?: Maybe<Customers_Sum_Fields>;
  var_pop?: Maybe<Customers_Var_Pop_Fields>;
  var_samp?: Maybe<Customers_Var_Samp_Fields>;
  variance?: Maybe<Customers_Variance_Fields>;
};


/** aggregate fields of "customers" */
export type Customers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Customers_Avg_Fields = {
  __typename?: 'customers_avg_fields';
  parrotCredits?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "customers". All fields are combined with a logical 'AND'. */
export type Customers_Bool_Exp = {
  _and?: InputMaybe<Array<Customers_Bool_Exp>>;
  _not?: InputMaybe<Customers_Bool_Exp>;
  _or?: InputMaybe<Array<Customers_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  extendedTrial?: InputMaybe<Boolean_Comparison_Exp>;
  freeTrialEnd?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  organizationSubscriptionExpiration?: InputMaybe<Timestamptz_Comparison_Exp>;
  parrotCredits?: InputMaybe<Int_Comparison_Exp>;
  planTier?: InputMaybe<Plan_Tier_Enum_Comparison_Exp>;
  subscriptionStatus?: InputMaybe<String_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "customers" */
export enum Customers_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomersPkey = 'customers_pkey',
  /** unique or primary key constraint on columns "teacher_id" */
  CustomersTeacherIdKey = 'customers_teacher_id_key'
}

/** input type for incrementing numeric columns in table "customers" */
export type Customers_Inc_Input = {
  parrotCredits?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "customers" */
export type Customers_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  extendedTrial?: InputMaybe<Scalars['Boolean']['input']>;
  freeTrialEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationSubscriptionExpiration?: InputMaybe<Scalars['timestamptz']['input']>;
  parrotCredits?: InputMaybe<Scalars['Int']['input']>;
  planTier?: InputMaybe<Plan_Tier_Enum>;
  subscriptionStatus?: InputMaybe<Scalars['String']['input']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Customers_Max_Fields = {
  __typename?: 'customers_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  freeTrialEnd?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationSubscriptionExpiration?: Maybe<Scalars['timestamptz']['output']>;
  parrotCredits?: Maybe<Scalars['Int']['output']>;
  subscriptionStatus?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Customers_Min_Fields = {
  __typename?: 'customers_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  freeTrialEnd?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationSubscriptionExpiration?: Maybe<Scalars['timestamptz']['output']>;
  parrotCredits?: Maybe<Scalars['Int']['output']>;
  subscriptionStatus?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "customers" */
export type Customers_Mutation_Response = {
  __typename?: 'customers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Customers>;
};

/** input type for inserting object relation for remote table "customers" */
export type Customers_Obj_Rel_Insert_Input = {
  data: Customers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customers_On_Conflict>;
};

/** on_conflict condition type for table "customers" */
export type Customers_On_Conflict = {
  constraint: Customers_Constraint;
  update_columns?: Array<Customers_Update_Column>;
  where?: InputMaybe<Customers_Bool_Exp>;
};

/** Ordering options when selecting data from "customers". */
export type Customers_Order_By = {
  created?: InputMaybe<Order_By>;
  extendedTrial?: InputMaybe<Order_By>;
  freeTrialEnd?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationSubscriptionExpiration?: InputMaybe<Order_By>;
  parrotCredits?: InputMaybe<Order_By>;
  planTier?: InputMaybe<Order_By>;
  subscriptionStatus?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customers */
export type Customers_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "customers" */
export enum Customers_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  ExtendedTrial = 'extendedTrial',
  /** column name */
  FreeTrialEnd = 'freeTrialEnd',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationSubscriptionExpiration = 'organizationSubscriptionExpiration',
  /** column name */
  ParrotCredits = 'parrotCredits',
  /** column name */
  PlanTier = 'planTier',
  /** column name */
  SubscriptionStatus = 'subscriptionStatus',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "customers" */
export type Customers_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  extendedTrial?: InputMaybe<Scalars['Boolean']['input']>;
  freeTrialEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationSubscriptionExpiration?: InputMaybe<Scalars['timestamptz']['input']>;
  parrotCredits?: InputMaybe<Scalars['Int']['input']>;
  planTier?: InputMaybe<Plan_Tier_Enum>;
  subscriptionStatus?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Customers_Stddev_Fields = {
  __typename?: 'customers_stddev_fields';
  parrotCredits?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Customers_Stddev_Pop_Fields = {
  __typename?: 'customers_stddev_pop_fields';
  parrotCredits?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Customers_Stddev_Samp_Fields = {
  __typename?: 'customers_stddev_samp_fields';
  parrotCredits?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "customers" */
export type Customers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customers_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  extendedTrial?: InputMaybe<Scalars['Boolean']['input']>;
  freeTrialEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationSubscriptionExpiration?: InputMaybe<Scalars['timestamptz']['input']>;
  parrotCredits?: InputMaybe<Scalars['Int']['input']>;
  planTier?: InputMaybe<Plan_Tier_Enum>;
  subscriptionStatus?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Customers_Sum_Fields = {
  __typename?: 'customers_sum_fields';
  parrotCredits?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "customers" */
export enum Customers_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  ExtendedTrial = 'extendedTrial',
  /** column name */
  FreeTrialEnd = 'freeTrialEnd',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationSubscriptionExpiration = 'organizationSubscriptionExpiration',
  /** column name */
  ParrotCredits = 'parrotCredits',
  /** column name */
  PlanTier = 'planTier',
  /** column name */
  SubscriptionStatus = 'subscriptionStatus',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

export type Customers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Customers_Var_Pop_Fields = {
  __typename?: 'customers_var_pop_fields';
  parrotCredits?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Customers_Var_Samp_Fields = {
  __typename?: 'customers_var_samp_fields';
  parrotCredits?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Customers_Variance_Fields = {
  __typename?: 'customers_variance_fields';
  parrotCredits?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** This table has to be named event_t in order to not conflict with the Hasura Events feature which has an event_type component. */
export type Event_T = {
  __typename?: 'event_t';
  value: Scalars['String']['output'];
};

/** aggregated selection of "event_t" */
export type Event_T_Aggregate = {
  __typename?: 'event_t_aggregate';
  aggregate?: Maybe<Event_T_Aggregate_Fields>;
  nodes: Array<Event_T>;
};

/** aggregate fields of "event_t" */
export type Event_T_Aggregate_Fields = {
  __typename?: 'event_t_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Event_T_Max_Fields>;
  min?: Maybe<Event_T_Min_Fields>;
};


/** aggregate fields of "event_t" */
export type Event_T_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Event_T_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "event_t". All fields are combined with a logical 'AND'. */
export type Event_T_Bool_Exp = {
  _and?: InputMaybe<Array<Event_T_Bool_Exp>>;
  _not?: InputMaybe<Event_T_Bool_Exp>;
  _or?: InputMaybe<Array<Event_T_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "event_t" */
export enum Event_T_Constraint {
  /** unique or primary key constraint on columns "value" */
  EventTypePkey = 'event_type_pkey'
}

export enum Event_T_Enum {
  Other = 'OTHER',
  Vacation = 'VACATION'
}

/** Boolean expression to compare columns of type "event_t_enum". All fields are combined with logical 'AND'. */
export type Event_T_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Event_T_Enum>;
  _in?: InputMaybe<Array<Event_T_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Event_T_Enum>;
  _nin?: InputMaybe<Array<Event_T_Enum>>;
};

/** input type for inserting data into table "event_t" */
export type Event_T_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Event_T_Max_Fields = {
  __typename?: 'event_t_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Event_T_Min_Fields = {
  __typename?: 'event_t_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "event_t" */
export type Event_T_Mutation_Response = {
  __typename?: 'event_t_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_T>;
};

/** on_conflict condition type for table "event_t" */
export type Event_T_On_Conflict = {
  constraint: Event_T_Constraint;
  update_columns?: Array<Event_T_Update_Column>;
  where?: InputMaybe<Event_T_Bool_Exp>;
};

/** Ordering options when selecting data from "event_t". */
export type Event_T_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: event_t */
export type Event_T_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "event_t" */
export enum Event_T_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "event_t" */
export type Event_T_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "event_t" */
export type Event_T_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Event_T_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Event_T_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "event_t" */
export enum Event_T_Update_Column {
  /** column name */
  Value = 'value'
}

export type Event_T_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Event_T_Set_Input>;
  /** filter the rows which have to be updated */
  where: Event_T_Bool_Exp;
};

/** columns and relationships of "events" */
export type Events = {
  __typename?: 'events';
  created: Scalars['timestamptz']['output'];
  end: Scalars['date']['output'];
  eventType: Event_T_Enum;
  id: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
  start: Scalars['date']['output'];
  /** An array relationship */
  studentEvents: Array<Student_Events>;
  /** An aggregate relationship */
  studentEvents_aggregate: Student_Events_Aggregate;
  /** An object relationship */
  teacher: Teachers;
  teacherId: Scalars['String']['output'];
  updated: Scalars['timestamptz']['output'];
};


/** columns and relationships of "events" */
export type EventsStudentEventsArgs = {
  distinct_on?: InputMaybe<Array<Student_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Events_Order_By>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsStudentEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Events_Order_By>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};

/** aggregated selection of "events" */
export type Events_Aggregate = {
  __typename?: 'events_aggregate';
  aggregate?: Maybe<Events_Aggregate_Fields>;
  nodes: Array<Events>;
};

export type Events_Aggregate_Bool_Exp = {
  count?: InputMaybe<Events_Aggregate_Bool_Exp_Count>;
};

export type Events_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Events_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "events" */
export type Events_Aggregate_Fields = {
  __typename?: 'events_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Max_Fields>;
  min?: Maybe<Events_Min_Fields>;
};


/** aggregate fields of "events" */
export type Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "events" */
export type Events_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Events_Max_Order_By>;
  min?: InputMaybe<Events_Min_Order_By>;
};

/** input type for inserting array relation for remote table "events" */
export type Events_Arr_Rel_Insert_Input = {
  data: Array<Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Events_On_Conflict>;
};

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export type Events_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Bool_Exp>>;
  _not?: InputMaybe<Events_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  end?: InputMaybe<Date_Comparison_Exp>;
  eventType?: InputMaybe<Event_T_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  start?: InputMaybe<Date_Comparison_Exp>;
  studentEvents?: InputMaybe<Student_Events_Bool_Exp>;
  studentEvents_aggregate?: InputMaybe<Student_Events_Aggregate_Bool_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "events" */
export enum Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  VacationsPkey = 'vacations_pkey'
}

/** input type for inserting data into table "events" */
export type Events_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  eventType?: InputMaybe<Event_T_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['date']['input']>;
  studentEvents?: InputMaybe<Student_Events_Arr_Rel_Insert_Input>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Events_Max_Fields = {
  __typename?: 'events_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  end?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['date']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "events" */
export type Events_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Events_Min_Fields = {
  __typename?: 'events_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  end?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['date']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "events" */
export type Events_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "events" */
export type Events_Mutation_Response = {
  __typename?: 'events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Events>;
};

/** input type for inserting object relation for remote table "events" */
export type Events_Obj_Rel_Insert_Input = {
  data: Events_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Events_On_Conflict>;
};

/** on_conflict condition type for table "events" */
export type Events_On_Conflict = {
  constraint: Events_Constraint;
  update_columns?: Array<Events_Update_Column>;
  where?: InputMaybe<Events_Bool_Exp>;
};

/** Ordering options when selecting data from "events". */
export type Events_Order_By = {
  created?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  eventType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  studentEvents_aggregate?: InputMaybe<Student_Events_Aggregate_Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: events */
export type Events_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "events" */
export enum Events_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  End = 'end',
  /** column name */
  EventType = 'eventType',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Start = 'start',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "events" */
export type Events_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  eventType?: InputMaybe<Event_T_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['date']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "events" */
export type Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  eventType?: InputMaybe<Event_T_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['date']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "events" */
export enum Events_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  End = 'end',
  /** column name */
  EventType = 'eventType',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Start = 'start',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

export type Events_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Events_Bool_Exp;
};

/** columns and relationships of "files" */
export type Files = {
  __typename?: 'files';
  /** An object relationship */
  assignment?: Maybe<Assignments>;
  assignmentId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  parrotRequest?: Maybe<Parrot_Requests>;
  parrotRequestId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  printingJob?: Maybe<Printing_Jobs>;
  printingJobId?: Maybe<Scalars['uuid']['output']>;
  size: Scalars['bigint']['output'];
  /** An object relationship */
  studentAssignment?: Maybe<Student_Assignments>;
  studentAssignmentId?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  url: Scalars['String']['output'];
};

/** aggregated selection of "files" */
export type Files_Aggregate = {
  __typename?: 'files_aggregate';
  aggregate?: Maybe<Files_Aggregate_Fields>;
  nodes: Array<Files>;
};

export type Files_Aggregate_Bool_Exp = {
  count?: InputMaybe<Files_Aggregate_Bool_Exp_Count>;
};

export type Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "files" */
export type Files_Aggregate_Fields = {
  __typename?: 'files_aggregate_fields';
  avg?: Maybe<Files_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Files_Max_Fields>;
  min?: Maybe<Files_Min_Fields>;
  stddev?: Maybe<Files_Stddev_Fields>;
  stddev_pop?: Maybe<Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Files_Stddev_Samp_Fields>;
  sum?: Maybe<Files_Sum_Fields>;
  var_pop?: Maybe<Files_Var_Pop_Fields>;
  var_samp?: Maybe<Files_Var_Samp_Fields>;
  variance?: Maybe<Files_Variance_Fields>;
};


/** aggregate fields of "files" */
export type Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "files" */
export type Files_Aggregate_Order_By = {
  avg?: InputMaybe<Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Files_Max_Order_By>;
  min?: InputMaybe<Files_Min_Order_By>;
  stddev?: InputMaybe<Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Files_Sum_Order_By>;
  var_pop?: InputMaybe<Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Files_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "files" */
export type Files_Arr_Rel_Insert_Input = {
  data: Array<Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** aggregate avg on columns */
export type Files_Avg_Fields = {
  __typename?: 'files_avg_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "files" */
export type Files_Avg_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  assignment?: InputMaybe<Assignments_Bool_Exp>;
  assignmentId?: InputMaybe<Uuid_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  parrotRequest?: InputMaybe<Parrot_Requests_Bool_Exp>;
  parrotRequestId?: InputMaybe<Uuid_Comparison_Exp>;
  printingJob?: InputMaybe<Printing_Jobs_Bool_Exp>;
  printingJobId?: InputMaybe<Uuid_Comparison_Exp>;
  size?: InputMaybe<Bigint_Comparison_Exp>;
  studentAssignment?: InputMaybe<Student_Assignments_Bool_Exp>;
  studentAssignmentId?: InputMaybe<Uuid_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey',
  /** unique or primary key constraint on columns "printing_job_id" */
  FilesPrintingJobIdKey = 'files_printing_job_id_key'
}

/** input type for incrementing numeric columns in table "files" */
export type Files_Inc_Input = {
  size?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "files" */
export type Files_Insert_Input = {
  assignment?: InputMaybe<Assignments_Obj_Rel_Insert_Input>;
  assignmentId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parrotRequest?: InputMaybe<Parrot_Requests_Obj_Rel_Insert_Input>;
  parrotRequestId?: InputMaybe<Scalars['uuid']['input']>;
  printingJob?: InputMaybe<Printing_Jobs_Obj_Rel_Insert_Input>;
  printingJobId?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['bigint']['input']>;
  studentAssignment?: InputMaybe<Student_Assignments_Obj_Rel_Insert_Input>;
  studentAssignmentId?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Files_Max_Fields = {
  __typename?: 'files_max_fields';
  assignmentId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parrotRequestId?: Maybe<Scalars['uuid']['output']>;
  printingJobId?: Maybe<Scalars['uuid']['output']>;
  size?: Maybe<Scalars['bigint']['output']>;
  studentAssignmentId?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "files" */
export type Files_Max_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parrotRequestId?: InputMaybe<Order_By>;
  printingJobId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  studentAssignmentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Files_Min_Fields = {
  __typename?: 'files_min_fields';
  assignmentId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parrotRequestId?: Maybe<Scalars['uuid']['output']>;
  printingJobId?: Maybe<Scalars['uuid']['output']>;
  size?: Maybe<Scalars['bigint']['output']>;
  studentAssignmentId?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "files" */
export type Files_Min_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parrotRequestId?: InputMaybe<Order_By>;
  printingJobId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  studentAssignmentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "files" */
export type Files_Mutation_Response = {
  __typename?: 'files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** input type for inserting object relation for remote table "files" */
export type Files_Obj_Rel_Insert_Input = {
  data: Files_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** on_conflict condition type for table "files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint;
  update_columns?: Array<Files_Update_Column>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** Ordering options when selecting data from "files". */
export type Files_Order_By = {
  assignment?: InputMaybe<Assignments_Order_By>;
  assignmentId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parrotRequest?: InputMaybe<Parrot_Requests_Order_By>;
  parrotRequestId?: InputMaybe<Order_By>;
  printingJob?: InputMaybe<Printing_Jobs_Order_By>;
  printingJobId?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  studentAssignment?: InputMaybe<Student_Assignments_Order_By>;
  studentAssignmentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: files */
export type Files_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "files" */
export enum Files_Select_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  ParrotRequestId = 'parrotRequestId',
  /** column name */
  PrintingJobId = 'printingJobId',
  /** column name */
  Size = 'size',
  /** column name */
  StudentAssignmentId = 'studentAssignmentId',
  /** column name */
  Updated = 'updated',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "files" */
export type Files_Set_Input = {
  assignmentId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parrotRequestId?: InputMaybe<Scalars['uuid']['input']>;
  printingJobId?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['bigint']['input']>;
  studentAssignmentId?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Files_Stddev_Fields = {
  __typename?: 'files_stddev_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "files" */
export type Files_Stddev_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Files_Stddev_Pop_Fields = {
  __typename?: 'files_stddev_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "files" */
export type Files_Stddev_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Files_Stddev_Samp_Fields = {
  __typename?: 'files_stddev_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "files" */
export type Files_Stddev_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input = {
  assignmentId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parrotRequestId?: InputMaybe<Scalars['uuid']['input']>;
  printingJobId?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['bigint']['input']>;
  studentAssignmentId?: InputMaybe<Scalars['uuid']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Files_Sum_Fields = {
  __typename?: 'files_sum_fields';
  size?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "files" */
export type Files_Sum_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** update columns of table "files" */
export enum Files_Update_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  ParrotRequestId = 'parrotRequestId',
  /** column name */
  PrintingJobId = 'printingJobId',
  /** column name */
  Size = 'size',
  /** column name */
  StudentAssignmentId = 'studentAssignmentId',
  /** column name */
  Updated = 'updated',
  /** column name */
  Url = 'url'
}

export type Files_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Files_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Files_Var_Pop_Fields = {
  __typename?: 'files_var_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "files" */
export type Files_Var_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Files_Var_Samp_Fields = {
  __typename?: 'files_var_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "files" */
export type Files_Var_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Files_Variance_Fields = {
  __typename?: 'files_variance_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "files" */
export type Files_Variance_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** columns and relationships of "grading_style" */
export type Grading_Style = {
  __typename?: 'grading_style';
  value: Scalars['String']['output'];
};

/** aggregated selection of "grading_style" */
export type Grading_Style_Aggregate = {
  __typename?: 'grading_style_aggregate';
  aggregate?: Maybe<Grading_Style_Aggregate_Fields>;
  nodes: Array<Grading_Style>;
};

/** aggregate fields of "grading_style" */
export type Grading_Style_Aggregate_Fields = {
  __typename?: 'grading_style_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Grading_Style_Max_Fields>;
  min?: Maybe<Grading_Style_Min_Fields>;
};


/** aggregate fields of "grading_style" */
export type Grading_Style_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Grading_Style_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "grading_style". All fields are combined with a logical 'AND'. */
export type Grading_Style_Bool_Exp = {
  _and?: InputMaybe<Array<Grading_Style_Bool_Exp>>;
  _not?: InputMaybe<Grading_Style_Bool_Exp>;
  _or?: InputMaybe<Array<Grading_Style_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "grading_style" */
export enum Grading_Style_Constraint {
  /** unique or primary key constraint on columns "value" */
  GradingStylePkey = 'grading_style_pkey'
}

export enum Grading_Style_Enum {
  Percent = 'PERCENT',
  Point = 'POINT',
  Ungraded = 'UNGRADED'
}

/** Boolean expression to compare columns of type "grading_style_enum". All fields are combined with logical 'AND'. */
export type Grading_Style_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Grading_Style_Enum>;
  _in?: InputMaybe<Array<Grading_Style_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Grading_Style_Enum>;
  _nin?: InputMaybe<Array<Grading_Style_Enum>>;
};

/** input type for inserting data into table "grading_style" */
export type Grading_Style_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Grading_Style_Max_Fields = {
  __typename?: 'grading_style_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Grading_Style_Min_Fields = {
  __typename?: 'grading_style_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "grading_style" */
export type Grading_Style_Mutation_Response = {
  __typename?: 'grading_style_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Grading_Style>;
};

/** on_conflict condition type for table "grading_style" */
export type Grading_Style_On_Conflict = {
  constraint: Grading_Style_Constraint;
  update_columns?: Array<Grading_Style_Update_Column>;
  where?: InputMaybe<Grading_Style_Bool_Exp>;
};

/** Ordering options when selecting data from "grading_style". */
export type Grading_Style_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: grading_style */
export type Grading_Style_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "grading_style" */
export enum Grading_Style_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "grading_style" */
export type Grading_Style_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "grading_style" */
export type Grading_Style_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Grading_Style_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grading_Style_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "grading_style" */
export enum Grading_Style_Update_Column {
  /** column name */
  Value = 'value'
}

export type Grading_Style_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Grading_Style_Set_Input>;
  /** filter the rows which have to be updated */
  where: Grading_Style_Bool_Exp;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete single row from the table: "assignments" */
  delete_assignment?: Maybe<Assignments>;
  /** delete data from the table: "assignment_type" */
  delete_assignment_type?: Maybe<Assignment_Type_Mutation_Response>;
  /** delete single row from the table: "assignment_type" */
  delete_assignment_type_by_pk?: Maybe<Assignment_Type>;
  /** delete single row from the table: "assignment_type_weights" */
  delete_assignment_type_weight?: Maybe<Assignment_Type_Weights>;
  /** delete data from the table: "assignment_type_weights" */
  delete_assignment_type_weights?: Maybe<Assignment_Type_Weights_Mutation_Response>;
  /** delete data from the table: "assignments" */
  delete_assignments?: Maybe<Assignments_Mutation_Response>;
  /** delete single row from the table: "comments" */
  delete_comment?: Maybe<Comments>;
  /** delete data from the table: "comments" */
  delete_comments?: Maybe<Comments_Mutation_Response>;
  /** delete single row from the table: "courses" */
  delete_course?: Maybe<Courses>;
  /** delete data from the table: "courses" */
  delete_courses?: Maybe<Courses_Mutation_Response>;
  /** delete single row from the table: "custom_assignment_types" */
  delete_custom_assignment_type?: Maybe<Custom_Assignment_Types>;
  /** delete data from the table: "custom_assignment_types" */
  delete_custom_assignment_types?: Maybe<Custom_Assignment_Types_Mutation_Response>;
  /** delete single row from the table: "customers" */
  delete_customer?: Maybe<Customers>;
  /** delete data from the table: "customers" */
  delete_customers?: Maybe<Customers_Mutation_Response>;
  /** delete single row from the table: "events" */
  delete_event?: Maybe<Events>;
  /** delete data from the table: "event_t" */
  delete_event_t?: Maybe<Event_T_Mutation_Response>;
  /** delete single row from the table: "event_t" */
  delete_event_type?: Maybe<Event_T>;
  /** delete data from the table: "events" */
  delete_events?: Maybe<Events_Mutation_Response>;
  /** delete single row from the table: "files" */
  delete_file?: Maybe<Files>;
  /** delete data from the table: "files" */
  delete_files?: Maybe<Files_Mutation_Response>;
  /** delete data from the table: "grading_style" */
  delete_grading_style?: Maybe<Grading_Style_Mutation_Response>;
  /** delete single row from the table: "grading_style" */
  delete_grading_style_by_pk?: Maybe<Grading_Style>;
  /** delete single row from the table: "organizations" */
  delete_organization?: Maybe<Organizations>;
  /** delete single row from the table: "organization_admins" */
  delete_organization_admin?: Maybe<Organization_Admins>;
  /** delete data from the table: "organization_admins" */
  delete_organization_admins?: Maybe<Organization_Admins_Mutation_Response>;
  /** delete single row from the table: "organization_codes" */
  delete_organization_code?: Maybe<Organization_Codes>;
  /** delete data from the table: "organization_codes" */
  delete_organization_codes?: Maybe<Organization_Codes_Mutation_Response>;
  /** delete data from the table: "organizations" */
  delete_organizations?: Maybe<Organizations_Mutation_Response>;
  /** delete single row from the table: "parrot_requests" */
  delete_parrot_request?: Maybe<Parrot_Requests>;
  /** delete data from the table: "parrot_request_status" */
  delete_parrot_request_status?: Maybe<Parrot_Request_Status_Mutation_Response>;
  /** delete single row from the table: "parrot_request_status" */
  delete_parrot_request_status_by_pk?: Maybe<Parrot_Request_Status>;
  /** delete data from the table: "parrot_requests" */
  delete_parrot_requests?: Maybe<Parrot_Requests_Mutation_Response>;
  /** delete data from the table: "plan_tier" */
  delete_plan_tier?: Maybe<Plan_Tier_Mutation_Response>;
  /** delete single row from the table: "plan_tier" */
  delete_plan_tier_by_pk?: Maybe<Plan_Tier>;
  /** delete single row from the table: "printing_jobs" */
  delete_printing_job?: Maybe<Printing_Jobs>;
  /** delete data from the table: "printing_job_status" */
  delete_printing_job_status?: Maybe<Printing_Job_Status_Mutation_Response>;
  /** delete single row from the table: "printing_job_status" */
  delete_printing_job_status_by_pk?: Maybe<Printing_Job_Status>;
  /** delete data from the table: "printing_job_type" */
  delete_printing_job_type?: Maybe<Printing_Job_Type_Mutation_Response>;
  /** delete single row from the table: "printing_job_type" */
  delete_printing_job_type_by_pk?: Maybe<Printing_Job_Type>;
  /** delete data from the table: "printing_jobs" */
  delete_printing_jobs?: Maybe<Printing_Jobs_Mutation_Response>;
  /** delete data from the table: "school_year" */
  delete_school_year?: Maybe<School_Year_Mutation_Response>;
  /** delete single row from the table: "school_year" */
  delete_school_year_by_pk?: Maybe<School_Year>;
  /** delete single row from the table: "students" */
  delete_student?: Maybe<Students>;
  /** delete single row from the table: "student_accounts" */
  delete_student_account?: Maybe<Student_Accounts>;
  /** delete data from the table: "student_accounts" */
  delete_student_accounts?: Maybe<Student_Accounts_Mutation_Response>;
  /** delete single row from the table: "student_assignments" */
  delete_student_assignment?: Maybe<Student_Assignments>;
  /** delete data from the table: "student_assignment_status" */
  delete_student_assignment_status?: Maybe<Student_Assignment_Status_Mutation_Response>;
  /** delete single row from the table: "student_assignment_status" */
  delete_student_assignment_status_by_pk?: Maybe<Student_Assignment_Status>;
  /** delete data from the table: "student_assignments" */
  delete_student_assignments?: Maybe<Student_Assignments_Mutation_Response>;
  /** delete single row from the table: "student_courses" */
  delete_student_course?: Maybe<Student_Courses>;
  /** delete data from the table: "student_course_status" */
  delete_student_course_status?: Maybe<Student_Course_Status_Mutation_Response>;
  /** delete single row from the table: "student_course_status" */
  delete_student_course_status_by_pk?: Maybe<Student_Course_Status>;
  /** delete data from the table: "student_courses" */
  delete_student_courses?: Maybe<Student_Courses_Mutation_Response>;
  /** delete single row from the table: "student_events" */
  delete_student_event?: Maybe<Student_Events>;
  /** delete data from the table: "student_events" */
  delete_student_events?: Maybe<Student_Events_Mutation_Response>;
  /** delete data from the table: "students" */
  delete_students?: Maybe<Students_Mutation_Response>;
  /** delete single row from the table: "teachers" */
  delete_teacher?: Maybe<Teachers>;
  /** delete data from the table: "teachers" */
  delete_teachers?: Maybe<Teachers_Mutation_Response>;
  /** delete data from the table: "teachers_students" */
  delete_teachers_students?: Maybe<Teachers_Students_Mutation_Response>;
  /** delete single row from the table: "teachers_students" */
  delete_teachers_students_by_pk?: Maybe<Teachers_Students>;
  /** delete data from the table: "themes" */
  delete_themes?: Maybe<Themes_Mutation_Response>;
  /** delete single row from the table: "themes" */
  delete_themes_by_pk?: Maybe<Themes>;
  /** delete data from the table: "user_settings" */
  delete_user_settings?: Maybe<User_Settings_Mutation_Response>;
  /** delete single row from the table: "user_settings" */
  delete_user_settings_by_pk?: Maybe<User_Settings>;
  /** insert a single row into the table: "assignments" */
  insert_assignment?: Maybe<Assignments>;
  /** insert data into the table: "assignment_type" */
  insert_assignment_type?: Maybe<Assignment_Type_Mutation_Response>;
  /** insert a single row into the table: "assignment_type" */
  insert_assignment_type_one?: Maybe<Assignment_Type>;
  /** insert a single row into the table: "assignment_type_weights" */
  insert_assignment_type_weight?: Maybe<Assignment_Type_Weights>;
  /** insert data into the table: "assignment_type_weights" */
  insert_assignment_type_weights?: Maybe<Assignment_Type_Weights_Mutation_Response>;
  /** insert data into the table: "assignments" */
  insert_assignments?: Maybe<Assignments_Mutation_Response>;
  /** insert a single row into the table: "comments" */
  insert_comment?: Maybe<Comments>;
  /** insert data into the table: "comments" */
  insert_comments?: Maybe<Comments_Mutation_Response>;
  /** insert a single row into the table: "courses" */
  insert_course?: Maybe<Courses>;
  /** insert data into the table: "courses" */
  insert_courses?: Maybe<Courses_Mutation_Response>;
  /** insert a single row into the table: "custom_assignment_types" */
  insert_custom_assignment_type?: Maybe<Custom_Assignment_Types>;
  /** insert data into the table: "custom_assignment_types" */
  insert_custom_assignment_types?: Maybe<Custom_Assignment_Types_Mutation_Response>;
  /** insert a single row into the table: "customers" */
  insert_customer?: Maybe<Customers>;
  /** insert data into the table: "customers" */
  insert_customers?: Maybe<Customers_Mutation_Response>;
  /** insert a single row into the table: "events" */
  insert_event?: Maybe<Events>;
  /** insert data into the table: "event_t" */
  insert_event_t?: Maybe<Event_T_Mutation_Response>;
  /** insert a single row into the table: "event_t" */
  insert_event_type?: Maybe<Event_T>;
  /** insert data into the table: "events" */
  insert_events?: Maybe<Events_Mutation_Response>;
  /** insert a single row into the table: "files" */
  insert_file?: Maybe<Files>;
  /** insert data into the table: "files" */
  insert_files?: Maybe<Files_Mutation_Response>;
  /** insert data into the table: "grading_style" */
  insert_grading_style?: Maybe<Grading_Style_Mutation_Response>;
  /** insert a single row into the table: "grading_style" */
  insert_grading_style_one?: Maybe<Grading_Style>;
  /** insert a single row into the table: "organizations" */
  insert_organization?: Maybe<Organizations>;
  /** insert a single row into the table: "organization_admins" */
  insert_organization_admin?: Maybe<Organization_Admins>;
  /** insert data into the table: "organization_admins" */
  insert_organization_admins?: Maybe<Organization_Admins_Mutation_Response>;
  /** insert a single row into the table: "organization_codes" */
  insert_organization_code?: Maybe<Organization_Codes>;
  /** insert data into the table: "organization_codes" */
  insert_organization_codes?: Maybe<Organization_Codes_Mutation_Response>;
  /** insert data into the table: "organizations" */
  insert_organizations?: Maybe<Organizations_Mutation_Response>;
  /** insert a single row into the table: "parrot_requests" */
  insert_parrot_request?: Maybe<Parrot_Requests>;
  /** insert data into the table: "parrot_request_status" */
  insert_parrot_request_status?: Maybe<Parrot_Request_Status_Mutation_Response>;
  /** insert a single row into the table: "parrot_request_status" */
  insert_parrot_request_status_one?: Maybe<Parrot_Request_Status>;
  /** insert data into the table: "parrot_requests" */
  insert_parrot_requests?: Maybe<Parrot_Requests_Mutation_Response>;
  /** insert data into the table: "plan_tier" */
  insert_plan_tier?: Maybe<Plan_Tier_Mutation_Response>;
  /** insert a single row into the table: "plan_tier" */
  insert_plan_tier_one?: Maybe<Plan_Tier>;
  /** insert a single row into the table: "printing_jobs" */
  insert_printing_job?: Maybe<Printing_Jobs>;
  /** insert data into the table: "printing_job_status" */
  insert_printing_job_status?: Maybe<Printing_Job_Status_Mutation_Response>;
  /** insert a single row into the table: "printing_job_status" */
  insert_printing_job_status_one?: Maybe<Printing_Job_Status>;
  /** insert data into the table: "printing_job_type" */
  insert_printing_job_type?: Maybe<Printing_Job_Type_Mutation_Response>;
  /** insert a single row into the table: "printing_job_type" */
  insert_printing_job_type_one?: Maybe<Printing_Job_Type>;
  /** insert data into the table: "printing_jobs" */
  insert_printing_jobs?: Maybe<Printing_Jobs_Mutation_Response>;
  /** insert data into the table: "school_year" */
  insert_school_year?: Maybe<School_Year_Mutation_Response>;
  /** insert a single row into the table: "school_year" */
  insert_school_year_one?: Maybe<School_Year>;
  /** insert a single row into the table: "students" */
  insert_student?: Maybe<Students>;
  /** insert a single row into the table: "student_accounts" */
  insert_student_account?: Maybe<Student_Accounts>;
  /** insert data into the table: "student_accounts" */
  insert_student_accounts?: Maybe<Student_Accounts_Mutation_Response>;
  /** insert a single row into the table: "student_assignments" */
  insert_student_assignment?: Maybe<Student_Assignments>;
  /** insert data into the table: "student_assignment_status" */
  insert_student_assignment_status?: Maybe<Student_Assignment_Status_Mutation_Response>;
  /** insert a single row into the table: "student_assignment_status" */
  insert_student_assignment_status_one?: Maybe<Student_Assignment_Status>;
  /** insert data into the table: "student_assignments" */
  insert_student_assignments?: Maybe<Student_Assignments_Mutation_Response>;
  /** insert a single row into the table: "student_courses" */
  insert_student_course?: Maybe<Student_Courses>;
  /** insert data into the table: "student_course_status" */
  insert_student_course_status?: Maybe<Student_Course_Status_Mutation_Response>;
  /** insert a single row into the table: "student_course_status" */
  insert_student_course_status_one?: Maybe<Student_Course_Status>;
  /** insert data into the table: "student_courses" */
  insert_student_courses?: Maybe<Student_Courses_Mutation_Response>;
  /** insert a single row into the table: "student_events" */
  insert_student_event?: Maybe<Student_Events>;
  /** insert data into the table: "student_events" */
  insert_student_events?: Maybe<Student_Events_Mutation_Response>;
  /** insert data into the table: "students" */
  insert_students?: Maybe<Students_Mutation_Response>;
  /** insert a single row into the table: "teachers" */
  insert_teacher?: Maybe<Teachers>;
  /** insert data into the table: "teachers" */
  insert_teachers?: Maybe<Teachers_Mutation_Response>;
  /** insert data into the table: "teachers_students" */
  insert_teachers_students?: Maybe<Teachers_Students_Mutation_Response>;
  /** insert a single row into the table: "teachers_students" */
  insert_teachers_students_one?: Maybe<Teachers_Students>;
  /** insert data into the table: "themes" */
  insert_themes?: Maybe<Themes_Mutation_Response>;
  /** insert a single row into the table: "themes" */
  insert_themes_one?: Maybe<Themes>;
  /** insert data into the table: "user_settings" */
  insert_user_settings?: Maybe<User_Settings_Mutation_Response>;
  /** insert a single row into the table: "user_settings" */
  insert_user_settings_one?: Maybe<User_Settings>;
  /** update single row of the table: "assignments" */
  update_assignment?: Maybe<Assignments>;
  /** update data of the table: "assignment_type" */
  update_assignment_type?: Maybe<Assignment_Type_Mutation_Response>;
  /** update single row of the table: "assignment_type" */
  update_assignment_type_by_pk?: Maybe<Assignment_Type>;
  /** update multiples rows of table: "assignment_type" */
  update_assignment_type_many?: Maybe<Array<Maybe<Assignment_Type_Mutation_Response>>>;
  /** update single row of the table: "assignment_type_weights" */
  update_assignment_type_weight?: Maybe<Assignment_Type_Weights>;
  /** update data of the table: "assignment_type_weights" */
  update_assignment_type_weights?: Maybe<Assignment_Type_Weights_Mutation_Response>;
  /** update multiples rows of table: "assignment_type_weights" */
  update_assignment_type_weights_many?: Maybe<Array<Maybe<Assignment_Type_Weights_Mutation_Response>>>;
  /** update data of the table: "assignments" */
  update_assignments?: Maybe<Assignments_Mutation_Response>;
  /** update multiples rows of table: "assignments" */
  update_assignments_many?: Maybe<Array<Maybe<Assignments_Mutation_Response>>>;
  /** update single row of the table: "comments" */
  update_comment?: Maybe<Comments>;
  /** update data of the table: "comments" */
  update_comments?: Maybe<Comments_Mutation_Response>;
  /** update multiples rows of table: "comments" */
  update_comments_many?: Maybe<Array<Maybe<Comments_Mutation_Response>>>;
  /** update single row of the table: "courses" */
  update_course?: Maybe<Courses>;
  /** update data of the table: "courses" */
  update_courses?: Maybe<Courses_Mutation_Response>;
  /** update multiples rows of table: "courses" */
  update_courses_many?: Maybe<Array<Maybe<Courses_Mutation_Response>>>;
  /** update single row of the table: "custom_assignment_types" */
  update_custom_assignment_type?: Maybe<Custom_Assignment_Types>;
  /** update data of the table: "custom_assignment_types" */
  update_custom_assignment_types?: Maybe<Custom_Assignment_Types_Mutation_Response>;
  /** update multiples rows of table: "custom_assignment_types" */
  update_custom_assignment_types_many?: Maybe<Array<Maybe<Custom_Assignment_Types_Mutation_Response>>>;
  /** update single row of the table: "customers" */
  update_customer?: Maybe<Customers>;
  /** update data of the table: "customers" */
  update_customers?: Maybe<Customers_Mutation_Response>;
  /** update multiples rows of table: "customers" */
  update_customers_many?: Maybe<Array<Maybe<Customers_Mutation_Response>>>;
  /** update single row of the table: "events" */
  update_event?: Maybe<Events>;
  /** update data of the table: "event_t" */
  update_event_t?: Maybe<Event_T_Mutation_Response>;
  /** update multiples rows of table: "event_t" */
  update_event_t_many?: Maybe<Array<Maybe<Event_T_Mutation_Response>>>;
  /** update single row of the table: "event_t" */
  update_event_type?: Maybe<Event_T>;
  /** update data of the table: "events" */
  update_events?: Maybe<Events_Mutation_Response>;
  /** update multiples rows of table: "events" */
  update_events_many?: Maybe<Array<Maybe<Events_Mutation_Response>>>;
  /** update single row of the table: "files" */
  update_file?: Maybe<Files>;
  /** update data of the table: "files" */
  update_files?: Maybe<Files_Mutation_Response>;
  /** update multiples rows of table: "files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response>>>;
  /** update data of the table: "grading_style" */
  update_grading_style?: Maybe<Grading_Style_Mutation_Response>;
  /** update single row of the table: "grading_style" */
  update_grading_style_by_pk?: Maybe<Grading_Style>;
  /** update multiples rows of table: "grading_style" */
  update_grading_style_many?: Maybe<Array<Maybe<Grading_Style_Mutation_Response>>>;
  /** update single row of the table: "organizations" */
  update_organization?: Maybe<Organizations>;
  /** update single row of the table: "organization_admins" */
  update_organization_admin?: Maybe<Organization_Admins>;
  /** update data of the table: "organization_admins" */
  update_organization_admins?: Maybe<Organization_Admins_Mutation_Response>;
  /** update multiples rows of table: "organization_admins" */
  update_organization_admins_many?: Maybe<Array<Maybe<Organization_Admins_Mutation_Response>>>;
  /** update single row of the table: "organization_codes" */
  update_organization_code?: Maybe<Organization_Codes>;
  /** update data of the table: "organization_codes" */
  update_organization_codes?: Maybe<Organization_Codes_Mutation_Response>;
  /** update multiples rows of table: "organization_codes" */
  update_organization_codes_many?: Maybe<Array<Maybe<Organization_Codes_Mutation_Response>>>;
  /** update data of the table: "organizations" */
  update_organizations?: Maybe<Organizations_Mutation_Response>;
  /** update multiples rows of table: "organizations" */
  update_organizations_many?: Maybe<Array<Maybe<Organizations_Mutation_Response>>>;
  /** update single row of the table: "parrot_requests" */
  update_parrot_request?: Maybe<Parrot_Requests>;
  /** update data of the table: "parrot_request_status" */
  update_parrot_request_status?: Maybe<Parrot_Request_Status_Mutation_Response>;
  /** update single row of the table: "parrot_request_status" */
  update_parrot_request_status_by_pk?: Maybe<Parrot_Request_Status>;
  /** update multiples rows of table: "parrot_request_status" */
  update_parrot_request_status_many?: Maybe<Array<Maybe<Parrot_Request_Status_Mutation_Response>>>;
  /** update data of the table: "parrot_requests" */
  update_parrot_requests?: Maybe<Parrot_Requests_Mutation_Response>;
  /** update multiples rows of table: "parrot_requests" */
  update_parrot_requests_many?: Maybe<Array<Maybe<Parrot_Requests_Mutation_Response>>>;
  /** update data of the table: "plan_tier" */
  update_plan_tier?: Maybe<Plan_Tier_Mutation_Response>;
  /** update single row of the table: "plan_tier" */
  update_plan_tier_by_pk?: Maybe<Plan_Tier>;
  /** update multiples rows of table: "plan_tier" */
  update_plan_tier_many?: Maybe<Array<Maybe<Plan_Tier_Mutation_Response>>>;
  /** update single row of the table: "printing_jobs" */
  update_printing_job?: Maybe<Printing_Jobs>;
  /** update data of the table: "printing_job_status" */
  update_printing_job_status?: Maybe<Printing_Job_Status_Mutation_Response>;
  /** update single row of the table: "printing_job_status" */
  update_printing_job_status_by_pk?: Maybe<Printing_Job_Status>;
  /** update multiples rows of table: "printing_job_status" */
  update_printing_job_status_many?: Maybe<Array<Maybe<Printing_Job_Status_Mutation_Response>>>;
  /** update data of the table: "printing_job_type" */
  update_printing_job_type?: Maybe<Printing_Job_Type_Mutation_Response>;
  /** update single row of the table: "printing_job_type" */
  update_printing_job_type_by_pk?: Maybe<Printing_Job_Type>;
  /** update multiples rows of table: "printing_job_type" */
  update_printing_job_type_many?: Maybe<Array<Maybe<Printing_Job_Type_Mutation_Response>>>;
  /** update data of the table: "printing_jobs" */
  update_printing_jobs?: Maybe<Printing_Jobs_Mutation_Response>;
  /** update multiples rows of table: "printing_jobs" */
  update_printing_jobs_many?: Maybe<Array<Maybe<Printing_Jobs_Mutation_Response>>>;
  /** update data of the table: "school_year" */
  update_school_year?: Maybe<School_Year_Mutation_Response>;
  /** update single row of the table: "school_year" */
  update_school_year_by_pk?: Maybe<School_Year>;
  /** update multiples rows of table: "school_year" */
  update_school_year_many?: Maybe<Array<Maybe<School_Year_Mutation_Response>>>;
  /** update single row of the table: "students" */
  update_student?: Maybe<Students>;
  /** update single row of the table: "student_accounts" */
  update_student_account?: Maybe<Student_Accounts>;
  /** update data of the table: "student_accounts" */
  update_student_accounts?: Maybe<Student_Accounts_Mutation_Response>;
  /** update multiples rows of table: "student_accounts" */
  update_student_accounts_many?: Maybe<Array<Maybe<Student_Accounts_Mutation_Response>>>;
  /** update single row of the table: "student_assignments" */
  update_student_assignment?: Maybe<Student_Assignments>;
  /** update data of the table: "student_assignment_status" */
  update_student_assignment_status?: Maybe<Student_Assignment_Status_Mutation_Response>;
  /** update single row of the table: "student_assignment_status" */
  update_student_assignment_status_by_pk?: Maybe<Student_Assignment_Status>;
  /** update multiples rows of table: "student_assignment_status" */
  update_student_assignment_status_many?: Maybe<Array<Maybe<Student_Assignment_Status_Mutation_Response>>>;
  /** update data of the table: "student_assignments" */
  update_student_assignments?: Maybe<Student_Assignments_Mutation_Response>;
  /** update multiples rows of table: "student_assignments" */
  update_student_assignments_many?: Maybe<Array<Maybe<Student_Assignments_Mutation_Response>>>;
  /** update single row of the table: "student_courses" */
  update_student_course?: Maybe<Student_Courses>;
  /** update data of the table: "student_course_status" */
  update_student_course_status?: Maybe<Student_Course_Status_Mutation_Response>;
  /** update single row of the table: "student_course_status" */
  update_student_course_status_by_pk?: Maybe<Student_Course_Status>;
  /** update multiples rows of table: "student_course_status" */
  update_student_course_status_many?: Maybe<Array<Maybe<Student_Course_Status_Mutation_Response>>>;
  /** update data of the table: "student_courses" */
  update_student_courses?: Maybe<Student_Courses_Mutation_Response>;
  /** update multiples rows of table: "student_courses" */
  update_student_courses_many?: Maybe<Array<Maybe<Student_Courses_Mutation_Response>>>;
  /** update single row of the table: "student_events" */
  update_student_event?: Maybe<Student_Events>;
  /** update data of the table: "student_events" */
  update_student_events?: Maybe<Student_Events_Mutation_Response>;
  /** update multiples rows of table: "student_events" */
  update_student_events_many?: Maybe<Array<Maybe<Student_Events_Mutation_Response>>>;
  /** update data of the table: "students" */
  update_students?: Maybe<Students_Mutation_Response>;
  /** update multiples rows of table: "students" */
  update_students_many?: Maybe<Array<Maybe<Students_Mutation_Response>>>;
  /** update single row of the table: "teachers" */
  update_teacher?: Maybe<Teachers>;
  /** update data of the table: "teachers" */
  update_teachers?: Maybe<Teachers_Mutation_Response>;
  /** update multiples rows of table: "teachers" */
  update_teachers_many?: Maybe<Array<Maybe<Teachers_Mutation_Response>>>;
  /** update data of the table: "teachers_students" */
  update_teachers_students?: Maybe<Teachers_Students_Mutation_Response>;
  /** update single row of the table: "teachers_students" */
  update_teachers_students_by_pk?: Maybe<Teachers_Students>;
  /** update multiples rows of table: "teachers_students" */
  update_teachers_students_many?: Maybe<Array<Maybe<Teachers_Students_Mutation_Response>>>;
  /** update data of the table: "themes" */
  update_themes?: Maybe<Themes_Mutation_Response>;
  /** update single row of the table: "themes" */
  update_themes_by_pk?: Maybe<Themes>;
  /** update multiples rows of table: "themes" */
  update_themes_many?: Maybe<Array<Maybe<Themes_Mutation_Response>>>;
  /** update data of the table: "user_settings" */
  update_user_settings?: Maybe<User_Settings_Mutation_Response>;
  /** update single row of the table: "user_settings" */
  update_user_settings_by_pk?: Maybe<User_Settings>;
  /** update multiples rows of table: "user_settings" */
  update_user_settings_many?: Maybe<Array<Maybe<User_Settings_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_AssignmentArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Assignment_TypeArgs = {
  where: Assignment_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assignment_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Assignment_Type_WeightArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Assignment_Type_WeightsArgs = {
  where: Assignment_Type_Weights_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AssignmentsArgs = {
  where: Assignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CommentArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CommentsArgs = {
  where: Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CourseArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CoursesArgs = {
  where: Courses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Assignment_TypeArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_Assignment_TypesArgs = {
  where: Custom_Assignment_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CustomerArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CustomersArgs = {
  where: Customers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Event_TArgs = {
  where: Event_T_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Event_TypeArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EventsArgs = {
  where: Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_FileArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FilesArgs = {
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Grading_StyleArgs = {
  where: Grading_Style_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Grading_Style_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrganizationArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_AdminArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_AdminsArgs = {
  where: Organization_Admins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_CodeArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_CodesArgs = {
  where: Organization_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_OrganizationsArgs = {
  where: Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parrot_RequestArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parrot_Request_StatusArgs = {
  where: Parrot_Request_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parrot_Request_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parrot_RequestsArgs = {
  where: Parrot_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plan_TierArgs = {
  where: Plan_Tier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plan_Tier_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Printing_JobArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Printing_Job_StatusArgs = {
  where: Printing_Job_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Printing_Job_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Printing_Job_TypeArgs = {
  where: Printing_Job_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Printing_Job_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Printing_JobsArgs = {
  where: Printing_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_School_YearArgs = {
  where: School_Year_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_School_Year_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StudentArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Student_AccountArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Student_AccountsArgs = {
  where: Student_Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Student_AssignmentArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Student_Assignment_StatusArgs = {
  where: Student_Assignment_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Student_Assignment_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Student_AssignmentsArgs = {
  where: Student_Assignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Student_CourseArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Student_Course_StatusArgs = {
  where: Student_Course_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Student_Course_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Student_CoursesArgs = {
  where: Student_Courses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Student_EventArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Student_EventsArgs = {
  where: Student_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_StudentsArgs = {
  where: Students_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TeacherArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TeachersArgs = {
  where: Teachers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Teachers_StudentsArgs = {
  where: Teachers_Students_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Teachers_Students_By_PkArgs = {
  studentId: Scalars['String']['input'];
  teacherId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ThemesArgs = {
  where: Themes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Themes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_SettingsArgs = {
  where: User_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsert_AssignmentArgs = {
  object: Assignments_Insert_Input;
  on_conflict?: InputMaybe<Assignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_TypeArgs = {
  objects: Array<Assignment_Type_Insert_Input>;
  on_conflict?: InputMaybe<Assignment_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_Type_OneArgs = {
  object: Assignment_Type_Insert_Input;
  on_conflict?: InputMaybe<Assignment_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_Type_WeightArgs = {
  object: Assignment_Type_Weights_Insert_Input;
  on_conflict?: InputMaybe<Assignment_Type_Weights_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assignment_Type_WeightsArgs = {
  objects: Array<Assignment_Type_Weights_Insert_Input>;
  on_conflict?: InputMaybe<Assignment_Type_Weights_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AssignmentsArgs = {
  objects: Array<Assignments_Insert_Input>;
  on_conflict?: InputMaybe<Assignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CommentArgs = {
  object: Comments_Insert_Input;
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CommentsArgs = {
  objects: Array<Comments_Insert_Input>;
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CourseArgs = {
  object: Courses_Insert_Input;
  on_conflict?: InputMaybe<Courses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CoursesArgs = {
  objects: Array<Courses_Insert_Input>;
  on_conflict?: InputMaybe<Courses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Assignment_TypeArgs = {
  object: Custom_Assignment_Types_Insert_Input;
  on_conflict?: InputMaybe<Custom_Assignment_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Assignment_TypesArgs = {
  objects: Array<Custom_Assignment_Types_Insert_Input>;
  on_conflict?: InputMaybe<Custom_Assignment_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CustomerArgs = {
  object: Customers_Insert_Input;
  on_conflict?: InputMaybe<Customers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CustomersArgs = {
  objects: Array<Customers_Insert_Input>;
  on_conflict?: InputMaybe<Customers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventArgs = {
  object: Events_Insert_Input;
  on_conflict?: InputMaybe<Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_TArgs = {
  objects: Array<Event_T_Insert_Input>;
  on_conflict?: InputMaybe<Event_T_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Event_TypeArgs = {
  object: Event_T_Insert_Input;
  on_conflict?: InputMaybe<Event_T_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventsArgs = {
  objects: Array<Events_Insert_Input>;
  on_conflict?: InputMaybe<Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FileArgs = {
  object: Files_Insert_Input;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FilesArgs = {
  objects: Array<Files_Insert_Input>;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grading_StyleArgs = {
  objects: Array<Grading_Style_Insert_Input>;
  on_conflict?: InputMaybe<Grading_Style_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grading_Style_OneArgs = {
  object: Grading_Style_Insert_Input;
  on_conflict?: InputMaybe<Grading_Style_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganizationArgs = {
  object: Organizations_Insert_Input;
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_AdminArgs = {
  object: Organization_Admins_Insert_Input;
  on_conflict?: InputMaybe<Organization_Admins_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_AdminsArgs = {
  objects: Array<Organization_Admins_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Admins_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_CodeArgs = {
  object: Organization_Codes_Insert_Input;
  on_conflict?: InputMaybe<Organization_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_CodesArgs = {
  objects: Array<Organization_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganizationsArgs = {
  objects: Array<Organizations_Insert_Input>;
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parrot_RequestArgs = {
  object: Parrot_Requests_Insert_Input;
  on_conflict?: InputMaybe<Parrot_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parrot_Request_StatusArgs = {
  objects: Array<Parrot_Request_Status_Insert_Input>;
  on_conflict?: InputMaybe<Parrot_Request_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parrot_Request_Status_OneArgs = {
  object: Parrot_Request_Status_Insert_Input;
  on_conflict?: InputMaybe<Parrot_Request_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parrot_RequestsArgs = {
  objects: Array<Parrot_Requests_Insert_Input>;
  on_conflict?: InputMaybe<Parrot_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plan_TierArgs = {
  objects: Array<Plan_Tier_Insert_Input>;
  on_conflict?: InputMaybe<Plan_Tier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plan_Tier_OneArgs = {
  object: Plan_Tier_Insert_Input;
  on_conflict?: InputMaybe<Plan_Tier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printing_JobArgs = {
  object: Printing_Jobs_Insert_Input;
  on_conflict?: InputMaybe<Printing_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printing_Job_StatusArgs = {
  objects: Array<Printing_Job_Status_Insert_Input>;
  on_conflict?: InputMaybe<Printing_Job_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printing_Job_Status_OneArgs = {
  object: Printing_Job_Status_Insert_Input;
  on_conflict?: InputMaybe<Printing_Job_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printing_Job_TypeArgs = {
  objects: Array<Printing_Job_Type_Insert_Input>;
  on_conflict?: InputMaybe<Printing_Job_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printing_Job_Type_OneArgs = {
  object: Printing_Job_Type_Insert_Input;
  on_conflict?: InputMaybe<Printing_Job_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printing_JobsArgs = {
  objects: Array<Printing_Jobs_Insert_Input>;
  on_conflict?: InputMaybe<Printing_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_School_YearArgs = {
  objects: Array<School_Year_Insert_Input>;
  on_conflict?: InputMaybe<School_Year_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_School_Year_OneArgs = {
  object: School_Year_Insert_Input;
  on_conflict?: InputMaybe<School_Year_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StudentArgs = {
  object: Students_Insert_Input;
  on_conflict?: InputMaybe<Students_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_AccountArgs = {
  object: Student_Accounts_Insert_Input;
  on_conflict?: InputMaybe<Student_Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_AccountsArgs = {
  objects: Array<Student_Accounts_Insert_Input>;
  on_conflict?: InputMaybe<Student_Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_AssignmentArgs = {
  object: Student_Assignments_Insert_Input;
  on_conflict?: InputMaybe<Student_Assignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_Assignment_StatusArgs = {
  objects: Array<Student_Assignment_Status_Insert_Input>;
  on_conflict?: InputMaybe<Student_Assignment_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_Assignment_Status_OneArgs = {
  object: Student_Assignment_Status_Insert_Input;
  on_conflict?: InputMaybe<Student_Assignment_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_AssignmentsArgs = {
  objects: Array<Student_Assignments_Insert_Input>;
  on_conflict?: InputMaybe<Student_Assignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_CourseArgs = {
  object: Student_Courses_Insert_Input;
  on_conflict?: InputMaybe<Student_Courses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_Course_StatusArgs = {
  objects: Array<Student_Course_Status_Insert_Input>;
  on_conflict?: InputMaybe<Student_Course_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_Course_Status_OneArgs = {
  object: Student_Course_Status_Insert_Input;
  on_conflict?: InputMaybe<Student_Course_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_CoursesArgs = {
  objects: Array<Student_Courses_Insert_Input>;
  on_conflict?: InputMaybe<Student_Courses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_EventArgs = {
  object: Student_Events_Insert_Input;
  on_conflict?: InputMaybe<Student_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Student_EventsArgs = {
  objects: Array<Student_Events_Insert_Input>;
  on_conflict?: InputMaybe<Student_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StudentsArgs = {
  objects: Array<Students_Insert_Input>;
  on_conflict?: InputMaybe<Students_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TeacherArgs = {
  object: Teachers_Insert_Input;
  on_conflict?: InputMaybe<Teachers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TeachersArgs = {
  objects: Array<Teachers_Insert_Input>;
  on_conflict?: InputMaybe<Teachers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teachers_StudentsArgs = {
  objects: Array<Teachers_Students_Insert_Input>;
  on_conflict?: InputMaybe<Teachers_Students_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teachers_Students_OneArgs = {
  object: Teachers_Students_Insert_Input;
  on_conflict?: InputMaybe<Teachers_Students_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ThemesArgs = {
  objects: Array<Themes_Insert_Input>;
  on_conflict?: InputMaybe<Themes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Themes_OneArgs = {
  object: Themes_Insert_Input;
  on_conflict?: InputMaybe<Themes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_SettingsArgs = {
  objects: Array<User_Settings_Insert_Input>;
  on_conflict?: InputMaybe<User_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Settings_OneArgs = {
  object: User_Settings_Insert_Input;
  on_conflict?: InputMaybe<User_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_AssignmentArgs = {
  _inc?: InputMaybe<Assignments_Inc_Input>;
  _set?: InputMaybe<Assignments_Set_Input>;
  pk_columns: Assignments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_TypeArgs = {
  _set?: InputMaybe<Assignment_Type_Set_Input>;
  where: Assignment_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Type_By_PkArgs = {
  _set?: InputMaybe<Assignment_Type_Set_Input>;
  pk_columns: Assignment_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Type_ManyArgs = {
  updates: Array<Assignment_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Type_WeightArgs = {
  _inc?: InputMaybe<Assignment_Type_Weights_Inc_Input>;
  _set?: InputMaybe<Assignment_Type_Weights_Set_Input>;
  pk_columns: Assignment_Type_Weights_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Type_WeightsArgs = {
  _inc?: InputMaybe<Assignment_Type_Weights_Inc_Input>;
  _set?: InputMaybe<Assignment_Type_Weights_Set_Input>;
  where: Assignment_Type_Weights_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assignment_Type_Weights_ManyArgs = {
  updates: Array<Assignment_Type_Weights_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AssignmentsArgs = {
  _inc?: InputMaybe<Assignments_Inc_Input>;
  _set?: InputMaybe<Assignments_Set_Input>;
  where: Assignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assignments_ManyArgs = {
  updates: Array<Assignments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CommentArgs = {
  _set?: InputMaybe<Comments_Set_Input>;
  pk_columns: Comments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CommentsArgs = {
  _set?: InputMaybe<Comments_Set_Input>;
  where: Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Comments_ManyArgs = {
  updates: Array<Comments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CourseArgs = {
  _append?: InputMaybe<Courses_Append_Input>;
  _delete_at_path?: InputMaybe<Courses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Courses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Courses_Delete_Key_Input>;
  _inc?: InputMaybe<Courses_Inc_Input>;
  _prepend?: InputMaybe<Courses_Prepend_Input>;
  _set?: InputMaybe<Courses_Set_Input>;
  pk_columns: Courses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CoursesArgs = {
  _append?: InputMaybe<Courses_Append_Input>;
  _delete_at_path?: InputMaybe<Courses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Courses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Courses_Delete_Key_Input>;
  _inc?: InputMaybe<Courses_Inc_Input>;
  _prepend?: InputMaybe<Courses_Prepend_Input>;
  _set?: InputMaybe<Courses_Set_Input>;
  where: Courses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Courses_ManyArgs = {
  updates: Array<Courses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Assignment_TypeArgs = {
  _inc?: InputMaybe<Custom_Assignment_Types_Inc_Input>;
  _set?: InputMaybe<Custom_Assignment_Types_Set_Input>;
  pk_columns: Custom_Assignment_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Assignment_TypesArgs = {
  _inc?: InputMaybe<Custom_Assignment_Types_Inc_Input>;
  _set?: InputMaybe<Custom_Assignment_Types_Set_Input>;
  where: Custom_Assignment_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Assignment_Types_ManyArgs = {
  updates: Array<Custom_Assignment_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CustomerArgs = {
  _inc?: InputMaybe<Customers_Inc_Input>;
  _set?: InputMaybe<Customers_Set_Input>;
  pk_columns: Customers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CustomersArgs = {
  _inc?: InputMaybe<Customers_Inc_Input>;
  _set?: InputMaybe<Customers_Set_Input>;
  where: Customers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customers_ManyArgs = {
  updates: Array<Customers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventArgs = {
  _set?: InputMaybe<Events_Set_Input>;
  pk_columns: Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Event_TArgs = {
  _set?: InputMaybe<Event_T_Set_Input>;
  where: Event_T_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Event_T_ManyArgs = {
  updates: Array<Event_T_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Event_TypeArgs = {
  _set?: InputMaybe<Event_T_Set_Input>;
  pk_columns: Event_T_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventsArgs = {
  _set?: InputMaybe<Events_Set_Input>;
  where: Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Events_ManyArgs = {
  updates: Array<Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FileArgs = {
  _inc?: InputMaybe<Files_Inc_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  pk_columns: Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_FilesArgs = {
  _inc?: InputMaybe<Files_Inc_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs = {
  updates: Array<Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Grading_StyleArgs = {
  _set?: InputMaybe<Grading_Style_Set_Input>;
  where: Grading_Style_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Grading_Style_By_PkArgs = {
  _set?: InputMaybe<Grading_Style_Set_Input>;
  pk_columns: Grading_Style_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Grading_Style_ManyArgs = {
  updates: Array<Grading_Style_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganizationArgs = {
  _inc?: InputMaybe<Organizations_Inc_Input>;
  _set?: InputMaybe<Organizations_Set_Input>;
  pk_columns: Organizations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_AdminArgs = {
  _set?: InputMaybe<Organization_Admins_Set_Input>;
  pk_columns: Organization_Admins_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_AdminsArgs = {
  _set?: InputMaybe<Organization_Admins_Set_Input>;
  where: Organization_Admins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Admins_ManyArgs = {
  updates: Array<Organization_Admins_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_CodeArgs = {
  _set?: InputMaybe<Organization_Codes_Set_Input>;
  pk_columns: Organization_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_CodesArgs = {
  _set?: InputMaybe<Organization_Codes_Set_Input>;
  where: Organization_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Codes_ManyArgs = {
  updates: Array<Organization_Codes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganizationsArgs = {
  _inc?: InputMaybe<Organizations_Inc_Input>;
  _set?: InputMaybe<Organizations_Set_Input>;
  where: Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_ManyArgs = {
  updates: Array<Organizations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parrot_RequestArgs = {
  _inc?: InputMaybe<Parrot_Requests_Inc_Input>;
  _set?: InputMaybe<Parrot_Requests_Set_Input>;
  pk_columns: Parrot_Requests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parrot_Request_StatusArgs = {
  _set?: InputMaybe<Parrot_Request_Status_Set_Input>;
  where: Parrot_Request_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parrot_Request_Status_By_PkArgs = {
  _set?: InputMaybe<Parrot_Request_Status_Set_Input>;
  pk_columns: Parrot_Request_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parrot_Request_Status_ManyArgs = {
  updates: Array<Parrot_Request_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parrot_RequestsArgs = {
  _inc?: InputMaybe<Parrot_Requests_Inc_Input>;
  _set?: InputMaybe<Parrot_Requests_Set_Input>;
  where: Parrot_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parrot_Requests_ManyArgs = {
  updates: Array<Parrot_Requests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_TierArgs = {
  _set?: InputMaybe<Plan_Tier_Set_Input>;
  where: Plan_Tier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_Tier_By_PkArgs = {
  _set?: InputMaybe<Plan_Tier_Set_Input>;
  pk_columns: Plan_Tier_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plan_Tier_ManyArgs = {
  updates: Array<Plan_Tier_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_JobArgs = {
  _append?: InputMaybe<Printing_Jobs_Append_Input>;
  _delete_at_path?: InputMaybe<Printing_Jobs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Printing_Jobs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Printing_Jobs_Delete_Key_Input>;
  _prepend?: InputMaybe<Printing_Jobs_Prepend_Input>;
  _set?: InputMaybe<Printing_Jobs_Set_Input>;
  pk_columns: Printing_Jobs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_Job_StatusArgs = {
  _set?: InputMaybe<Printing_Job_Status_Set_Input>;
  where: Printing_Job_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_Job_Status_By_PkArgs = {
  _set?: InputMaybe<Printing_Job_Status_Set_Input>;
  pk_columns: Printing_Job_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_Job_Status_ManyArgs = {
  updates: Array<Printing_Job_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_Job_TypeArgs = {
  _set?: InputMaybe<Printing_Job_Type_Set_Input>;
  where: Printing_Job_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_Job_Type_By_PkArgs = {
  _set?: InputMaybe<Printing_Job_Type_Set_Input>;
  pk_columns: Printing_Job_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_Job_Type_ManyArgs = {
  updates: Array<Printing_Job_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_JobsArgs = {
  _append?: InputMaybe<Printing_Jobs_Append_Input>;
  _delete_at_path?: InputMaybe<Printing_Jobs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Printing_Jobs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Printing_Jobs_Delete_Key_Input>;
  _prepend?: InputMaybe<Printing_Jobs_Prepend_Input>;
  _set?: InputMaybe<Printing_Jobs_Set_Input>;
  where: Printing_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Printing_Jobs_ManyArgs = {
  updates: Array<Printing_Jobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_School_YearArgs = {
  _set?: InputMaybe<School_Year_Set_Input>;
  where: School_Year_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_School_Year_By_PkArgs = {
  _set?: InputMaybe<School_Year_Set_Input>;
  pk_columns: School_Year_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_School_Year_ManyArgs = {
  updates: Array<School_Year_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StudentArgs = {
  _set?: InputMaybe<Students_Set_Input>;
  pk_columns: Students_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Student_AccountArgs = {
  _set?: InputMaybe<Student_Accounts_Set_Input>;
  pk_columns: Student_Accounts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Student_AccountsArgs = {
  _set?: InputMaybe<Student_Accounts_Set_Input>;
  where: Student_Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Accounts_ManyArgs = {
  updates: Array<Student_Accounts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Student_AssignmentArgs = {
  _inc?: InputMaybe<Student_Assignments_Inc_Input>;
  _set?: InputMaybe<Student_Assignments_Set_Input>;
  pk_columns: Student_Assignments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Assignment_StatusArgs = {
  _set?: InputMaybe<Student_Assignment_Status_Set_Input>;
  where: Student_Assignment_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Assignment_Status_By_PkArgs = {
  _set?: InputMaybe<Student_Assignment_Status_Set_Input>;
  pk_columns: Student_Assignment_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Assignment_Status_ManyArgs = {
  updates: Array<Student_Assignment_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Student_AssignmentsArgs = {
  _inc?: InputMaybe<Student_Assignments_Inc_Input>;
  _set?: InputMaybe<Student_Assignments_Set_Input>;
  where: Student_Assignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Assignments_ManyArgs = {
  updates: Array<Student_Assignments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Student_CourseArgs = {
  _append?: InputMaybe<Student_Courses_Append_Input>;
  _delete_at_path?: InputMaybe<Student_Courses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Student_Courses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Student_Courses_Delete_Key_Input>;
  _prepend?: InputMaybe<Student_Courses_Prepend_Input>;
  _set?: InputMaybe<Student_Courses_Set_Input>;
  pk_columns: Student_Courses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Course_StatusArgs = {
  _set?: InputMaybe<Student_Course_Status_Set_Input>;
  where: Student_Course_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Course_Status_By_PkArgs = {
  _set?: InputMaybe<Student_Course_Status_Set_Input>;
  pk_columns: Student_Course_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Course_Status_ManyArgs = {
  updates: Array<Student_Course_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Student_CoursesArgs = {
  _append?: InputMaybe<Student_Courses_Append_Input>;
  _delete_at_path?: InputMaybe<Student_Courses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Student_Courses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Student_Courses_Delete_Key_Input>;
  _prepend?: InputMaybe<Student_Courses_Prepend_Input>;
  _set?: InputMaybe<Student_Courses_Set_Input>;
  where: Student_Courses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Courses_ManyArgs = {
  updates: Array<Student_Courses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Student_EventArgs = {
  _set?: InputMaybe<Student_Events_Set_Input>;
  pk_columns: Student_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Student_EventsArgs = {
  _set?: InputMaybe<Student_Events_Set_Input>;
  where: Student_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Student_Events_ManyArgs = {
  updates: Array<Student_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StudentsArgs = {
  _set?: InputMaybe<Students_Set_Input>;
  where: Students_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Students_ManyArgs = {
  updates: Array<Students_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TeacherArgs = {
  _set?: InputMaybe<Teachers_Set_Input>;
  pk_columns: Teachers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TeachersArgs = {
  _set?: InputMaybe<Teachers_Set_Input>;
  where: Teachers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teachers_ManyArgs = {
  updates: Array<Teachers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Teachers_StudentsArgs = {
  _set?: InputMaybe<Teachers_Students_Set_Input>;
  where: Teachers_Students_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teachers_Students_By_PkArgs = {
  _set?: InputMaybe<Teachers_Students_Set_Input>;
  pk_columns: Teachers_Students_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Teachers_Students_ManyArgs = {
  updates: Array<Teachers_Students_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ThemesArgs = {
  _append?: InputMaybe<Themes_Append_Input>;
  _delete_at_path?: InputMaybe<Themes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Themes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Themes_Delete_Key_Input>;
  _inc?: InputMaybe<Themes_Inc_Input>;
  _prepend?: InputMaybe<Themes_Prepend_Input>;
  _set?: InputMaybe<Themes_Set_Input>;
  where: Themes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Themes_By_PkArgs = {
  _append?: InputMaybe<Themes_Append_Input>;
  _delete_at_path?: InputMaybe<Themes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Themes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Themes_Delete_Key_Input>;
  _inc?: InputMaybe<Themes_Inc_Input>;
  _prepend?: InputMaybe<Themes_Prepend_Input>;
  _set?: InputMaybe<Themes_Set_Input>;
  pk_columns: Themes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Themes_ManyArgs = {
  updates: Array<Themes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_SettingsArgs = {
  _set?: InputMaybe<User_Settings_Set_Input>;
  where: User_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Settings_By_PkArgs = {
  _set?: InputMaybe<User_Settings_Set_Input>;
  pk_columns: User_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Settings_ManyArgs = {
  updates: Array<User_Settings_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "organization_admins" */
export type Organization_Admins = {
  __typename?: 'organization_admins';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** An object relationship */
  organization: Organizations;
  organizationId: Scalars['uuid']['output'];
};

/** aggregated selection of "organization_admins" */
export type Organization_Admins_Aggregate = {
  __typename?: 'organization_admins_aggregate';
  aggregate?: Maybe<Organization_Admins_Aggregate_Fields>;
  nodes: Array<Organization_Admins>;
};

export type Organization_Admins_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Admins_Aggregate_Bool_Exp_Count>;
};

export type Organization_Admins_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Admins_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_admins" */
export type Organization_Admins_Aggregate_Fields = {
  __typename?: 'organization_admins_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Admins_Max_Fields>;
  min?: Maybe<Organization_Admins_Min_Fields>;
};


/** aggregate fields of "organization_admins" */
export type Organization_Admins_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_admins" */
export type Organization_Admins_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Admins_Max_Order_By>;
  min?: InputMaybe<Organization_Admins_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_admins" */
export type Organization_Admins_Arr_Rel_Insert_Input = {
  data: Array<Organization_Admins_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Admins_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_admins". All fields are combined with a logical 'AND'. */
export type Organization_Admins_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Admins_Bool_Exp>>;
  _not?: InputMaybe<Organization_Admins_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Admins_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_admins" */
export enum Organization_Admins_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationAdminsPkey = 'organization_admins_pkey'
}

/** input type for inserting data into table "organization_admins" */
export type Organization_Admins_Insert_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organization_Admins_Max_Fields = {
  __typename?: 'organization_admins_max_fields';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "organization_admins" */
export type Organization_Admins_Max_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Admins_Min_Fields = {
  __typename?: 'organization_admins_min_fields';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "organization_admins" */
export type Organization_Admins_Min_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_admins" */
export type Organization_Admins_Mutation_Response = {
  __typename?: 'organization_admins_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Admins>;
};

/** on_conflict condition type for table "organization_admins" */
export type Organization_Admins_On_Conflict = {
  constraint: Organization_Admins_Constraint;
  update_columns?: Array<Organization_Admins_Update_Column>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_admins". */
export type Organization_Admins_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organizationId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_admins */
export type Organization_Admins_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "organization_admins" */
export enum Organization_Admins_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId'
}

/** input type for updating data in table "organization_admins" */
export type Organization_Admins_Set_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "organization_admins" */
export type Organization_Admins_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Admins_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Admins_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organization_admins" */
export enum Organization_Admins_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId'
}

export type Organization_Admins_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Admins_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Admins_Bool_Exp;
};

/** columns and relationships of "organization_codes" */
export type Organization_Codes = {
  __typename?: 'organization_codes';
  code: Scalars['String']['output'];
  /** Temporarily nullable to backfill data for existing rows before making it non-nullable */
  created?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organization: Organizations;
  organizationId: Scalars['uuid']['output'];
  originalUserEmail?: Maybe<Scalars['String']['output']>;
  subscriptionExpiration?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  teacher?: Maybe<Teachers>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "organization_codes" */
export type Organization_Codes_Aggregate = {
  __typename?: 'organization_codes_aggregate';
  aggregate?: Maybe<Organization_Codes_Aggregate_Fields>;
  nodes: Array<Organization_Codes>;
};

export type Organization_Codes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Codes_Aggregate_Bool_Exp_Count>;
};

export type Organization_Codes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Codes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_codes" */
export type Organization_Codes_Aggregate_Fields = {
  __typename?: 'organization_codes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Codes_Max_Fields>;
  min?: Maybe<Organization_Codes_Min_Fields>;
};


/** aggregate fields of "organization_codes" */
export type Organization_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_codes" */
export type Organization_Codes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Codes_Max_Order_By>;
  min?: InputMaybe<Organization_Codes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_codes" */
export type Organization_Codes_Arr_Rel_Insert_Input = {
  data: Array<Organization_Codes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Codes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_codes". All fields are combined with a logical 'AND'. */
export type Organization_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Codes_Bool_Exp>>;
  _not?: InputMaybe<Organization_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Codes_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
  originalUserEmail?: InputMaybe<String_Comparison_Exp>;
  subscriptionExpiration?: InputMaybe<Timestamptz_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_codes" */
export enum Organization_Codes_Constraint {
  /** unique or primary key constraint on columns "code" */
  OrganizationCodesCodeKey = 'organization_codes_code_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationCodesPkey = 'organization_codes_pkey'
}

/** input type for inserting data into table "organization_codes" */
export type Organization_Codes_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  /** Temporarily nullable to backfill data for existing rows before making it non-nullable */
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  originalUserEmail?: InputMaybe<Scalars['String']['input']>;
  subscriptionExpiration?: InputMaybe<Scalars['timestamptz']['input']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Organization_Codes_Max_Fields = {
  __typename?: 'organization_codes_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  /** Temporarily nullable to backfill data for existing rows before making it non-nullable */
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  originalUserEmail?: Maybe<Scalars['String']['output']>;
  subscriptionExpiration?: Maybe<Scalars['timestamptz']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "organization_codes" */
export type Organization_Codes_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  /** Temporarily nullable to backfill data for existing rows before making it non-nullable */
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  originalUserEmail?: InputMaybe<Order_By>;
  subscriptionExpiration?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Codes_Min_Fields = {
  __typename?: 'organization_codes_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  /** Temporarily nullable to backfill data for existing rows before making it non-nullable */
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  originalUserEmail?: Maybe<Scalars['String']['output']>;
  subscriptionExpiration?: Maybe<Scalars['timestamptz']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "organization_codes" */
export type Organization_Codes_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  /** Temporarily nullable to backfill data for existing rows before making it non-nullable */
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  originalUserEmail?: InputMaybe<Order_By>;
  subscriptionExpiration?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_codes" */
export type Organization_Codes_Mutation_Response = {
  __typename?: 'organization_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Codes>;
};

/** on_conflict condition type for table "organization_codes" */
export type Organization_Codes_On_Conflict = {
  constraint: Organization_Codes_Constraint;
  update_columns?: Array<Organization_Codes_Update_Column>;
  where?: InputMaybe<Organization_Codes_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_codes". */
export type Organization_Codes_Order_By = {
  code?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  originalUserEmail?: InputMaybe<Order_By>;
  subscriptionExpiration?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_codes */
export type Organization_Codes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_codes" */
export enum Organization_Codes_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  OriginalUserEmail = 'originalUserEmail',
  /** column name */
  SubscriptionExpiration = 'subscriptionExpiration',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "organization_codes" */
export type Organization_Codes_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  /** Temporarily nullable to backfill data for existing rows before making it non-nullable */
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  originalUserEmail?: InputMaybe<Scalars['String']['input']>;
  subscriptionExpiration?: InputMaybe<Scalars['timestamptz']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "organization_codes" */
export type Organization_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Codes_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  /** Temporarily nullable to backfill data for existing rows before making it non-nullable */
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  originalUserEmail?: InputMaybe<Scalars['String']['input']>;
  subscriptionExpiration?: InputMaybe<Scalars['timestamptz']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organization_codes" */
export enum Organization_Codes_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  OriginalUserEmail = 'originalUserEmail',
  /** column name */
  SubscriptionExpiration = 'subscriptionExpiration',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

export type Organization_Codes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Codes_Bool_Exp;
};

/** columns and relationships of "organizations" */
export type Organizations = {
  __typename?: 'organizations';
  /** An array relationship */
  courses: Array<Courses>;
  /** An aggregate relationship */
  courses_aggregate: Courses_Aggregate;
  freeEmails?: Maybe<Array<Scalars['String']['output']>>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  ignoredEmails?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  numberOfSeatsAvailable?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  organizationAdmins: Array<Organization_Admins>;
  /** An aggregate relationship */
  organizationAdmins_aggregate: Organization_Admins_Aggregate;
  /** An array relationship */
  organizationCodes: Array<Organization_Codes>;
  /** An aggregate relationship */
  organizationCodes_aggregate: Organization_Codes_Aggregate;
  supportLink?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  teachers: Array<Teachers>;
  /** An aggregate relationship */
  teachers_aggregate: Teachers_Aggregate;
  /** An object relationship */
  theme?: Maybe<Themes>;
  themeId?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "organizations" */
export type OrganizationsCoursesArgs = {
  distinct_on?: InputMaybe<Array<Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Courses_Order_By>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Courses_Order_By>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganizationAdminsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganizationAdmins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganizationCodesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Codes_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganizationCodes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Codes_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsTeachersArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Order_By>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsTeachers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Order_By>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};

/** aggregated selection of "organizations" */
export type Organizations_Aggregate = {
  __typename?: 'organizations_aggregate';
  aggregate?: Maybe<Organizations_Aggregate_Fields>;
  nodes: Array<Organizations>;
};

export type Organizations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organizations_Aggregate_Bool_Exp_Count>;
};

export type Organizations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organizations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organizations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organizations" */
export type Organizations_Aggregate_Fields = {
  __typename?: 'organizations_aggregate_fields';
  avg?: Maybe<Organizations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organizations_Max_Fields>;
  min?: Maybe<Organizations_Min_Fields>;
  stddev?: Maybe<Organizations_Stddev_Fields>;
  stddev_pop?: Maybe<Organizations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organizations_Stddev_Samp_Fields>;
  sum?: Maybe<Organizations_Sum_Fields>;
  var_pop?: Maybe<Organizations_Var_Pop_Fields>;
  var_samp?: Maybe<Organizations_Var_Samp_Fields>;
  variance?: Maybe<Organizations_Variance_Fields>;
};


/** aggregate fields of "organizations" */
export type Organizations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organizations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organizations" */
export type Organizations_Aggregate_Order_By = {
  avg?: InputMaybe<Organizations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organizations_Max_Order_By>;
  min?: InputMaybe<Organizations_Min_Order_By>;
  stddev?: InputMaybe<Organizations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organizations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organizations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organizations_Sum_Order_By>;
  var_pop?: InputMaybe<Organizations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organizations_Var_Samp_Order_By>;
  variance?: InputMaybe<Organizations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organizations" */
export type Organizations_Arr_Rel_Insert_Input = {
  data: Array<Organizations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};

/** aggregate avg on columns */
export type Organizations_Avg_Fields = {
  __typename?: 'organizations_avg_fields';
  numberOfSeatsAvailable?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organizations" */
export type Organizations_Avg_Order_By = {
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organizations". All fields are combined with a logical 'AND'. */
export type Organizations_Bool_Exp = {
  _and?: InputMaybe<Array<Organizations_Bool_Exp>>;
  _not?: InputMaybe<Organizations_Bool_Exp>;
  _or?: InputMaybe<Array<Organizations_Bool_Exp>>;
  courses?: InputMaybe<Courses_Bool_Exp>;
  courses_aggregate?: InputMaybe<Courses_Aggregate_Bool_Exp>;
  freeEmails?: InputMaybe<String_Array_Comparison_Exp>;
  icon?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ignoredEmails?: InputMaybe<String_Array_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  numberOfSeatsAvailable?: InputMaybe<Int_Comparison_Exp>;
  organizationAdmins?: InputMaybe<Organization_Admins_Bool_Exp>;
  organizationAdmins_aggregate?: InputMaybe<Organization_Admins_Aggregate_Bool_Exp>;
  organizationCodes?: InputMaybe<Organization_Codes_Bool_Exp>;
  organizationCodes_aggregate?: InputMaybe<Organization_Codes_Aggregate_Bool_Exp>;
  supportLink?: InputMaybe<String_Comparison_Exp>;
  teachers?: InputMaybe<Teachers_Bool_Exp>;
  teachers_aggregate?: InputMaybe<Teachers_Aggregate_Bool_Exp>;
  theme?: InputMaybe<Themes_Bool_Exp>;
  themeId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organizations" */
export enum Organizations_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationsPkey = 'organizations_pkey'
}

/** input type for incrementing numeric columns in table "organizations" */
export type Organizations_Inc_Input = {
  numberOfSeatsAvailable?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organizations" */
export type Organizations_Insert_Input = {
  courses?: InputMaybe<Courses_Arr_Rel_Insert_Input>;
  freeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ignoredEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfSeatsAvailable?: InputMaybe<Scalars['Int']['input']>;
  organizationAdmins?: InputMaybe<Organization_Admins_Arr_Rel_Insert_Input>;
  organizationCodes?: InputMaybe<Organization_Codes_Arr_Rel_Insert_Input>;
  supportLink?: InputMaybe<Scalars['String']['input']>;
  teachers?: InputMaybe<Teachers_Arr_Rel_Insert_Input>;
  theme?: InputMaybe<Themes_Obj_Rel_Insert_Input>;
  themeId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Organizations_Max_Fields = {
  __typename?: 'organizations_max_fields';
  freeEmails?: Maybe<Array<Scalars['String']['output']>>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ignoredEmails?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfSeatsAvailable?: Maybe<Scalars['Int']['output']>;
  supportLink?: Maybe<Scalars['String']['output']>;
  themeId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "organizations" */
export type Organizations_Max_Order_By = {
  freeEmails?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ignoredEmails?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
  supportLink?: InputMaybe<Order_By>;
  themeId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organizations_Min_Fields = {
  __typename?: 'organizations_min_fields';
  freeEmails?: Maybe<Array<Scalars['String']['output']>>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ignoredEmails?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfSeatsAvailable?: Maybe<Scalars['Int']['output']>;
  supportLink?: Maybe<Scalars['String']['output']>;
  themeId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "organizations" */
export type Organizations_Min_Order_By = {
  freeEmails?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ignoredEmails?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
  supportLink?: InputMaybe<Order_By>;
  themeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organizations" */
export type Organizations_Mutation_Response = {
  __typename?: 'organizations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organizations>;
};

/** input type for inserting object relation for remote table "organizations" */
export type Organizations_Obj_Rel_Insert_Input = {
  data: Organizations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};

/** on_conflict condition type for table "organizations" */
export type Organizations_On_Conflict = {
  constraint: Organizations_Constraint;
  update_columns?: Array<Organizations_Update_Column>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};

/** Ordering options when selecting data from "organizations". */
export type Organizations_Order_By = {
  courses_aggregate?: InputMaybe<Courses_Aggregate_Order_By>;
  freeEmails?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ignoredEmails?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
  organizationAdmins_aggregate?: InputMaybe<Organization_Admins_Aggregate_Order_By>;
  organizationCodes_aggregate?: InputMaybe<Organization_Codes_Aggregate_Order_By>;
  supportLink?: InputMaybe<Order_By>;
  teachers_aggregate?: InputMaybe<Teachers_Aggregate_Order_By>;
  theme?: InputMaybe<Themes_Order_By>;
  themeId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organizations */
export type Organizations_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organizations" */
export enum Organizations_Select_Column {
  /** column name */
  FreeEmails = 'freeEmails',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  IgnoredEmails = 'ignoredEmails',
  /** column name */
  Name = 'name',
  /** column name */
  NumberOfSeatsAvailable = 'numberOfSeatsAvailable',
  /** column name */
  SupportLink = 'supportLink',
  /** column name */
  ThemeId = 'themeId'
}

/** input type for updating data in table "organizations" */
export type Organizations_Set_Input = {
  freeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ignoredEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfSeatsAvailable?: InputMaybe<Scalars['Int']['input']>;
  supportLink?: InputMaybe<Scalars['String']['input']>;
  themeId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Organizations_Stddev_Fields = {
  __typename?: 'organizations_stddev_fields';
  numberOfSeatsAvailable?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organizations" */
export type Organizations_Stddev_Order_By = {
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organizations_Stddev_Pop_Fields = {
  __typename?: 'organizations_stddev_pop_fields';
  numberOfSeatsAvailable?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organizations" */
export type Organizations_Stddev_Pop_Order_By = {
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organizations_Stddev_Samp_Fields = {
  __typename?: 'organizations_stddev_samp_fields';
  numberOfSeatsAvailable?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organizations" */
export type Organizations_Stddev_Samp_Order_By = {
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organizations" */
export type Organizations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organizations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organizations_Stream_Cursor_Value_Input = {
  freeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ignoredEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfSeatsAvailable?: InputMaybe<Scalars['Int']['input']>;
  supportLink?: InputMaybe<Scalars['String']['input']>;
  themeId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Organizations_Sum_Fields = {
  __typename?: 'organizations_sum_fields';
  numberOfSeatsAvailable?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "organizations" */
export type Organizations_Sum_Order_By = {
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
};

/** update columns of table "organizations" */
export enum Organizations_Update_Column {
  /** column name */
  FreeEmails = 'freeEmails',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  IgnoredEmails = 'ignoredEmails',
  /** column name */
  Name = 'name',
  /** column name */
  NumberOfSeatsAvailable = 'numberOfSeatsAvailable',
  /** column name */
  SupportLink = 'supportLink',
  /** column name */
  ThemeId = 'themeId'
}

export type Organizations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organizations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organizations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organizations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organizations_Var_Pop_Fields = {
  __typename?: 'organizations_var_pop_fields';
  numberOfSeatsAvailable?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organizations" */
export type Organizations_Var_Pop_Order_By = {
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organizations_Var_Samp_Fields = {
  __typename?: 'organizations_var_samp_fields';
  numberOfSeatsAvailable?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organizations" */
export type Organizations_Var_Samp_Order_By = {
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organizations_Variance_Fields = {
  __typename?: 'organizations_variance_fields';
  numberOfSeatsAvailable?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organizations" */
export type Organizations_Variance_Order_By = {
  numberOfSeatsAvailable?: InputMaybe<Order_By>;
};

/** columns and relationships of "parrot_request_status" */
export type Parrot_Request_Status = {
  __typename?: 'parrot_request_status';
  value: Scalars['String']['output'];
};

/** aggregated selection of "parrot_request_status" */
export type Parrot_Request_Status_Aggregate = {
  __typename?: 'parrot_request_status_aggregate';
  aggregate?: Maybe<Parrot_Request_Status_Aggregate_Fields>;
  nodes: Array<Parrot_Request_Status>;
};

/** aggregate fields of "parrot_request_status" */
export type Parrot_Request_Status_Aggregate_Fields = {
  __typename?: 'parrot_request_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Parrot_Request_Status_Max_Fields>;
  min?: Maybe<Parrot_Request_Status_Min_Fields>;
};


/** aggregate fields of "parrot_request_status" */
export type Parrot_Request_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parrot_Request_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "parrot_request_status". All fields are combined with a logical 'AND'. */
export type Parrot_Request_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Parrot_Request_Status_Bool_Exp>>;
  _not?: InputMaybe<Parrot_Request_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Parrot_Request_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "parrot_request_status" */
export enum Parrot_Request_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  ParrotRequestStatusPkey = 'parrot_request_status_pkey'
}

export enum Parrot_Request_Status_Enum {
  Blocked = 'BLOCKED',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "parrot_request_status_enum". All fields are combined with logical 'AND'. */
export type Parrot_Request_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Parrot_Request_Status_Enum>;
  _in?: InputMaybe<Array<Parrot_Request_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Parrot_Request_Status_Enum>;
  _nin?: InputMaybe<Array<Parrot_Request_Status_Enum>>;
};

/** input type for inserting data into table "parrot_request_status" */
export type Parrot_Request_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Parrot_Request_Status_Max_Fields = {
  __typename?: 'parrot_request_status_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Parrot_Request_Status_Min_Fields = {
  __typename?: 'parrot_request_status_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "parrot_request_status" */
export type Parrot_Request_Status_Mutation_Response = {
  __typename?: 'parrot_request_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parrot_Request_Status>;
};

/** on_conflict condition type for table "parrot_request_status" */
export type Parrot_Request_Status_On_Conflict = {
  constraint: Parrot_Request_Status_Constraint;
  update_columns?: Array<Parrot_Request_Status_Update_Column>;
  where?: InputMaybe<Parrot_Request_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "parrot_request_status". */
export type Parrot_Request_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parrot_request_status */
export type Parrot_Request_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "parrot_request_status" */
export enum Parrot_Request_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "parrot_request_status" */
export type Parrot_Request_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "parrot_request_status" */
export type Parrot_Request_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parrot_Request_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parrot_Request_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "parrot_request_status" */
export enum Parrot_Request_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Parrot_Request_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parrot_Request_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parrot_Request_Status_Bool_Exp;
};

/** columns and relationships of "parrot_requests" */
export type Parrot_Requests = {
  __typename?: 'parrot_requests';
  claimerId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  course: Courses;
  courseId: Scalars['uuid']['output'];
  created: Scalars['timestamptz']['output'];
  endWeek: Scalars['Int']['output'];
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  id: Scalars['uuid']['output'];
  queuePosition?: Maybe<Scalars['Int']['output']>;
  startWeek: Scalars['Int']['output'];
  status: Parrot_Request_Status_Enum;
  /** An object relationship */
  teacher: Teachers;
  teacherId: Scalars['String']['output'];
  updated: Scalars['timestamptz']['output'];
  userNotes?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "parrot_requests" */
export type Parrot_RequestsFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "parrot_requests" */
export type Parrot_RequestsFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** aggregated selection of "parrot_requests" */
export type Parrot_Requests_Aggregate = {
  __typename?: 'parrot_requests_aggregate';
  aggregate?: Maybe<Parrot_Requests_Aggregate_Fields>;
  nodes: Array<Parrot_Requests>;
};

export type Parrot_Requests_Aggregate_Bool_Exp = {
  count?: InputMaybe<Parrot_Requests_Aggregate_Bool_Exp_Count>;
};

export type Parrot_Requests_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parrot_Requests_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parrot_requests" */
export type Parrot_Requests_Aggregate_Fields = {
  __typename?: 'parrot_requests_aggregate_fields';
  avg?: Maybe<Parrot_Requests_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parrot_Requests_Max_Fields>;
  min?: Maybe<Parrot_Requests_Min_Fields>;
  stddev?: Maybe<Parrot_Requests_Stddev_Fields>;
  stddev_pop?: Maybe<Parrot_Requests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parrot_Requests_Stddev_Samp_Fields>;
  sum?: Maybe<Parrot_Requests_Sum_Fields>;
  var_pop?: Maybe<Parrot_Requests_Var_Pop_Fields>;
  var_samp?: Maybe<Parrot_Requests_Var_Samp_Fields>;
  variance?: Maybe<Parrot_Requests_Variance_Fields>;
};


/** aggregate fields of "parrot_requests" */
export type Parrot_Requests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parrot_requests" */
export type Parrot_Requests_Aggregate_Order_By = {
  avg?: InputMaybe<Parrot_Requests_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parrot_Requests_Max_Order_By>;
  min?: InputMaybe<Parrot_Requests_Min_Order_By>;
  stddev?: InputMaybe<Parrot_Requests_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parrot_Requests_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parrot_Requests_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parrot_Requests_Sum_Order_By>;
  var_pop?: InputMaybe<Parrot_Requests_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parrot_Requests_Var_Samp_Order_By>;
  variance?: InputMaybe<Parrot_Requests_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parrot_requests" */
export type Parrot_Requests_Arr_Rel_Insert_Input = {
  data: Array<Parrot_Requests_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parrot_Requests_On_Conflict>;
};

/** aggregate avg on columns */
export type Parrot_Requests_Avg_Fields = {
  __typename?: 'parrot_requests_avg_fields';
  endWeek?: Maybe<Scalars['Float']['output']>;
  queuePosition?: Maybe<Scalars['Float']['output']>;
  startWeek?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parrot_requests" */
export type Parrot_Requests_Avg_Order_By = {
  endWeek?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parrot_requests". All fields are combined with a logical 'AND'. */
export type Parrot_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Parrot_Requests_Bool_Exp>>;
  _not?: InputMaybe<Parrot_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Parrot_Requests_Bool_Exp>>;
  claimerId?: InputMaybe<String_Comparison_Exp>;
  course?: InputMaybe<Courses_Bool_Exp>;
  courseId?: InputMaybe<Uuid_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  endWeek?: InputMaybe<Int_Comparison_Exp>;
  files?: InputMaybe<Files_Bool_Exp>;
  files_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  queuePosition?: InputMaybe<Int_Comparison_Exp>;
  startWeek?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Parrot_Request_Status_Enum_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  userNotes?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "parrot_requests" */
export enum Parrot_Requests_Constraint {
  /** unique or primary key constraint on columns "id" */
  ParrotRequestsPkey = 'parrot_requests_pkey'
}

/** input type for incrementing numeric columns in table "parrot_requests" */
export type Parrot_Requests_Inc_Input = {
  endWeek?: InputMaybe<Scalars['Int']['input']>;
  queuePosition?: InputMaybe<Scalars['Int']['input']>;
  startWeek?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "parrot_requests" */
export type Parrot_Requests_Insert_Input = {
  claimerId?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<Courses_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  endWeek?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Files_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  queuePosition?: InputMaybe<Scalars['Int']['input']>;
  startWeek?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Parrot_Request_Status_Enum>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  userNotes?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Parrot_Requests_Max_Fields = {
  __typename?: 'parrot_requests_max_fields';
  claimerId?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  endWeek?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  queuePosition?: Maybe<Scalars['Int']['output']>;
  startWeek?: Maybe<Scalars['Int']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  userNotes?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "parrot_requests" */
export type Parrot_Requests_Max_Order_By = {
  claimerId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  endWeek?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  userNotes?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parrot_Requests_Min_Fields = {
  __typename?: 'parrot_requests_min_fields';
  claimerId?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  endWeek?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  queuePosition?: Maybe<Scalars['Int']['output']>;
  startWeek?: Maybe<Scalars['Int']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  userNotes?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "parrot_requests" */
export type Parrot_Requests_Min_Order_By = {
  claimerId?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  endWeek?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  userNotes?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parrot_requests" */
export type Parrot_Requests_Mutation_Response = {
  __typename?: 'parrot_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parrot_Requests>;
};

/** input type for inserting object relation for remote table "parrot_requests" */
export type Parrot_Requests_Obj_Rel_Insert_Input = {
  data: Parrot_Requests_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Parrot_Requests_On_Conflict>;
};

/** on_conflict condition type for table "parrot_requests" */
export type Parrot_Requests_On_Conflict = {
  constraint: Parrot_Requests_Constraint;
  update_columns?: Array<Parrot_Requests_Update_Column>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};

/** Ordering options when selecting data from "parrot_requests". */
export type Parrot_Requests_Order_By = {
  claimerId?: InputMaybe<Order_By>;
  course?: InputMaybe<Courses_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  endWeek?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<Files_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  userNotes?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parrot_requests */
export type Parrot_Requests_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "parrot_requests" */
export enum Parrot_Requests_Select_Column {
  /** column name */
  ClaimerId = 'claimerId',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Created = 'created',
  /** column name */
  EndWeek = 'endWeek',
  /** column name */
  Id = 'id',
  /** column name */
  QueuePosition = 'queuePosition',
  /** column name */
  StartWeek = 'startWeek',
  /** column name */
  Status = 'status',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated',
  /** column name */
  UserNotes = 'userNotes'
}

/** input type for updating data in table "parrot_requests" */
export type Parrot_Requests_Set_Input = {
  claimerId?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  endWeek?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  queuePosition?: InputMaybe<Scalars['Int']['input']>;
  startWeek?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Parrot_Request_Status_Enum>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  userNotes?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Parrot_Requests_Stddev_Fields = {
  __typename?: 'parrot_requests_stddev_fields';
  endWeek?: Maybe<Scalars['Float']['output']>;
  queuePosition?: Maybe<Scalars['Float']['output']>;
  startWeek?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parrot_requests" */
export type Parrot_Requests_Stddev_Order_By = {
  endWeek?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parrot_Requests_Stddev_Pop_Fields = {
  __typename?: 'parrot_requests_stddev_pop_fields';
  endWeek?: Maybe<Scalars['Float']['output']>;
  queuePosition?: Maybe<Scalars['Float']['output']>;
  startWeek?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parrot_requests" */
export type Parrot_Requests_Stddev_Pop_Order_By = {
  endWeek?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parrot_Requests_Stddev_Samp_Fields = {
  __typename?: 'parrot_requests_stddev_samp_fields';
  endWeek?: Maybe<Scalars['Float']['output']>;
  queuePosition?: Maybe<Scalars['Float']['output']>;
  startWeek?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parrot_requests" */
export type Parrot_Requests_Stddev_Samp_Order_By = {
  endWeek?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parrot_requests" */
export type Parrot_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parrot_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parrot_Requests_Stream_Cursor_Value_Input = {
  claimerId?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  endWeek?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  queuePosition?: InputMaybe<Scalars['Int']['input']>;
  startWeek?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Parrot_Request_Status_Enum>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  userNotes?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Parrot_Requests_Sum_Fields = {
  __typename?: 'parrot_requests_sum_fields';
  endWeek?: Maybe<Scalars['Int']['output']>;
  queuePosition?: Maybe<Scalars['Int']['output']>;
  startWeek?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "parrot_requests" */
export type Parrot_Requests_Sum_Order_By = {
  endWeek?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
};

/** update columns of table "parrot_requests" */
export enum Parrot_Requests_Update_Column {
  /** column name */
  ClaimerId = 'claimerId',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Created = 'created',
  /** column name */
  EndWeek = 'endWeek',
  /** column name */
  Id = 'id',
  /** column name */
  QueuePosition = 'queuePosition',
  /** column name */
  StartWeek = 'startWeek',
  /** column name */
  Status = 'status',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated',
  /** column name */
  UserNotes = 'userNotes'
}

export type Parrot_Requests_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parrot_Requests_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parrot_Requests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parrot_Requests_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parrot_Requests_Var_Pop_Fields = {
  __typename?: 'parrot_requests_var_pop_fields';
  endWeek?: Maybe<Scalars['Float']['output']>;
  queuePosition?: Maybe<Scalars['Float']['output']>;
  startWeek?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parrot_requests" */
export type Parrot_Requests_Var_Pop_Order_By = {
  endWeek?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parrot_Requests_Var_Samp_Fields = {
  __typename?: 'parrot_requests_var_samp_fields';
  endWeek?: Maybe<Scalars['Float']['output']>;
  queuePosition?: Maybe<Scalars['Float']['output']>;
  startWeek?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parrot_requests" */
export type Parrot_Requests_Var_Samp_Order_By = {
  endWeek?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parrot_Requests_Variance_Fields = {
  __typename?: 'parrot_requests_variance_fields';
  endWeek?: Maybe<Scalars['Float']['output']>;
  queuePosition?: Maybe<Scalars['Float']['output']>;
  startWeek?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parrot_requests" */
export type Parrot_Requests_Variance_Order_By = {
  endWeek?: InputMaybe<Order_By>;
  queuePosition?: InputMaybe<Order_By>;
  startWeek?: InputMaybe<Order_By>;
};

/** columns and relationships of "plan_tier" */
export type Plan_Tier = {
  __typename?: 'plan_tier';
  value: Scalars['String']['output'];
};

/** aggregated selection of "plan_tier" */
export type Plan_Tier_Aggregate = {
  __typename?: 'plan_tier_aggregate';
  aggregate?: Maybe<Plan_Tier_Aggregate_Fields>;
  nodes: Array<Plan_Tier>;
};

/** aggregate fields of "plan_tier" */
export type Plan_Tier_Aggregate_Fields = {
  __typename?: 'plan_tier_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Plan_Tier_Max_Fields>;
  min?: Maybe<Plan_Tier_Min_Fields>;
};


/** aggregate fields of "plan_tier" */
export type Plan_Tier_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plan_Tier_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "plan_tier". All fields are combined with a logical 'AND'. */
export type Plan_Tier_Bool_Exp = {
  _and?: InputMaybe<Array<Plan_Tier_Bool_Exp>>;
  _not?: InputMaybe<Plan_Tier_Bool_Exp>;
  _or?: InputMaybe<Array<Plan_Tier_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "plan_tier" */
export enum Plan_Tier_Constraint {
  /** unique or primary key constraint on columns "value" */
  PlanTierPkey = 'plan_tier_pkey'
}

export enum Plan_Tier_Enum {
  Tier1 = 'TIER1',
  Tier2 = 'TIER2',
  Trial = 'TRIAL'
}

/** Boolean expression to compare columns of type "plan_tier_enum". All fields are combined with logical 'AND'. */
export type Plan_Tier_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Plan_Tier_Enum>;
  _in?: InputMaybe<Array<Plan_Tier_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Plan_Tier_Enum>;
  _nin?: InputMaybe<Array<Plan_Tier_Enum>>;
};

/** input type for inserting data into table "plan_tier" */
export type Plan_Tier_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Plan_Tier_Max_Fields = {
  __typename?: 'plan_tier_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Plan_Tier_Min_Fields = {
  __typename?: 'plan_tier_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "plan_tier" */
export type Plan_Tier_Mutation_Response = {
  __typename?: 'plan_tier_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Plan_Tier>;
};

/** on_conflict condition type for table "plan_tier" */
export type Plan_Tier_On_Conflict = {
  constraint: Plan_Tier_Constraint;
  update_columns?: Array<Plan_Tier_Update_Column>;
  where?: InputMaybe<Plan_Tier_Bool_Exp>;
};

/** Ordering options when selecting data from "plan_tier". */
export type Plan_Tier_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plan_tier */
export type Plan_Tier_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "plan_tier" */
export enum Plan_Tier_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "plan_tier" */
export type Plan_Tier_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "plan_tier" */
export type Plan_Tier_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plan_Tier_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plan_Tier_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "plan_tier" */
export enum Plan_Tier_Update_Column {
  /** column name */
  Value = 'value'
}

export type Plan_Tier_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plan_Tier_Set_Input>;
  /** filter the rows which have to be updated */
  where: Plan_Tier_Bool_Exp;
};

/** columns and relationships of "printing_job_status" */
export type Printing_Job_Status = {
  __typename?: 'printing_job_status';
  value: Scalars['String']['output'];
};

/** aggregated selection of "printing_job_status" */
export type Printing_Job_Status_Aggregate = {
  __typename?: 'printing_job_status_aggregate';
  aggregate?: Maybe<Printing_Job_Status_Aggregate_Fields>;
  nodes: Array<Printing_Job_Status>;
};

/** aggregate fields of "printing_job_status" */
export type Printing_Job_Status_Aggregate_Fields = {
  __typename?: 'printing_job_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Printing_Job_Status_Max_Fields>;
  min?: Maybe<Printing_Job_Status_Min_Fields>;
};


/** aggregate fields of "printing_job_status" */
export type Printing_Job_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Printing_Job_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "printing_job_status". All fields are combined with a logical 'AND'. */
export type Printing_Job_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Printing_Job_Status_Bool_Exp>>;
  _not?: InputMaybe<Printing_Job_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Printing_Job_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "printing_job_status" */
export enum Printing_Job_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  PrintingJobStatusPkey = 'printing_job_status_pkey'
}

export enum Printing_Job_Status_Enum {
  Complete = 'COMPLETE',
  Error = 'ERROR',
  Generating = 'GENERATING'
}

/** Boolean expression to compare columns of type "printing_job_status_enum". All fields are combined with logical 'AND'. */
export type Printing_Job_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Printing_Job_Status_Enum>;
  _in?: InputMaybe<Array<Printing_Job_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Printing_Job_Status_Enum>;
  _nin?: InputMaybe<Array<Printing_Job_Status_Enum>>;
};

/** input type for inserting data into table "printing_job_status" */
export type Printing_Job_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Printing_Job_Status_Max_Fields = {
  __typename?: 'printing_job_status_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Printing_Job_Status_Min_Fields = {
  __typename?: 'printing_job_status_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "printing_job_status" */
export type Printing_Job_Status_Mutation_Response = {
  __typename?: 'printing_job_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Printing_Job_Status>;
};

/** on_conflict condition type for table "printing_job_status" */
export type Printing_Job_Status_On_Conflict = {
  constraint: Printing_Job_Status_Constraint;
  update_columns?: Array<Printing_Job_Status_Update_Column>;
  where?: InputMaybe<Printing_Job_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "printing_job_status". */
export type Printing_Job_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: printing_job_status */
export type Printing_Job_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "printing_job_status" */
export enum Printing_Job_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "printing_job_status" */
export type Printing_Job_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "printing_job_status" */
export type Printing_Job_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Printing_Job_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Printing_Job_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "printing_job_status" */
export enum Printing_Job_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Printing_Job_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Printing_Job_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Printing_Job_Status_Bool_Exp;
};

/** columns and relationships of "printing_job_type" */
export type Printing_Job_Type = {
  __typename?: 'printing_job_type';
  value: Scalars['String']['output'];
};

/** aggregated selection of "printing_job_type" */
export type Printing_Job_Type_Aggregate = {
  __typename?: 'printing_job_type_aggregate';
  aggregate?: Maybe<Printing_Job_Type_Aggregate_Fields>;
  nodes: Array<Printing_Job_Type>;
};

/** aggregate fields of "printing_job_type" */
export type Printing_Job_Type_Aggregate_Fields = {
  __typename?: 'printing_job_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Printing_Job_Type_Max_Fields>;
  min?: Maybe<Printing_Job_Type_Min_Fields>;
};


/** aggregate fields of "printing_job_type" */
export type Printing_Job_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Printing_Job_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "printing_job_type". All fields are combined with a logical 'AND'. */
export type Printing_Job_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Printing_Job_Type_Bool_Exp>>;
  _not?: InputMaybe<Printing_Job_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Printing_Job_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "printing_job_type" */
export enum Printing_Job_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  PrintingJobTypePkey = 'printing_job_type_pkey'
}

export enum Printing_Job_Type_Enum {
  Calendar = 'CALENDAR',
  CourseInfo = 'COURSE_INFO',
  StudentCourseInfo = 'STUDENT_COURSE_INFO',
  Transcript = 'TRANSCRIPT'
}

/** Boolean expression to compare columns of type "printing_job_type_enum". All fields are combined with logical 'AND'. */
export type Printing_Job_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Printing_Job_Type_Enum>;
  _in?: InputMaybe<Array<Printing_Job_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Printing_Job_Type_Enum>;
  _nin?: InputMaybe<Array<Printing_Job_Type_Enum>>;
};

/** input type for inserting data into table "printing_job_type" */
export type Printing_Job_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Printing_Job_Type_Max_Fields = {
  __typename?: 'printing_job_type_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Printing_Job_Type_Min_Fields = {
  __typename?: 'printing_job_type_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "printing_job_type" */
export type Printing_Job_Type_Mutation_Response = {
  __typename?: 'printing_job_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Printing_Job_Type>;
};

/** on_conflict condition type for table "printing_job_type" */
export type Printing_Job_Type_On_Conflict = {
  constraint: Printing_Job_Type_Constraint;
  update_columns?: Array<Printing_Job_Type_Update_Column>;
  where?: InputMaybe<Printing_Job_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "printing_job_type". */
export type Printing_Job_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: printing_job_type */
export type Printing_Job_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "printing_job_type" */
export enum Printing_Job_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "printing_job_type" */
export type Printing_Job_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "printing_job_type" */
export type Printing_Job_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Printing_Job_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Printing_Job_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "printing_job_type" */
export enum Printing_Job_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Printing_Job_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Printing_Job_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Printing_Job_Type_Bool_Exp;
};

/** columns and relationships of "printing_jobs" */
export type Printing_Jobs = {
  __typename?: 'printing_jobs';
  created: Scalars['timestamptz']['output'];
  data: Scalars['jsonb']['output'];
  /** An object relationship */
  file?: Maybe<Files>;
  id: Scalars['uuid']['output'];
  status: Printing_Job_Status_Enum;
  /** An object relationship */
  studentAccount?: Maybe<Student_Accounts>;
  studentAccountId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  teacher?: Maybe<Teachers>;
  teacherId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Printing_Job_Type_Enum>;
  updated: Scalars['timestamptz']['output'];
};


/** columns and relationships of "printing_jobs" */
export type Printing_JobsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "printing_jobs" */
export type Printing_Jobs_Aggregate = {
  __typename?: 'printing_jobs_aggregate';
  aggregate?: Maybe<Printing_Jobs_Aggregate_Fields>;
  nodes: Array<Printing_Jobs>;
};

/** aggregate fields of "printing_jobs" */
export type Printing_Jobs_Aggregate_Fields = {
  __typename?: 'printing_jobs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Printing_Jobs_Max_Fields>;
  min?: Maybe<Printing_Jobs_Min_Fields>;
};


/** aggregate fields of "printing_jobs" */
export type Printing_Jobs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Printing_Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Printing_Jobs_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "printing_jobs". All fields are combined with a logical 'AND'. */
export type Printing_Jobs_Bool_Exp = {
  _and?: InputMaybe<Array<Printing_Jobs_Bool_Exp>>;
  _not?: InputMaybe<Printing_Jobs_Bool_Exp>;
  _or?: InputMaybe<Array<Printing_Jobs_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Printing_Job_Status_Enum_Comparison_Exp>;
  studentAccount?: InputMaybe<Student_Accounts_Bool_Exp>;
  studentAccountId?: InputMaybe<String_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Printing_Job_Type_Enum_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "printing_jobs" */
export enum Printing_Jobs_Constraint {
  /** unique or primary key constraint on columns "id" */
  PrintingJobsPkey = 'printing_jobs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Printing_Jobs_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Printing_Jobs_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Printing_Jobs_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "printing_jobs" */
export type Printing_Jobs_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Printing_Job_Status_Enum>;
  studentAccount?: InputMaybe<Student_Accounts_Obj_Rel_Insert_Input>;
  studentAccountId?: InputMaybe<Scalars['String']['input']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Printing_Job_Type_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Printing_Jobs_Max_Fields = {
  __typename?: 'printing_jobs_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  studentAccountId?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Printing_Jobs_Min_Fields = {
  __typename?: 'printing_jobs_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  studentAccountId?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "printing_jobs" */
export type Printing_Jobs_Mutation_Response = {
  __typename?: 'printing_jobs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Printing_Jobs>;
};

/** input type for inserting object relation for remote table "printing_jobs" */
export type Printing_Jobs_Obj_Rel_Insert_Input = {
  data: Printing_Jobs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Printing_Jobs_On_Conflict>;
};

/** on_conflict condition type for table "printing_jobs" */
export type Printing_Jobs_On_Conflict = {
  constraint: Printing_Jobs_Constraint;
  update_columns?: Array<Printing_Jobs_Update_Column>;
  where?: InputMaybe<Printing_Jobs_Bool_Exp>;
};

/** Ordering options when selecting data from "printing_jobs". */
export type Printing_Jobs_Order_By = {
  created?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  studentAccount?: InputMaybe<Student_Accounts_Order_By>;
  studentAccountId?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: printing_jobs */
export type Printing_Jobs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Printing_Jobs_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "printing_jobs" */
export enum Printing_Jobs_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  StudentAccountId = 'studentAccountId',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Type = 'type',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "printing_jobs" */
export type Printing_Jobs_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Printing_Job_Status_Enum>;
  studentAccountId?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Printing_Job_Type_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "printing_jobs" */
export type Printing_Jobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Printing_Jobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Printing_Jobs_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Printing_Job_Status_Enum>;
  studentAccountId?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Printing_Job_Type_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "printing_jobs" */
export enum Printing_Jobs_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  StudentAccountId = 'studentAccountId',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Type = 'type',
  /** column name */
  Updated = 'updated'
}

export type Printing_Jobs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Printing_Jobs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Printing_Jobs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Printing_Jobs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Printing_Jobs_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Printing_Jobs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Printing_Jobs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Printing_Jobs_Bool_Exp;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "assignments" using primary key columns */
  assignment?: Maybe<Assignments>;
  /** fetch data from the table: "assignment_type" */
  assignment_type: Array<Assignment_Type>;
  /** fetch aggregated fields from the table: "assignment_type" */
  assignment_type_aggregate: Assignment_Type_Aggregate;
  /** fetch data from the table: "assignment_type" using primary key columns */
  assignment_type_by_pk?: Maybe<Assignment_Type>;
  /** fetch data from the table: "assignment_type_weights" using primary key columns */
  assignment_type_weight?: Maybe<Assignment_Type_Weights>;
  /** fetch data from the table: "assignment_type_weights" */
  assignment_type_weights: Array<Assignment_Type_Weights>;
  /** fetch aggregated fields from the table: "assignment_type_weights" */
  assignment_type_weights_aggregate: Assignment_Type_Weights_Aggregate;
  /** An array relationship */
  assignments: Array<Assignments>;
  /** An aggregate relationship */
  assignments_aggregate: Assignments_Aggregate;
  /** fetch data from the table: "comments" using primary key columns */
  comment?: Maybe<Comments>;
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  /** fetch data from the table: "courses" using primary key columns */
  course?: Maybe<Courses>;
  /** An array relationship */
  courses: Array<Courses>;
  /** An aggregate relationship */
  courses_aggregate: Courses_Aggregate;
  /** fetch data from the table: "custom_assignment_types" using primary key columns */
  custom_assignment_type?: Maybe<Custom_Assignment_Types>;
  /** fetch data from the table: "custom_assignment_types" */
  custom_assignment_types: Array<Custom_Assignment_Types>;
  /** fetch aggregated fields from the table: "custom_assignment_types" */
  custom_assignment_types_aggregate: Custom_Assignment_Types_Aggregate;
  /** fetch data from the table: "customers" using primary key columns */
  customer?: Maybe<Customers>;
  /** fetch data from the table: "customers" */
  customers: Array<Customers>;
  /** fetch aggregated fields from the table: "customers" */
  customers_aggregate: Customers_Aggregate;
  /** fetch data from the table: "events" using primary key columns */
  event?: Maybe<Events>;
  /** fetch data from the table: "event_t" */
  event_t: Array<Event_T>;
  /** fetch aggregated fields from the table: "event_t" */
  event_t_aggregate: Event_T_Aggregate;
  /** fetch data from the table: "event_t" using primary key columns */
  event_type?: Maybe<Event_T>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  events_aggregate: Events_Aggregate;
  /** fetch data from the table: "files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  /** fetch data from the table: "grading_style" */
  grading_style: Array<Grading_Style>;
  /** fetch aggregated fields from the table: "grading_style" */
  grading_style_aggregate: Grading_Style_Aggregate;
  /** fetch data from the table: "grading_style" using primary key columns */
  grading_style_by_pk?: Maybe<Grading_Style>;
  /** fetch data from the table: "organizations" using primary key columns */
  organization?: Maybe<Organizations>;
  /** Query to get a course from an Organization */
  organizationCourse?: Maybe<OrganizationCourse>;
  /** Query to get courses from an Organization */
  organizationCourses: Array<OrganizationCourse>;
  /** fetch data from the table: "organization_admins" using primary key columns */
  organization_admin?: Maybe<Organization_Admins>;
  /** fetch data from the table: "organization_admins" */
  organization_admins: Array<Organization_Admins>;
  /** fetch aggregated fields from the table: "organization_admins" */
  organization_admins_aggregate: Organization_Admins_Aggregate;
  /** fetch data from the table: "organization_codes" using primary key columns */
  organization_code?: Maybe<Organization_Codes>;
  /** fetch data from the table: "organization_codes" */
  organization_codes: Array<Organization_Codes>;
  /** fetch aggregated fields from the table: "organization_codes" */
  organization_codes_aggregate: Organization_Codes_Aggregate;
  /** An array relationship */
  organizations: Array<Organizations>;
  /** An aggregate relationship */
  organizations_aggregate: Organizations_Aggregate;
  /** fetch data from the table: "parrot_requests" using primary key columns */
  parrot_request?: Maybe<Parrot_Requests>;
  /** fetch data from the table: "parrot_request_status" */
  parrot_request_status: Array<Parrot_Request_Status>;
  /** fetch aggregated fields from the table: "parrot_request_status" */
  parrot_request_status_aggregate: Parrot_Request_Status_Aggregate;
  /** fetch data from the table: "parrot_request_status" using primary key columns */
  parrot_request_status_by_pk?: Maybe<Parrot_Request_Status>;
  /** fetch data from the table: "parrot_requests" */
  parrot_requests: Array<Parrot_Requests>;
  /** fetch aggregated fields from the table: "parrot_requests" */
  parrot_requests_aggregate: Parrot_Requests_Aggregate;
  /** fetch data from the table: "plan_tier" */
  plan_tier: Array<Plan_Tier>;
  /** fetch aggregated fields from the table: "plan_tier" */
  plan_tier_aggregate: Plan_Tier_Aggregate;
  /** fetch data from the table: "plan_tier" using primary key columns */
  plan_tier_by_pk?: Maybe<Plan_Tier>;
  /** fetch data from the table: "printing_jobs" using primary key columns */
  printing_job?: Maybe<Printing_Jobs>;
  /** fetch data from the table: "printing_job_status" */
  printing_job_status: Array<Printing_Job_Status>;
  /** fetch aggregated fields from the table: "printing_job_status" */
  printing_job_status_aggregate: Printing_Job_Status_Aggregate;
  /** fetch data from the table: "printing_job_status" using primary key columns */
  printing_job_status_by_pk?: Maybe<Printing_Job_Status>;
  /** fetch data from the table: "printing_job_type" */
  printing_job_type: Array<Printing_Job_Type>;
  /** fetch aggregated fields from the table: "printing_job_type" */
  printing_job_type_aggregate: Printing_Job_Type_Aggregate;
  /** fetch data from the table: "printing_job_type" using primary key columns */
  printing_job_type_by_pk?: Maybe<Printing_Job_Type>;
  /** fetch data from the table: "printing_jobs" */
  printing_jobs: Array<Printing_Jobs>;
  /** fetch aggregated fields from the table: "printing_jobs" */
  printing_jobs_aggregate: Printing_Jobs_Aggregate;
  /** fetch data from the table: "school_year" */
  school_year: Array<School_Year>;
  /** fetch aggregated fields from the table: "school_year" */
  school_year_aggregate: School_Year_Aggregate;
  /** fetch data from the table: "school_year" using primary key columns */
  school_year_by_pk?: Maybe<School_Year>;
  /** fetch data from the table: "students" using primary key columns */
  student?: Maybe<Students>;
  /** fetch data from the table: "student_accounts" using primary key columns */
  student_account?: Maybe<Student_Accounts>;
  /** fetch data from the table: "student_accounts" */
  student_accounts: Array<Student_Accounts>;
  /** fetch aggregated fields from the table: "student_accounts" */
  student_accounts_aggregate: Student_Accounts_Aggregate;
  /** fetch data from the table: "student_assignments" using primary key columns */
  student_assignment?: Maybe<Student_Assignments>;
  /** fetch data from the table: "student_assignment_status" */
  student_assignment_status: Array<Student_Assignment_Status>;
  /** fetch aggregated fields from the table: "student_assignment_status" */
  student_assignment_status_aggregate: Student_Assignment_Status_Aggregate;
  /** fetch data from the table: "student_assignment_status" using primary key columns */
  student_assignment_status_by_pk?: Maybe<Student_Assignment_Status>;
  /** fetch data from the table: "student_assignments" */
  student_assignments: Array<Student_Assignments>;
  /** fetch aggregated fields from the table: "student_assignments" */
  student_assignments_aggregate: Student_Assignments_Aggregate;
  /** fetch data from the table: "student_courses" using primary key columns */
  student_course?: Maybe<Student_Courses>;
  /** fetch data from the table: "student_course_status" */
  student_course_status: Array<Student_Course_Status>;
  /** fetch aggregated fields from the table: "student_course_status" */
  student_course_status_aggregate: Student_Course_Status_Aggregate;
  /** fetch data from the table: "student_course_status" using primary key columns */
  student_course_status_by_pk?: Maybe<Student_Course_Status>;
  /** fetch data from the table: "student_courses" */
  student_courses: Array<Student_Courses>;
  /** fetch aggregated fields from the table: "student_courses" */
  student_courses_aggregate: Student_Courses_Aggregate;
  /** fetch data from the table: "student_events" using primary key columns */
  student_event?: Maybe<Student_Events>;
  /** fetch data from the table: "student_events" */
  student_events: Array<Student_Events>;
  /** fetch aggregated fields from the table: "student_events" */
  student_events_aggregate: Student_Events_Aggregate;
  /** fetch data from the table: "students" */
  students: Array<Students>;
  /** fetch aggregated fields from the table: "students" */
  students_aggregate: Students_Aggregate;
  /** fetch data from the table: "teachers" using primary key columns */
  teacher?: Maybe<Teachers>;
  /** An array relationship */
  teachers: Array<Teachers>;
  /** An aggregate relationship */
  teachers_aggregate: Teachers_Aggregate;
  /** fetch data from the table: "teachers_students" */
  teachers_students: Array<Teachers_Students>;
  /** fetch aggregated fields from the table: "teachers_students" */
  teachers_students_aggregate: Teachers_Students_Aggregate;
  /** fetch data from the table: "teachers_students" using primary key columns */
  teachers_students_by_pk?: Maybe<Teachers_Students>;
  /** fetch data from the table: "themes" */
  themes: Array<Themes>;
  /** fetch aggregated fields from the table: "themes" */
  themes_aggregate: Themes_Aggregate;
  /** fetch data from the table: "themes" using primary key columns */
  themes_by_pk?: Maybe<Themes>;
  /** fetch data from the table: "user_settings" */
  user_settings: Array<User_Settings>;
  /** fetch aggregated fields from the table: "user_settings" */
  user_settings_aggregate: User_Settings_Aggregate;
  /** fetch data from the table: "user_settings" using primary key columns */
  user_settings_by_pk?: Maybe<User_Settings>;
};


export type Query_RootAssignmentArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAssignment_TypeArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Order_By>>;
  where?: InputMaybe<Assignment_Type_Bool_Exp>;
};


export type Query_RootAssignment_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Order_By>>;
  where?: InputMaybe<Assignment_Type_Bool_Exp>;
};


export type Query_RootAssignment_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAssignment_Type_WeightArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAssignment_Type_WeightsArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Weights_Order_By>>;
  where?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
};


export type Query_RootAssignment_Type_Weights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Weights_Order_By>>;
  where?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
};


export type Query_RootAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignments_Order_By>>;
  where?: InputMaybe<Assignments_Bool_Exp>;
};


export type Query_RootAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignments_Order_By>>;
  where?: InputMaybe<Assignments_Bool_Exp>;
};


export type Query_RootCommentArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Query_RootComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Query_RootCourseArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCoursesArgs = {
  distinct_on?: InputMaybe<Array<Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Courses_Order_By>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


export type Query_RootCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Courses_Order_By>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


export type Query_RootCustom_Assignment_TypeArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustom_Assignment_TypesArgs = {
  distinct_on?: InputMaybe<Array<Custom_Assignment_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Assignment_Types_Order_By>>;
  where?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
};


export type Query_RootCustom_Assignment_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Assignment_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Assignment_Types_Order_By>>;
  where?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
};


export type Query_RootCustomerArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootCustomersArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Query_RootCustomers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Query_RootEventArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEvent_TArgs = {
  distinct_on?: InputMaybe<Array<Event_T_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_T_Order_By>>;
  where?: InputMaybe<Event_T_Bool_Exp>;
};


export type Query_RootEvent_T_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_T_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_T_Order_By>>;
  where?: InputMaybe<Event_T_Bool_Exp>;
};


export type Query_RootEvent_TypeArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootFileArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootGrading_StyleArgs = {
  distinct_on?: InputMaybe<Array<Grading_Style_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grading_Style_Order_By>>;
  where?: InputMaybe<Grading_Style_Bool_Exp>;
};


export type Query_RootGrading_Style_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grading_Style_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grading_Style_Order_By>>;
  where?: InputMaybe<Grading_Style_Bool_Exp>;
};


export type Query_RootGrading_Style_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganizationCourseArgs = {
  courseId: Scalars['uuid']['input'];
  organizationId: Scalars['uuid']['input'];
};


export type Query_RootOrganizationCoursesArgs = {
  organizationId: Scalars['uuid']['input'];
};


export type Query_RootOrganization_AdminArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootOrganization_AdminsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


export type Query_RootOrganization_Admins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


export type Query_RootOrganization_CodeArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_CodesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Codes_Bool_Exp>;
};


export type Query_RootOrganization_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Codes_Bool_Exp>;
};


export type Query_RootOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Query_RootOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Query_RootParrot_RequestArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootParrot_Request_StatusArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Request_Status_Order_By>>;
  where?: InputMaybe<Parrot_Request_Status_Bool_Exp>;
};


export type Query_RootParrot_Request_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Request_Status_Order_By>>;
  where?: InputMaybe<Parrot_Request_Status_Bool_Exp>;
};


export type Query_RootParrot_Request_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootParrot_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Requests_Order_By>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


export type Query_RootParrot_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Requests_Order_By>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


export type Query_RootPlan_TierArgs = {
  distinct_on?: InputMaybe<Array<Plan_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plan_Tier_Order_By>>;
  where?: InputMaybe<Plan_Tier_Bool_Exp>;
};


export type Query_RootPlan_Tier_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plan_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plan_Tier_Order_By>>;
  where?: InputMaybe<Plan_Tier_Bool_Exp>;
};


export type Query_RootPlan_Tier_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPrinting_JobArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPrinting_Job_StatusArgs = {
  distinct_on?: InputMaybe<Array<Printing_Job_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Job_Status_Order_By>>;
  where?: InputMaybe<Printing_Job_Status_Bool_Exp>;
};


export type Query_RootPrinting_Job_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printing_Job_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Job_Status_Order_By>>;
  where?: InputMaybe<Printing_Job_Status_Bool_Exp>;
};


export type Query_RootPrinting_Job_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPrinting_Job_TypeArgs = {
  distinct_on?: InputMaybe<Array<Printing_Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Job_Type_Order_By>>;
  where?: InputMaybe<Printing_Job_Type_Bool_Exp>;
};


export type Query_RootPrinting_Job_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printing_Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Job_Type_Order_By>>;
  where?: InputMaybe<Printing_Job_Type_Bool_Exp>;
};


export type Query_RootPrinting_Job_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPrinting_JobsArgs = {
  distinct_on?: InputMaybe<Array<Printing_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Jobs_Order_By>>;
  where?: InputMaybe<Printing_Jobs_Bool_Exp>;
};


export type Query_RootPrinting_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printing_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Jobs_Order_By>>;
  where?: InputMaybe<Printing_Jobs_Bool_Exp>;
};


export type Query_RootSchool_YearArgs = {
  distinct_on?: InputMaybe<Array<School_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<School_Year_Order_By>>;
  where?: InputMaybe<School_Year_Bool_Exp>;
};


export type Query_RootSchool_Year_AggregateArgs = {
  distinct_on?: InputMaybe<Array<School_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<School_Year_Order_By>>;
  where?: InputMaybe<School_Year_Bool_Exp>;
};


export type Query_RootSchool_Year_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootStudentArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootStudent_AccountArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootStudent_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Student_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Accounts_Order_By>>;
  where?: InputMaybe<Student_Accounts_Bool_Exp>;
};


export type Query_RootStudent_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Accounts_Order_By>>;
  where?: InputMaybe<Student_Accounts_Bool_Exp>;
};


export type Query_RootStudent_AssignmentArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStudent_Assignment_StatusArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignment_Status_Order_By>>;
  where?: InputMaybe<Student_Assignment_Status_Bool_Exp>;
};


export type Query_RootStudent_Assignment_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignment_Status_Order_By>>;
  where?: InputMaybe<Student_Assignment_Status_Bool_Exp>;
};


export type Query_RootStudent_Assignment_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootStudent_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


export type Query_RootStudent_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


export type Query_RootStudent_CourseArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStudent_Course_StatusArgs = {
  distinct_on?: InputMaybe<Array<Student_Course_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Course_Status_Order_By>>;
  where?: InputMaybe<Student_Course_Status_Bool_Exp>;
};


export type Query_RootStudent_Course_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Course_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Course_Status_Order_By>>;
  where?: InputMaybe<Student_Course_Status_Bool_Exp>;
};


export type Query_RootStudent_Course_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootStudent_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Student_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Courses_Order_By>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


export type Query_RootStudent_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Courses_Order_By>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


export type Query_RootStudent_EventArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStudent_EventsArgs = {
  distinct_on?: InputMaybe<Array<Student_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Events_Order_By>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};


export type Query_RootStudent_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Events_Order_By>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};


export type Query_RootStudentsArgs = {
  distinct_on?: InputMaybe<Array<Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Students_Order_By>>;
  where?: InputMaybe<Students_Bool_Exp>;
};


export type Query_RootStudents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Students_Order_By>>;
  where?: InputMaybe<Students_Bool_Exp>;
};


export type Query_RootTeacherArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTeachersArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Order_By>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};


export type Query_RootTeachers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Order_By>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};


export type Query_RootTeachers_StudentsArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Students_Order_By>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};


export type Query_RootTeachers_Students_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Students_Order_By>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};


export type Query_RootTeachers_Students_By_PkArgs = {
  studentId: Scalars['String']['input'];
  teacherId: Scalars['String']['input'];
};


export type Query_RootThemesArgs = {
  distinct_on?: InputMaybe<Array<Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Themes_Order_By>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};


export type Query_RootThemes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Themes_Order_By>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};


export type Query_RootThemes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_SettingsArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Query_RootUser_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Query_RootUser_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "school_year" */
export type School_Year = {
  __typename?: 'school_year';
  value: Scalars['String']['output'];
};

/** aggregated selection of "school_year" */
export type School_Year_Aggregate = {
  __typename?: 'school_year_aggregate';
  aggregate?: Maybe<School_Year_Aggregate_Fields>;
  nodes: Array<School_Year>;
};

/** aggregate fields of "school_year" */
export type School_Year_Aggregate_Fields = {
  __typename?: 'school_year_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<School_Year_Max_Fields>;
  min?: Maybe<School_Year_Min_Fields>;
};


/** aggregate fields of "school_year" */
export type School_Year_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<School_Year_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "school_year". All fields are combined with a logical 'AND'. */
export type School_Year_Bool_Exp = {
  _and?: InputMaybe<Array<School_Year_Bool_Exp>>;
  _not?: InputMaybe<School_Year_Bool_Exp>;
  _or?: InputMaybe<Array<School_Year_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "school_year" */
export enum School_Year_Constraint {
  /** unique or primary key constraint on columns "value" */
  SchoolYearPkey = 'school_year_pkey'
}

export enum School_Year_Enum {
  Eighthgrade = 'EIGHTHGRADE',
  Eleventhgrade = 'ELEVENTHGRADE',
  Fifthgrade = 'FIFTHGRADE',
  Firstgrade = 'FIRSTGRADE',
  Fourthgrade = 'FOURTHGRADE',
  Kindergarten = 'KINDERGARTEN',
  Ninthgrade = 'NINTHGRADE',
  Prekindergarten = 'PREKINDERGARTEN',
  Preschool = 'PRESCHOOL',
  Secondgrade = 'SECONDGRADE',
  Seventhgrade = 'SEVENTHGRADE',
  Sixthgrade = 'SIXTHGRADE',
  Tenthgrade = 'TENTHGRADE',
  Thirdgrade = 'THIRDGRADE',
  Twelfthgrade = 'TWELFTHGRADE'
}

/** Boolean expression to compare columns of type "school_year_enum". All fields are combined with logical 'AND'. */
export type School_Year_Enum_Comparison_Exp = {
  _eq?: InputMaybe<School_Year_Enum>;
  _in?: InputMaybe<Array<School_Year_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<School_Year_Enum>;
  _nin?: InputMaybe<Array<School_Year_Enum>>;
};

/** input type for inserting data into table "school_year" */
export type School_Year_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type School_Year_Max_Fields = {
  __typename?: 'school_year_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type School_Year_Min_Fields = {
  __typename?: 'school_year_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "school_year" */
export type School_Year_Mutation_Response = {
  __typename?: 'school_year_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<School_Year>;
};

/** on_conflict condition type for table "school_year" */
export type School_Year_On_Conflict = {
  constraint: School_Year_Constraint;
  update_columns?: Array<School_Year_Update_Column>;
  where?: InputMaybe<School_Year_Bool_Exp>;
};

/** Ordering options when selecting data from "school_year". */
export type School_Year_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: school_year */
export type School_Year_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "school_year" */
export enum School_Year_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "school_year" */
export type School_Year_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "school_year" */
export type School_Year_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: School_Year_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type School_Year_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "school_year" */
export enum School_Year_Update_Column {
  /** column name */
  Value = 'value'
}

export type School_Year_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<School_Year_Set_Input>;
  /** filter the rows which have to be updated */
  where: School_Year_Bool_Exp;
};

/** columns and relationships of "student_accounts" */
export type Student_Accounts = {
  __typename?: 'student_accounts';
  created: Scalars['timestamptz']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  settingsId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  student: Students;
  studentId: Scalars['String']['output'];
  updated: Scalars['timestamptz']['output'];
  /** An object relationship */
  userSettings?: Maybe<User_Settings>;
};

/** aggregated selection of "student_accounts" */
export type Student_Accounts_Aggregate = {
  __typename?: 'student_accounts_aggregate';
  aggregate?: Maybe<Student_Accounts_Aggregate_Fields>;
  nodes: Array<Student_Accounts>;
};

export type Student_Accounts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Student_Accounts_Aggregate_Bool_Exp_Count>;
};

export type Student_Accounts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Student_Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Student_Accounts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "student_accounts" */
export type Student_Accounts_Aggregate_Fields = {
  __typename?: 'student_accounts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Student_Accounts_Max_Fields>;
  min?: Maybe<Student_Accounts_Min_Fields>;
};


/** aggregate fields of "student_accounts" */
export type Student_Accounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Student_Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "student_accounts" */
export type Student_Accounts_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Student_Accounts_Max_Order_By>;
  min?: InputMaybe<Student_Accounts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "student_accounts" */
export type Student_Accounts_Arr_Rel_Insert_Input = {
  data: Array<Student_Accounts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Student_Accounts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "student_accounts". All fields are combined with a logical 'AND'. */
export type Student_Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<Student_Accounts_Bool_Exp>>;
  _not?: InputMaybe<Student_Accounts_Bool_Exp>;
  _or?: InputMaybe<Array<Student_Accounts_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  picture?: InputMaybe<String_Comparison_Exp>;
  settingsId?: InputMaybe<Uuid_Comparison_Exp>;
  student?: InputMaybe<Students_Bool_Exp>;
  studentId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  userSettings?: InputMaybe<User_Settings_Bool_Exp>;
};

/** unique or primary key constraints on table "student_accounts" */
export enum Student_Accounts_Constraint {
  /** unique or primary key constraint on columns "id" */
  StudentAccountsPkey = 'student_accounts_pkey',
  /** unique or primary key constraint on columns "student_id" */
  StudentAccountsStudentIdKey = 'student_accounts_student_id_key'
}

/** input type for inserting data into table "student_accounts" */
export type Student_Accounts_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  settingsId?: InputMaybe<Scalars['uuid']['input']>;
  student?: InputMaybe<Students_Obj_Rel_Insert_Input>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  userSettings?: InputMaybe<User_Settings_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Student_Accounts_Max_Fields = {
  __typename?: 'student_accounts_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  settingsId?: Maybe<Scalars['uuid']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "student_accounts" */
export type Student_Accounts_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Student_Accounts_Min_Fields = {
  __typename?: 'student_accounts_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  settingsId?: Maybe<Scalars['uuid']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "student_accounts" */
export type Student_Accounts_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "student_accounts" */
export type Student_Accounts_Mutation_Response = {
  __typename?: 'student_accounts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Student_Accounts>;
};

/** input type for inserting object relation for remote table "student_accounts" */
export type Student_Accounts_Obj_Rel_Insert_Input = {
  data: Student_Accounts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Student_Accounts_On_Conflict>;
};

/** on_conflict condition type for table "student_accounts" */
export type Student_Accounts_On_Conflict = {
  constraint: Student_Accounts_Constraint;
  update_columns?: Array<Student_Accounts_Update_Column>;
  where?: InputMaybe<Student_Accounts_Bool_Exp>;
};

/** Ordering options when selecting data from "student_accounts". */
export type Student_Accounts_Order_By = {
  created?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  student?: InputMaybe<Students_Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  userSettings?: InputMaybe<User_Settings_Order_By>;
};

/** primary key columns input for table: student_accounts */
export type Student_Accounts_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "student_accounts" */
export enum Student_Accounts_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Picture = 'picture',
  /** column name */
  SettingsId = 'settingsId',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "student_accounts" */
export type Student_Accounts_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  settingsId?: InputMaybe<Scalars['uuid']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "student_accounts" */
export type Student_Accounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Student_Accounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Student_Accounts_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  settingsId?: InputMaybe<Scalars['uuid']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "student_accounts" */
export enum Student_Accounts_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Picture = 'picture',
  /** column name */
  SettingsId = 'settingsId',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Updated = 'updated'
}

export type Student_Accounts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Student_Accounts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Student_Accounts_Bool_Exp;
};

/** columns and relationships of "student_assignment_status" */
export type Student_Assignment_Status = {
  __typename?: 'student_assignment_status';
  value: Scalars['String']['output'];
};

/** aggregated selection of "student_assignment_status" */
export type Student_Assignment_Status_Aggregate = {
  __typename?: 'student_assignment_status_aggregate';
  aggregate?: Maybe<Student_Assignment_Status_Aggregate_Fields>;
  nodes: Array<Student_Assignment_Status>;
};

/** aggregate fields of "student_assignment_status" */
export type Student_Assignment_Status_Aggregate_Fields = {
  __typename?: 'student_assignment_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Student_Assignment_Status_Max_Fields>;
  min?: Maybe<Student_Assignment_Status_Min_Fields>;
};


/** aggregate fields of "student_assignment_status" */
export type Student_Assignment_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Student_Assignment_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "student_assignment_status". All fields are combined with a logical 'AND'. */
export type Student_Assignment_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Student_Assignment_Status_Bool_Exp>>;
  _not?: InputMaybe<Student_Assignment_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Student_Assignment_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "student_assignment_status" */
export enum Student_Assignment_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  StudentAssignmentStatusPkey = 'student_assignment_status_pkey'
}

export enum Student_Assignment_Status_Enum {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'
}

/** Boolean expression to compare columns of type "student_assignment_status_enum". All fields are combined with logical 'AND'. */
export type Student_Assignment_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Student_Assignment_Status_Enum>;
  _in?: InputMaybe<Array<Student_Assignment_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Student_Assignment_Status_Enum>;
  _nin?: InputMaybe<Array<Student_Assignment_Status_Enum>>;
};

/** input type for inserting data into table "student_assignment_status" */
export type Student_Assignment_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Student_Assignment_Status_Max_Fields = {
  __typename?: 'student_assignment_status_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Student_Assignment_Status_Min_Fields = {
  __typename?: 'student_assignment_status_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "student_assignment_status" */
export type Student_Assignment_Status_Mutation_Response = {
  __typename?: 'student_assignment_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Student_Assignment_Status>;
};

/** on_conflict condition type for table "student_assignment_status" */
export type Student_Assignment_Status_On_Conflict = {
  constraint: Student_Assignment_Status_Constraint;
  update_columns?: Array<Student_Assignment_Status_Update_Column>;
  where?: InputMaybe<Student_Assignment_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "student_assignment_status". */
export type Student_Assignment_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: student_assignment_status */
export type Student_Assignment_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "student_assignment_status" */
export enum Student_Assignment_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "student_assignment_status" */
export type Student_Assignment_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "student_assignment_status" */
export type Student_Assignment_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Student_Assignment_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Student_Assignment_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "student_assignment_status" */
export enum Student_Assignment_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Student_Assignment_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Student_Assignment_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Student_Assignment_Status_Bool_Exp;
};

/** columns and relationships of "student_assignments" */
export type Student_Assignments = {
  __typename?: 'student_assignments';
  /** An object relationship */
  assignment: Assignments;
  assignmentId: Scalars['uuid']['output'];
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  completed?: Maybe<Scalars['timestamptz']['output']>;
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: Maybe<Scalars['Int']['output']>;
  created: Scalars['timestamptz']['output'];
  end?: Maybe<Scalars['date']['output']>;
  freeForm: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: Maybe<Scalars['numeric']['output']>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: Maybe<Scalars['numeric']['output']>;
  start?: Maybe<Scalars['date']['output']>;
  status: Student_Assignment_Status_Enum;
  /** An object relationship */
  student: Students;
  /** An object relationship */
  studentCourse: Student_Courses;
  studentCourseId: Scalars['uuid']['output'];
  studentId: Scalars['String']['output'];
  /** An array relationship */
  submissions: Array<Files>;
  /** An aggregate relationship */
  submissions_aggregate: Files_Aggregate;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "student_assignments" */
export type Student_AssignmentsCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** columns and relationships of "student_assignments" */
export type Student_AssignmentsComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** columns and relationships of "student_assignments" */
export type Student_AssignmentsSubmissionsArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "student_assignments" */
export type Student_AssignmentsSubmissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** aggregated selection of "student_assignments" */
export type Student_Assignments_Aggregate = {
  __typename?: 'student_assignments_aggregate';
  aggregate?: Maybe<Student_Assignments_Aggregate_Fields>;
  nodes: Array<Student_Assignments>;
};

export type Student_Assignments_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Student_Assignments_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Student_Assignments_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Student_Assignments_Aggregate_Bool_Exp_Count>;
};

export type Student_Assignments_Aggregate_Bool_Exp_Bool_And = {
  arguments: Student_Assignments_Select_Column_Student_Assignments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Student_Assignments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Student_Assignments_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Student_Assignments_Select_Column_Student_Assignments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Student_Assignments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Student_Assignments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Student_Assignments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "student_assignments" */
export type Student_Assignments_Aggregate_Fields = {
  __typename?: 'student_assignments_aggregate_fields';
  avg?: Maybe<Student_Assignments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Student_Assignments_Max_Fields>;
  min?: Maybe<Student_Assignments_Min_Fields>;
  stddev?: Maybe<Student_Assignments_Stddev_Fields>;
  stddev_pop?: Maybe<Student_Assignments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Student_Assignments_Stddev_Samp_Fields>;
  sum?: Maybe<Student_Assignments_Sum_Fields>;
  var_pop?: Maybe<Student_Assignments_Var_Pop_Fields>;
  var_samp?: Maybe<Student_Assignments_Var_Samp_Fields>;
  variance?: Maybe<Student_Assignments_Variance_Fields>;
};


/** aggregate fields of "student_assignments" */
export type Student_Assignments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "student_assignments" */
export type Student_Assignments_Aggregate_Order_By = {
  avg?: InputMaybe<Student_Assignments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Student_Assignments_Max_Order_By>;
  min?: InputMaybe<Student_Assignments_Min_Order_By>;
  stddev?: InputMaybe<Student_Assignments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Student_Assignments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Student_Assignments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Student_Assignments_Sum_Order_By>;
  var_pop?: InputMaybe<Student_Assignments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Student_Assignments_Var_Samp_Order_By>;
  variance?: InputMaybe<Student_Assignments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "student_assignments" */
export type Student_Assignments_Arr_Rel_Insert_Input = {
  data: Array<Student_Assignments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Student_Assignments_On_Conflict>;
};

/** aggregate avg on columns */
export type Student_Assignments_Avg_Fields = {
  __typename?: 'student_assignments_avg_fields';
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: Maybe<Scalars['Float']['output']>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: Maybe<Scalars['Float']['output']>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "student_assignments" */
export type Student_Assignments_Avg_Order_By = {
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: InputMaybe<Order_By>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: InputMaybe<Order_By>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "student_assignments". All fields are combined with a logical 'AND'. */
export type Student_Assignments_Bool_Exp = {
  _and?: InputMaybe<Array<Student_Assignments_Bool_Exp>>;
  _not?: InputMaybe<Student_Assignments_Bool_Exp>;
  _or?: InputMaybe<Array<Student_Assignments_Bool_Exp>>;
  assignment?: InputMaybe<Assignments_Bool_Exp>;
  assignmentId?: InputMaybe<Uuid_Comparison_Exp>;
  comments?: InputMaybe<Comments_Bool_Exp>;
  comments_aggregate?: InputMaybe<Comments_Aggregate_Bool_Exp>;
  completed?: InputMaybe<Timestamptz_Comparison_Exp>;
  courseDayOffset?: InputMaybe<Int_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  end?: InputMaybe<Date_Comparison_Exp>;
  freeForm?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  pointsAvailable?: InputMaybe<Numeric_Comparison_Exp>;
  pointsEarned?: InputMaybe<Numeric_Comparison_Exp>;
  start?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Student_Assignment_Status_Enum_Comparison_Exp>;
  student?: InputMaybe<Students_Bool_Exp>;
  studentCourse?: InputMaybe<Student_Courses_Bool_Exp>;
  studentCourseId?: InputMaybe<Uuid_Comparison_Exp>;
  studentId?: InputMaybe<String_Comparison_Exp>;
  submissions?: InputMaybe<Files_Bool_Exp>;
  submissions_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "student_assignments" */
export enum Student_Assignments_Constraint {
  /** unique or primary key constraint on columns "id" */
  StudentAssignmentsPkey = 'student_assignments_pkey'
}

/** input type for incrementing numeric columns in table "student_assignments" */
export type Student_Assignments_Inc_Input = {
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: InputMaybe<Scalars['Int']['input']>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: InputMaybe<Scalars['numeric']['input']>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "student_assignments" */
export type Student_Assignments_Insert_Input = {
  assignment?: InputMaybe<Assignments_Obj_Rel_Insert_Input>;
  assignmentId?: InputMaybe<Scalars['uuid']['input']>;
  comments?: InputMaybe<Comments_Arr_Rel_Insert_Input>;
  completed?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  freeForm?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: InputMaybe<Scalars['numeric']['input']>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: InputMaybe<Scalars['numeric']['input']>;
  start?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Student_Assignment_Status_Enum>;
  student?: InputMaybe<Students_Obj_Rel_Insert_Input>;
  studentCourse?: InputMaybe<Student_Courses_Obj_Rel_Insert_Input>;
  studentCourseId?: InputMaybe<Scalars['uuid']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  submissions?: InputMaybe<Files_Arr_Rel_Insert_Input>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Student_Assignments_Max_Fields = {
  __typename?: 'student_assignments_max_fields';
  assignmentId?: Maybe<Scalars['uuid']['output']>;
  completed?: Maybe<Scalars['timestamptz']['output']>;
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  end?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: Maybe<Scalars['numeric']['output']>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: Maybe<Scalars['numeric']['output']>;
  start?: Maybe<Scalars['date']['output']>;
  studentCourseId?: Maybe<Scalars['uuid']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "student_assignments" */
export type Student_Assignments_Max_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  completed?: InputMaybe<Order_By>;
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: InputMaybe<Order_By>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  studentCourseId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Student_Assignments_Min_Fields = {
  __typename?: 'student_assignments_min_fields';
  assignmentId?: Maybe<Scalars['uuid']['output']>;
  completed?: Maybe<Scalars['timestamptz']['output']>;
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  end?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: Maybe<Scalars['numeric']['output']>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: Maybe<Scalars['numeric']['output']>;
  start?: Maybe<Scalars['date']['output']>;
  studentCourseId?: Maybe<Scalars['uuid']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "student_assignments" */
export type Student_Assignments_Min_Order_By = {
  assignmentId?: InputMaybe<Order_By>;
  completed?: InputMaybe<Order_By>;
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: InputMaybe<Order_By>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  studentCourseId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "student_assignments" */
export type Student_Assignments_Mutation_Response = {
  __typename?: 'student_assignments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Student_Assignments>;
};

/** input type for inserting object relation for remote table "student_assignments" */
export type Student_Assignments_Obj_Rel_Insert_Input = {
  data: Student_Assignments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Student_Assignments_On_Conflict>;
};

/** on_conflict condition type for table "student_assignments" */
export type Student_Assignments_On_Conflict = {
  constraint: Student_Assignments_Constraint;
  update_columns?: Array<Student_Assignments_Update_Column>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};

/** Ordering options when selecting data from "student_assignments". */
export type Student_Assignments_Order_By = {
  assignment?: InputMaybe<Assignments_Order_By>;
  assignmentId?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  completed?: InputMaybe<Order_By>;
  courseDayOffset?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  freeForm?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pointsAvailable?: InputMaybe<Order_By>;
  pointsEarned?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  student?: InputMaybe<Students_Order_By>;
  studentCourse?: InputMaybe<Student_Courses_Order_By>;
  studentCourseId?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  submissions_aggregate?: InputMaybe<Files_Aggregate_Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: student_assignments */
export type Student_Assignments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "student_assignments" */
export enum Student_Assignments_Select_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  Completed = 'completed',
  /** column name */
  CourseDayOffset = 'courseDayOffset',
  /** column name */
  Created = 'created',
  /** column name */
  End = 'end',
  /** column name */
  FreeForm = 'freeForm',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  PointsAvailable = 'pointsAvailable',
  /** column name */
  PointsEarned = 'pointsEarned',
  /** column name */
  Start = 'start',
  /** column name */
  Status = 'status',
  /** column name */
  StudentCourseId = 'studentCourseId',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Updated = 'updated'
}

/** select "student_assignments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "student_assignments" */
export enum Student_Assignments_Select_Column_Student_Assignments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  FreeForm = 'freeForm'
}

/** select "student_assignments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "student_assignments" */
export enum Student_Assignments_Select_Column_Student_Assignments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  FreeForm = 'freeForm'
}

/** input type for updating data in table "student_assignments" */
export type Student_Assignments_Set_Input = {
  assignmentId?: InputMaybe<Scalars['uuid']['input']>;
  completed?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  freeForm?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: InputMaybe<Scalars['numeric']['input']>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: InputMaybe<Scalars['numeric']['input']>;
  start?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Student_Assignment_Status_Enum>;
  studentCourseId?: InputMaybe<Scalars['uuid']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Student_Assignments_Stddev_Fields = {
  __typename?: 'student_assignments_stddev_fields';
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: Maybe<Scalars['Float']['output']>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: Maybe<Scalars['Float']['output']>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "student_assignments" */
export type Student_Assignments_Stddev_Order_By = {
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: InputMaybe<Order_By>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: InputMaybe<Order_By>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Student_Assignments_Stddev_Pop_Fields = {
  __typename?: 'student_assignments_stddev_pop_fields';
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: Maybe<Scalars['Float']['output']>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: Maybe<Scalars['Float']['output']>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "student_assignments" */
export type Student_Assignments_Stddev_Pop_Order_By = {
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: InputMaybe<Order_By>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: InputMaybe<Order_By>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Student_Assignments_Stddev_Samp_Fields = {
  __typename?: 'student_assignments_stddev_samp_fields';
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: Maybe<Scalars['Float']['output']>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: Maybe<Scalars['Float']['output']>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "student_assignments" */
export type Student_Assignments_Stddev_Samp_Order_By = {
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: InputMaybe<Order_By>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: InputMaybe<Order_By>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "student_assignments" */
export type Student_Assignments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Student_Assignments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Student_Assignments_Stream_Cursor_Value_Input = {
  assignmentId?: InputMaybe<Scalars['uuid']['input']>;
  completed?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  freeForm?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: InputMaybe<Scalars['numeric']['input']>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: InputMaybe<Scalars['numeric']['input']>;
  start?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Student_Assignment_Status_Enum>;
  studentCourseId?: InputMaybe<Scalars['uuid']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Student_Assignments_Sum_Fields = {
  __typename?: 'student_assignments_sum_fields';
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: Maybe<Scalars['Int']['output']>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: Maybe<Scalars['numeric']['output']>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "student_assignments" */
export type Student_Assignments_Sum_Order_By = {
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: InputMaybe<Order_By>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: InputMaybe<Order_By>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: InputMaybe<Order_By>;
};

/** update columns of table "student_assignments" */
export enum Student_Assignments_Update_Column {
  /** column name */
  AssignmentId = 'assignmentId',
  /** column name */
  Completed = 'completed',
  /** column name */
  CourseDayOffset = 'courseDayOffset',
  /** column name */
  Created = 'created',
  /** column name */
  End = 'end',
  /** column name */
  FreeForm = 'freeForm',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  PointsAvailable = 'pointsAvailable',
  /** column name */
  PointsEarned = 'pointsEarned',
  /** column name */
  Start = 'start',
  /** column name */
  Status = 'status',
  /** column name */
  StudentCourseId = 'studentCourseId',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Updated = 'updated'
}

export type Student_Assignments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Student_Assignments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Student_Assignments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Student_Assignments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Student_Assignments_Var_Pop_Fields = {
  __typename?: 'student_assignments_var_pop_fields';
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: Maybe<Scalars['Float']['output']>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: Maybe<Scalars['Float']['output']>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "student_assignments" */
export type Student_Assignments_Var_Pop_Order_By = {
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: InputMaybe<Order_By>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: InputMaybe<Order_By>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Student_Assignments_Var_Samp_Fields = {
  __typename?: 'student_assignments_var_samp_fields';
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: Maybe<Scalars['Float']['output']>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: Maybe<Scalars['Float']['output']>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "student_assignments" */
export type Student_Assignments_Var_Samp_Order_By = {
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: InputMaybe<Order_By>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: InputMaybe<Order_By>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Student_Assignments_Variance_Fields = {
  __typename?: 'student_assignments_variance_fields';
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: Maybe<Scalars['Float']['output']>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: Maybe<Scalars['Float']['output']>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "student_assignments" */
export type Student_Assignments_Variance_Order_By = {
  /** Number of course days before or after the parent assignment's day/week. */
  courseDayOffset?: InputMaybe<Order_By>;
  /** used in combination with points_earned to grade courses and assignments */
  pointsAvailable?: InputMaybe<Order_By>;
  /** used in combination with points_available to grade courses and assignments */
  pointsEarned?: InputMaybe<Order_By>;
};

/** columns and relationships of "student_course_status" */
export type Student_Course_Status = {
  __typename?: 'student_course_status';
  value: Scalars['String']['output'];
};

/** aggregated selection of "student_course_status" */
export type Student_Course_Status_Aggregate = {
  __typename?: 'student_course_status_aggregate';
  aggregate?: Maybe<Student_Course_Status_Aggregate_Fields>;
  nodes: Array<Student_Course_Status>;
};

/** aggregate fields of "student_course_status" */
export type Student_Course_Status_Aggregate_Fields = {
  __typename?: 'student_course_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Student_Course_Status_Max_Fields>;
  min?: Maybe<Student_Course_Status_Min_Fields>;
};


/** aggregate fields of "student_course_status" */
export type Student_Course_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Student_Course_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "student_course_status". All fields are combined with a logical 'AND'. */
export type Student_Course_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Student_Course_Status_Bool_Exp>>;
  _not?: InputMaybe<Student_Course_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Student_Course_Status_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "student_course_status" */
export enum Student_Course_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  StudentCourseStatusPkey = 'student_course_status_pkey'
}

export enum Student_Course_Status_Enum {
  Completed = 'COMPLETED',
  Dropped = 'DROPPED',
  Enrolled = 'ENROLLED'
}

/** Boolean expression to compare columns of type "student_course_status_enum". All fields are combined with logical 'AND'. */
export type Student_Course_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Student_Course_Status_Enum>;
  _in?: InputMaybe<Array<Student_Course_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Student_Course_Status_Enum>;
  _nin?: InputMaybe<Array<Student_Course_Status_Enum>>;
};

/** input type for inserting data into table "student_course_status" */
export type Student_Course_Status_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Student_Course_Status_Max_Fields = {
  __typename?: 'student_course_status_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Student_Course_Status_Min_Fields = {
  __typename?: 'student_course_status_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "student_course_status" */
export type Student_Course_Status_Mutation_Response = {
  __typename?: 'student_course_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Student_Course_Status>;
};

/** on_conflict condition type for table "student_course_status" */
export type Student_Course_Status_On_Conflict = {
  constraint: Student_Course_Status_Constraint;
  update_columns?: Array<Student_Course_Status_Update_Column>;
  where?: InputMaybe<Student_Course_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "student_course_status". */
export type Student_Course_Status_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: student_course_status */
export type Student_Course_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "student_course_status" */
export enum Student_Course_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "student_course_status" */
export type Student_Course_Status_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "student_course_status" */
export type Student_Course_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Student_Course_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Student_Course_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "student_course_status" */
export enum Student_Course_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Student_Course_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Student_Course_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Student_Course_Status_Bool_Exp;
};

/** columns and relationships of "student_courses" */
export type Student_Courses = {
  __typename?: 'student_courses';
  calendarYear?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  course?: Maybe<Courses>;
  courseDayOffsets?: Maybe<Scalars['jsonb']['output']>;
  courseId?: Maybe<Scalars['uuid']['output']>;
  courseSnapshot?: Maybe<Scalars['jsonb']['output']>;
  created: Scalars['timestamptz']['output'];
  dailySortOrder: Scalars['jsonb']['output'];
  daysOfTheWeek: Scalars['jsonb']['output'];
  end: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  schoolYear?: Maybe<School_Year_Enum>;
  start: Scalars['date']['output'];
  status: Student_Course_Status_Enum;
  /** An object relationship */
  student: Students;
  /** An array relationship */
  studentAssignments: Array<Student_Assignments>;
  /** An aggregate relationship */
  studentAssignments_aggregate: Student_Assignments_Aggregate;
  studentId: Scalars['String']['output'];
  updated?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "student_courses" */
export type Student_CoursesCourseDayOffsetsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "student_courses" */
export type Student_CoursesCourseSnapshotArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "student_courses" */
export type Student_CoursesDailySortOrderArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "student_courses" */
export type Student_CoursesDaysOfTheWeekArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "student_courses" */
export type Student_CoursesStudentAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


/** columns and relationships of "student_courses" */
export type Student_CoursesStudentAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};

/** aggregated selection of "student_courses" */
export type Student_Courses_Aggregate = {
  __typename?: 'student_courses_aggregate';
  aggregate?: Maybe<Student_Courses_Aggregate_Fields>;
  nodes: Array<Student_Courses>;
};

export type Student_Courses_Aggregate_Bool_Exp = {
  count?: InputMaybe<Student_Courses_Aggregate_Bool_Exp_Count>;
};

export type Student_Courses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Student_Courses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Student_Courses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "student_courses" */
export type Student_Courses_Aggregate_Fields = {
  __typename?: 'student_courses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Student_Courses_Max_Fields>;
  min?: Maybe<Student_Courses_Min_Fields>;
};


/** aggregate fields of "student_courses" */
export type Student_Courses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Student_Courses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "student_courses" */
export type Student_Courses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Student_Courses_Max_Order_By>;
  min?: InputMaybe<Student_Courses_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Student_Courses_Append_Input = {
  courseDayOffsets?: InputMaybe<Scalars['jsonb']['input']>;
  courseSnapshot?: InputMaybe<Scalars['jsonb']['input']>;
  dailySortOrder?: InputMaybe<Scalars['jsonb']['input']>;
  daysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "student_courses" */
export type Student_Courses_Arr_Rel_Insert_Input = {
  data: Array<Student_Courses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Student_Courses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "student_courses". All fields are combined with a logical 'AND'. */
export type Student_Courses_Bool_Exp = {
  _and?: InputMaybe<Array<Student_Courses_Bool_Exp>>;
  _not?: InputMaybe<Student_Courses_Bool_Exp>;
  _or?: InputMaybe<Array<Student_Courses_Bool_Exp>>;
  calendarYear?: InputMaybe<String_Comparison_Exp>;
  course?: InputMaybe<Courses_Bool_Exp>;
  courseDayOffsets?: InputMaybe<Jsonb_Comparison_Exp>;
  courseId?: InputMaybe<Uuid_Comparison_Exp>;
  courseSnapshot?: InputMaybe<Jsonb_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  dailySortOrder?: InputMaybe<Jsonb_Comparison_Exp>;
  daysOfTheWeek?: InputMaybe<Jsonb_Comparison_Exp>;
  end?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  schoolYear?: InputMaybe<School_Year_Enum_Comparison_Exp>;
  start?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Student_Course_Status_Enum_Comparison_Exp>;
  student?: InputMaybe<Students_Bool_Exp>;
  studentAssignments?: InputMaybe<Student_Assignments_Bool_Exp>;
  studentAssignments_aggregate?: InputMaybe<Student_Assignments_Aggregate_Bool_Exp>;
  studentId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "student_courses" */
export enum Student_Courses_Constraint {
  /** unique or primary key constraint on columns "id" */
  StudentCoursesPkey = 'student_courses_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Student_Courses_Delete_At_Path_Input = {
  courseDayOffsets?: InputMaybe<Array<Scalars['String']['input']>>;
  courseSnapshot?: InputMaybe<Array<Scalars['String']['input']>>;
  dailySortOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  daysOfTheWeek?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Student_Courses_Delete_Elem_Input = {
  courseDayOffsets?: InputMaybe<Scalars['Int']['input']>;
  courseSnapshot?: InputMaybe<Scalars['Int']['input']>;
  dailySortOrder?: InputMaybe<Scalars['Int']['input']>;
  daysOfTheWeek?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Student_Courses_Delete_Key_Input = {
  courseDayOffsets?: InputMaybe<Scalars['String']['input']>;
  courseSnapshot?: InputMaybe<Scalars['String']['input']>;
  dailySortOrder?: InputMaybe<Scalars['String']['input']>;
  daysOfTheWeek?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "student_courses" */
export type Student_Courses_Insert_Input = {
  calendarYear?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<Courses_Obj_Rel_Insert_Input>;
  courseDayOffsets?: InputMaybe<Scalars['jsonb']['input']>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  courseSnapshot?: InputMaybe<Scalars['jsonb']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  dailySortOrder?: InputMaybe<Scalars['jsonb']['input']>;
  daysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  schoolYear?: InputMaybe<School_Year_Enum>;
  start?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Student_Course_Status_Enum>;
  student?: InputMaybe<Students_Obj_Rel_Insert_Input>;
  studentAssignments?: InputMaybe<Student_Assignments_Arr_Rel_Insert_Input>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Student_Courses_Max_Fields = {
  __typename?: 'student_courses_max_fields';
  calendarYear?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  end?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  start?: Maybe<Scalars['date']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "student_courses" */
export type Student_Courses_Max_Order_By = {
  calendarYear?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Student_Courses_Min_Fields = {
  __typename?: 'student_courses_min_fields';
  calendarYear?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['uuid']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  end?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  start?: Maybe<Scalars['date']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "student_courses" */
export type Student_Courses_Min_Order_By = {
  calendarYear?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "student_courses" */
export type Student_Courses_Mutation_Response = {
  __typename?: 'student_courses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Student_Courses>;
};

/** input type for inserting object relation for remote table "student_courses" */
export type Student_Courses_Obj_Rel_Insert_Input = {
  data: Student_Courses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Student_Courses_On_Conflict>;
};

/** on_conflict condition type for table "student_courses" */
export type Student_Courses_On_Conflict = {
  constraint: Student_Courses_Constraint;
  update_columns?: Array<Student_Courses_Update_Column>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};

/** Ordering options when selecting data from "student_courses". */
export type Student_Courses_Order_By = {
  calendarYear?: InputMaybe<Order_By>;
  course?: InputMaybe<Courses_Order_By>;
  courseDayOffsets?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  courseSnapshot?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  dailySortOrder?: InputMaybe<Order_By>;
  daysOfTheWeek?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  schoolYear?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  student?: InputMaybe<Students_Order_By>;
  studentAssignments_aggregate?: InputMaybe<Student_Assignments_Aggregate_Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: student_courses */
export type Student_Courses_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Student_Courses_Prepend_Input = {
  courseDayOffsets?: InputMaybe<Scalars['jsonb']['input']>;
  courseSnapshot?: InputMaybe<Scalars['jsonb']['input']>;
  dailySortOrder?: InputMaybe<Scalars['jsonb']['input']>;
  daysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "student_courses" */
export enum Student_Courses_Select_Column {
  /** column name */
  CalendarYear = 'calendarYear',
  /** column name */
  CourseDayOffsets = 'courseDayOffsets',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CourseSnapshot = 'courseSnapshot',
  /** column name */
  Created = 'created',
  /** column name */
  DailySortOrder = 'dailySortOrder',
  /** column name */
  DaysOfTheWeek = 'daysOfTheWeek',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  SchoolYear = 'schoolYear',
  /** column name */
  Start = 'start',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "student_courses" */
export type Student_Courses_Set_Input = {
  calendarYear?: InputMaybe<Scalars['String']['input']>;
  courseDayOffsets?: InputMaybe<Scalars['jsonb']['input']>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  courseSnapshot?: InputMaybe<Scalars['jsonb']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  dailySortOrder?: InputMaybe<Scalars['jsonb']['input']>;
  daysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  schoolYear?: InputMaybe<School_Year_Enum>;
  start?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Student_Course_Status_Enum>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "student_courses" */
export type Student_Courses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Student_Courses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Student_Courses_Stream_Cursor_Value_Input = {
  calendarYear?: InputMaybe<Scalars['String']['input']>;
  courseDayOffsets?: InputMaybe<Scalars['jsonb']['input']>;
  courseId?: InputMaybe<Scalars['uuid']['input']>;
  courseSnapshot?: InputMaybe<Scalars['jsonb']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  dailySortOrder?: InputMaybe<Scalars['jsonb']['input']>;
  daysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  schoolYear?: InputMaybe<School_Year_Enum>;
  start?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Student_Course_Status_Enum>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "student_courses" */
export enum Student_Courses_Update_Column {
  /** column name */
  CalendarYear = 'calendarYear',
  /** column name */
  CourseDayOffsets = 'courseDayOffsets',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CourseSnapshot = 'courseSnapshot',
  /** column name */
  Created = 'created',
  /** column name */
  DailySortOrder = 'dailySortOrder',
  /** column name */
  DaysOfTheWeek = 'daysOfTheWeek',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  SchoolYear = 'schoolYear',
  /** column name */
  Start = 'start',
  /** column name */
  Status = 'status',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Updated = 'updated'
}

export type Student_Courses_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Student_Courses_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Student_Courses_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Student_Courses_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Student_Courses_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Student_Courses_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Student_Courses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Student_Courses_Bool_Exp;
};

/** columns and relationships of "student_events" */
export type Student_Events = {
  __typename?: 'student_events';
  created: Scalars['timestamptz']['output'];
  /** An object relationship */
  event: Events;
  eventId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  student: Students;
  studentId: Scalars['String']['output'];
  updated: Scalars['timestamptz']['output'];
};

/** aggregated selection of "student_events" */
export type Student_Events_Aggregate = {
  __typename?: 'student_events_aggregate';
  aggregate?: Maybe<Student_Events_Aggregate_Fields>;
  nodes: Array<Student_Events>;
};

export type Student_Events_Aggregate_Bool_Exp = {
  count?: InputMaybe<Student_Events_Aggregate_Bool_Exp_Count>;
};

export type Student_Events_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Student_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Student_Events_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "student_events" */
export type Student_Events_Aggregate_Fields = {
  __typename?: 'student_events_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Student_Events_Max_Fields>;
  min?: Maybe<Student_Events_Min_Fields>;
};


/** aggregate fields of "student_events" */
export type Student_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Student_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "student_events" */
export type Student_Events_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Student_Events_Max_Order_By>;
  min?: InputMaybe<Student_Events_Min_Order_By>;
};

/** input type for inserting array relation for remote table "student_events" */
export type Student_Events_Arr_Rel_Insert_Input = {
  data: Array<Student_Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Student_Events_On_Conflict>;
};

/** Boolean expression to filter rows from the table "student_events". All fields are combined with a logical 'AND'. */
export type Student_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Student_Events_Bool_Exp>>;
  _not?: InputMaybe<Student_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Student_Events_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  student?: InputMaybe<Students_Bool_Exp>;
  studentId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "student_events" */
export enum Student_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  StudentEventsPkey = 'student_events_pkey'
}

/** input type for inserting data into table "student_events" */
export type Student_Events_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  student?: InputMaybe<Students_Obj_Rel_Insert_Input>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Student_Events_Max_Fields = {
  __typename?: 'student_events_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  eventId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "student_events" */
export type Student_Events_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Student_Events_Min_Fields = {
  __typename?: 'student_events_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  eventId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "student_events" */
export type Student_Events_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "student_events" */
export type Student_Events_Mutation_Response = {
  __typename?: 'student_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Student_Events>;
};

/** on_conflict condition type for table "student_events" */
export type Student_Events_On_Conflict = {
  constraint: Student_Events_Constraint;
  update_columns?: Array<Student_Events_Update_Column>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "student_events". */
export type Student_Events_Order_By = {
  created?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  student?: InputMaybe<Students_Order_By>;
  studentId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: student_events */
export type Student_Events_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "student_events" */
export enum Student_Events_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "student_events" */
export type Student_Events_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  eventId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "student_events" */
export type Student_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Student_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Student_Events_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  eventId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "student_events" */
export enum Student_Events_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  Updated = 'updated'
}

export type Student_Events_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Student_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Student_Events_Bool_Exp;
};

/** columns and relationships of "students" */
export type Students = {
  __typename?: 'students';
  created: Scalars['timestamptz']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  picture?: Maybe<Scalars['String']['output']>;
  schoolYear?: Maybe<School_Year_Enum>;
  /** An object relationship */
  studentAccount?: Maybe<Student_Accounts>;
  /** An array relationship */
  studentAssignments: Array<Student_Assignments>;
  /** An aggregate relationship */
  studentAssignments_aggregate: Student_Assignments_Aggregate;
  /** An array relationship */
  studentCourses: Array<Student_Courses>;
  /** An aggregate relationship */
  studentCourses_aggregate: Student_Courses_Aggregate;
  /** An array relationship */
  studentEvents: Array<Student_Events>;
  /** An aggregate relationship */
  studentEvents_aggregate: Student_Events_Aggregate;
  /** An array relationship */
  teachers: Array<Teachers_Students>;
  /** An aggregate relationship */
  teachers_aggregate: Teachers_Students_Aggregate;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "students" */
export type StudentsStudentAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


/** columns and relationships of "students" */
export type StudentsStudentAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


/** columns and relationships of "students" */
export type StudentsStudentCoursesArgs = {
  distinct_on?: InputMaybe<Array<Student_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Courses_Order_By>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


/** columns and relationships of "students" */
export type StudentsStudentCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Courses_Order_By>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


/** columns and relationships of "students" */
export type StudentsStudentEventsArgs = {
  distinct_on?: InputMaybe<Array<Student_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Events_Order_By>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};


/** columns and relationships of "students" */
export type StudentsStudentEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Events_Order_By>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};


/** columns and relationships of "students" */
export type StudentsTeachersArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Students_Order_By>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};


/** columns and relationships of "students" */
export type StudentsTeachers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Students_Order_By>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};

/** aggregated selection of "students" */
export type Students_Aggregate = {
  __typename?: 'students_aggregate';
  aggregate?: Maybe<Students_Aggregate_Fields>;
  nodes: Array<Students>;
};

/** aggregate fields of "students" */
export type Students_Aggregate_Fields = {
  __typename?: 'students_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Students_Max_Fields>;
  min?: Maybe<Students_Min_Fields>;
};


/** aggregate fields of "students" */
export type Students_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Students_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "students". All fields are combined with a logical 'AND'. */
export type Students_Bool_Exp = {
  _and?: InputMaybe<Array<Students_Bool_Exp>>;
  _not?: InputMaybe<Students_Bool_Exp>;
  _or?: InputMaybe<Array<Students_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  picture?: InputMaybe<String_Comparison_Exp>;
  schoolYear?: InputMaybe<School_Year_Enum_Comparison_Exp>;
  studentAccount?: InputMaybe<Student_Accounts_Bool_Exp>;
  studentAssignments?: InputMaybe<Student_Assignments_Bool_Exp>;
  studentAssignments_aggregate?: InputMaybe<Student_Assignments_Aggregate_Bool_Exp>;
  studentCourses?: InputMaybe<Student_Courses_Bool_Exp>;
  studentCourses_aggregate?: InputMaybe<Student_Courses_Aggregate_Bool_Exp>;
  studentEvents?: InputMaybe<Student_Events_Bool_Exp>;
  studentEvents_aggregate?: InputMaybe<Student_Events_Aggregate_Bool_Exp>;
  teachers?: InputMaybe<Teachers_Students_Bool_Exp>;
  teachers_aggregate?: InputMaybe<Teachers_Students_Aggregate_Bool_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "students" */
export enum Students_Constraint {
  /** unique or primary key constraint on columns "id" */
  StudentsPkey = 'students_pkey'
}

/** input type for inserting data into table "students" */
export type Students_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  schoolYear?: InputMaybe<School_Year_Enum>;
  studentAccount?: InputMaybe<Student_Accounts_Obj_Rel_Insert_Input>;
  studentAssignments?: InputMaybe<Student_Assignments_Arr_Rel_Insert_Input>;
  studentCourses?: InputMaybe<Student_Courses_Arr_Rel_Insert_Input>;
  studentEvents?: InputMaybe<Student_Events_Arr_Rel_Insert_Input>;
  teachers?: InputMaybe<Teachers_Students_Arr_Rel_Insert_Input>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Students_Max_Fields = {
  __typename?: 'students_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Students_Min_Fields = {
  __typename?: 'students_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "students" */
export type Students_Mutation_Response = {
  __typename?: 'students_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Students>;
};

/** input type for inserting object relation for remote table "students" */
export type Students_Obj_Rel_Insert_Input = {
  data: Students_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Students_On_Conflict>;
};

/** on_conflict condition type for table "students" */
export type Students_On_Conflict = {
  constraint: Students_Constraint;
  update_columns?: Array<Students_Update_Column>;
  where?: InputMaybe<Students_Bool_Exp>;
};

/** Ordering options when selecting data from "students". */
export type Students_Order_By = {
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  schoolYear?: InputMaybe<Order_By>;
  studentAccount?: InputMaybe<Student_Accounts_Order_By>;
  studentAssignments_aggregate?: InputMaybe<Student_Assignments_Aggregate_Order_By>;
  studentCourses_aggregate?: InputMaybe<Student_Courses_Aggregate_Order_By>;
  studentEvents_aggregate?: InputMaybe<Student_Events_Aggregate_Order_By>;
  teachers_aggregate?: InputMaybe<Teachers_Students_Aggregate_Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: students */
export type Students_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "students" */
export enum Students_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Picture = 'picture',
  /** column name */
  SchoolYear = 'schoolYear',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "students" */
export type Students_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  schoolYear?: InputMaybe<School_Year_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "students" */
export type Students_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Students_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Students_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  schoolYear?: InputMaybe<School_Year_Enum>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "students" */
export enum Students_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Picture = 'picture',
  /** column name */
  SchoolYear = 'schoolYear',
  /** column name */
  Updated = 'updated'
}

export type Students_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Students_Set_Input>;
  /** filter the rows which have to be updated */
  where: Students_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "assignments" using primary key columns */
  assignment?: Maybe<Assignments>;
  /** fetch data from the table: "assignment_type" */
  assignment_type: Array<Assignment_Type>;
  /** fetch aggregated fields from the table: "assignment_type" */
  assignment_type_aggregate: Assignment_Type_Aggregate;
  /** fetch data from the table: "assignment_type" using primary key columns */
  assignment_type_by_pk?: Maybe<Assignment_Type>;
  /** fetch data from the table in a streaming manner: "assignment_type" */
  assignment_type_stream: Array<Assignment_Type>;
  /** fetch data from the table: "assignment_type_weights" using primary key columns */
  assignment_type_weight?: Maybe<Assignment_Type_Weights>;
  /** fetch data from the table: "assignment_type_weights" */
  assignment_type_weights: Array<Assignment_Type_Weights>;
  /** fetch aggregated fields from the table: "assignment_type_weights" */
  assignment_type_weights_aggregate: Assignment_Type_Weights_Aggregate;
  /** fetch data from the table in a streaming manner: "assignment_type_weights" */
  assignment_type_weights_stream: Array<Assignment_Type_Weights>;
  /** An array relationship */
  assignments: Array<Assignments>;
  /** An aggregate relationship */
  assignments_aggregate: Assignments_Aggregate;
  /** fetch data from the table in a streaming manner: "assignments" */
  assignments_stream: Array<Assignments>;
  /** fetch data from the table: "comments" using primary key columns */
  comment?: Maybe<Comments>;
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  /** fetch data from the table in a streaming manner: "comments" */
  comments_stream: Array<Comments>;
  /** fetch data from the table: "courses" using primary key columns */
  course?: Maybe<Courses>;
  /** An array relationship */
  courses: Array<Courses>;
  /** An aggregate relationship */
  courses_aggregate: Courses_Aggregate;
  /** fetch data from the table in a streaming manner: "courses" */
  courses_stream: Array<Courses>;
  /** fetch data from the table: "custom_assignment_types" using primary key columns */
  custom_assignment_type?: Maybe<Custom_Assignment_Types>;
  /** fetch data from the table: "custom_assignment_types" */
  custom_assignment_types: Array<Custom_Assignment_Types>;
  /** fetch aggregated fields from the table: "custom_assignment_types" */
  custom_assignment_types_aggregate: Custom_Assignment_Types_Aggregate;
  /** fetch data from the table in a streaming manner: "custom_assignment_types" */
  custom_assignment_types_stream: Array<Custom_Assignment_Types>;
  /** fetch data from the table: "customers" using primary key columns */
  customer?: Maybe<Customers>;
  /** fetch data from the table: "customers" */
  customers: Array<Customers>;
  /** fetch aggregated fields from the table: "customers" */
  customers_aggregate: Customers_Aggregate;
  /** fetch data from the table in a streaming manner: "customers" */
  customers_stream: Array<Customers>;
  /** fetch data from the table: "events" using primary key columns */
  event?: Maybe<Events>;
  /** fetch data from the table: "event_t" */
  event_t: Array<Event_T>;
  /** fetch aggregated fields from the table: "event_t" */
  event_t_aggregate: Event_T_Aggregate;
  /** fetch data from the table in a streaming manner: "event_t" */
  event_t_stream: Array<Event_T>;
  /** fetch data from the table: "event_t" using primary key columns */
  event_type?: Maybe<Event_T>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  events_aggregate: Events_Aggregate;
  /** fetch data from the table in a streaming manner: "events" */
  events_stream: Array<Events>;
  /** fetch data from the table: "files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  /** fetch data from the table in a streaming manner: "files" */
  files_stream: Array<Files>;
  /** fetch data from the table: "grading_style" */
  grading_style: Array<Grading_Style>;
  /** fetch aggregated fields from the table: "grading_style" */
  grading_style_aggregate: Grading_Style_Aggregate;
  /** fetch data from the table: "grading_style" using primary key columns */
  grading_style_by_pk?: Maybe<Grading_Style>;
  /** fetch data from the table in a streaming manner: "grading_style" */
  grading_style_stream: Array<Grading_Style>;
  /** fetch data from the table: "organizations" using primary key columns */
  organization?: Maybe<Organizations>;
  /** fetch data from the table: "organization_admins" using primary key columns */
  organization_admin?: Maybe<Organization_Admins>;
  /** fetch data from the table: "organization_admins" */
  organization_admins: Array<Organization_Admins>;
  /** fetch aggregated fields from the table: "organization_admins" */
  organization_admins_aggregate: Organization_Admins_Aggregate;
  /** fetch data from the table in a streaming manner: "organization_admins" */
  organization_admins_stream: Array<Organization_Admins>;
  /** fetch data from the table: "organization_codes" using primary key columns */
  organization_code?: Maybe<Organization_Codes>;
  /** fetch data from the table: "organization_codes" */
  organization_codes: Array<Organization_Codes>;
  /** fetch aggregated fields from the table: "organization_codes" */
  organization_codes_aggregate: Organization_Codes_Aggregate;
  /** fetch data from the table in a streaming manner: "organization_codes" */
  organization_codes_stream: Array<Organization_Codes>;
  /** An array relationship */
  organizations: Array<Organizations>;
  /** An aggregate relationship */
  organizations_aggregate: Organizations_Aggregate;
  /** fetch data from the table in a streaming manner: "organizations" */
  organizations_stream: Array<Organizations>;
  /** fetch data from the table: "parrot_requests" using primary key columns */
  parrot_request?: Maybe<Parrot_Requests>;
  /** fetch data from the table: "parrot_request_status" */
  parrot_request_status: Array<Parrot_Request_Status>;
  /** fetch aggregated fields from the table: "parrot_request_status" */
  parrot_request_status_aggregate: Parrot_Request_Status_Aggregate;
  /** fetch data from the table: "parrot_request_status" using primary key columns */
  parrot_request_status_by_pk?: Maybe<Parrot_Request_Status>;
  /** fetch data from the table in a streaming manner: "parrot_request_status" */
  parrot_request_status_stream: Array<Parrot_Request_Status>;
  /** fetch data from the table: "parrot_requests" */
  parrot_requests: Array<Parrot_Requests>;
  /** fetch aggregated fields from the table: "parrot_requests" */
  parrot_requests_aggregate: Parrot_Requests_Aggregate;
  /** fetch data from the table in a streaming manner: "parrot_requests" */
  parrot_requests_stream: Array<Parrot_Requests>;
  /** fetch data from the table: "plan_tier" */
  plan_tier: Array<Plan_Tier>;
  /** fetch aggregated fields from the table: "plan_tier" */
  plan_tier_aggregate: Plan_Tier_Aggregate;
  /** fetch data from the table: "plan_tier" using primary key columns */
  plan_tier_by_pk?: Maybe<Plan_Tier>;
  /** fetch data from the table in a streaming manner: "plan_tier" */
  plan_tier_stream: Array<Plan_Tier>;
  /** fetch data from the table: "printing_jobs" using primary key columns */
  printing_job?: Maybe<Printing_Jobs>;
  /** fetch data from the table: "printing_job_status" */
  printing_job_status: Array<Printing_Job_Status>;
  /** fetch aggregated fields from the table: "printing_job_status" */
  printing_job_status_aggregate: Printing_Job_Status_Aggregate;
  /** fetch data from the table: "printing_job_status" using primary key columns */
  printing_job_status_by_pk?: Maybe<Printing_Job_Status>;
  /** fetch data from the table in a streaming manner: "printing_job_status" */
  printing_job_status_stream: Array<Printing_Job_Status>;
  /** fetch data from the table: "printing_job_type" */
  printing_job_type: Array<Printing_Job_Type>;
  /** fetch aggregated fields from the table: "printing_job_type" */
  printing_job_type_aggregate: Printing_Job_Type_Aggregate;
  /** fetch data from the table: "printing_job_type" using primary key columns */
  printing_job_type_by_pk?: Maybe<Printing_Job_Type>;
  /** fetch data from the table in a streaming manner: "printing_job_type" */
  printing_job_type_stream: Array<Printing_Job_Type>;
  /** fetch data from the table: "printing_jobs" */
  printing_jobs: Array<Printing_Jobs>;
  /** fetch aggregated fields from the table: "printing_jobs" */
  printing_jobs_aggregate: Printing_Jobs_Aggregate;
  /** fetch data from the table in a streaming manner: "printing_jobs" */
  printing_jobs_stream: Array<Printing_Jobs>;
  /** fetch data from the table: "school_year" */
  school_year: Array<School_Year>;
  /** fetch aggregated fields from the table: "school_year" */
  school_year_aggregate: School_Year_Aggregate;
  /** fetch data from the table: "school_year" using primary key columns */
  school_year_by_pk?: Maybe<School_Year>;
  /** fetch data from the table in a streaming manner: "school_year" */
  school_year_stream: Array<School_Year>;
  /** fetch data from the table: "students" using primary key columns */
  student?: Maybe<Students>;
  /** fetch data from the table: "student_accounts" using primary key columns */
  student_account?: Maybe<Student_Accounts>;
  /** fetch data from the table: "student_accounts" */
  student_accounts: Array<Student_Accounts>;
  /** fetch aggregated fields from the table: "student_accounts" */
  student_accounts_aggregate: Student_Accounts_Aggregate;
  /** fetch data from the table in a streaming manner: "student_accounts" */
  student_accounts_stream: Array<Student_Accounts>;
  /** fetch data from the table: "student_assignments" using primary key columns */
  student_assignment?: Maybe<Student_Assignments>;
  /** fetch data from the table: "student_assignment_status" */
  student_assignment_status: Array<Student_Assignment_Status>;
  /** fetch aggregated fields from the table: "student_assignment_status" */
  student_assignment_status_aggregate: Student_Assignment_Status_Aggregate;
  /** fetch data from the table: "student_assignment_status" using primary key columns */
  student_assignment_status_by_pk?: Maybe<Student_Assignment_Status>;
  /** fetch data from the table in a streaming manner: "student_assignment_status" */
  student_assignment_status_stream: Array<Student_Assignment_Status>;
  /** fetch data from the table: "student_assignments" */
  student_assignments: Array<Student_Assignments>;
  /** fetch aggregated fields from the table: "student_assignments" */
  student_assignments_aggregate: Student_Assignments_Aggregate;
  /** fetch data from the table in a streaming manner: "student_assignments" */
  student_assignments_stream: Array<Student_Assignments>;
  /** fetch data from the table: "student_courses" using primary key columns */
  student_course?: Maybe<Student_Courses>;
  /** fetch data from the table: "student_course_status" */
  student_course_status: Array<Student_Course_Status>;
  /** fetch aggregated fields from the table: "student_course_status" */
  student_course_status_aggregate: Student_Course_Status_Aggregate;
  /** fetch data from the table: "student_course_status" using primary key columns */
  student_course_status_by_pk?: Maybe<Student_Course_Status>;
  /** fetch data from the table in a streaming manner: "student_course_status" */
  student_course_status_stream: Array<Student_Course_Status>;
  /** fetch data from the table: "student_courses" */
  student_courses: Array<Student_Courses>;
  /** fetch aggregated fields from the table: "student_courses" */
  student_courses_aggregate: Student_Courses_Aggregate;
  /** fetch data from the table in a streaming manner: "student_courses" */
  student_courses_stream: Array<Student_Courses>;
  /** fetch data from the table: "student_events" using primary key columns */
  student_event?: Maybe<Student_Events>;
  /** fetch data from the table: "student_events" */
  student_events: Array<Student_Events>;
  /** fetch aggregated fields from the table: "student_events" */
  student_events_aggregate: Student_Events_Aggregate;
  /** fetch data from the table in a streaming manner: "student_events" */
  student_events_stream: Array<Student_Events>;
  /** fetch data from the table: "students" */
  students: Array<Students>;
  /** fetch aggregated fields from the table: "students" */
  students_aggregate: Students_Aggregate;
  /** fetch data from the table in a streaming manner: "students" */
  students_stream: Array<Students>;
  /** fetch data from the table: "teachers" using primary key columns */
  teacher?: Maybe<Teachers>;
  /** An array relationship */
  teachers: Array<Teachers>;
  /** An aggregate relationship */
  teachers_aggregate: Teachers_Aggregate;
  /** fetch data from the table in a streaming manner: "teachers" */
  teachers_stream: Array<Teachers>;
  /** fetch data from the table: "teachers_students" */
  teachers_students: Array<Teachers_Students>;
  /** fetch aggregated fields from the table: "teachers_students" */
  teachers_students_aggregate: Teachers_Students_Aggregate;
  /** fetch data from the table: "teachers_students" using primary key columns */
  teachers_students_by_pk?: Maybe<Teachers_Students>;
  /** fetch data from the table in a streaming manner: "teachers_students" */
  teachers_students_stream: Array<Teachers_Students>;
  /** fetch data from the table: "themes" */
  themes: Array<Themes>;
  /** fetch aggregated fields from the table: "themes" */
  themes_aggregate: Themes_Aggregate;
  /** fetch data from the table: "themes" using primary key columns */
  themes_by_pk?: Maybe<Themes>;
  /** fetch data from the table in a streaming manner: "themes" */
  themes_stream: Array<Themes>;
  /** fetch data from the table: "user_settings" */
  user_settings: Array<User_Settings>;
  /** fetch aggregated fields from the table: "user_settings" */
  user_settings_aggregate: User_Settings_Aggregate;
  /** fetch data from the table: "user_settings" using primary key columns */
  user_settings_by_pk?: Maybe<User_Settings>;
  /** fetch data from the table in a streaming manner: "user_settings" */
  user_settings_stream: Array<User_Settings>;
};


export type Subscription_RootAssignmentArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAssignment_TypeArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Order_By>>;
  where?: InputMaybe<Assignment_Type_Bool_Exp>;
};


export type Subscription_RootAssignment_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Order_By>>;
  where?: InputMaybe<Assignment_Type_Bool_Exp>;
};


export type Subscription_RootAssignment_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAssignment_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assignment_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Assignment_Type_Bool_Exp>;
};


export type Subscription_RootAssignment_Type_WeightArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAssignment_Type_WeightsArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Weights_Order_By>>;
  where?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
};


export type Subscription_RootAssignment_Type_Weights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignment_Type_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignment_Type_Weights_Order_By>>;
  where?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
};


export type Subscription_RootAssignment_Type_Weights_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assignment_Type_Weights_Stream_Cursor_Input>>;
  where?: InputMaybe<Assignment_Type_Weights_Bool_Exp>;
};


export type Subscription_RootAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignments_Order_By>>;
  where?: InputMaybe<Assignments_Bool_Exp>;
};


export type Subscription_RootAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assignments_Order_By>>;
  where?: InputMaybe<Assignments_Bool_Exp>;
};


export type Subscription_RootAssignments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assignments_Stream_Cursor_Input>>;
  where?: InputMaybe<Assignments_Bool_Exp>;
};


export type Subscription_RootCommentArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Subscription_RootComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Subscription_RootComments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Subscription_RootCourseArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCoursesArgs = {
  distinct_on?: InputMaybe<Array<Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Courses_Order_By>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


export type Subscription_RootCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Courses_Order_By>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


export type Subscription_RootCourses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Courses_Stream_Cursor_Input>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


export type Subscription_RootCustom_Assignment_TypeArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustom_Assignment_TypesArgs = {
  distinct_on?: InputMaybe<Array<Custom_Assignment_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Assignment_Types_Order_By>>;
  where?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
};


export type Subscription_RootCustom_Assignment_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Assignment_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Assignment_Types_Order_By>>;
  where?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
};


export type Subscription_RootCustom_Assignment_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Assignment_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Assignment_Types_Bool_Exp>;
};


export type Subscription_RootCustomerArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootCustomersArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Subscription_RootCustomers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Customers_Order_By>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Subscription_RootCustomers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Customers_Stream_Cursor_Input>>;
  where?: InputMaybe<Customers_Bool_Exp>;
};


export type Subscription_RootEventArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEvent_TArgs = {
  distinct_on?: InputMaybe<Array<Event_T_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_T_Order_By>>;
  where?: InputMaybe<Event_T_Bool_Exp>;
};


export type Subscription_RootEvent_T_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_T_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_T_Order_By>>;
  where?: InputMaybe<Event_T_Bool_Exp>;
};


export type Subscription_RootEvent_T_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Event_T_Stream_Cursor_Input>>;
  where?: InputMaybe<Event_T_Bool_Exp>;
};


export type Subscription_RootEvent_TypeArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootEvents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootFileArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootGrading_StyleArgs = {
  distinct_on?: InputMaybe<Array<Grading_Style_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grading_Style_Order_By>>;
  where?: InputMaybe<Grading_Style_Bool_Exp>;
};


export type Subscription_RootGrading_Style_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grading_Style_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Grading_Style_Order_By>>;
  where?: InputMaybe<Grading_Style_Bool_Exp>;
};


export type Subscription_RootGrading_Style_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootGrading_Style_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Grading_Style_Stream_Cursor_Input>>;
  where?: InputMaybe<Grading_Style_Bool_Exp>;
};


export type Subscription_RootOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_AdminArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootOrganization_AdminsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


export type Subscription_RootOrganization_Admins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


export type Subscription_RootOrganization_Admins_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Admins_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


export type Subscription_RootOrganization_CodeArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_CodesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Codes_Bool_Exp>;
};


export type Subscription_RootOrganization_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Codes_Order_By>>;
  where?: InputMaybe<Organization_Codes_Bool_Exp>;
};


export type Subscription_RootOrganization_Codes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Codes_Bool_Exp>;
};


export type Subscription_RootOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Subscription_RootOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Subscription_RootOrganizations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organizations_Stream_Cursor_Input>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Subscription_RootParrot_RequestArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootParrot_Request_StatusArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Request_Status_Order_By>>;
  where?: InputMaybe<Parrot_Request_Status_Bool_Exp>;
};


export type Subscription_RootParrot_Request_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Request_Status_Order_By>>;
  where?: InputMaybe<Parrot_Request_Status_Bool_Exp>;
};


export type Subscription_RootParrot_Request_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootParrot_Request_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parrot_Request_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Parrot_Request_Status_Bool_Exp>;
};


export type Subscription_RootParrot_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Requests_Order_By>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


export type Subscription_RootParrot_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Requests_Order_By>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


export type Subscription_RootParrot_Requests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parrot_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


export type Subscription_RootPlan_TierArgs = {
  distinct_on?: InputMaybe<Array<Plan_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plan_Tier_Order_By>>;
  where?: InputMaybe<Plan_Tier_Bool_Exp>;
};


export type Subscription_RootPlan_Tier_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plan_Tier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Plan_Tier_Order_By>>;
  where?: InputMaybe<Plan_Tier_Bool_Exp>;
};


export type Subscription_RootPlan_Tier_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPlan_Tier_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Plan_Tier_Stream_Cursor_Input>>;
  where?: InputMaybe<Plan_Tier_Bool_Exp>;
};


export type Subscription_RootPrinting_JobArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPrinting_Job_StatusArgs = {
  distinct_on?: InputMaybe<Array<Printing_Job_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Job_Status_Order_By>>;
  where?: InputMaybe<Printing_Job_Status_Bool_Exp>;
};


export type Subscription_RootPrinting_Job_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printing_Job_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Job_Status_Order_By>>;
  where?: InputMaybe<Printing_Job_Status_Bool_Exp>;
};


export type Subscription_RootPrinting_Job_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPrinting_Job_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Printing_Job_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Printing_Job_Status_Bool_Exp>;
};


export type Subscription_RootPrinting_Job_TypeArgs = {
  distinct_on?: InputMaybe<Array<Printing_Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Job_Type_Order_By>>;
  where?: InputMaybe<Printing_Job_Type_Bool_Exp>;
};


export type Subscription_RootPrinting_Job_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printing_Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Job_Type_Order_By>>;
  where?: InputMaybe<Printing_Job_Type_Bool_Exp>;
};


export type Subscription_RootPrinting_Job_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPrinting_Job_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Printing_Job_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Printing_Job_Type_Bool_Exp>;
};


export type Subscription_RootPrinting_JobsArgs = {
  distinct_on?: InputMaybe<Array<Printing_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Jobs_Order_By>>;
  where?: InputMaybe<Printing_Jobs_Bool_Exp>;
};


export type Subscription_RootPrinting_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printing_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printing_Jobs_Order_By>>;
  where?: InputMaybe<Printing_Jobs_Bool_Exp>;
};


export type Subscription_RootPrinting_Jobs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Printing_Jobs_Stream_Cursor_Input>>;
  where?: InputMaybe<Printing_Jobs_Bool_Exp>;
};


export type Subscription_RootSchool_YearArgs = {
  distinct_on?: InputMaybe<Array<School_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<School_Year_Order_By>>;
  where?: InputMaybe<School_Year_Bool_Exp>;
};


export type Subscription_RootSchool_Year_AggregateArgs = {
  distinct_on?: InputMaybe<Array<School_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<School_Year_Order_By>>;
  where?: InputMaybe<School_Year_Bool_Exp>;
};


export type Subscription_RootSchool_Year_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSchool_Year_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<School_Year_Stream_Cursor_Input>>;
  where?: InputMaybe<School_Year_Bool_Exp>;
};


export type Subscription_RootStudentArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootStudent_AccountArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootStudent_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Student_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Accounts_Order_By>>;
  where?: InputMaybe<Student_Accounts_Bool_Exp>;
};


export type Subscription_RootStudent_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Accounts_Order_By>>;
  where?: InputMaybe<Student_Accounts_Bool_Exp>;
};


export type Subscription_RootStudent_Accounts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Student_Accounts_Stream_Cursor_Input>>;
  where?: InputMaybe<Student_Accounts_Bool_Exp>;
};


export type Subscription_RootStudent_AssignmentArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStudent_Assignment_StatusArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignment_Status_Order_By>>;
  where?: InputMaybe<Student_Assignment_Status_Bool_Exp>;
};


export type Subscription_RootStudent_Assignment_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignment_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignment_Status_Order_By>>;
  where?: InputMaybe<Student_Assignment_Status_Bool_Exp>;
};


export type Subscription_RootStudent_Assignment_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootStudent_Assignment_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Student_Assignment_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Student_Assignment_Status_Bool_Exp>;
};


export type Subscription_RootStudent_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


export type Subscription_RootStudent_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Assignments_Order_By>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


export type Subscription_RootStudent_Assignments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Student_Assignments_Stream_Cursor_Input>>;
  where?: InputMaybe<Student_Assignments_Bool_Exp>;
};


export type Subscription_RootStudent_CourseArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStudent_Course_StatusArgs = {
  distinct_on?: InputMaybe<Array<Student_Course_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Course_Status_Order_By>>;
  where?: InputMaybe<Student_Course_Status_Bool_Exp>;
};


export type Subscription_RootStudent_Course_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Course_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Course_Status_Order_By>>;
  where?: InputMaybe<Student_Course_Status_Bool_Exp>;
};


export type Subscription_RootStudent_Course_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootStudent_Course_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Student_Course_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Student_Course_Status_Bool_Exp>;
};


export type Subscription_RootStudent_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Student_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Courses_Order_By>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


export type Subscription_RootStudent_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Courses_Order_By>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


export type Subscription_RootStudent_Courses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Student_Courses_Stream_Cursor_Input>>;
  where?: InputMaybe<Student_Courses_Bool_Exp>;
};


export type Subscription_RootStudent_EventArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootStudent_EventsArgs = {
  distinct_on?: InputMaybe<Array<Student_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Events_Order_By>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};


export type Subscription_RootStudent_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Events_Order_By>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};


export type Subscription_RootStudent_Events_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Student_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Student_Events_Bool_Exp>;
};


export type Subscription_RootStudentsArgs = {
  distinct_on?: InputMaybe<Array<Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Students_Order_By>>;
  where?: InputMaybe<Students_Bool_Exp>;
};


export type Subscription_RootStudents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Students_Order_By>>;
  where?: InputMaybe<Students_Bool_Exp>;
};


export type Subscription_RootStudents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Students_Stream_Cursor_Input>>;
  where?: InputMaybe<Students_Bool_Exp>;
};


export type Subscription_RootTeacherArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTeachersArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Order_By>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};


export type Subscription_RootTeachers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Order_By>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};


export type Subscription_RootTeachers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Teachers_Stream_Cursor_Input>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};


export type Subscription_RootTeachers_StudentsArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Students_Order_By>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};


export type Subscription_RootTeachers_Students_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Students_Order_By>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};


export type Subscription_RootTeachers_Students_By_PkArgs = {
  studentId: Scalars['String']['input'];
  teacherId: Scalars['String']['input'];
};


export type Subscription_RootTeachers_Students_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Teachers_Students_Stream_Cursor_Input>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};


export type Subscription_RootThemesArgs = {
  distinct_on?: InputMaybe<Array<Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Themes_Order_By>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};


export type Subscription_RootThemes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Themes_Order_By>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};


export type Subscription_RootThemes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootThemes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Themes_Stream_Cursor_Input>>;
  where?: InputMaybe<Themes_Bool_Exp>;
};


export type Subscription_RootUser_SettingsArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Subscription_RootUser_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Subscription_RootUser_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};

/** columns and relationships of "teachers" */
export type Teachers = {
  __typename?: 'teachers';
  /** An array relationship */
  courses: Array<Courses>;
  /** An aggregate relationship */
  courses_aggregate: Courses_Aggregate;
  created: Scalars['timestamptz']['output'];
  /** An object relationship */
  customer?: Maybe<Customers>;
  email?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  events_aggregate: Events_Aggregate;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  needsDemoData: Scalars['Boolean']['output'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  parrotRequests: Array<Parrot_Requests>;
  /** An aggregate relationship */
  parrotRequests_aggregate: Parrot_Requests_Aggregate;
  picture?: Maybe<Scalars['String']['output']>;
  settingsId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  students: Array<Teachers_Students>;
  /** An aggregate relationship */
  students_aggregate: Teachers_Students_Aggregate;
  toured?: Maybe<Scalars['Boolean']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  userSettings?: Maybe<User_Settings>;
};


/** columns and relationships of "teachers" */
export type TeachersCoursesArgs = {
  distinct_on?: InputMaybe<Array<Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Courses_Order_By>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


/** columns and relationships of "teachers" */
export type TeachersCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Courses_Order_By>>;
  where?: InputMaybe<Courses_Bool_Exp>;
};


/** columns and relationships of "teachers" */
export type TeachersEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "teachers" */
export type TeachersEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "teachers" */
export type TeachersParrotRequestsArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Requests_Order_By>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


/** columns and relationships of "teachers" */
export type TeachersParrotRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parrot_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parrot_Requests_Order_By>>;
  where?: InputMaybe<Parrot_Requests_Bool_Exp>;
};


/** columns and relationships of "teachers" */
export type TeachersStudentsArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Students_Order_By>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};


/** columns and relationships of "teachers" */
export type TeachersStudents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Students_Order_By>>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};

/** aggregated selection of "teachers" */
export type Teachers_Aggregate = {
  __typename?: 'teachers_aggregate';
  aggregate?: Maybe<Teachers_Aggregate_Fields>;
  nodes: Array<Teachers>;
};

export type Teachers_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Teachers_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Teachers_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Teachers_Aggregate_Bool_Exp_Count>;
};

export type Teachers_Aggregate_Bool_Exp_Bool_And = {
  arguments: Teachers_Select_Column_Teachers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teachers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Teachers_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Teachers_Select_Column_Teachers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teachers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Teachers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Teachers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teachers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "teachers" */
export type Teachers_Aggregate_Fields = {
  __typename?: 'teachers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Teachers_Max_Fields>;
  min?: Maybe<Teachers_Min_Fields>;
};


/** aggregate fields of "teachers" */
export type Teachers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teachers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "teachers" */
export type Teachers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teachers_Max_Order_By>;
  min?: InputMaybe<Teachers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "teachers" */
export type Teachers_Arr_Rel_Insert_Input = {
  data: Array<Teachers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teachers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "teachers". All fields are combined with a logical 'AND'. */
export type Teachers_Bool_Exp = {
  _and?: InputMaybe<Array<Teachers_Bool_Exp>>;
  _not?: InputMaybe<Teachers_Bool_Exp>;
  _or?: InputMaybe<Array<Teachers_Bool_Exp>>;
  courses?: InputMaybe<Courses_Bool_Exp>;
  courses_aggregate?: InputMaybe<Courses_Aggregate_Bool_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer?: InputMaybe<Customers_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  events?: InputMaybe<Events_Bool_Exp>;
  events_aggregate?: InputMaybe<Events_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  needsDemoData?: InputMaybe<Boolean_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
  parrotRequests?: InputMaybe<Parrot_Requests_Bool_Exp>;
  parrotRequests_aggregate?: InputMaybe<Parrot_Requests_Aggregate_Bool_Exp>;
  picture?: InputMaybe<String_Comparison_Exp>;
  settingsId?: InputMaybe<Uuid_Comparison_Exp>;
  students?: InputMaybe<Teachers_Students_Bool_Exp>;
  students_aggregate?: InputMaybe<Teachers_Students_Aggregate_Bool_Exp>;
  toured?: InputMaybe<Boolean_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  userSettings?: InputMaybe<User_Settings_Bool_Exp>;
};

/** unique or primary key constraints on table "teachers" */
export enum Teachers_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeachersPkey = 'teachers_pkey'
}

/** input type for inserting data into table "teachers" */
export type Teachers_Insert_Input = {
  courses?: InputMaybe<Courses_Arr_Rel_Insert_Input>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  customer?: InputMaybe<Customers_Obj_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Events_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsDemoData?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  parrotRequests?: InputMaybe<Parrot_Requests_Arr_Rel_Insert_Input>;
  picture?: InputMaybe<Scalars['String']['input']>;
  settingsId?: InputMaybe<Scalars['uuid']['input']>;
  students?: InputMaybe<Teachers_Students_Arr_Rel_Insert_Input>;
  toured?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
  userSettings?: InputMaybe<User_Settings_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Teachers_Max_Fields = {
  __typename?: 'teachers_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  settingsId?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "teachers" */
export type Teachers_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Teachers_Min_Fields = {
  __typename?: 'teachers_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  settingsId?: Maybe<Scalars['uuid']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "teachers" */
export type Teachers_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  picture?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "teachers" */
export type Teachers_Mutation_Response = {
  __typename?: 'teachers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Teachers>;
};

/** input type for inserting object relation for remote table "teachers" */
export type Teachers_Obj_Rel_Insert_Input = {
  data: Teachers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Teachers_On_Conflict>;
};

/** on_conflict condition type for table "teachers" */
export type Teachers_On_Conflict = {
  constraint: Teachers_Constraint;
  update_columns?: Array<Teachers_Update_Column>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};

/** Ordering options when selecting data from "teachers". */
export type Teachers_Order_By = {
  courses_aggregate?: InputMaybe<Courses_Aggregate_Order_By>;
  created?: InputMaybe<Order_By>;
  customer?: InputMaybe<Customers_Order_By>;
  email?: InputMaybe<Order_By>;
  events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  needsDemoData?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  parrotRequests_aggregate?: InputMaybe<Parrot_Requests_Aggregate_Order_By>;
  picture?: InputMaybe<Order_By>;
  settingsId?: InputMaybe<Order_By>;
  students_aggregate?: InputMaybe<Teachers_Students_Aggregate_Order_By>;
  toured?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  userSettings?: InputMaybe<User_Settings_Order_By>;
};

/** primary key columns input for table: teachers */
export type Teachers_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "teachers" */
export enum Teachers_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NeedsDemoData = 'needsDemoData',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Picture = 'picture',
  /** column name */
  SettingsId = 'settingsId',
  /** column name */
  Toured = 'toured',
  /** column name */
  Updated = 'updated'
}

/** select "teachers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "teachers" */
export enum Teachers_Select_Column_Teachers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  NeedsDemoData = 'needsDemoData',
  /** column name */
  Toured = 'toured'
}

/** select "teachers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "teachers" */
export enum Teachers_Select_Column_Teachers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  NeedsDemoData = 'needsDemoData',
  /** column name */
  Toured = 'toured'
}

/** input type for updating data in table "teachers" */
export type Teachers_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsDemoData?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  settingsId?: InputMaybe<Scalars['uuid']['input']>;
  toured?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "teachers" */
export type Teachers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teachers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teachers_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsDemoData?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  settingsId?: InputMaybe<Scalars['uuid']['input']>;
  toured?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "teachers_students" */
export type Teachers_Students = {
  __typename?: 'teachers_students';
  created?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  student: Students;
  studentId: Scalars['String']['output'];
  /** An object relationship */
  teacher: Teachers;
  teacherId: Scalars['String']['output'];
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "teachers_students" */
export type Teachers_Students_Aggregate = {
  __typename?: 'teachers_students_aggregate';
  aggregate?: Maybe<Teachers_Students_Aggregate_Fields>;
  nodes: Array<Teachers_Students>;
};

export type Teachers_Students_Aggregate_Bool_Exp = {
  count?: InputMaybe<Teachers_Students_Aggregate_Bool_Exp_Count>;
};

export type Teachers_Students_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teachers_Students_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "teachers_students" */
export type Teachers_Students_Aggregate_Fields = {
  __typename?: 'teachers_students_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Teachers_Students_Max_Fields>;
  min?: Maybe<Teachers_Students_Min_Fields>;
};


/** aggregate fields of "teachers_students" */
export type Teachers_Students_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teachers_Students_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "teachers_students" */
export type Teachers_Students_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teachers_Students_Max_Order_By>;
  min?: InputMaybe<Teachers_Students_Min_Order_By>;
};

/** input type for inserting array relation for remote table "teachers_students" */
export type Teachers_Students_Arr_Rel_Insert_Input = {
  data: Array<Teachers_Students_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teachers_Students_On_Conflict>;
};

/** Boolean expression to filter rows from the table "teachers_students". All fields are combined with a logical 'AND'. */
export type Teachers_Students_Bool_Exp = {
  _and?: InputMaybe<Array<Teachers_Students_Bool_Exp>>;
  _not?: InputMaybe<Teachers_Students_Bool_Exp>;
  _or?: InputMaybe<Array<Teachers_Students_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  student?: InputMaybe<Students_Bool_Exp>;
  studentId?: InputMaybe<String_Comparison_Exp>;
  teacher?: InputMaybe<Teachers_Bool_Exp>;
  teacherId?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "teachers_students" */
export enum Teachers_Students_Constraint {
  /** unique or primary key constraint on columns "teacher_id", "student_id" */
  TeachersStudentsPkey = 'teachers_students_pkey'
}

/** input type for inserting data into table "teachers_students" */
export type Teachers_Students_Insert_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  student?: InputMaybe<Students_Obj_Rel_Insert_Input>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_Input>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Teachers_Students_Max_Fields = {
  __typename?: 'teachers_students_max_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "teachers_students" */
export type Teachers_Students_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Teachers_Students_Min_Fields = {
  __typename?: 'teachers_students_min_fields';
  created?: Maybe<Scalars['timestamptz']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "teachers_students" */
export type Teachers_Students_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  studentId?: InputMaybe<Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "teachers_students" */
export type Teachers_Students_Mutation_Response = {
  __typename?: 'teachers_students_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Teachers_Students>;
};

/** on_conflict condition type for table "teachers_students" */
export type Teachers_Students_On_Conflict = {
  constraint: Teachers_Students_Constraint;
  update_columns?: Array<Teachers_Students_Update_Column>;
  where?: InputMaybe<Teachers_Students_Bool_Exp>;
};

/** Ordering options when selecting data from "teachers_students". */
export type Teachers_Students_Order_By = {
  created?: InputMaybe<Order_By>;
  student?: InputMaybe<Students_Order_By>;
  studentId?: InputMaybe<Order_By>;
  teacher?: InputMaybe<Teachers_Order_By>;
  teacherId?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: teachers_students */
export type Teachers_Students_Pk_Columns_Input = {
  studentId: Scalars['String']['input'];
  teacherId: Scalars['String']['input'];
};

/** select columns of table "teachers_students" */
export enum Teachers_Students_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

/** input type for updating data in table "teachers_students" */
export type Teachers_Students_Set_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "teachers_students" */
export type Teachers_Students_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teachers_Students_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teachers_Students_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
  teacherId?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "teachers_students" */
export enum Teachers_Students_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  StudentId = 'studentId',
  /** column name */
  TeacherId = 'teacherId',
  /** column name */
  Updated = 'updated'
}

export type Teachers_Students_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teachers_Students_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teachers_Students_Bool_Exp;
};

/** update columns of table "teachers" */
export enum Teachers_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NeedsDemoData = 'needsDemoData',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Picture = 'picture',
  /** column name */
  SettingsId = 'settingsId',
  /** column name */
  Toured = 'toured',
  /** column name */
  Updated = 'updated'
}

export type Teachers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teachers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teachers_Bool_Exp;
};

/** columns and relationships of "themes" */
export type Themes = {
  __typename?: 'themes';
  appBackground?: Maybe<Scalars['String']['output']>;
  baseFontSize?: Maybe<Scalars['numeric']['output']>;
  colorPalette?: Maybe<Scalars['jsonb']['output']>;
  contentBackground?: Maybe<Scalars['String']['output']>;
  contentContrast?: Maybe<Scalars['String']['output']>;
  contentPrimary?: Maybe<Scalars['String']['output']>;
  contentSecondary?: Maybe<Scalars['String']['output']>;
  contentTertiary?: Maybe<Scalars['String']['output']>;
  elementBorder?: Maybe<Scalars['String']['output']>;
  faintBorder?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontUrl?: Maybe<Scalars['String']['output']>;
  headerBackground?: Maybe<Scalars['String']['output']>;
  headerForeground?: Maybe<Scalars['String']['output']>;
  headerForegroundActive?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  info?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  mediumBorder?: Maybe<Scalars['String']['output']>;
  negative?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  organizations: Array<Organizations>;
  /** An aggregate relationship */
  organizations_aggregate: Organizations_Aggregate;
  portalIconUrl?: Maybe<Scalars['String']['output']>;
  positive?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['String']['output']>;
  vacation?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "themes" */
export type ThemesColorPaletteArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "themes" */
export type ThemesOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


/** columns and relationships of "themes" */
export type ThemesOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};

/** aggregated selection of "themes" */
export type Themes_Aggregate = {
  __typename?: 'themes_aggregate';
  aggregate?: Maybe<Themes_Aggregate_Fields>;
  nodes: Array<Themes>;
};

/** aggregate fields of "themes" */
export type Themes_Aggregate_Fields = {
  __typename?: 'themes_aggregate_fields';
  avg?: Maybe<Themes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Themes_Max_Fields>;
  min?: Maybe<Themes_Min_Fields>;
  stddev?: Maybe<Themes_Stddev_Fields>;
  stddev_pop?: Maybe<Themes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Themes_Stddev_Samp_Fields>;
  sum?: Maybe<Themes_Sum_Fields>;
  var_pop?: Maybe<Themes_Var_Pop_Fields>;
  var_samp?: Maybe<Themes_Var_Samp_Fields>;
  variance?: Maybe<Themes_Variance_Fields>;
};


/** aggregate fields of "themes" */
export type Themes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Themes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Themes_Append_Input = {
  colorPalette?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Themes_Avg_Fields = {
  __typename?: 'themes_avg_fields';
  baseFontSize?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "themes". All fields are combined with a logical 'AND'. */
export type Themes_Bool_Exp = {
  _and?: InputMaybe<Array<Themes_Bool_Exp>>;
  _not?: InputMaybe<Themes_Bool_Exp>;
  _or?: InputMaybe<Array<Themes_Bool_Exp>>;
  appBackground?: InputMaybe<String_Comparison_Exp>;
  baseFontSize?: InputMaybe<Numeric_Comparison_Exp>;
  colorPalette?: InputMaybe<Jsonb_Comparison_Exp>;
  contentBackground?: InputMaybe<String_Comparison_Exp>;
  contentContrast?: InputMaybe<String_Comparison_Exp>;
  contentPrimary?: InputMaybe<String_Comparison_Exp>;
  contentSecondary?: InputMaybe<String_Comparison_Exp>;
  contentTertiary?: InputMaybe<String_Comparison_Exp>;
  elementBorder?: InputMaybe<String_Comparison_Exp>;
  faintBorder?: InputMaybe<String_Comparison_Exp>;
  fontFamily?: InputMaybe<String_Comparison_Exp>;
  fontUrl?: InputMaybe<String_Comparison_Exp>;
  headerBackground?: InputMaybe<String_Comparison_Exp>;
  headerForeground?: InputMaybe<String_Comparison_Exp>;
  headerForegroundActive?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  info?: InputMaybe<String_Comparison_Exp>;
  logoUrl?: InputMaybe<String_Comparison_Exp>;
  mediumBorder?: InputMaybe<String_Comparison_Exp>;
  negative?: InputMaybe<String_Comparison_Exp>;
  organizations?: InputMaybe<Organizations_Bool_Exp>;
  organizations_aggregate?: InputMaybe<Organizations_Aggregate_Bool_Exp>;
  portalIconUrl?: InputMaybe<String_Comparison_Exp>;
  positive?: InputMaybe<String_Comparison_Exp>;
  primary?: InputMaybe<String_Comparison_Exp>;
  vacation?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "themes" */
export enum Themes_Constraint {
  /** unique or primary key constraint on columns "id" */
  ThemesPkey = 'themes_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Themes_Delete_At_Path_Input = {
  colorPalette?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Themes_Delete_Elem_Input = {
  colorPalette?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Themes_Delete_Key_Input = {
  colorPalette?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "themes" */
export type Themes_Inc_Input = {
  baseFontSize?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "themes" */
export type Themes_Insert_Input = {
  appBackground?: InputMaybe<Scalars['String']['input']>;
  baseFontSize?: InputMaybe<Scalars['numeric']['input']>;
  colorPalette?: InputMaybe<Scalars['jsonb']['input']>;
  contentBackground?: InputMaybe<Scalars['String']['input']>;
  contentContrast?: InputMaybe<Scalars['String']['input']>;
  contentPrimary?: InputMaybe<Scalars['String']['input']>;
  contentSecondary?: InputMaybe<Scalars['String']['input']>;
  contentTertiary?: InputMaybe<Scalars['String']['input']>;
  elementBorder?: InputMaybe<Scalars['String']['input']>;
  faintBorder?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontUrl?: InputMaybe<Scalars['String']['input']>;
  headerBackground?: InputMaybe<Scalars['String']['input']>;
  headerForeground?: InputMaybe<Scalars['String']['input']>;
  headerForegroundActive?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  mediumBorder?: InputMaybe<Scalars['String']['input']>;
  negative?: InputMaybe<Scalars['String']['input']>;
  organizations?: InputMaybe<Organizations_Arr_Rel_Insert_Input>;
  portalIconUrl?: InputMaybe<Scalars['String']['input']>;
  positive?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['String']['input']>;
  vacation?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Themes_Max_Fields = {
  __typename?: 'themes_max_fields';
  appBackground?: Maybe<Scalars['String']['output']>;
  baseFontSize?: Maybe<Scalars['numeric']['output']>;
  contentBackground?: Maybe<Scalars['String']['output']>;
  contentContrast?: Maybe<Scalars['String']['output']>;
  contentPrimary?: Maybe<Scalars['String']['output']>;
  contentSecondary?: Maybe<Scalars['String']['output']>;
  contentTertiary?: Maybe<Scalars['String']['output']>;
  elementBorder?: Maybe<Scalars['String']['output']>;
  faintBorder?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontUrl?: Maybe<Scalars['String']['output']>;
  headerBackground?: Maybe<Scalars['String']['output']>;
  headerForeground?: Maybe<Scalars['String']['output']>;
  headerForegroundActive?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  mediumBorder?: Maybe<Scalars['String']['output']>;
  negative?: Maybe<Scalars['String']['output']>;
  portalIconUrl?: Maybe<Scalars['String']['output']>;
  positive?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['String']['output']>;
  vacation?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Themes_Min_Fields = {
  __typename?: 'themes_min_fields';
  appBackground?: Maybe<Scalars['String']['output']>;
  baseFontSize?: Maybe<Scalars['numeric']['output']>;
  contentBackground?: Maybe<Scalars['String']['output']>;
  contentContrast?: Maybe<Scalars['String']['output']>;
  contentPrimary?: Maybe<Scalars['String']['output']>;
  contentSecondary?: Maybe<Scalars['String']['output']>;
  contentTertiary?: Maybe<Scalars['String']['output']>;
  elementBorder?: Maybe<Scalars['String']['output']>;
  faintBorder?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontUrl?: Maybe<Scalars['String']['output']>;
  headerBackground?: Maybe<Scalars['String']['output']>;
  headerForeground?: Maybe<Scalars['String']['output']>;
  headerForegroundActive?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  mediumBorder?: Maybe<Scalars['String']['output']>;
  negative?: Maybe<Scalars['String']['output']>;
  portalIconUrl?: Maybe<Scalars['String']['output']>;
  positive?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['String']['output']>;
  vacation?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "themes" */
export type Themes_Mutation_Response = {
  __typename?: 'themes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Themes>;
};

/** input type for inserting object relation for remote table "themes" */
export type Themes_Obj_Rel_Insert_Input = {
  data: Themes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Themes_On_Conflict>;
};

/** on_conflict condition type for table "themes" */
export type Themes_On_Conflict = {
  constraint: Themes_Constraint;
  update_columns?: Array<Themes_Update_Column>;
  where?: InputMaybe<Themes_Bool_Exp>;
};

/** Ordering options when selecting data from "themes". */
export type Themes_Order_By = {
  appBackground?: InputMaybe<Order_By>;
  baseFontSize?: InputMaybe<Order_By>;
  colorPalette?: InputMaybe<Order_By>;
  contentBackground?: InputMaybe<Order_By>;
  contentContrast?: InputMaybe<Order_By>;
  contentPrimary?: InputMaybe<Order_By>;
  contentSecondary?: InputMaybe<Order_By>;
  contentTertiary?: InputMaybe<Order_By>;
  elementBorder?: InputMaybe<Order_By>;
  faintBorder?: InputMaybe<Order_By>;
  fontFamily?: InputMaybe<Order_By>;
  fontUrl?: InputMaybe<Order_By>;
  headerBackground?: InputMaybe<Order_By>;
  headerForeground?: InputMaybe<Order_By>;
  headerForegroundActive?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  info?: InputMaybe<Order_By>;
  logoUrl?: InputMaybe<Order_By>;
  mediumBorder?: InputMaybe<Order_By>;
  negative?: InputMaybe<Order_By>;
  organizations_aggregate?: InputMaybe<Organizations_Aggregate_Order_By>;
  portalIconUrl?: InputMaybe<Order_By>;
  positive?: InputMaybe<Order_By>;
  primary?: InputMaybe<Order_By>;
  vacation?: InputMaybe<Order_By>;
};

/** primary key columns input for table: themes */
export type Themes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Themes_Prepend_Input = {
  colorPalette?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "themes" */
export enum Themes_Select_Column {
  /** column name */
  AppBackground = 'appBackground',
  /** column name */
  BaseFontSize = 'baseFontSize',
  /** column name */
  ColorPalette = 'colorPalette',
  /** column name */
  ContentBackground = 'contentBackground',
  /** column name */
  ContentContrast = 'contentContrast',
  /** column name */
  ContentPrimary = 'contentPrimary',
  /** column name */
  ContentSecondary = 'contentSecondary',
  /** column name */
  ContentTertiary = 'contentTertiary',
  /** column name */
  ElementBorder = 'elementBorder',
  /** column name */
  FaintBorder = 'faintBorder',
  /** column name */
  FontFamily = 'fontFamily',
  /** column name */
  FontUrl = 'fontUrl',
  /** column name */
  HeaderBackground = 'headerBackground',
  /** column name */
  HeaderForeground = 'headerForeground',
  /** column name */
  HeaderForegroundActive = 'headerForegroundActive',
  /** column name */
  Id = 'id',
  /** column name */
  Info = 'info',
  /** column name */
  LogoUrl = 'logoUrl',
  /** column name */
  MediumBorder = 'mediumBorder',
  /** column name */
  Negative = 'negative',
  /** column name */
  PortalIconUrl = 'portalIconUrl',
  /** column name */
  Positive = 'positive',
  /** column name */
  Primary = 'primary',
  /** column name */
  Vacation = 'vacation'
}

/** input type for updating data in table "themes" */
export type Themes_Set_Input = {
  appBackground?: InputMaybe<Scalars['String']['input']>;
  baseFontSize?: InputMaybe<Scalars['numeric']['input']>;
  colorPalette?: InputMaybe<Scalars['jsonb']['input']>;
  contentBackground?: InputMaybe<Scalars['String']['input']>;
  contentContrast?: InputMaybe<Scalars['String']['input']>;
  contentPrimary?: InputMaybe<Scalars['String']['input']>;
  contentSecondary?: InputMaybe<Scalars['String']['input']>;
  contentTertiary?: InputMaybe<Scalars['String']['input']>;
  elementBorder?: InputMaybe<Scalars['String']['input']>;
  faintBorder?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontUrl?: InputMaybe<Scalars['String']['input']>;
  headerBackground?: InputMaybe<Scalars['String']['input']>;
  headerForeground?: InputMaybe<Scalars['String']['input']>;
  headerForegroundActive?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  mediumBorder?: InputMaybe<Scalars['String']['input']>;
  negative?: InputMaybe<Scalars['String']['input']>;
  portalIconUrl?: InputMaybe<Scalars['String']['input']>;
  positive?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['String']['input']>;
  vacation?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Themes_Stddev_Fields = {
  __typename?: 'themes_stddev_fields';
  baseFontSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Themes_Stddev_Pop_Fields = {
  __typename?: 'themes_stddev_pop_fields';
  baseFontSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Themes_Stddev_Samp_Fields = {
  __typename?: 'themes_stddev_samp_fields';
  baseFontSize?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "themes" */
export type Themes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Themes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Themes_Stream_Cursor_Value_Input = {
  appBackground?: InputMaybe<Scalars['String']['input']>;
  baseFontSize?: InputMaybe<Scalars['numeric']['input']>;
  colorPalette?: InputMaybe<Scalars['jsonb']['input']>;
  contentBackground?: InputMaybe<Scalars['String']['input']>;
  contentContrast?: InputMaybe<Scalars['String']['input']>;
  contentPrimary?: InputMaybe<Scalars['String']['input']>;
  contentSecondary?: InputMaybe<Scalars['String']['input']>;
  contentTertiary?: InputMaybe<Scalars['String']['input']>;
  elementBorder?: InputMaybe<Scalars['String']['input']>;
  faintBorder?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontUrl?: InputMaybe<Scalars['String']['input']>;
  headerBackground?: InputMaybe<Scalars['String']['input']>;
  headerForeground?: InputMaybe<Scalars['String']['input']>;
  headerForegroundActive?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  mediumBorder?: InputMaybe<Scalars['String']['input']>;
  negative?: InputMaybe<Scalars['String']['input']>;
  portalIconUrl?: InputMaybe<Scalars['String']['input']>;
  positive?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['String']['input']>;
  vacation?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Themes_Sum_Fields = {
  __typename?: 'themes_sum_fields';
  baseFontSize?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "themes" */
export enum Themes_Update_Column {
  /** column name */
  AppBackground = 'appBackground',
  /** column name */
  BaseFontSize = 'baseFontSize',
  /** column name */
  ColorPalette = 'colorPalette',
  /** column name */
  ContentBackground = 'contentBackground',
  /** column name */
  ContentContrast = 'contentContrast',
  /** column name */
  ContentPrimary = 'contentPrimary',
  /** column name */
  ContentSecondary = 'contentSecondary',
  /** column name */
  ContentTertiary = 'contentTertiary',
  /** column name */
  ElementBorder = 'elementBorder',
  /** column name */
  FaintBorder = 'faintBorder',
  /** column name */
  FontFamily = 'fontFamily',
  /** column name */
  FontUrl = 'fontUrl',
  /** column name */
  HeaderBackground = 'headerBackground',
  /** column name */
  HeaderForeground = 'headerForeground',
  /** column name */
  HeaderForegroundActive = 'headerForegroundActive',
  /** column name */
  Id = 'id',
  /** column name */
  Info = 'info',
  /** column name */
  LogoUrl = 'logoUrl',
  /** column name */
  MediumBorder = 'mediumBorder',
  /** column name */
  Negative = 'negative',
  /** column name */
  PortalIconUrl = 'portalIconUrl',
  /** column name */
  Positive = 'positive',
  /** column name */
  Primary = 'primary',
  /** column name */
  Vacation = 'vacation'
}

export type Themes_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Themes_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Themes_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Themes_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Themes_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Themes_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Themes_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Themes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Themes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Themes_Var_Pop_Fields = {
  __typename?: 'themes_var_pop_fields';
  baseFontSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Themes_Var_Samp_Fields = {
  __typename?: 'themes_var_samp_fields';
  baseFontSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Themes_Variance_Fields = {
  __typename?: 'themes_variance_fields';
  baseFontSize?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "user_settings" */
export type User_Settings = {
  __typename?: 'user_settings';
  id: Scalars['uuid']['output'];
  showEmptyAssignmentDays: Scalars['Boolean']['output'];
  /** An array relationship */
  studentAccounts: Array<Student_Accounts>;
  /** An aggregate relationship */
  studentAccounts_aggregate: Student_Accounts_Aggregate;
  /** An array relationship */
  teachers: Array<Teachers>;
  /** An aggregate relationship */
  teachers_aggregate: Teachers_Aggregate;
};


/** columns and relationships of "user_settings" */
export type User_SettingsStudentAccountsArgs = {
  distinct_on?: InputMaybe<Array<Student_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Accounts_Order_By>>;
  where?: InputMaybe<Student_Accounts_Bool_Exp>;
};


/** columns and relationships of "user_settings" */
export type User_SettingsStudentAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Student_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Student_Accounts_Order_By>>;
  where?: InputMaybe<Student_Accounts_Bool_Exp>;
};


/** columns and relationships of "user_settings" */
export type User_SettingsTeachersArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Order_By>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};


/** columns and relationships of "user_settings" */
export type User_SettingsTeachers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teachers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teachers_Order_By>>;
  where?: InputMaybe<Teachers_Bool_Exp>;
};

/** aggregated selection of "user_settings" */
export type User_Settings_Aggregate = {
  __typename?: 'user_settings_aggregate';
  aggregate?: Maybe<User_Settings_Aggregate_Fields>;
  nodes: Array<User_Settings>;
};

/** aggregate fields of "user_settings" */
export type User_Settings_Aggregate_Fields = {
  __typename?: 'user_settings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Settings_Max_Fields>;
  min?: Maybe<User_Settings_Min_Fields>;
};


/** aggregate fields of "user_settings" */
export type User_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_settings". All fields are combined with a logical 'AND'. */
export type User_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<User_Settings_Bool_Exp>>;
  _not?: InputMaybe<User_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<User_Settings_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  showEmptyAssignmentDays?: InputMaybe<Boolean_Comparison_Exp>;
  studentAccounts?: InputMaybe<Student_Accounts_Bool_Exp>;
  studentAccounts_aggregate?: InputMaybe<Student_Accounts_Aggregate_Bool_Exp>;
  teachers?: InputMaybe<Teachers_Bool_Exp>;
  teachers_aggregate?: InputMaybe<Teachers_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "user_settings" */
export enum User_Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserSettingsPkey = 'user_settings_pkey'
}

/** input type for inserting data into table "user_settings" */
export type User_Settings_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  showEmptyAssignmentDays?: InputMaybe<Scalars['Boolean']['input']>;
  studentAccounts?: InputMaybe<Student_Accounts_Arr_Rel_Insert_Input>;
  teachers?: InputMaybe<Teachers_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Settings_Max_Fields = {
  __typename?: 'user_settings_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type User_Settings_Min_Fields = {
  __typename?: 'user_settings_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "user_settings" */
export type User_Settings_Mutation_Response = {
  __typename?: 'user_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Settings>;
};

/** input type for inserting object relation for remote table "user_settings" */
export type User_Settings_Obj_Rel_Insert_Input = {
  data: User_Settings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Settings_On_Conflict>;
};

/** on_conflict condition type for table "user_settings" */
export type User_Settings_On_Conflict = {
  constraint: User_Settings_Constraint;
  update_columns?: Array<User_Settings_Update_Column>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "user_settings". */
export type User_Settings_Order_By = {
  id?: InputMaybe<Order_By>;
  showEmptyAssignmentDays?: InputMaybe<Order_By>;
  studentAccounts_aggregate?: InputMaybe<Student_Accounts_Aggregate_Order_By>;
  teachers_aggregate?: InputMaybe<Teachers_Aggregate_Order_By>;
};

/** primary key columns input for table: user_settings */
export type User_Settings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_settings" */
export enum User_Settings_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ShowEmptyAssignmentDays = 'showEmptyAssignmentDays'
}

/** input type for updating data in table "user_settings" */
export type User_Settings_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  showEmptyAssignmentDays?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "user_settings" */
export type User_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Settings_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  showEmptyAssignmentDays?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "user_settings" */
export enum User_Settings_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ShowEmptyAssignmentDays = 'showEmptyAssignmentDays'
}

export type User_Settings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Settings_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type PlanningAssignmentFragment = { __typename?: 'assignments', id: string, courseId: string, name: string, description?: string | null, teachersNote?: string | null, duration: number, graded: boolean, created: string, day?: number | null, week?: number | null, parrotRequestId?: string | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, courseDayOffset?: number | null, pointsAvailable?: number | null, completed?: string | null, studentId: string, assignmentId: string, studentCourseId: string, assignment: { __typename?: 'assignments', id: string, name: string, graded: boolean, description?: string | null, week?: number | null, day?: number | null, assignmentType?: Assignment_Type_Enum | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, course: { __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null } }, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null } }>, attachments: Array<{ __typename?: 'files', id: string, url: string, size: any }>, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string } | null };

export type CoursePlanCardAssignmentFragment = { __typename?: 'assignments', id: string, day?: number | null, week?: number | null };

export type CourseAssignmentScheduleFragment = { __typename?: 'assignments', id: string, day?: number | null, week?: number | null, duration: number };

export type AssignmentInfoFragment = { __typename?: 'assignments', courseId: string, id: string, name: string, description?: string | null, teachersNote?: string | null, duration: number, graded: boolean, created: string, day?: number | null, week?: number | null, parrotRequestId?: string | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, courseDayOffset?: number | null, pointsAvailable?: number | null, completed?: string | null, studentId: string, assignmentId: string, studentCourseId: string, assignment: { __typename?: 'assignments', id: string, name: string, graded: boolean, description?: string | null, week?: number | null, day?: number | null, assignmentType?: Assignment_Type_Enum | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, course: { __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null } }, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null } }>, attachments: Array<{ __typename?: 'files', id: string, url: string, size: any }>, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string } | null };

export type AssignmentTypeWeightInfoFragment = { __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null };

export type AssignmentTypeWeightsInfoFragment = { __typename?: 'courses', id: string, assignmentTypeWeights: Array<{ __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> };

export type CommentInfoFragment = { __typename?: 'comments', id: string, content: string, created: string, studentAccount?: { __typename?: 'student_accounts', id: string, name?: string | null, picture?: string | null } | null, teacher?: { __typename?: 'teachers', id: string, name?: string | null, picture?: string | null } | null, studentAssignment?: { __typename?: 'student_assignments', id: string } | null };

export type CourseInfoAssignmentFragment = { __typename?: 'assignments', id: string, day?: number | null, week?: number | null, name: string, duration: number, graded: boolean, courseId: string, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string } | null };

export type CourseInfoStudentAssignmentFragment = { __typename?: 'student_assignments', id: string, freeForm: boolean, start?: string | null, end?: string | null, status: Student_Assignment_Status_Enum, assignmentId: string, studentId: string, studentCourseId: string, courseDayOffset?: number | null };

export type CourseInfoStudentCourseFragment = { __typename?: 'student_courses', id: string, studentId: string, status: Student_Course_Status_Enum, start: string, end: string, courseId?: string | null, daysOfTheWeek: object, courseDayOffsets?: object | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null } };

export type CourseInfoFragment = { __typename?: 'courses', id: string, name: string, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek?: object | null, color: string, picture?: string | null, subjects?: object | null, gradeYears?: object | null, description?: string | null, introduction?: string | null, gradingStyle: Grading_Style_Enum, credits?: number | null, archived: boolean, useAssignmentTypeWeights?: boolean | null, assignments: Array<{ __typename?: 'assignments', id: string, day?: number | null, week?: number | null, name: string, duration: number, graded: boolean, courseId: string, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string } | null }>, studentCourses?: Array<{ __typename?: 'student_courses', id: string, studentId: string, status: Student_Course_Status_Enum, start: string, end: string, courseId?: string | null, daysOfTheWeek: object, courseDayOffsets?: object | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null } }>, assignmentTypeWeights: Array<{ __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> };

export type CourseCardInfoFragment = { __typename?: 'courses', id: string, name: string, subjects?: object | null, gradeYears?: object | null, color: string, picture?: string | null, archived: boolean, description?: string | null, numberOfWeeks: number, numberOfDaysPerWeek: number, studentCourses?: Array<{ __typename?: 'student_courses', id: string, student: { __typename?: 'students', id: string, name: string, picture?: string | null } }> };

export type CoursePlanCardInfoFragment = { __typename?: 'courses', id: string, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, assignments: Array<{ __typename?: 'assignments', id: string, day?: number | null, week?: number | null }> };

export type CalendarCourseFragment = { __typename?: 'courses', id: string, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, studentCourses: Array<{ __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets?: object | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null }, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null }, assignment: { __typename?: 'assignments', id: string, name: string, description?: string | null, week?: number | null, day?: number | null, graded: boolean, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null } }> }> };

export type ClaimedParrotRequestCourseInfoFragment = { __typename?: 'courses', assignments: Array<{ __typename?: 'assignments', id: string, day?: number | null, week?: number | null, duration: number }>, studentCourses: Array<{ __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null, student: { __typename?: 'students', id: string, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> } }> };

export type CourseOptionFragment = { __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek?: object | null };

export type CustomAssignmentTypeFragment = { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean };

export type EventInfoFragment = { __typename?: 'events', id: string, name?: string | null, start: string, end: string, eventType: Event_T_Enum, studentEvents: Array<{ __typename?: 'student_events', id: string, student: { __typename?: 'students', id: string, name: string, picture?: string | null } }> };

export type StudentEventInfoFragment = { __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } };

export type CalendarVacationFragment = { __typename?: 'events', id: string, name?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, student: { __typename?: 'students', id: string, name: string } }> };

export type OrganizationFragment = { __typename?: 'organizations', id: string, name: string, supportLink?: string | null };

export type OrganizationAdminInfoFragment = { __typename?: 'organization_admins', id: string, email: string, organization: { __typename?: 'organizations', icon?: string | null, id: string, name: string, supportLink?: string | null } };

export type OrganizationCourseCardInfoFragment = { __typename?: 'OrganizationCourse', id: string, name: string, subjects?: object | null, gradeYears?: object | null, color: string, picture?: string | null, archived: boolean, description?: string | null, numberOfWeeks: number, numberOfDaysPerWeek: number };

export type OrganizationCourseInfoFragment = { __typename?: 'OrganizationCourse', id: string, name: string, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek?: object | null, color: string, picture?: string | null, subjects?: object | null, gradeYears?: object | null, description?: string | null, introduction?: string | null, gradingStyle: string, credits?: number | null, archived: boolean, useAssignmentTypeWeights?: boolean | null, assignmentTypeWeights: Array<{ __typename?: 'OrganizationCourseAssignmentTypeWeights', id: string, weight: number, assignmentType?: string | null, sortOrder: number, customAssignmentType?: { __typename?: 'OrganizationCourseCustomAssignmnetType', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> };

export type ParrotRequestInfoFragment = { __typename?: 'parrot_requests', id: string, startWeek: number, endWeek: number, status: Parrot_Request_Status_Enum, queuePosition?: number | null, userNotes?: string | null, created: string, course: { __typename?: 'courses', id: string, name: string, color: string, numberOfWeeks: number }, files: Array<{ __typename?: 'files', id: string, url: string }>, teacher: { __typename?: 'teachers', id: string, email?: string | null } };

export type PrintingJobInfoFragment = { __typename?: 'printing_jobs', id: string, teacherId?: string | null, studentAccountId?: string | null, status: Printing_Job_Status_Enum, file?: { __typename?: 'files', id: string, url: string } | null };

export type StudentInfoFragment = { __typename?: 'students', id: string, name: string, schoolYear?: School_Year_Enum | null, picture?: string | null, studentAccount?: { __typename?: 'student_accounts', id: string, email: string } | null };

export type StudentOptionFragment = { __typename?: 'students', id: string, name: string, picture?: string | null };

export type StudentsEventsFragment = { __typename?: 'students', id: string, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> };

export type HomeStudentAssignmentFragment = { __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, assignment: { __typename?: 'assignments', id: string, name: string, graded: boolean, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, course: { __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null } }, student: { __typename?: 'students', id: string, name: string, picture?: string | null }, studentCourse: { __typename?: 'student_courses', id: string } };

export type CalendarStudentAssignmentsFragment = { __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null }, assignment: { __typename?: 'assignments', id: string, name: string, description?: string | null, week?: number | null, day?: number | null, graded: boolean, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null } };

export type PlanningStudentAssignmentFragment = { __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, courseDayOffset?: number | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null } };

export type GradebookStudentAssignmentFragment = { __typename?: 'student_assignments', id: string, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, pointsAvailable?: number | null, start?: string | null, completed?: string | null, assignment: { __typename?: 'assignments', id: string, name: string, assignmentType?: Assignment_Type_Enum | null, graded: boolean, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null } };

export type NewStudentAssignmentFragment = { __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, courseDayOffset?: number | null, pointsAvailable?: number | null, completed?: string | null, studentId: string, assignmentId: string, studentCourseId: string, assignment: { __typename?: 'assignments', id: string, name: string, graded: boolean, description?: string | null, week?: number | null, day?: number | null, assignmentType?: Assignment_Type_Enum | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, course: { __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null } }, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null } };

export type StudentAssignmentDetailsFragment = { __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, pointsEarned?: number | null, pointsAvailable?: number | null, freeForm: boolean, status: Student_Assignment_Status_Enum, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, name: string, week?: number | null, day?: number | null, description?: string | null, teachersNote?: string | null, assignmentType?: Assignment_Type_Enum | null, graded: boolean, created: string, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, attachments: Array<{ __typename?: 'files', id: string, url: string }>, course: { __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null } }, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets?: object | null, start: string, course?: { __typename?: 'courses', id: string, gradingStyle: Grading_Style_Enum } | null }, submissions: Array<{ __typename?: 'files', id: string, url: string }>, comments: Array<{ __typename?: 'comments', id: string, content: string, created: string, studentAccount?: { __typename?: 'student_accounts', id: string, name?: string | null, picture?: string | null } | null, teacher?: { __typename?: 'teachers', id: string, name?: string | null, picture?: string | null } | null, studentAssignment?: { __typename?: 'student_assignments', id: string } | null }> };

export type StudentAssignmentToRescheduleFragment = { __typename?: 'student_assignments', id: string, studentId: string, assignmentId: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, week?: number | null, day?: number | null, duration: number } };

export type StudentAssignmentToUpdateGradingStyleFragment = { __typename?: 'student_assignments', id: string, studentId: string, assignmentId: string, status: Student_Assignment_Status_Enum, studentCourseId: string, pointsEarned?: number | null, pointsAvailable?: number | null };

export type CompletedStudentCourseCardInfoFragment = { __typename?: 'student_courses', id: string, status: Student_Course_Status_Enum, start: string, end: string, calendarYear?: string | null, schoolYear?: School_Year_Enum | null, courseSnapshot?: object | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null } };

export type CourseSnapshotFragment = { __typename?: 'student_courses', course?: { __typename?: 'courses', id: string, name: string, numberOfWeeks: number, numberOfDaysPerWeek: number, color: string, description?: string | null, teacherId?: string | null, credits?: number | null, gradingStyle: Grading_Style_Enum, defaultDaysOfTheWeek?: object | null, subjects?: object | null, gradeYears?: object | null, introduction?: string | null, useAssignmentTypeWeights?: boolean | null, assignmentTypeWeights: Array<{ __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> } | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, pointsAvailable?: number | null, completed?: string | null, submissions: Array<{ __typename?: 'files', id: string, url: string }>, assignment: { __typename?: 'assignments', id: string, name: string, week?: number | null, day?: number | null, duration: number, graded: boolean, description?: string | null, teachersNote?: string | null, created: string, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, attachments: Array<{ __typename?: 'files', id: string, url: string }> }, comments: Array<{ __typename?: 'comments', id: string, content: string, created: string, studentAccount?: { __typename?: 'student_accounts', id: string, name?: string | null, picture?: string | null } | null, teacher?: { __typename?: 'teachers', id: string, name?: string | null, picture?: string | null } | null, studentAssignment?: { __typename?: 'student_assignments', id: string } | null }> }> };

export type ActiveStudentCoursesInfoFragment = { __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null, course?: { __typename?: 'courses', numberOfDaysPerWeek: number, numberOfWeeks: number } | null, student: { __typename?: 'students', id: string, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> } };

export type ActiveStudentCourseCardInfoFragment = { __typename?: 'student_courses', id: string, start: string, end: string, daysOfTheWeek: object, status: Student_Course_Status_Enum, dailySortOrder: object, courseDayOffsets?: object | null, student: { __typename?: 'students', id: string, name: string, schoolYear?: School_Year_Enum | null }, course?: { __typename?: 'courses', id: string, name: string, color: string, gradingStyle: Grading_Style_Enum, numberOfDaysPerWeek: number, numberOfWeeks: number, useAssignmentTypeWeights?: boolean | null, assignmentTypeWeights: Array<{ __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> } | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, pointsAvailable?: number | null, start?: string | null, completed?: string | null, studentId: string, assignmentId: string, end?: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, name: string, assignmentType?: Assignment_Type_Enum | null, graded: boolean, week?: number | null, day?: number | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null } }> };

export type StudentCourseInfoFragment = { __typename?: 'student_courses', id: string, status: Student_Course_Status_Enum, start: string, end: string, daysOfTheWeek: object, calendarYear?: string | null, schoolYear?: School_Year_Enum | null, courseDayOffsets?: object | null, courseSnapshot?: object | null, student: { __typename?: 'students', id: string, name: string, schoolYear?: School_Year_Enum | null, picture?: string | null }, course?: { __typename?: 'courses', id: string, name: string, color: string, gradingStyle: Grading_Style_Enum, numberOfDaysPerWeek: number, numberOfWeeks: number, useAssignmentTypeWeights?: boolean | null, assignmentTypeWeights: Array<{ __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> } | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, pointsAvailable?: number | null, start?: string | null, completed?: string | null, studentId: string, assignmentId: string, end?: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, name: string, assignmentType?: Assignment_Type_Enum | null, graded: boolean, week?: number | null, day?: number | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null } }> };

export type CourseStudentCardInfoFragment = { __typename?: 'student_courses', id: string, student: { __typename?: 'students', id: string, name: string, picture?: string | null } };

export type PlanningStudentCourseFragment = { __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null, student: { __typename?: 'students', id: string, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, studentId: string, assignmentId: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, week?: number | null, day?: number | null, duration: number } }> };

export type CalendarStudentCourseFragment = { __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets?: object | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null }, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null }, assignment: { __typename?: 'assignments', id: string, name: string, description?: string | null, week?: number | null, day?: number | null, graded: boolean, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null } }> };

export type StudentCourseToRescheduleFragment = { __typename?: 'student_courses', id: string, daysOfTheWeek: object, studentId: string, start: string, courseDayOffsets?: object | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, studentId: string, assignmentId: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, week?: number | null, day?: number | null, duration: number } }> };

export type StudentCourseToReoffsetFragment = { __typename?: 'student_courses', id: string, daysOfTheWeek: object, studentId: string, start: string, courseDayOffsets?: object | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, studentId: string, assignmentId: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, week?: number | null, day?: number | null, duration: number } }> };

export type StudentCoursesToUpdateGradingStyleFragment = { __typename?: 'student_courses', id: string, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, studentId: string, assignmentId: string, status: Student_Assignment_Status_Enum, studentCourseId: string, pointsEarned?: number | null, pointsAvailable?: number | null }> };

export type RequiredStudentCourseInfoFragment = { __typename?: 'student_courses', id: string, studentId: string, status: Student_Course_Status_Enum, start: string, end: string, courseId?: string | null, daysOfTheWeek: object, courseDayOffsets?: object | null };

export type ActiveStudentTranscriptCourseFragment = { __typename?: 'student_courses', id: string, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, pointsAvailable?: number | null, start?: string | null, completed?: string | null, studentId: string, assignmentId: string, end?: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, name: string, assignmentType?: Assignment_Type_Enum | null, graded: boolean, week?: number | null, day?: number | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null } }>, course?: { __typename?: 'courses', id: string, name: string, color: string, credits?: number | null, gradingStyle: Grading_Style_Enum, useAssignmentTypeWeights?: boolean | null, assignmentTypeWeights: Array<{ __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> } | null };

export type CompletedStudentTranscriptCourseFragment = { __typename?: 'student_courses', id: string, calendarYear?: string | null, courseSnapshot?: object | null };

export type TeacherInfoFragment = { __typename?: 'teachers', id: string, email?: string | null, name?: string | null, picture?: string | null, organization?: { __typename?: 'organizations', id: string, name: string, supportLink?: string | null } | null };

export type OrganizationThemeFragment = { __typename?: 'themes', id: string, headerBackground?: string | null, headerForeground?: string | null, headerForegroundActive?: string | null, primary?: string | null, appBackground?: string | null, contentBackground?: string | null, faintBorder?: string | null, mediumBorder?: string | null, elementBorder?: string | null, colorPalette?: object | null, contentContrast?: string | null, contentPrimary?: string | null, contentSecondary?: string | null, contentTertiary?: string | null, positive?: string | null, negative?: string | null, info?: string | null, vacation?: string | null, logoUrl?: string | null, portalIconUrl?: string | null, fontUrl?: string | null, fontFamily?: string | null, baseFontSize?: number | null };

export type UserSettingsFragment = { __typename?: 'user_settings', id: string, showEmptyAssignmentDays: boolean };

export type BulkUpdateAssignmentsMutationVariables = Exact<{
  assignments: Array<Assignments_Insert_Input> | Assignments_Insert_Input;
}>;


export type BulkUpdateAssignmentsMutation = { __typename?: 'mutation_root', insert_assignments?: { __typename?: 'assignments_mutation_response', returning: Array<{ __typename?: 'assignments', id: string, name: string, description?: string | null, teachersNote?: string | null, graded: boolean, day?: number | null, week?: number | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> } | null };

export type CompleteStudentCourseMutationVariables = Exact<{
  studentCourseId: Scalars['uuid']['input'];
  schoolYear: School_Year_Enum;
  calendarYear: Scalars['String']['input'];
  courseSnapshot: Scalars['jsonb']['input'];
}>;


export type CompleteStudentCourseMutation = { __typename?: 'mutation_root', studentCourse?: { __typename?: 'student_courses', id: string, schoolYear?: School_Year_Enum | null, calendarYear?: string | null, courseSnapshot?: object | null, status: Student_Course_Status_Enum, courseId?: string | null, start: string, end: string, student: { __typename?: 'students', id: string, name: string, picture?: string | null } } | null, studentAssignments?: { __typename?: 'student_assignments_mutation_response', returning: Array<{ __typename?: 'student_assignments', id: string }> } | null };

export type CreateAssignmentMutationVariables = Exact<{
  assignment: Assignments_Insert_Input;
}>;


export type CreateAssignmentMutation = { __typename?: 'mutation_root', assignment?: { __typename?: 'assignments', courseId: string, id: string, name: string, description?: string | null, teachersNote?: string | null, duration: number, graded: boolean, created: string, day?: number | null, week?: number | null, parrotRequestId?: string | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, courseDayOffset?: number | null, pointsAvailable?: number | null, completed?: string | null, studentId: string, assignmentId: string, studentCourseId: string, assignment: { __typename?: 'assignments', id: string, name: string, graded: boolean, description?: string | null, week?: number | null, day?: number | null, assignmentType?: Assignment_Type_Enum | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, course: { __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null } }, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null } }>, attachments: Array<{ __typename?: 'files', id: string, url: string, size: any }>, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string } | null } | null };

export type CreateAssignmentsMutationVariables = Exact<{
  assignments: Array<Assignments_Insert_Input> | Assignments_Insert_Input;
}>;


export type CreateAssignmentsMutation = { __typename?: 'mutation_root', assignments?: { __typename?: 'assignments_mutation_response', returning: Array<{ __typename?: 'assignments', courseId: string, id: string, name: string, description?: string | null, teachersNote?: string | null, duration: number, graded: boolean, created: string, day?: number | null, week?: number | null, parrotRequestId?: string | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, courseDayOffset?: number | null, pointsAvailable?: number | null, completed?: string | null, studentId: string, assignmentId: string, studentCourseId: string, assignment: { __typename?: 'assignments', id: string, name: string, graded: boolean, description?: string | null, week?: number | null, day?: number | null, assignmentType?: Assignment_Type_Enum | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, course: { __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null } }, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null } }>, attachments: Array<{ __typename?: 'files', id: string, url: string, size: any }>, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string } | null }> } | null };

export type CreateAttachmentsMutationVariables = Exact<{
  attachments: Array<Files_Insert_Input> | Files_Insert_Input;
}>;


export type CreateAttachmentsMutation = { __typename?: 'mutation_root', attachments?: { __typename?: 'files_mutation_response', returning: Array<{ __typename?: 'files', id: string, url: string, size: any, assignmentId?: string | null }> } | null };

export type NewAttachmentFragment = { __typename?: 'files', id: string, url: string, assignmentId?: string | null };

export type CreateCommentMutationVariables = Exact<{
  comment: Comments_Insert_Input;
}>;


export type CreateCommentMutation = { __typename?: 'mutation_root', comment?: { __typename?: 'comments', id: string, content: string, created: string, studentAccount?: { __typename?: 'student_accounts', id: string, name?: string | null, picture?: string | null } | null, teacher?: { __typename?: 'teachers', id: string, name?: string | null, picture?: string | null } | null, studentAssignment?: { __typename?: 'student_assignments', id: string } | null } | null };

export type CreateCourseMutationVariables = Exact<{
  course: Courses_Insert_Input;
  includeStudentCourses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateCourseMutation = { __typename?: 'mutation_root', course?: { __typename?: 'courses', id: string, name: string, subjects?: object | null, gradeYears?: object | null, color: string, picture?: string | null, archived: boolean, description?: string | null, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek?: object | null, studentCourses?: Array<{ __typename?: 'student_courses', id: string, student: { __typename?: 'students', id: string, name: string, picture?: string | null } }>, assignments: Array<{ __typename?: 'assignments', id: string, day?: number | null, week?: number | null }> } | null };

export type CreateCustomAssignmentTypeMutationVariables = Exact<{
  customAssignmentType: Custom_Assignment_Types_Insert_Input;
}>;


export type CreateCustomAssignmentTypeMutation = { __typename?: 'mutation_root', customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null };

export type CreateCustomAssignmentTypesMutationVariables = Exact<{
  customAssignmentTypes: Array<Custom_Assignment_Types_Insert_Input> | Custom_Assignment_Types_Insert_Input;
}>;


export type CreateCustomAssignmentTypesMutation = { __typename?: 'mutation_root', customAssignmentTypes?: { __typename?: 'custom_assignment_types_mutation_response', returning: Array<{ __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean }> } | null };

export type CreateEventMutationVariables = Exact<{
  start: Scalars['date']['input'];
  end: Scalars['date']['input'];
  eventType: Event_T_Enum;
  teacherId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  studentEvents: Array<Student_Events_Insert_Input> | Student_Events_Insert_Input;
  studentAssignments: Array<Student_Assignments_Insert_Input> | Student_Assignments_Insert_Input;
}>;


export type CreateEventMutation = { __typename?: 'mutation_root', event?: { __typename?: 'events', id: string, name?: string | null, start: string, end: string, eventType: Event_T_Enum, studentEvents: Array<{ __typename?: 'student_events', id: string, student: { __typename?: 'students', id: string, name: string, picture?: string | null } }> } | null, insert_student_assignments?: { __typename?: 'student_assignments_mutation_response', returning: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null }> } | null };

export type CreateParrotRequestMutationVariables = Exact<{
  teacherId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  parrotRequestWeeksUsed: Scalars['Int']['input'];
  courseId: Scalars['uuid']['input'];
  startWeek: Scalars['Int']['input'];
  endWeek: Scalars['Int']['input'];
  status: Parrot_Request_Status_Enum;
  queuePosition?: InputMaybe<Scalars['Int']['input']>;
  userNotes?: InputMaybe<Scalars['String']['input']>;
  files: Array<Files_Insert_Input> | Files_Insert_Input;
}>;


export type CreateParrotRequestMutation = { __typename?: 'mutation_root', parrotRequest?: { __typename?: 'parrot_requests', id: string, startWeek: number, endWeek: number, status: Parrot_Request_Status_Enum, queuePosition?: number | null, userNotes?: string | null, created: string, course: { __typename?: 'courses', id: string, name: string, color: string, numberOfWeeks: number }, files: Array<{ __typename?: 'files', id: string, url: string }>, teacher: { __typename?: 'teachers', id: string, email?: string | null } } | null, customer?: { __typename?: 'customers', id: string, parrotCredits: number } | null };

export type CreateParrotRequestFilesMutationVariables = Exact<{
  files: Array<Files_Insert_Input> | Files_Insert_Input;
}>;


export type CreateParrotRequestFilesMutation = { __typename?: 'mutation_root', files?: { __typename?: 'files_mutation_response', returning: Array<{ __typename?: 'files', id: string, url: string, size: any, parrotRequestId?: string | null }> } | null };

export type NewParrotRequstFileFragment = { __typename?: 'files', id: string, url: string, parrotRequestId?: string | null };

export type CreatePrintingJobMutationVariables = Exact<{
  teacherId?: InputMaybe<Scalars['String']['input']>;
  studentAccountId?: InputMaybe<Scalars['String']['input']>;
  printingJobType: Printing_Job_Type_Enum;
  data: Scalars['jsonb']['input'];
}>;


export type CreatePrintingJobMutation = { __typename?: 'mutation_root', printingJob?: { __typename?: 'printing_jobs', id: string } | null };

export type CreateStudentMutationVariables = Exact<{
  teacherId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  schoolYear?: InputMaybe<School_Year_Enum>;
  picture?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateStudentMutation = { __typename?: 'mutation_root', student?: { __typename?: 'students', id: string, name: string, schoolYear?: School_Year_Enum | null, picture?: string | null, studentAccount?: { __typename?: 'student_accounts', id: string, email: string } | null } | null };

export type CreateSubmissionsMutationVariables = Exact<{
  submissions: Array<Files_Insert_Input> | Files_Insert_Input;
}>;


export type CreateSubmissionsMutation = { __typename?: 'mutation_root', submissions?: { __typename?: 'files_mutation_response', returning: Array<{ __typename?: 'files', id: string, url: string, size: any, studentAssignmentId?: string | null }> } | null };

export type DeleteAssignmentMutationVariables = Exact<{
  assignmentId: Scalars['uuid']['input'];
}>;


export type DeleteAssignmentMutation = { __typename?: 'mutation_root', assignment?: { __typename?: 'assignments', courseId: string, id: string, name: string, description?: string | null, teachersNote?: string | null, duration: number, graded: boolean, created: string, day?: number | null, week?: number | null, parrotRequestId?: string | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, courseDayOffset?: number | null, pointsAvailable?: number | null, completed?: string | null, studentId: string, assignmentId: string, studentCourseId: string, assignment: { __typename?: 'assignments', id: string, name: string, graded: boolean, description?: string | null, week?: number | null, day?: number | null, assignmentType?: Assignment_Type_Enum | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, course: { __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null } }, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null } }>, attachments: Array<{ __typename?: 'files', id: string, url: string, size: any }>, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string } | null } | null };

export type DeleteAssignmentTypeWeightsMutationVariables = Exact<{
  courseId: Scalars['uuid']['input'];
}>;


export type DeleteAssignmentTypeWeightsMutation = { __typename?: 'mutation_root', assignmentTypeWeight?: { __typename?: 'assignment_type_weights_mutation_response', returning: Array<{ __typename?: 'assignment_type_weights', id: string }> } | null };

export type DeleteAssignmentTypeWeightsByIdsMutationVariables = Exact<{
  assignmentTypeWeightsIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteAssignmentTypeWeightsByIdsMutation = { __typename?: 'mutation_root', assignmentTypeWeights?: { __typename?: 'assignment_type_weights_mutation_response', returning: Array<{ __typename?: 'assignment_type_weights', id: string }> } | null };

export type DeleteAssignmentsMutationVariables = Exact<{
  assignmentIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteAssignmentsMutation = { __typename?: 'mutation_root', assignments?: { __typename?: 'assignments_mutation_response', returning: Array<{ __typename?: 'assignments', id: string }> } | null };

export type DeleteCommentMutationVariables = Exact<{
  commentId: Scalars['uuid']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'mutation_root', comment?: { __typename?: 'comments', id: string } | null };

export type DeleteCourseMutationVariables = Exact<{
  courseId: Scalars['uuid']['input'];
}>;


export type DeleteCourseMutation = { __typename?: 'mutation_root', course?: { __typename?: 'courses', id: string } | null };

export type DeleteCustomAssignmentTypeMutationVariables = Exact<{
  customAssignmentTypeId: Scalars['uuid']['input'];
}>;


export type DeleteCustomAssignmentTypeMutation = { __typename?: 'mutation_root', customAssignmentType?: { __typename?: 'custom_assignment_types', id: string } | null };

export type DeleteEventMutationVariables = Exact<{
  eventId: Scalars['uuid']['input'];
  studentAssignments: Array<Student_Assignments_Insert_Input> | Student_Assignments_Insert_Input;
}>;


export type DeleteEventMutation = { __typename?: 'mutation_root', event?: { __typename?: 'events', id: string, name?: string | null, start: string, end: string, eventType: Event_T_Enum, studentEvents: Array<{ __typename?: 'student_events', id: string, student: { __typename?: 'students', id: string, name: string, picture?: string | null } }> } | null, insert_student_assignments?: { __typename?: 'student_assignments_mutation_response', returning: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null }> } | null };

export type DeleteFileMutationVariables = Exact<{
  fileId: Scalars['uuid']['input'];
}>;


export type DeleteFileMutation = { __typename?: 'mutation_root', file?: { __typename?: 'files', id: string, size: any, parrotRequestId?: string | null } | null };

export type DeleteOrganizationCodeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteOrganizationCodeMutation = { __typename?: 'mutation_root', delete_organization_code?: { __typename?: 'organization_codes', id: string } | null };

export type DeleteParrotRequestMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  customerId: Scalars['String']['input'];
  parrotCreditsToAdd: Scalars['Int']['input'];
}>;


export type DeleteParrotRequestMutation = { __typename?: 'mutation_root', parrotRequest?: { __typename?: 'parrot_requests', id: string } | null, customer?: { __typename?: 'customers', id: string, parrotCredits: number } | null };

export type DeleteStudentMutationVariables = Exact<{
  studentId: Scalars['String']['input'];
}>;


export type DeleteStudentMutation = { __typename?: 'mutation_root', student?: { __typename?: 'students', id: string } | null };

export type DeleteStudentAccountMutationVariables = Exact<{
  studentAccountId: Scalars['String']['input'];
}>;


export type DeleteStudentAccountMutation = { __typename?: 'mutation_root', studentAccount?: { __typename?: 'student_accounts', id: string } | null };

export type DeleteStudentCourseMutationVariables = Exact<{
  studentCourseId: Scalars['uuid']['input'];
}>;


export type DeleteStudentCourseMutation = { __typename?: 'mutation_root', studentCourse?: { __typename?: 'student_courses', id: string } | null };

export type EnrollStudentInCourseMutationVariables = Exact<{
  studentId: Scalars['String']['input'];
  courseId: Scalars['uuid']['input'];
  start: Scalars['date']['input'];
  end: Scalars['date']['input'];
  daysOfTheWeek: Scalars['jsonb']['input'];
  studentAssignments: Array<Student_Assignments_Insert_Input> | Student_Assignments_Insert_Input;
}>;


export type EnrollStudentInCourseMutation = { __typename?: 'mutation_root', studentCourse?: { __typename?: 'student_courses', id: string, status: Student_Course_Status_Enum, start: string, end: string, daysOfTheWeek: object, calendarYear?: string | null, schoolYear?: School_Year_Enum | null, courseDayOffsets?: object | null, courseSnapshot?: object | null, dailySortOrder: object, studentId: string, courseId?: string | null, student: { __typename?: 'students', id: string, name: string, schoolYear?: School_Year_Enum | null, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, course?: { __typename?: 'courses', id: string, name: string, color: string, gradingStyle: Grading_Style_Enum, numberOfDaysPerWeek: number, numberOfWeeks: number, useAssignmentTypeWeights?: boolean | null, assignmentTypeWeights: Array<{ __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> } | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, pointsAvailable?: number | null, start?: string | null, completed?: string | null, studentId: string, assignmentId: string, end?: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, name: string, assignmentType?: Assignment_Type_Enum | null, graded: boolean, week?: number | null, day?: number | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null } }> } | null };

export type RevokeOrganizationCodeMutationVariables = Exact<{
  organizationCodeId: Scalars['uuid']['input'];
  teacherId: Scalars['String']['input'];
}>;


export type RevokeOrganizationCodeMutation = { __typename?: 'mutation_root', delete_organization_code?: { __typename?: 'organization_codes', id: string } | null, update_customers?: { __typename?: 'customers_mutation_response', returning: Array<{ __typename?: 'customers', id: string, subscriptionStatus?: string | null, organizationSubscriptionExpiration?: string | null }> } | null, update_teacher?: { __typename?: 'teachers', id: string, organizationId?: string | null } | null };

export type SetCourseArchiveStatusMutationVariables = Exact<{
  courseId: Scalars['uuid']['input'];
  archived: Scalars['Boolean']['input'];
}>;


export type SetCourseArchiveStatusMutation = { __typename?: 'mutation_root', course?: { __typename?: 'courses', id: string, archived: boolean, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, assignments: Array<{ __typename?: 'assignments', id: string, day?: number | null, week?: number | null }> } | null };

export type SetTeacherHasDemoDataMutationVariables = Exact<{
  teacherId: Scalars['String']['input'];
}>;


export type SetTeacherHasDemoDataMutation = { __typename?: 'mutation_root', update_teacher?: { __typename?: 'teachers', id: string, needsDemoData: boolean } | null };

export type UnscheduleCourseAssignmentsMutationVariables = Exact<{
  assignments: Array<Assignments_Insert_Input> | Assignments_Insert_Input;
  courseId: Scalars['uuid']['input'];
  maxDay: Scalars['Int']['input'];
  maxWeek: Scalars['Int']['input'];
  studentAssignments: Array<Student_Assignments_Insert_Input> | Student_Assignments_Insert_Input;
  studentCourses: Array<Student_Courses_Insert_Input> | Student_Courses_Insert_Input;
}>;


export type UnscheduleCourseAssignmentsMutation = { __typename?: 'mutation_root', update_student_assignments?: { __typename?: 'student_assignments_mutation_response', returning: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, courseDayOffset?: number | null }> } | null, insert_assignments?: { __typename?: 'assignments_mutation_response', returning: Array<{ __typename?: 'assignments', id: string, day?: number | null, week?: number | null }> } | null, insert_student_assignments?: { __typename?: 'student_assignments_mutation_response', returning: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null }> } | null, insert_student_courses?: { __typename?: 'student_courses_mutation_response', returning: Array<{ __typename?: 'student_courses', id: string, courseDayOffsets?: object | null, daysOfTheWeek: object }> } | null };

export type UpdateAssignmentMutationVariables = Exact<{
  assignmentId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  teachersNote?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Int']['input'];
  graded: Scalars['Boolean']['input'];
  day?: InputMaybe<Scalars['Int']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
  customAssignmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type UpdateAssignmentMutation = { __typename?: 'mutation_root', assignment?: { __typename?: 'assignments', courseId: string, id: string, name: string, description?: string | null, teachersNote?: string | null, duration: number, graded: boolean, created: string, day?: number | null, week?: number | null, parrotRequestId?: string | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, courseDayOffset?: number | null, pointsAvailable?: number | null, completed?: string | null, studentId: string, assignmentId: string, studentCourseId: string, assignment: { __typename?: 'assignments', id: string, name: string, graded: boolean, description?: string | null, week?: number | null, day?: number | null, assignmentType?: Assignment_Type_Enum | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, course: { __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null } }, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null } }>, attachments: Array<{ __typename?: 'files', id: string, url: string, size: any }>, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string } | null } | null };

export type UpdateAssignmentDayWeekMutationVariables = Exact<{
  assignments: Array<Assignments_Insert_Input> | Assignments_Insert_Input;
}>;


export type UpdateAssignmentDayWeekMutation = { __typename?: 'mutation_root', insert_assignments?: { __typename?: 'assignments_mutation_response', returning: Array<{ __typename?: 'assignments', id: string, day?: number | null, week?: number | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, student: { __typename?: 'students', id: string } }> }> } | null };

export type UpdateCourseMutationVariables = Exact<{
  courseId: Scalars['uuid']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  subjects?: InputMaybe<Scalars['jsonb']['input']>;
  gradeYears?: InputMaybe<Scalars['jsonb']['input']>;
  numberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
  numberOfDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  defaultDaysOfTheWeek?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  gradingStyle: Grading_Style_Enum;
  credits?: InputMaybe<Scalars['numeric']['input']>;
  color: Scalars['String']['input'];
  useAssignmentTypeWeights?: InputMaybe<Scalars['Boolean']['input']>;
  assignmentTypeWeights: Array<Assignment_Type_Weights_Insert_Input> | Assignment_Type_Weights_Insert_Input;
}>;


export type UpdateCourseMutation = { __typename?: 'mutation_root', update_course?: { __typename?: 'courses', id: string, name: string, subjects?: object | null, gradeYears?: object | null, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek?: object | null, description?: string | null, introduction?: string | null, gradingStyle: Grading_Style_Enum, credits?: number | null, color: string, useAssignmentTypeWeights?: boolean | null } | null, insert_assignment_type_weights?: { __typename?: 'assignment_type_weights_mutation_response', returning: Array<{ __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, course: { __typename?: 'courses', id: string }, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> } | null };

export type UpdateCoursePictureMutationVariables = Exact<{
  courseId: Scalars['uuid']['input'];
  picture?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCoursePictureMutation = { __typename?: 'mutation_root', update_course?: { __typename?: 'courses', id: string, picture?: string | null } | null };

export type UpdateCustomAssignmentTypeMutationVariables = Exact<{
  customAssignmentTypeId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  color: Scalars['String']['input'];
  hidden: Scalars['Boolean']['input'];
}>;


export type UpdateCustomAssignmentTypeMutation = { __typename?: 'mutation_root', customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null };

export type UpdateCustomAssignmentTypesSortOrderMutationVariables = Exact<{
  updates: Array<Custom_Assignment_Types_Updates> | Custom_Assignment_Types_Updates;
}>;


export type UpdateCustomAssignmentTypesSortOrderMutation = { __typename?: 'mutation_root', update_custom_assignment_types_many?: Array<{ __typename?: 'custom_assignment_types_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean }> } | null> | null };

export type UpdateOrganizationAdminMutationVariables = Exact<{
  organizationAdminId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type UpdateOrganizationAdminMutation = { __typename?: 'mutation_root', update_organization_admin?: { __typename?: 'organization_admins', id: string, email: string, organization: { __typename?: 'organizations', icon?: string | null, id: string, name: string, supportLink?: string | null } } | null };

export type UpdateParrotRequestMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  customerId: Scalars['String']['input'];
  startWeek: Scalars['Int']['input'];
  endWeek: Scalars['Int']['input'];
  userNotes?: InputMaybe<Scalars['String']['input']>;
  parrotCreditsDifference: Scalars['Int']['input'];
}>;


export type UpdateParrotRequestMutation = { __typename?: 'mutation_root', update_parrot_request?: { __typename?: 'parrot_requests', id: string, startWeek: number, endWeek: number, status: Parrot_Request_Status_Enum, queuePosition?: number | null, userNotes?: string | null, created: string, course: { __typename?: 'courses', id: string, name: string, color: string, numberOfWeeks: number }, files: Array<{ __typename?: 'files', id: string, url: string }>, teacher: { __typename?: 'teachers', id: string, email?: string | null } } | null, update_customer?: { __typename?: 'customers', id: string, parrotCredits: number } | null };

export type SetParrotRequestStatusMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  status: Parrot_Request_Status_Enum;
}>;


export type SetParrotRequestStatusMutation = { __typename?: 'mutation_root', parrotRequest?: { __typename?: 'parrot_requests', id: string, status: Parrot_Request_Status_Enum } | null };

export type CompleteParrotRequestMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  studentAssignments: Array<Student_Assignments_Insert_Input> | Student_Assignments_Insert_Input;
}>;


export type CompleteParrotRequestMutation = { __typename?: 'mutation_root', parrotRequest?: { __typename?: 'parrot_requests', id: string, status: Parrot_Request_Status_Enum } | null, update_assignments?: { __typename?: 'assignments_mutation_response', returning: Array<{ __typename?: 'assignments', id: string, visible: boolean }> } | null, insert_student_assignments?: { __typename?: 'student_assignments_mutation_response', returning: Array<{ __typename?: 'student_assignments', id: string }> } | null };

export type ReopenParrotRequestMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type ReopenParrotRequestMutation = { __typename?: 'mutation_root', parrotRequest?: { __typename?: 'parrot_requests', id: string, status: Parrot_Request_Status_Enum } | null, update_assignments?: { __typename?: 'assignments_mutation_response', returning: Array<{ __typename?: 'assignments', id: string, visible: boolean }> } | null, deletedStudentAssignments?: { __typename?: 'student_assignments_mutation_response', returning: Array<{ __typename?: 'student_assignments', id: string }> } | null };

export type ClaimParrotRequestMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  claimerId: Scalars['String']['input'];
}>;


export type ClaimParrotRequestMutation = { __typename?: 'mutation_root', parrotRequest?: { __typename?: 'parrot_requests', claimerId?: string | null, id: string, startWeek: number, endWeek: number, status: Parrot_Request_Status_Enum, queuePosition?: number | null, userNotes?: string | null, created: string, course: { __typename?: 'courses', numberOfDaysPerWeek: number, id: string, name: string, color: string, numberOfWeeks: number, assignments: Array<{ __typename?: 'assignments', id: string, day?: number | null, week?: number | null, duration: number }>, studentCourses: Array<{ __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null, student: { __typename?: 'students', id: string, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> } }> }, files: Array<{ __typename?: 'files', id: string, url: string }>, teacher: { __typename?: 'teachers', id: string, email?: string | null } } | null };

export type UpdateStudentMutationVariables = Exact<{
  studentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  schoolYear?: InputMaybe<School_Year_Enum>;
}>;


export type UpdateStudentMutation = { __typename?: 'mutation_root', update_student?: { __typename?: 'students', id: string, name: string, schoolYear?: School_Year_Enum | null, picture?: string | null, studentAccount?: { __typename?: 'student_accounts', id: string, email: string } | null } | null };

export type UpdateStudentAccountMutationVariables = Exact<{
  studentAccountId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateStudentAccountMutation = { __typename?: 'mutation_root', update_student_account?: { __typename?: 'student_accounts', id: string, email: string, name?: string | null, picture?: string | null } | null };

export type UpdateStudentAssignmentDatesMutationVariables = Exact<{
  studentAssignmentId: Scalars['uuid']['input'];
  start?: InputMaybe<Scalars['date']['input']>;
  end?: InputMaybe<Scalars['date']['input']>;
  courseDayOffset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateStudentAssignmentDatesMutation = { __typename?: 'mutation_root', update_student_assignment?: { __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, courseDayOffset?: number | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null } } | null };

export type UpdateStudentAssignmentDatesOnRescheduleMutationVariables = Exact<{
  studentAssignmentId: Scalars['uuid']['input'];
  start: Scalars['date']['input'];
  end: Scalars['date']['input'];
  freeForm?: InputMaybe<Scalars['Boolean']['input']>;
  courseDayOffset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateStudentAssignmentDatesOnRescheduleMutation = { __typename?: 'mutation_root', update_student_assignment?: { __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, courseDayOffset?: number | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null } } | null };

export type UpdateStudentAssignmentGradeMutationVariables = Exact<{
  studentAssignmentId: Scalars['uuid']['input'];
  pointsEarned: Scalars['numeric']['input'];
  pointsAvailable: Scalars['numeric']['input'];
}>;


export type UpdateStudentAssignmentGradeMutation = { __typename?: 'mutation_root', update_student_assignment?: { __typename?: 'student_assignments', id: string, pointsEarned?: number | null, pointsAvailable?: number | null } | null };

export type UpdateStudentAssignmentStatusMutationVariables = Exact<{
  studentAssignmentId: Scalars['uuid']['input'];
  status: Student_Assignment_Status_Enum;
  completed?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type UpdateStudentAssignmentStatusMutation = { __typename?: 'mutation_root', update_student_assignment?: { __typename?: 'student_assignments', id: string, status: Student_Assignment_Status_Enum, completed?: string | null } | null };

export type UpdateStudentAssignmentsStatusMutationVariables = Exact<{
  studentAssignmentIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  status: Student_Assignment_Status_Enum;
  completed?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type UpdateStudentAssignmentsStatusMutation = { __typename?: 'mutation_root', update_student_assignments?: { __typename?: 'student_assignments_mutation_response', returning: Array<{ __typename?: 'student_assignments', id: string, status: Student_Assignment_Status_Enum, completed?: string | null }> } | null };

export type UpdateStudentCourseDayOffsetsMutationVariables = Exact<{
  studentCourseId: Scalars['uuid']['input'];
  studentCourseDayOffsets: Scalars['jsonb']['input'];
  studentAssignments: Array<Student_Assignments_Insert_Input> | Student_Assignments_Insert_Input;
}>;


export type UpdateStudentCourseDayOffsetsMutation = { __typename?: 'mutation_root', update_student_course?: { __typename?: 'student_courses', id: string, courseDayOffsets?: object | null } | null, insert_student_assignments?: { __typename?: 'student_assignments_mutation_response', returning: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, courseDayOffset?: number | null }> } | null };

export type UpdateStudentCourseScheduleMutationVariables = Exact<{
  studentCourseId: Scalars['uuid']['input'];
  daysOfTheWeek: Scalars['jsonb']['input'];
  start: Scalars['date']['input'];
  studentAssignments: Array<Student_Assignments_Insert_Input> | Student_Assignments_Insert_Input;
}>;


export type UpdateStudentCourseScheduleMutation = { __typename?: 'mutation_root', update_student_course?: { __typename?: 'student_courses', id: string, daysOfTheWeek: object } | null, insert_student_assignments?: { __typename?: 'student_assignments_mutation_response', returning: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null }> } | null };

export type UpdateStudentCoursesDailyOrderMutationVariables = Exact<{
  studentCourses: Array<Student_Courses_Insert_Input> | Student_Courses_Insert_Input;
}>;


export type UpdateStudentCoursesDailyOrderMutation = { __typename?: 'mutation_root', insert_student_courses?: { __typename?: 'student_courses_mutation_response', returning: Array<{ __typename?: 'student_courses', id: string, dailySortOrder: object }> } | null };

export type UpdateStudentPictureMutationVariables = Exact<{
  studentId: Scalars['String']['input'];
  picture?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateStudentPictureMutation = { __typename?: 'mutation_root', update_student?: { __typename?: 'students', id: string, picture?: string | null } | null };

export type UpdateTeacherMutationVariables = Exact<{
  teacherId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTeacherMutation = { __typename?: 'mutation_root', update_teacher?: { __typename?: 'teachers', id: string, email?: string | null, name?: string | null, picture?: string | null, organization?: { __typename?: 'organizations', id: string, name: string, supportLink?: string | null } | null } | null };

export type UpdateThemeMutationVariables = Exact<{
  themeId: Scalars['uuid']['input'];
  headerBackground?: InputMaybe<Scalars['String']['input']>;
  headerForeground?: InputMaybe<Scalars['String']['input']>;
  headerForegroundActive?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['String']['input']>;
  appBackground?: InputMaybe<Scalars['String']['input']>;
  contentBackground?: InputMaybe<Scalars['String']['input']>;
  faintBorder?: InputMaybe<Scalars['String']['input']>;
  mediumBorder?: InputMaybe<Scalars['String']['input']>;
  elementBorder?: InputMaybe<Scalars['String']['input']>;
  colorPalette?: InputMaybe<Scalars['jsonb']['input']>;
  contentContrast?: InputMaybe<Scalars['String']['input']>;
  contentPrimary?: InputMaybe<Scalars['String']['input']>;
  contentSecondary?: InputMaybe<Scalars['String']['input']>;
  contentTertiary?: InputMaybe<Scalars['String']['input']>;
  positive?: InputMaybe<Scalars['String']['input']>;
  negative?: InputMaybe<Scalars['String']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  vacation?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  portalIconUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateThemeMutation = { __typename?: 'mutation_root', update_themes_by_pk?: { __typename?: 'themes', id: string, headerBackground?: string | null, headerForeground?: string | null, headerForegroundActive?: string | null, primary?: string | null, appBackground?: string | null, contentBackground?: string | null, faintBorder?: string | null, mediumBorder?: string | null, elementBorder?: string | null, colorPalette?: object | null, contentContrast?: string | null, contentPrimary?: string | null, contentSecondary?: string | null, contentTertiary?: string | null, positive?: string | null, negative?: string | null, info?: string | null, vacation?: string | null, logoUrl?: string | null, portalIconUrl?: string | null, fontUrl?: string | null, fontFamily?: string | null, baseFontSize?: number | null } | null };

export type UpdateVacationMutationVariables = Exact<{
  eventId: Scalars['uuid']['input'];
  start: Scalars['date']['input'];
  end: Scalars['date']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  studentEvents: Array<Student_Events_Insert_Input> | Student_Events_Insert_Input;
  studentAssignments: Array<Student_Assignments_Insert_Input> | Student_Assignments_Insert_Input;
}>;


export type UpdateVacationMutation = { __typename?: 'mutation_root', update_event?: { __typename?: 'events', id: string, name?: string | null, start: string, end: string, eventType: Event_T_Enum, studentEvents: Array<{ __typename?: 'student_events', id: string, student: { __typename?: 'students', id: string, name: string, picture?: string | null } }> } | null, deletedStudentEvents?: { __typename?: 'student_events_mutation_response', returning: Array<{ __typename?: 'student_events', id: string }> } | null, newStudentEvents?: { __typename?: 'student_events_mutation_response', returning: Array<{ __typename?: 'student_events', id: string, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, event: { __typename?: 'events', id: string, name?: string | null, start: string, end: string, eventType: Event_T_Enum, studentEvents: Array<{ __typename?: 'student_events', id: string, student: { __typename?: 'students', id: string, name: string, picture?: string | null } }> } }> } | null, insert_student_assignments?: { __typename?: 'student_assignments_mutation_response', returning: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null }> } | null };

export type UpsertStudentAssignmentsDatesMutationVariables = Exact<{
  studentAssignments: Array<Student_Assignments_Insert_Input> | Student_Assignments_Insert_Input;
}>;


export type UpsertStudentAssignmentsDatesMutation = { __typename?: 'mutation_root', insert_student_assignments?: { __typename?: 'student_assignments_mutation_response', returning: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, courseDayOffset?: number | null }> } | null };

export type UpsertStudentAssignmentsGradingStylesMutationVariables = Exact<{
  studentAssignments: Array<Student_Assignments_Insert_Input> | Student_Assignments_Insert_Input;
}>;


export type UpsertStudentAssignmentsGradingStylesMutation = { __typename?: 'mutation_root', insert_student_assignments?: { __typename?: 'student_assignments_mutation_response', returning: Array<{ __typename?: 'student_assignments', id: string, pointsEarned?: number | null, pointsAvailable?: number | null }> } | null };

export type UpsertTeacherSettingsMutationVariables = Exact<{
  teacherId: Scalars['String']['input'];
  userSettings: User_Settings_Insert_Input;
}>;


export type UpsertTeacherSettingsMutation = { __typename?: 'mutation_root', insert_teacher?: { __typename?: 'teachers', id: string, userSettings?: { __typename?: 'user_settings', id: string, showEmptyAssignmentDays: boolean } | null } | null };

export type UpsertStudentSettingsMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  userSettings: User_Settings_Insert_Input;
}>;


export type UpsertStudentSettingsMutation = { __typename?: 'mutation_root', insert_student_account?: { __typename?: 'student_accounts', id: string, userSettings?: { __typename?: 'user_settings', id: string, showEmptyAssignmentDays: boolean } | null } | null };

export type GetActiveCourseStudentsQueryVariables = Exact<{
  courseId: Scalars['uuid']['input'];
}>;


export type GetActiveCourseStudentsQuery = { __typename?: 'query_root', course?: { __typename?: 'courses', id: string, studentCourses: Array<{ __typename?: 'student_courses', id: string, status: Student_Course_Status_Enum, start: string, end: string, daysOfTheWeek: object, calendarYear?: string | null, schoolYear?: School_Year_Enum | null, courseDayOffsets?: object | null, courseSnapshot?: object | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null, schoolYear?: School_Year_Enum | null }, course?: { __typename?: 'courses', id: string, name: string, color: string, gradingStyle: Grading_Style_Enum, numberOfDaysPerWeek: number, numberOfWeeks: number, useAssignmentTypeWeights?: boolean | null, assignmentTypeWeights: Array<{ __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> } | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, pointsAvailable?: number | null, start?: string | null, completed?: string | null, studentId: string, assignmentId: string, end?: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, name: string, assignmentType?: Assignment_Type_Enum | null, graded: boolean, week?: number | null, day?: number | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null } }> }> } | null };

export type GetActiveCourseOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveCourseOptionsQuery = { __typename?: 'query_root', courses: Array<{ __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek?: object | null }> };

export type GetActiveStudentCoursesQueryVariables = Exact<{
  studentId: Scalars['String']['input'];
}>;


export type GetActiveStudentCoursesQuery = { __typename?: 'query_root', student?: { __typename?: 'students', id: string, name: string, picture?: string | null, studentCourses: Array<{ __typename?: 'student_courses', id: string, start: string, end: string, daysOfTheWeek: object, status: Student_Course_Status_Enum, dailySortOrder: object, courseDayOffsets?: object | null, student: { __typename?: 'students', id: string, name: string, schoolYear?: School_Year_Enum | null }, course?: { __typename?: 'courses', id: string, name: string, color: string, gradingStyle: Grading_Style_Enum, numberOfDaysPerWeek: number, numberOfWeeks: number, useAssignmentTypeWeights?: boolean | null, assignmentTypeWeights: Array<{ __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> } | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, pointsAvailable?: number | null, start?: string | null, completed?: string | null, studentId: string, assignmentId: string, end?: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, name: string, assignmentType?: Assignment_Type_Enum | null, graded: boolean, week?: number | null, day?: number | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null } }> }>, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> } | null };

export type GetActiveStudentCoursesForTranscriptQueryVariables = Exact<{
  studentId: Scalars['String']['input'];
}>;


export type GetActiveStudentCoursesForTranscriptQuery = { __typename?: 'query_root', student?: { __typename?: 'students', id: string, studentCourses: Array<{ __typename?: 'student_courses', id: string, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, pointsAvailable?: number | null, start?: string | null, completed?: string | null, studentId: string, assignmentId: string, end?: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, name: string, assignmentType?: Assignment_Type_Enum | null, graded: boolean, week?: number | null, day?: number | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null } }>, course?: { __typename?: 'courses', id: string, name: string, color: string, credits?: number | null, gradingStyle: Grading_Style_Enum, useAssignmentTypeWeights?: boolean | null, assignmentTypeWeights: Array<{ __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> } | null }> } | null };

export type GetAllActiveStudentCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllActiveStudentCoursesQuery = { __typename?: 'query_root', studentCourses: Array<{ __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null, course?: { __typename?: 'courses', id: string, numberOfWeeks: number, numberOfDaysPerWeek: number } | null, student: { __typename?: 'students', id: string, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> } }> };

export type GetAllEventsInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEventsInfoQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', id: string, name?: string | null, start: string, end: string, eventType: Event_T_Enum, studentEvents: Array<{ __typename?: 'student_events', id: string, student: { __typename?: 'students', id: string, name: string, picture?: string | null } }> }> };

export type GetAllParrotRequestsInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllParrotRequestsInfoQuery = { __typename?: 'query_root', parrotRequests: Array<{ __typename?: 'parrot_requests', id: string, startWeek: number, endWeek: number, status: Parrot_Request_Status_Enum, queuePosition?: number | null, userNotes?: string | null, created: string, course: { __typename?: 'courses', id: string, name: string, color: string, numberOfWeeks: number }, files: Array<{ __typename?: 'files', id: string, url: string }>, teacher: { __typename?: 'teachers', id: string, email?: string | null } }> };

export type GetAllParrotRequestsByClaimerIdQueryVariables = Exact<{
  claimerId: Scalars['String']['input'];
}>;


export type GetAllParrotRequestsByClaimerIdQuery = { __typename?: 'query_root', parrotRequests: Array<{ __typename?: 'parrot_requests', id: string, startWeek: number, endWeek: number, status: Parrot_Request_Status_Enum, queuePosition?: number | null, userNotes?: string | null, created: string, course: { __typename?: 'courses', id: string, name: string, color: string, numberOfWeeks: number, assignments: Array<{ __typename?: 'assignments', id: string, day?: number | null, week?: number | null, duration: number }>, studentCourses: Array<{ __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null, student: { __typename?: 'students', id: string, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> } }> }, files: Array<{ __typename?: 'files', id: string, url: string }>, teacher: { __typename?: 'teachers', id: string, email?: string | null } }> };

export type GetAllStudentsInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStudentsInfoQuery = { __typename?: 'query_root', students: Array<{ __typename?: 'students', id: string, name: string, schoolYear?: School_Year_Enum | null, picture?: string | null, studentCourses: Array<{ __typename?: 'student_courses', id: string, status: Student_Course_Status_Enum }>, studentAccount?: { __typename?: 'student_accounts', id: string, email: string } | null }> };

export type GetAssignmentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssignmentTypesQuery = { __typename?: 'query_root', assignmentTypes: Array<{ __typename?: 'assignment_type', value: string }> };

export type GetAttendanceDayCountQueryVariables = Exact<{
  studentId: Scalars['String']['input'];
}>;


export type GetAttendanceDayCountQuery = { __typename?: 'query_root', student_assignments_aggregate: { __typename?: 'student_assignments_aggregate', aggregate?: { __typename?: 'student_assignments_aggregate_fields', count: number } | null } };

export type GetCalendarStudentAssignmentsQueryVariables = Exact<{
  day: Scalars['date']['input'];
}>;


export type GetCalendarStudentAssignmentsQuery = { __typename?: 'query_root', courses: Array<{ __typename?: 'courses', id: string, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, studentCourses: Array<{ __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets?: object | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null }, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null }, assignment: { __typename?: 'assignments', id: string, name: string, description?: string | null, week?: number | null, day?: number | null, graded: boolean, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null } }> }> }> };

export type GetStudentOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStudentOptionsQuery = { __typename?: 'query_root', students: Array<{ __typename?: 'students', id: string, name: string, picture?: string | null }> };

export type GetCalendarVacationsQueryVariables = Exact<{
  day: Scalars['date']['input'];
}>;


export type GetCalendarVacationsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', id: string, name?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, student: { __typename?: 'students', id: string, name: string } }> }> };

export type GetCompletedCourseStudentsQueryVariables = Exact<{
  courseId: Scalars['uuid']['input'];
}>;


export type GetCompletedCourseStudentsQuery = { __typename?: 'query_root', studentCourses: Array<{ __typename?: 'student_courses', id: string, status: Student_Course_Status_Enum, start: string, end: string, calendarYear?: string | null, schoolYear?: School_Year_Enum | null, courseSnapshot?: object | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null } }> };

export type GetCompletedStudentCourseInfoQueryVariables = Exact<{
  studentCourseId: Scalars['uuid']['input'];
}>;


export type GetCompletedStudentCourseInfoQuery = { __typename?: 'query_root', studentCourse?: { __typename?: 'student_courses', id: string, course?: { __typename?: 'courses', id: string, name: string, numberOfWeeks: number, numberOfDaysPerWeek: number, color: string, description?: string | null, teacherId?: string | null, credits?: number | null, gradingStyle: Grading_Style_Enum, defaultDaysOfTheWeek?: object | null, subjects?: object | null, gradeYears?: object | null, introduction?: string | null, useAssignmentTypeWeights?: boolean | null, assignmentTypeWeights: Array<{ __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> } | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, pointsAvailable?: number | null, completed?: string | null, submissions: Array<{ __typename?: 'files', id: string, url: string }>, assignment: { __typename?: 'assignments', id: string, name: string, week?: number | null, day?: number | null, duration: number, graded: boolean, description?: string | null, teachersNote?: string | null, created: string, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, attachments: Array<{ __typename?: 'files', id: string, url: string }> }, comments: Array<{ __typename?: 'comments', id: string, content: string, created: string, studentAccount?: { __typename?: 'student_accounts', id: string, name?: string | null, picture?: string | null } | null, teacher?: { __typename?: 'teachers', id: string, name?: string | null, picture?: string | null } | null, studentAssignment?: { __typename?: 'student_assignments', id: string } | null }> }> } | null };

export type GetCompletedStudentCoursesQueryVariables = Exact<{
  studentId: Scalars['String']['input'];
}>;


export type GetCompletedStudentCoursesQuery = { __typename?: 'query_root', student?: { __typename?: 'students', id: string, name: string, picture?: string | null, studentCourses: Array<{ __typename?: 'student_courses', id: string, status: Student_Course_Status_Enum, start: string, end: string, calendarYear?: string | null, schoolYear?: School_Year_Enum | null, courseSnapshot?: object | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null } }> } | null };

export type GetCompletedStudentCoursesForYearQueryVariables = Exact<{
  studentId: Scalars['String']['input'];
  calendarYears: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetCompletedStudentCoursesForYearQuery = { __typename?: 'query_root', student?: { __typename?: 'students', id: string, studentCourses: Array<{ __typename?: 'student_courses', id: string, calendarYear?: string | null, courseSnapshot?: object | null }> } | null };

export type GetCourseAssignmentsScheduleQueryVariables = Exact<{
  courseId: Scalars['uuid']['input'];
}>;


export type GetCourseAssignmentsScheduleQuery = { __typename?: 'query_root', course?: { __typename?: 'courses', id: string, assignments: Array<{ __typename?: 'assignments', id: string, day?: number | null, week?: number | null, duration: number }> } | null };

export type GetCoursesAssignmentsScheduleQueryVariables = Exact<{
  courseIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetCoursesAssignmentsScheduleQuery = { __typename?: 'query_root', courses: Array<{ __typename?: 'courses', id: string, numberOfDaysPerWeek: number, numberOfWeeks: number, assignments: Array<{ __typename?: 'assignments', id: string, day?: number | null, week?: number | null, duration: number }> }> };

export type GetCourseCardsQueryVariables = Exact<{
  includeStudentCourses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCourseCardsQuery = { __typename?: 'query_root', courses: Array<{ __typename?: 'courses', id: string, name: string, subjects?: object | null, gradeYears?: object | null, color: string, picture?: string | null, archived: boolean, description?: string | null, numberOfWeeks: number, numberOfDaysPerWeek: number, studentCourses?: Array<{ __typename?: 'student_courses', id: string, student: { __typename?: 'students', id: string, name: string, picture?: string | null } }> }> };

export type GetCourseInfoQueryVariables = Exact<{
  courseId: Scalars['uuid']['input'];
  includeStudentCourses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCourseInfoQuery = { __typename?: 'query_root', course?: { __typename?: 'courses', id: string, name: string, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek?: object | null, color: string, picture?: string | null, subjects?: object | null, gradeYears?: object | null, description?: string | null, introduction?: string | null, gradingStyle: Grading_Style_Enum, credits?: number | null, archived: boolean, useAssignmentTypeWeights?: boolean | null, assignments: Array<{ __typename?: 'assignments', id: string, day?: number | null, week?: number | null, name: string, duration: number, graded: boolean, courseId: string, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string } | null }>, studentCourses?: Array<{ __typename?: 'student_courses', id: string, studentId: string, status: Student_Course_Status_Enum, start: string, end: string, courseId?: string | null, daysOfTheWeek: object, courseDayOffsets?: object | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null } }>, assignmentTypeWeights: Array<{ __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> } | null };

export type GetCoursePlanCardQueryVariables = Exact<{
  courseId: Scalars['uuid']['input'];
}>;


export type GetCoursePlanCardQuery = { __typename?: 'query_root', course?: { __typename?: 'courses', id: string, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, assignments: Array<{ __typename?: 'assignments', id: string, day?: number | null, week?: number | null }> } | null };

export type GetCoursePlanCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCoursePlanCardsQuery = { __typename?: 'query_root', courses: Array<{ __typename?: 'courses', id: string, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, assignments: Array<{ __typename?: 'assignments', id: string, day?: number | null, week?: number | null }> }> };

export type GetCoursePlanCardsFromParrotRequestsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetCoursePlanCardsFromParrotRequestsQuery = { __typename?: 'query_root', parrotRequests: Array<{ __typename?: 'parrot_requests', id: string, status: Parrot_Request_Status_Enum, course: { __typename?: 'courses', id: string, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, assignments: Array<{ __typename?: 'assignments', id: string, day?: number | null, week?: number | null }> } }> };

export type GetCourseRescheduleInfoQueryVariables = Exact<{
  courseId: Scalars['uuid']['input'];
  studentCourseIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetCourseRescheduleInfoQuery = { __typename?: 'query_root', course?: { __typename?: 'courses', id: string, assignments: Array<{ __typename?: 'assignments', id: string, day?: number | null, week?: number | null, name: string, duration: number, graded: boolean, courseId: string, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string } | null }>, studentCourses: Array<{ __typename?: 'student_courses', id: string, studentId: string, status: Student_Course_Status_Enum, start: string, end: string, courseId?: string | null, daysOfTheWeek: object, courseDayOffsets?: object | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, freeForm: boolean, start?: string | null, end?: string | null, status: Student_Assignment_Status_Enum, assignmentId: string, studentId: string, studentCourseId: string, courseDayOffset?: number | null }>, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> } }> } | null };

export type GetCourseSubjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCourseSubjectsQuery = { __typename?: 'query_root', courses: Array<{ __typename?: 'courses', id: string, subjects?: object | null }> };

export type GetCoursesByAssignmentTypeQueryVariables = Exact<{
  customAssignmentTypeId: Scalars['uuid']['input'];
}>;


export type GetCoursesByAssignmentTypeQuery = { __typename?: 'query_root', courses: Array<{ __typename?: 'courses', id: string, assignmentTypeWeights: Array<{ __typename?: 'assignment_type_weights', id: string, customAssignmentTypeId?: string | null }> }> };

export type GetCustomAssignmentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomAssignmentTypesQuery = { __typename?: 'query_root', customAssignmentTypes: Array<{ __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean }> };

export type GetCustomerInfoQueryVariables = Exact<{
  teacherId: Scalars['String']['input'];
}>;


export type GetCustomerInfoQuery = { __typename?: 'query_root', teacher?: { __typename?: 'teachers', id: string, needsDemoData: boolean, customer?: { __typename?: 'customers', id: string, subscriptionStatus?: string | null, freeTrialEnd: string, planTier: Plan_Tier_Enum, parrotCredits: number, extendedTrial: boolean } | null } | null };

export type GetCustomerInfoByStudentQueryVariables = Exact<{
  studentId: Scalars['String']['input'];
}>;


export type GetCustomerInfoByStudentQuery = { __typename?: 'query_root', student?: { __typename?: 'students', id: string, teachers: Array<{ __typename?: 'teachers_students', teacher: { __typename?: 'teachers', id: string, customer?: { __typename?: 'customers', id: string, subscriptionStatus?: string | null, planTier: Plan_Tier_Enum } | null } }> } | null };

export type GetEventsInfoQueryVariables = Exact<{
  studentIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetEventsInfoQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', id: string, name?: string | null, start: string, end: string, eventType: Event_T_Enum, studentEvents: Array<{ __typename?: 'student_events', id: string, student: { __typename?: 'students', id: string, name: string, picture?: string | null } }> }> };

export type GetHomeSidebarQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHomeSidebarQuery = { __typename?: 'query_root', students: Array<{ __typename?: 'students', id: string, name: string, picture?: string | null }>, courses: Array<{ __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek?: object | null }>, customAssignmentTypes: Array<{ __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean }> };

export type GetHomeStudentAssignmentsQueryVariables = Exact<{
  day: Scalars['date']['input'];
  isStudent: Scalars['Boolean']['input'];
}>;


export type GetHomeStudentAssignmentsQuery = { __typename?: 'query_root', studentAssignments: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, pointsEarned?: number | null, pointsAvailable?: number | null, freeForm: boolean, status: Student_Assignment_Status_Enum, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, name: string, week?: number | null, day?: number | null, description?: string | null, teachersNote?: string | null, assignmentType?: Assignment_Type_Enum | null, graded: boolean, created: string, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, attachments: Array<{ __typename?: 'files', id: string, url: string }>, course: { __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null } }, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets?: object | null, start: string, course?: { __typename?: 'courses', id: string, gradingStyle: Grading_Style_Enum } | null }, submissions: Array<{ __typename?: 'files', id: string, url: string }>, comments: Array<{ __typename?: 'comments', id: string, content: string, created: string, studentAccount?: { __typename?: 'student_accounts', id: string, name?: string | null, picture?: string | null } | null, teacher?: { __typename?: 'teachers', id: string, name?: string | null, picture?: string | null } | null, studentAssignment?: { __typename?: 'student_assignments', id: string } | null }> }>, studentAssignmentsForGrading: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, pointsEarned?: number | null, pointsAvailable?: number | null, freeForm: boolean, status: Student_Assignment_Status_Enum, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, name: string, week?: number | null, day?: number | null, description?: string | null, teachersNote?: string | null, assignmentType?: Assignment_Type_Enum | null, graded: boolean, created: string, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, attachments: Array<{ __typename?: 'files', id: string, url: string }>, course: { __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null } }, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets?: object | null, start: string, course?: { __typename?: 'courses', id: string, gradingStyle: Grading_Style_Enum } | null }, submissions: Array<{ __typename?: 'files', id: string, url: string }>, comments: Array<{ __typename?: 'comments', id: string, content: string, created: string, studentAccount?: { __typename?: 'student_accounts', id: string, name?: string | null, picture?: string | null } | null, teacher?: { __typename?: 'teachers', id: string, name?: string | null, picture?: string | null } | null, studentAssignment?: { __typename?: 'student_assignments', id: string } | null }> }> };

export type GetOrganizationAdminInfoQueryVariables = Exact<{
  organizationAdminId: Scalars['String']['input'];
}>;


export type GetOrganizationAdminInfoQuery = { __typename?: 'query_root', organizationAdmin?: { __typename?: 'organization_admins', id: string, email: string, organization: { __typename?: 'organizations', icon?: string | null, id: string, name: string, supportLink?: string | null } } | null };

export type GetOrganizationCourseCardsQueryVariables = Exact<{
  organizationId: Scalars['uuid']['input'];
}>;


export type GetOrganizationCourseCardsQuery = { __typename?: 'query_root', organizationCourses: Array<{ __typename?: 'OrganizationCourse', id: string, name: string, subjects?: object | null, gradeYears?: object | null, color: string, picture?: string | null, archived: boolean, description?: string | null, numberOfWeeks: number, numberOfDaysPerWeek: number }> };

export type GetOrganizationCourseInfoQueryVariables = Exact<{
  organizationId: Scalars['uuid']['input'];
  courseId: Scalars['uuid']['input'];
}>;


export type GetOrganizationCourseInfoQuery = { __typename?: 'query_root', organizationCourse?: { __typename?: 'OrganizationCourse', id: string, name: string, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek?: object | null, color: string, picture?: string | null, subjects?: object | null, gradeYears?: object | null, description?: string | null, introduction?: string | null, gradingStyle: string, credits?: number | null, archived: boolean, useAssignmentTypeWeights?: boolean | null, assignmentTypeWeights: Array<{ __typename?: 'OrganizationCourseAssignmentTypeWeights', id: string, weight: number, assignmentType?: string | null, sortOrder: number, customAssignmentType?: { __typename?: 'OrganizationCourseCustomAssignmnetType', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> } | null };

export type GetOrganizationCourseSubjectsQueryVariables = Exact<{
  organizationId: Scalars['uuid']['input'];
}>;


export type GetOrganizationCourseSubjectsQuery = { __typename?: 'query_root', organizationCourses: Array<{ __typename?: 'OrganizationCourse', id: string, subjects?: object | null }> };

export type GetOrganizationInfoQueryVariables = Exact<{
  organizationId: Scalars['uuid']['input'];
}>;


export type GetOrganizationInfoQuery = { __typename?: 'query_root', organization?: { __typename?: 'organizations', id: string, name: string, supportLink?: string | null } | null };

export type GetOrganizationThemeForOrganizationAdminQueryVariables = Exact<{
  organizationAdminId: Scalars['String']['input'];
}>;


export type GetOrganizationThemeForOrganizationAdminQuery = { __typename?: 'query_root', organizationAdmin?: { __typename?: 'organization_admins', id: string, organization: { __typename?: 'organizations', id: string, theme?: { __typename?: 'themes', id: string, headerBackground?: string | null, headerForeground?: string | null, headerForegroundActive?: string | null, primary?: string | null, appBackground?: string | null, contentBackground?: string | null, faintBorder?: string | null, mediumBorder?: string | null, elementBorder?: string | null, colorPalette?: object | null, contentContrast?: string | null, contentPrimary?: string | null, contentSecondary?: string | null, contentTertiary?: string | null, positive?: string | null, negative?: string | null, info?: string | null, vacation?: string | null, logoUrl?: string | null, portalIconUrl?: string | null, fontUrl?: string | null, fontFamily?: string | null, baseFontSize?: number | null } | null } } | null };

export type GetOrganizationThemeForStudentQueryVariables = Exact<{
  studentAccountId: Scalars['String']['input'];
}>;


export type GetOrganizationThemeForStudentQuery = { __typename?: 'query_root', studentAccount?: { __typename?: 'student_accounts', id: string, student: { __typename?: 'students', id: string, teachers: Array<{ __typename?: 'teachers_students', teacher: { __typename?: 'teachers', id: string, organization?: { __typename?: 'organizations', id: string, theme?: { __typename?: 'themes', id: string, headerBackground?: string | null, headerForeground?: string | null, headerForegroundActive?: string | null, primary?: string | null, appBackground?: string | null, contentBackground?: string | null, faintBorder?: string | null, mediumBorder?: string | null, elementBorder?: string | null, colorPalette?: object | null, contentContrast?: string | null, contentPrimary?: string | null, contentSecondary?: string | null, contentTertiary?: string | null, positive?: string | null, negative?: string | null, info?: string | null, vacation?: string | null, logoUrl?: string | null, portalIconUrl?: string | null, fontUrl?: string | null, fontFamily?: string | null, baseFontSize?: number | null } | null } | null } }> } } | null };

export type GetOrganizationThemeForTeacherQueryVariables = Exact<{
  teacherId: Scalars['String']['input'];
}>;


export type GetOrganizationThemeForTeacherQuery = { __typename?: 'query_root', teacher?: { __typename?: 'teachers', id: string, organization?: { __typename?: 'organizations', id: string, theme?: { __typename?: 'themes', id: string, headerBackground?: string | null, headerForeground?: string | null, headerForegroundActive?: string | null, primary?: string | null, appBackground?: string | null, contentBackground?: string | null, faintBorder?: string | null, mediumBorder?: string | null, elementBorder?: string | null, colorPalette?: object | null, contentContrast?: string | null, contentPrimary?: string | null, contentSecondary?: string | null, contentTertiary?: string | null, positive?: string | null, negative?: string | null, info?: string | null, vacation?: string | null, logoUrl?: string | null, portalIconUrl?: string | null, fontUrl?: string | null, fontFamily?: string | null, baseFontSize?: number | null } | null } | null } | null };

export type GetOrganizationWithCodesQueryVariables = Exact<{
  adminId: Scalars['String']['input'];
}>;


export type GetOrganizationWithCodesQuery = { __typename?: 'query_root', organization_admins: Array<{ __typename?: 'organization_admins', organization: { __typename?: 'organizations', id: string, ignoredEmails?: Array<string> | null, freeEmails?: Array<string> | null, numberOfSeatsAvailable?: number | null, organizationCodes: Array<{ __typename?: 'organization_codes', id: string, code: string, originalUserEmail?: string | null, subscriptionExpiration?: string | null, teacher?: { __typename?: 'teachers', id: string, email?: string | null, name?: string | null, customer?: { __typename?: 'customers', id: string, subscriptionStatus?: string | null, organizationSubscriptionExpiration?: string | null } | null } | null }> } }> };

export type GetParrotRequestQueueQueryVariables = Exact<{ [key: string]: never; }>;


export type GetParrotRequestQueueQuery = { __typename?: 'query_root', parrotRequests: Array<{ __typename?: 'parrot_requests', id: string, startWeek: number, endWeek: number, status: Parrot_Request_Status_Enum, queuePosition?: number | null, userNotes?: string | null, created: string, teacher: { __typename?: 'teachers', id: string, email?: string | null }, course: { __typename?: 'courses', id: string, name: string, color: string, numberOfWeeks: number }, files: Array<{ __typename?: 'files', id: string, url: string }> }> };

export type GetPlanningAssignmentQueryVariables = Exact<{
  assignmentId: Scalars['uuid']['input'];
}>;


export type GetPlanningAssignmentQuery = { __typename?: 'query_root', assignment?: { __typename?: 'assignments', id: string, courseId: string, name: string, description?: string | null, teachersNote?: string | null, duration: number, graded: boolean, created: string, day?: number | null, week?: number | null, parrotRequestId?: string | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, courseDayOffset?: number | null, pointsAvailable?: number | null, completed?: string | null, studentId: string, assignmentId: string, studentCourseId: string, assignment: { __typename?: 'assignments', id: string, name: string, graded: boolean, description?: string | null, week?: number | null, day?: number | null, assignmentType?: Assignment_Type_Enum | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, course: { __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null } }, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null } }>, attachments: Array<{ __typename?: 'files', id: string, url: string, size: any }>, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string } | null } | null };

export type GetPlanningCourseQueryVariables = Exact<{
  courseId: Scalars['uuid']['input'];
}>;


export type GetPlanningCourseQuery = { __typename?: 'query_root', course?: { __typename?: 'courses', id: string, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, assignments: Array<{ __typename?: 'assignments', id: string, courseId: string, name: string, description?: string | null, teachersNote?: string | null, duration: number, graded: boolean, created: string, day?: number | null, week?: number | null, parrotRequestId?: string | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, courseDayOffset?: number | null, pointsAvailable?: number | null, completed?: string | null, studentId: string, assignmentId: string, studentCourseId: string, assignment: { __typename?: 'assignments', id: string, name: string, graded: boolean, description?: string | null, week?: number | null, day?: number | null, assignmentType?: Assignment_Type_Enum | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, course: { __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null } }, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null } }>, attachments: Array<{ __typename?: 'files', id: string, url: string, size: any }>, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string } | null }>, studentCourses: Array<{ __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null, student: { __typename?: 'students', id: string, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, studentId: string, assignmentId: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, week?: number | null, day?: number | null, duration: number } }> }>, assignmentTypeWeights: Array<{ __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> } | null };

export type GetPlanningCourseForParrotQueryVariables = Exact<{
  courseId: Scalars['uuid']['input'];
  parrotRequestId: Scalars['uuid']['input'];
}>;


export type GetPlanningCourseForParrotQuery = { __typename?: 'query_root', course?: { __typename?: 'courses', id: string, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, assignments: Array<{ __typename?: 'assignments', id: string, courseId: string, name: string, description?: string | null, teachersNote?: string | null, duration: number, graded: boolean, created: string, day?: number | null, week?: number | null, parrotRequestId?: string | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, courseDayOffset?: number | null, pointsAvailable?: number | null, completed?: string | null, studentId: string, assignmentId: string, studentCourseId: string, assignment: { __typename?: 'assignments', id: string, name: string, graded: boolean, description?: string | null, week?: number | null, day?: number | null, assignmentType?: Assignment_Type_Enum | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, course: { __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null } }, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null } }>, attachments: Array<{ __typename?: 'files', id: string, url: string, size: any }>, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string } | null }>, studentCourses: Array<{ __typename?: 'student_courses', id: string, start: string, daysOfTheWeek: object, courseDayOffsets?: object | null, student: { __typename?: 'students', id: string, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, studentId: string, assignmentId: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, week?: number | null, day?: number | null, duration: number } }> }>, assignmentTypeWeights: Array<{ __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> } | null };

export type GetPreviousPrintingJobsQueryVariables = Exact<{
  printingJobType?: InputMaybe<Printing_Job_Type_Enum>;
}>;


export type GetPreviousPrintingJobsQuery = { __typename?: 'query_root', exports: Array<{ __typename?: 'printing_jobs', id: string, file?: { __typename?: 'files', id: string, url: string } | null }> };

export type GetQuotasUsageQueryVariables = Exact<{
  teacherId: Scalars['String']['input'];
}>;


export type GetQuotasUsageQuery = { __typename?: 'query_root', files: { __typename?: 'files_aggregate', aggregate?: { __typename?: 'files_aggregate_fields', sum?: { __typename?: 'files_sum_fields', size?: any | null } | null } | null }, teacher?: { __typename?: 'teachers', id: string, customer?: { __typename?: 'customers', id: string, parrotCredits: number } | null } | null };

export type GetStorageUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStorageUsageQuery = { __typename?: 'query_root', files: { __typename?: 'files_aggregate', aggregate?: { __typename?: 'files_aggregate_fields', sum?: { __typename?: 'files_sum_fields', size?: any | null } | null } | null } };

export type GetStudentAccountInfoQueryVariables = Exact<{
  studentAccountId: Scalars['String']['input'];
}>;


export type GetStudentAccountInfoQuery = { __typename?: 'query_root', studentAccount?: { __typename?: 'student_accounts', id: string, email: string, name?: string | null, picture?: string | null, userSettings?: { __typename?: 'user_settings', id: string, showEmptyAssignmentDays: boolean } | null, student: { __typename?: 'students', teachers: Array<{ __typename?: 'teachers_students', teacher: { __typename?: 'teachers', id: string, organization?: { __typename?: 'organizations', id: string, name: string, supportLink?: string | null } | null } }> } } | null };

export type GetStudentAssignmentQueryVariables = Exact<{
  studentAssignmentId: Scalars['uuid']['input'];
  isStudent: Scalars['Boolean']['input'];
}>;


export type GetStudentAssignmentQuery = { __typename?: 'query_root', studentAssignment?: { __typename?: 'student_assignments', id: string, start?: string | null, end?: string | null, pointsEarned?: number | null, pointsAvailable?: number | null, freeForm: boolean, status: Student_Assignment_Status_Enum, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, name: string, week?: number | null, day?: number | null, description?: string | null, teachersNote?: string | null, assignmentType?: Assignment_Type_Enum | null, graded: boolean, created: string, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null, attachments: Array<{ __typename?: 'files', id: string, url: string }>, course: { __typename?: 'courses', id: string, name: string, color: string, subjects?: object | null } }, student: { __typename?: 'students', id: string, name: string, picture?: string | null, studentEvents: Array<{ __typename?: 'student_events', id: string, event: { __typename?: 'events', id: string, start: string, end: string } }> }, studentCourse: { __typename?: 'student_courses', id: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets?: object | null, start: string, course?: { __typename?: 'courses', id: string, gradingStyle: Grading_Style_Enum } | null }, submissions: Array<{ __typename?: 'files', id: string, url: string }>, comments: Array<{ __typename?: 'comments', id: string, content: string, created: string, studentAccount?: { __typename?: 'student_accounts', id: string, name?: string | null, picture?: string | null } | null, teacher?: { __typename?: 'teachers', id: string, name?: string | null, picture?: string | null } | null, studentAssignment?: { __typename?: 'student_assignments', id: string } | null }> } | null };

export type GetStudentCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStudentCardsQuery = { __typename?: 'query_root', students: Array<{ __typename?: 'students', id: string, name: string, schoolYear?: School_Year_Enum | null, picture?: string | null, studentAccount?: { __typename?: 'student_accounts', id: string, email: string } | null }> };

export type GetStudentCourseQueryVariables = Exact<{
  studentCourseId: Scalars['uuid']['input'];
}>;


export type GetStudentCourseQuery = { __typename?: 'query_root', studentCourse?: { __typename?: 'student_courses', id: string, status: Student_Course_Status_Enum, start: string, end: string, daysOfTheWeek: object, calendarYear?: string | null, schoolYear?: School_Year_Enum | null, courseDayOffsets?: object | null, courseSnapshot?: object | null, student: { __typename?: 'students', id: string, name: string, picture?: string | null, schoolYear?: School_Year_Enum | null }, course?: { __typename?: 'courses', id: string, name: string, color: string, gradingStyle: Grading_Style_Enum, numberOfDaysPerWeek: number, numberOfWeeks: number, useAssignmentTypeWeights?: boolean | null, assignmentTypeWeights: Array<{ __typename?: 'assignment_type_weights', id: string, weight: number, assignmentType?: Assignment_Type_Enum | null, sortOrder?: number | null, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null }> } | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, status: Student_Assignment_Status_Enum, pointsEarned?: number | null, pointsAvailable?: number | null, start?: string | null, completed?: string | null, studentId: string, assignmentId: string, end?: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, name: string, assignmentType?: Assignment_Type_Enum | null, graded: boolean, week?: number | null, day?: number | null, duration: number, customAssignmentType?: { __typename?: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder?: number | null, hidden: boolean } | null } }> } | null };

export type GetStudentCourseToRescheduleForCourseShiftQueryVariables = Exact<{
  date: Scalars['date']['input'];
  week: Scalars['Int']['input'];
  day: Scalars['Int']['input'];
  courseId: Scalars['uuid']['input'];
  studentAssignmentId: Scalars['uuid']['input'];
}>;


export type GetStudentCourseToRescheduleForCourseShiftQuery = { __typename?: 'query_root', studentCourseToReschedule?: { __typename?: 'student_courses', id: string, daysOfTheWeek: object, studentId: string, start: string, courseDayOffsets?: object | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, studentId: string, assignmentId: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, week?: number | null, day?: number | null, duration: number } }> } | null, studentCourseToReoffset?: { __typename?: 'student_courses', id: string, daysOfTheWeek: object, studentId: string, start: string, courseDayOffsets?: object | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, studentId: string, assignmentId: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, week?: number | null, day?: number | null, duration: number } }> } | null };

export type GetStudentCoursesToConvertGradingStyleQueryVariables = Exact<{
  courseId: Scalars['uuid']['input'];
}>;


export type GetStudentCoursesToConvertGradingStyleQuery = { __typename?: 'query_root', studentCourses: Array<{ __typename?: 'student_courses', id: string, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, studentId: string, assignmentId: string, status: Student_Assignment_Status_Enum, studentCourseId: string, pointsEarned?: number | null, pointsAvailable?: number | null }> }> };

export type GetStudentCoursesToRescheduleQueryVariables = Exact<{
  date: Scalars['date']['input'];
  studentIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetStudentCoursesToRescheduleQuery = { __typename?: 'query_root', studentCourses: Array<{ __typename?: 'student_courses', id: string, daysOfTheWeek: object, studentId: string, start: string, courseDayOffsets?: object | null, studentAssignments: Array<{ __typename?: 'student_assignments', id: string, studentId: string, assignmentId: string, start?: string | null, end?: string | null, freeForm: boolean, status: Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset?: number | null, assignment: { __typename?: 'assignments', id: string, week?: number | null, day?: number | null, duration: number } }> }> };

export type GetStudentInfoQueryVariables = Exact<{
  studentId: Scalars['String']['input'];
}>;


export type GetStudentInfoQuery = { __typename?: 'query_root', student?: { __typename?: 'students', id: string, name: string, schoolYear?: School_Year_Enum | null, picture?: string | null, studentAccount?: { __typename?: 'student_accounts', id: string, email: string } | null } | null };

export type GetStudentInfoForStudentAccountQueryVariables = Exact<{
  studentAccountId: Scalars['String']['input'];
}>;


export type GetStudentInfoForStudentAccountQuery = { __typename?: 'query_root', student_account?: { __typename?: 'student_accounts', student: { __typename?: 'students', id: string, name: string, schoolYear?: School_Year_Enum | null, picture?: string | null, studentAccount?: { __typename?: 'student_accounts', id: string, email: string } | null } } | null };

export type GetTeacherInfoQueryVariables = Exact<{
  teacherId: Scalars['String']['input'];
}>;


export type GetTeacherInfoQuery = { __typename?: 'query_root', teacher?: { __typename?: 'teachers', id: string, email?: string | null, name?: string | null, picture?: string | null, userSettings?: { __typename?: 'user_settings', id: string, showEmptyAssignmentDays: boolean } | null, customer?: { __typename?: 'customers', id: string, subscriptionStatus?: string | null, freeTrialEnd: string, planTier: Plan_Tier_Enum } | null, organization?: { __typename?: 'organizations', id: string, name: string, supportLink?: string | null } | null } | null };

export type GetPrintingJobsByIdsSubscriptionVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetPrintingJobsByIdsSubscription = { __typename?: 'subscription_root', printingJobs: Array<{ __typename?: 'printing_jobs', id: string, teacherId?: string | null, studentAccountId?: string | null, status: Printing_Job_Status_Enum, file?: { __typename?: 'files', id: string, url: string } | null }> };

export const CourseAssignmentScheduleFragmentDoc = gql`
    fragment CourseAssignmentSchedule on assignments {
  id
  day
  week
  duration
}
    `;
export const CustomAssignmentTypeFragmentDoc = gql`
    fragment CustomAssignmentType on custom_assignment_types {
  id
  name
  color
  created
  sortOrder
  hidden
}
    `;
export const HomeStudentAssignmentFragmentDoc = gql`
    fragment HomeStudentAssignment on student_assignments {
  id
  start
  end
  freeForm
  status
  pointsEarned
  assignment {
    id
    name
    customAssignmentType {
      ...CustomAssignmentType
    }
    graded
    course {
      id
      name
      color
      subjects
    }
  }
  student {
    id
    name
    picture
  }
  studentCourse {
    id
  }
}
    ${CustomAssignmentTypeFragmentDoc}`;
export const CalendarStudentAssignmentsFragmentDoc = gql`
    fragment CalendarStudentAssignments on student_assignments {
  id
  start
  end
  freeForm
  status
  pointsEarned
  student {
    id
    name
    picture
  }
  assignment {
    id
    name
    description
    customAssignmentType {
      ...CustomAssignmentType
    }
    week
    day
    graded
  }
}
    ${CustomAssignmentTypeFragmentDoc}`;
export const StudentsEventsFragmentDoc = gql`
    fragment StudentsEvents on students {
  id
  studentEvents {
    id
    event {
      id
      start
      end
    }
  }
}
    `;
export const PlanningStudentAssignmentFragmentDoc = gql`
    fragment PlanningStudentAssignment on student_assignments {
  id
  start
  end
  freeForm
  courseDayOffset
  student {
    id
    name
    picture
    ...StudentsEvents
  }
  studentCourse {
    id
    start
    daysOfTheWeek
    courseDayOffsets
  }
}
    ${StudentsEventsFragmentDoc}`;
export const GradebookStudentAssignmentFragmentDoc = gql`
    fragment GradebookStudentAssignment on student_assignments {
  id
  assignment {
    id
    name
    assignmentType
    customAssignmentType {
      ...CustomAssignmentType
    }
    graded
  }
  status
  pointsEarned
  pointsAvailable
  start
  completed
}
    ${CustomAssignmentTypeFragmentDoc}`;
export const StudentAssignmentToRescheduleFragmentDoc = gql`
    fragment StudentAssignmentToReschedule on student_assignments {
  id
  studentId
  assignmentId
  start
  end
  freeForm
  status
  studentCourseId
  courseDayOffset
  assignment {
    id
    week
    day
    duration
  }
}
    `;
export const NewStudentAssignmentFragmentDoc = gql`
    fragment NewStudentAssignment on student_assignments {
  ...HomeStudentAssignment
  ...CalendarStudentAssignments
  ...PlanningStudentAssignment
  ...GradebookStudentAssignment
  ...StudentAssignmentToReschedule
}
    ${HomeStudentAssignmentFragmentDoc}
${CalendarStudentAssignmentsFragmentDoc}
${PlanningStudentAssignmentFragmentDoc}
${GradebookStudentAssignmentFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}`;
export const PlanningAssignmentFragmentDoc = gql`
    fragment PlanningAssignment on assignments {
  id
  courseId
  name
  description
  teachersNote
  duration
  graded
  created
  day
  week
  parrotRequestId
  studentAssignments(order_by: {student: {name: asc}}) {
    ...NewStudentAssignment
  }
  attachments {
    id
    url
    size
  }
  customAssignmentType {
    id
    name
    color
  }
}
    ${NewStudentAssignmentFragmentDoc}`;
export const CoursePlanCardAssignmentFragmentDoc = gql`
    fragment CoursePlanCardAssignment on assignments {
  id
  day
  week
}
    `;
export const AssignmentInfoFragmentDoc = gql`
    fragment AssignmentInfo on assignments {
  courseId
  ...PlanningAssignment
  ...CoursePlanCardAssignment
}
    ${PlanningAssignmentFragmentDoc}
${CoursePlanCardAssignmentFragmentDoc}`;
export const CourseInfoStudentAssignmentFragmentDoc = gql`
    fragment CourseInfoStudentAssignment on student_assignments {
  id
  freeForm
  start
  end
  status
  assignmentId
  studentId
  studentCourseId
  courseDayOffset
}
    `;
export const CourseInfoAssignmentFragmentDoc = gql`
    fragment CourseInfoAssignment on assignments {
  id
  day
  week
  name
  duration
  graded
  courseId
  customAssignmentType {
    id
  }
}
    `;
export const AssignmentTypeWeightInfoFragmentDoc = gql`
    fragment AssignmentTypeWeightInfo on assignment_type_weights {
  id
  weight
  assignmentType
  customAssignmentType {
    ...CustomAssignmentType
  }
  sortOrder
}
    ${CustomAssignmentTypeFragmentDoc}`;
export const AssignmentTypeWeightsInfoFragmentDoc = gql`
    fragment AssignmentTypeWeightsInfo on courses {
  id
  assignmentTypeWeights {
    ...AssignmentTypeWeightInfo
  }
}
    ${AssignmentTypeWeightInfoFragmentDoc}`;
export const RequiredStudentCourseInfoFragmentDoc = gql`
    fragment RequiredStudentCourseInfo on student_courses {
  id
  studentId
  status
  start
  end
  courseId
  daysOfTheWeek
  courseDayOffsets
}
    `;
export const CourseInfoStudentCourseFragmentDoc = gql`
    fragment CourseInfoStudentCourse on student_courses {
  id
  ...RequiredStudentCourseInfo
  student {
    id
    name
    picture
  }
}
    ${RequiredStudentCourseInfoFragmentDoc}`;
export const CourseInfoFragmentDoc = gql`
    fragment CourseInfo on courses {
  id
  name
  numberOfWeeks
  numberOfDaysPerWeek
  defaultDaysOfTheWeek
  color
  picture
  subjects
  gradeYears
  description
  introduction
  gradingStyle
  credits
  archived
  defaultDaysOfTheWeek
  assignments {
    ...CourseInfoAssignment
  }
  useAssignmentTypeWeights
  ...AssignmentTypeWeightsInfo
  studentCourses(where: {status: {_eq: ENROLLED}}) @include(if: $includeStudentCourses) {
    ...CourseInfoStudentCourse
  }
}
    ${CourseInfoAssignmentFragmentDoc}
${AssignmentTypeWeightsInfoFragmentDoc}
${CourseInfoStudentCourseFragmentDoc}`;
export const CourseStudentCardInfoFragmentDoc = gql`
    fragment CourseStudentCardInfo on student_courses {
  id
  student {
    id
    name
    picture
  }
}
    `;
export const CourseCardInfoFragmentDoc = gql`
    fragment CourseCardInfo on courses {
  id
  name
  subjects
  gradeYears
  color
  picture
  archived
  description
  numberOfWeeks
  numberOfDaysPerWeek
  studentCourses(where: {status: {_eq: ENROLLED}}) @include(if: $includeStudentCourses) {
    ...CourseStudentCardInfo
  }
}
    ${CourseStudentCardInfoFragmentDoc}`;
export const CoursePlanCardInfoFragmentDoc = gql`
    fragment CoursePlanCardInfo on courses {
  id
  name
  color
  numberOfWeeks
  numberOfDaysPerWeek
  assignments {
    ...CoursePlanCardAssignment
  }
}
    ${CoursePlanCardAssignmentFragmentDoc}`;
export const CalendarStudentCourseFragmentDoc = gql`
    fragment CalendarStudentCourse on student_courses {
  id
  start
  daysOfTheWeek
  dailySortOrder
  courseDayOffsets
  student {
    id
    name
    picture
  }
  studentAssignments(
    where: {_or: [{start: {_eq: $day}}, {end: {_eq: $day}}]}
    order_by: {assignment: {created: asc}}
  ) {
    ...CalendarStudentAssignments
  }
}
    ${CalendarStudentAssignmentsFragmentDoc}`;
export const CalendarCourseFragmentDoc = gql`
    fragment CalendarCourse on courses {
  id
  name
  color
  numberOfWeeks
  numberOfDaysPerWeek
  studentCourses(where: {status: {_eq: ENROLLED}}) {
    ...CalendarStudentCourse
  }
}
    ${CalendarStudentCourseFragmentDoc}`;
export const ClaimedParrotRequestCourseInfoFragmentDoc = gql`
    fragment ClaimedParrotRequestCourseInfo on courses {
  assignments {
    id
    day
    week
    duration
  }
  studentCourses(where: {status: {_in: [ENROLLED]}}) {
    id
    start
    daysOfTheWeek
    courseDayOffsets
    student {
      id
      ...StudentsEvents
    }
  }
}
    ${StudentsEventsFragmentDoc}`;
export const CourseOptionFragmentDoc = gql`
    fragment CourseOption on courses {
  id
  name
  color
  subjects
  numberOfWeeks
  numberOfDaysPerWeek
  defaultDaysOfTheWeek
}
    `;
export const EventInfoFragmentDoc = gql`
    fragment EventInfo on events {
  id
  name
  start
  end
  eventType
  studentEvents {
    id
    student {
      id
      name
      picture
    }
  }
}
    `;
export const StudentEventInfoFragmentDoc = gql`
    fragment StudentEventInfo on student_events {
  id
  event {
    id
    start
    end
  }
}
    `;
export const CalendarVacationFragmentDoc = gql`
    fragment CalendarVacation on events {
  id
  name
  studentEvents {
    id
    student {
      id
      name
    }
  }
}
    `;
export const OrganizationFragmentDoc = gql`
    fragment Organization on organizations {
  id
  name
  supportLink
}
    `;
export const OrganizationAdminInfoFragmentDoc = gql`
    fragment OrganizationAdminInfo on organization_admins {
  id
  email
  organization {
    ...Organization
    icon
  }
}
    ${OrganizationFragmentDoc}`;
export const OrganizationCourseCardInfoFragmentDoc = gql`
    fragment OrganizationCourseCardInfo on OrganizationCourse {
  id
  name
  subjects
  gradeYears
  color
  picture
  archived
  description
  numberOfWeeks
  numberOfDaysPerWeek
}
    `;
export const OrganizationCourseInfoFragmentDoc = gql`
    fragment OrganizationCourseInfo on OrganizationCourse {
  id
  name
  numberOfWeeks
  numberOfDaysPerWeek
  defaultDaysOfTheWeek
  color
  picture
  subjects
  gradeYears
  description
  introduction
  gradingStyle
  credits
  archived
  useAssignmentTypeWeights
  assignmentTypeWeights {
    id
    weight
    assignmentType
    customAssignmentType {
      id
      name
      color
      created
      sortOrder
      hidden
    }
    sortOrder
  }
}
    `;
export const ParrotRequestInfoFragmentDoc = gql`
    fragment ParrotRequestInfo on parrot_requests {
  id
  course {
    id
    name
    color
    numberOfWeeks
  }
  startWeek
  endWeek
  status
  queuePosition
  userNotes
  files {
    id
    url
  }
  teacher {
    id
    email
  }
  created
}
    `;
export const PrintingJobInfoFragmentDoc = gql`
    fragment PrintingJobInfo on printing_jobs {
  id
  teacherId
  studentAccountId
  status
  file {
    id
    url
  }
}
    `;
export const StudentInfoFragmentDoc = gql`
    fragment StudentInfo on students {
  id
  name
  schoolYear
  picture
  studentAccount {
    id
    email
  }
}
    `;
export const StudentOptionFragmentDoc = gql`
    fragment StudentOption on students {
  id
  name
  picture
}
    `;
export const CommentInfoFragmentDoc = gql`
    fragment CommentInfo on comments {
  id
  content
  created
  studentAccount {
    id
    name
    picture
  }
  teacher {
    id
    name
    picture
  }
  studentAssignment {
    id
  }
}
    `;
export const StudentAssignmentDetailsFragmentDoc = gql`
    fragment StudentAssignmentDetails on student_assignments {
  id
  start
  end
  pointsEarned
  pointsAvailable
  freeForm
  status
  courseDayOffset
  assignment {
    id
    name
    week
    day
    description
    teachersNote @skip(if: $isStudent)
    customAssignmentType {
      ...CustomAssignmentType
    }
    assignmentType
    graded
    created
    attachments {
      id
      url
    }
    course {
      id
      name
      color
      subjects
    }
  }
  student {
    id
    name
    picture
    ...StudentsEvents
  }
  studentCourse {
    id
    daysOfTheWeek
    dailySortOrder
    courseDayOffsets
    start
    course {
      id
      gradingStyle
    }
  }
  submissions {
    id
    url
  }
  comments {
    ...CommentInfo
  }
}
    ${CustomAssignmentTypeFragmentDoc}
${StudentsEventsFragmentDoc}
${CommentInfoFragmentDoc}`;
export const CompletedStudentCourseCardInfoFragmentDoc = gql`
    fragment CompletedStudentCourseCardInfo on student_courses {
  id
  status
  start
  end
  calendarYear
  schoolYear
  courseSnapshot
  student {
    id
    name
    picture
  }
}
    `;
export const CourseSnapshotFragmentDoc = gql`
    fragment CourseSnapshot on student_courses {
  course {
    id
    name
    numberOfWeeks
    numberOfDaysPerWeek
    color
    description
    teacherId
    credits
    gradingStyle
    defaultDaysOfTheWeek
    subjects
    gradeYears
    introduction
    useAssignmentTypeWeights
    ...AssignmentTypeWeightsInfo
  }
  studentAssignments {
    id
    start
    end
    status
    pointsEarned
    pointsAvailable
    completed
    submissions {
      id
      url
    }
    assignment {
      id
      name
      week
      day
      duration
      graded
      customAssignmentType {
        ...CustomAssignmentType
      }
      description
      teachersNote
      created
      attachments {
        id
        url
      }
    }
    comments {
      ...CommentInfo
    }
  }
}
    ${AssignmentTypeWeightsInfoFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${CommentInfoFragmentDoc}`;
export const ActiveStudentCoursesInfoFragmentDoc = gql`
    fragment ActiveStudentCoursesInfo on student_courses {
  id
  start
  daysOfTheWeek
  courseDayOffsets
  course {
    numberOfDaysPerWeek
    numberOfWeeks
  }
  student {
    ...StudentsEvents
  }
}
    ${StudentsEventsFragmentDoc}`;
export const ActiveStudentCourseCardInfoFragmentDoc = gql`
    fragment ActiveStudentCourseCardInfo on student_courses {
  id
  start
  end
  daysOfTheWeek
  status
  dailySortOrder
  courseDayOffsets
  student {
    id
    name
    schoolYear
  }
  course {
    id
    name
    color
    gradingStyle
    numberOfDaysPerWeek
    numberOfWeeks
    useAssignmentTypeWeights
    ...AssignmentTypeWeightsInfo
  }
  studentAssignments {
    ...GradebookStudentAssignment
    ...StudentAssignmentToReschedule
  }
}
    ${AssignmentTypeWeightsInfoFragmentDoc}
${GradebookStudentAssignmentFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}`;
export const StudentCourseInfoFragmentDoc = gql`
    fragment StudentCourseInfo on student_courses {
  id
  status
  start
  end
  daysOfTheWeek
  calendarYear
  schoolYear
  courseDayOffsets
  courseSnapshot
  student {
    id
    name
    schoolYear
    picture
  }
  course {
    id
    name
    color
    gradingStyle
    numberOfDaysPerWeek
    numberOfWeeks
    useAssignmentTypeWeights
    ...AssignmentTypeWeightsInfo
  }
  studentAssignments {
    ...GradebookStudentAssignment
    ...StudentAssignmentToReschedule
  }
}
    ${AssignmentTypeWeightsInfoFragmentDoc}
${GradebookStudentAssignmentFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}`;
export const PlanningStudentCourseFragmentDoc = gql`
    fragment PlanningStudentCourse on student_courses {
  id
  start
  daysOfTheWeek
  courseDayOffsets
  student {
    id
    ...StudentsEvents
  }
  studentAssignments {
    ...StudentAssignmentToReschedule
  }
}
    ${StudentsEventsFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}`;
export const StudentCourseToRescheduleFragmentDoc = gql`
    fragment StudentCourseToReschedule on student_courses {
  id
  daysOfTheWeek
  studentId
  start
  courseDayOffsets
  studentAssignments(
    where: {_and: [{start: {_gte: $date}}, {freeForm: {_eq: false}}, {status: {_neq: COMPLETE}}]}
  ) {
    ...StudentAssignmentToReschedule
  }
}
    ${StudentAssignmentToRescheduleFragmentDoc}`;
export const StudentCourseToReoffsetFragmentDoc = gql`
    fragment StudentCourseToReoffset on student_courses {
  id
  daysOfTheWeek
  studentId
  start
  courseDayOffsets
  studentAssignments(
    where: {_and: [{start: {_lt: $date}}, {assignment: {_or: [{week: {_gt: $week}}, {_and: [{week: {_eq: $week}}, {day: {_gte: $day}}]}]}}, {id: {_neq: $studentAssignmentId}}]}
  ) {
    ...StudentAssignmentToReschedule
  }
}
    ${StudentAssignmentToRescheduleFragmentDoc}`;
export const StudentAssignmentToUpdateGradingStyleFragmentDoc = gql`
    fragment StudentAssignmentToUpdateGradingStyle on student_assignments {
  id
  studentId
  assignmentId
  status
  studentCourseId
  pointsEarned
  pointsAvailable
}
    `;
export const StudentCoursesToUpdateGradingStyleFragmentDoc = gql`
    fragment StudentCoursesToUpdateGradingStyle on student_courses {
  id
  studentAssignments {
    ...StudentAssignmentToUpdateGradingStyle
  }
}
    ${StudentAssignmentToUpdateGradingStyleFragmentDoc}`;
export const ActiveStudentTranscriptCourseFragmentDoc = gql`
    fragment ActiveStudentTranscriptCourse on student_courses {
  id
  studentAssignments {
    ...GradebookStudentAssignment
    ...StudentAssignmentToReschedule
  }
  course {
    id
    name
    color
    credits
    gradingStyle
    useAssignmentTypeWeights
    ...AssignmentTypeWeightsInfo
  }
}
    ${GradebookStudentAssignmentFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}
${AssignmentTypeWeightsInfoFragmentDoc}`;
export const CompletedStudentTranscriptCourseFragmentDoc = gql`
    fragment CompletedStudentTranscriptCourse on student_courses {
  id
  calendarYear
  courseSnapshot
}
    `;
export const TeacherInfoFragmentDoc = gql`
    fragment TeacherInfo on teachers {
  id
  email
  name
  picture
  organization {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export const OrganizationThemeFragmentDoc = gql`
    fragment OrganizationTheme on themes {
  id
  headerBackground
  headerForeground
  headerForegroundActive
  primary
  appBackground
  contentBackground
  faintBorder
  mediumBorder
  elementBorder
  colorPalette
  contentContrast
  contentPrimary
  contentSecondary
  contentTertiary
  positive
  negative
  info
  vacation
  logoUrl
  portalIconUrl
  fontUrl
  fontFamily
  baseFontSize
}
    `;
export const UserSettingsFragmentDoc = gql`
    fragment UserSettings on user_settings {
  id
  showEmptyAssignmentDays
}
    `;
export const NewAttachmentFragmentDoc = gql`
    fragment NewAttachment on files {
  id
  url
  assignmentId
}
    `;
export const NewParrotRequstFileFragmentDoc = gql`
    fragment NewParrotRequstFile on files {
  id
  url
  parrotRequestId
}
    `;
export const BulkUpdateAssignmentsDocument = gql`
    mutation BulkUpdateAssignments($assignments: [assignments_insert_input!]!) {
  insert_assignments(
    objects: $assignments
    on_conflict: {constraint: assignments_pkey, update_columns: [name, description, teachersNote, graded, customAssignmentTypeId, day, week, duration]}
  ) {
    returning {
      id
      name
      description
      teachersNote
      graded
      customAssignmentType {
        ...CustomAssignmentType
      }
      day
      week
      duration
    }
  }
}
    ${CustomAssignmentTypeFragmentDoc}`;
export type BulkUpdateAssignmentsMutationFn = Apollo.MutationFunction<BulkUpdateAssignmentsMutation, BulkUpdateAssignmentsMutationVariables>;

/**
 * __useBulkUpdateAssignmentsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateAssignmentsMutation, { data, loading, error }] = useBulkUpdateAssignmentsMutation({
 *   variables: {
 *      assignments: // value for 'assignments'
 *   },
 * });
 */
export function useBulkUpdateAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateAssignmentsMutation, BulkUpdateAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateAssignmentsMutation, BulkUpdateAssignmentsMutationVariables>(BulkUpdateAssignmentsDocument, options);
      }
export type BulkUpdateAssignmentsMutationHookResult = ReturnType<typeof useBulkUpdateAssignmentsMutation>;
export type BulkUpdateAssignmentsMutationResult = Apollo.MutationResult<BulkUpdateAssignmentsMutation>;
export type BulkUpdateAssignmentsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateAssignmentsMutation, BulkUpdateAssignmentsMutationVariables>;
export const CompleteStudentCourseDocument = gql`
    mutation CompleteStudentCourse($studentCourseId: uuid!, $schoolYear: school_year_enum!, $calendarYear: String!, $courseSnapshot: jsonb!) {
  studentCourse: update_student_course(
    pk_columns: {id: $studentCourseId}
    _set: {schoolYear: $schoolYear, calendarYear: $calendarYear, courseSnapshot: $courseSnapshot, status: COMPLETED, courseId: null}
  ) {
    id
    schoolYear
    calendarYear
    courseSnapshot
    status
    courseId
    student {
      id
    }
    ...CompletedStudentCourseCardInfo
  }
  studentAssignments: delete_student_assignments(
    where: {studentCourseId: {_eq: $studentCourseId}}
  ) {
    returning {
      id
    }
  }
}
    ${CompletedStudentCourseCardInfoFragmentDoc}`;
export type CompleteStudentCourseMutationFn = Apollo.MutationFunction<CompleteStudentCourseMutation, CompleteStudentCourseMutationVariables>;

/**
 * __useCompleteStudentCourseMutation__
 *
 * To run a mutation, you first call `useCompleteStudentCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteStudentCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeStudentCourseMutation, { data, loading, error }] = useCompleteStudentCourseMutation({
 *   variables: {
 *      studentCourseId: // value for 'studentCourseId'
 *      schoolYear: // value for 'schoolYear'
 *      calendarYear: // value for 'calendarYear'
 *      courseSnapshot: // value for 'courseSnapshot'
 *   },
 * });
 */
export function useCompleteStudentCourseMutation(baseOptions?: Apollo.MutationHookOptions<CompleteStudentCourseMutation, CompleteStudentCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteStudentCourseMutation, CompleteStudentCourseMutationVariables>(CompleteStudentCourseDocument, options);
      }
export type CompleteStudentCourseMutationHookResult = ReturnType<typeof useCompleteStudentCourseMutation>;
export type CompleteStudentCourseMutationResult = Apollo.MutationResult<CompleteStudentCourseMutation>;
export type CompleteStudentCourseMutationOptions = Apollo.BaseMutationOptions<CompleteStudentCourseMutation, CompleteStudentCourseMutationVariables>;
export const CreateAssignmentDocument = gql`
    mutation CreateAssignment($assignment: assignments_insert_input!) {
  assignment: insert_assignment(object: $assignment) {
    ...AssignmentInfo
  }
}
    ${AssignmentInfoFragmentDoc}`;
export type CreateAssignmentMutationFn = Apollo.MutationFunction<CreateAssignmentMutation, CreateAssignmentMutationVariables>;

/**
 * __useCreateAssignmentMutation__
 *
 * To run a mutation, you first call `useCreateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentMutation, { data, loading, error }] = useCreateAssignmentMutation({
 *   variables: {
 *      assignment: // value for 'assignment'
 *   },
 * });
 */
export function useCreateAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssignmentMutation, CreateAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssignmentMutation, CreateAssignmentMutationVariables>(CreateAssignmentDocument, options);
      }
export type CreateAssignmentMutationHookResult = ReturnType<typeof useCreateAssignmentMutation>;
export type CreateAssignmentMutationResult = Apollo.MutationResult<CreateAssignmentMutation>;
export type CreateAssignmentMutationOptions = Apollo.BaseMutationOptions<CreateAssignmentMutation, CreateAssignmentMutationVariables>;
export const CreateAssignmentsDocument = gql`
    mutation CreateAssignments($assignments: [assignments_insert_input!]!) {
  assignments: insert_assignments(objects: $assignments) {
    returning {
      ...AssignmentInfo
    }
  }
}
    ${AssignmentInfoFragmentDoc}`;
export type CreateAssignmentsMutationFn = Apollo.MutationFunction<CreateAssignmentsMutation, CreateAssignmentsMutationVariables>;

/**
 * __useCreateAssignmentsMutation__
 *
 * To run a mutation, you first call `useCreateAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentsMutation, { data, loading, error }] = useCreateAssignmentsMutation({
 *   variables: {
 *      assignments: // value for 'assignments'
 *   },
 * });
 */
export function useCreateAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssignmentsMutation, CreateAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssignmentsMutation, CreateAssignmentsMutationVariables>(CreateAssignmentsDocument, options);
      }
export type CreateAssignmentsMutationHookResult = ReturnType<typeof useCreateAssignmentsMutation>;
export type CreateAssignmentsMutationResult = Apollo.MutationResult<CreateAssignmentsMutation>;
export type CreateAssignmentsMutationOptions = Apollo.BaseMutationOptions<CreateAssignmentsMutation, CreateAssignmentsMutationVariables>;
export const CreateAttachmentsDocument = gql`
    mutation CreateAttachments($attachments: [files_insert_input!]!) {
  attachments: insert_files(objects: $attachments) {
    returning {
      id
      url
      size
      assignmentId
    }
  }
}
    `;
export type CreateAttachmentsMutationFn = Apollo.MutationFunction<CreateAttachmentsMutation, CreateAttachmentsMutationVariables>;

/**
 * __useCreateAttachmentsMutation__
 *
 * To run a mutation, you first call `useCreateAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttachmentsMutation, { data, loading, error }] = useCreateAttachmentsMutation({
 *   variables: {
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useCreateAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttachmentsMutation, CreateAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttachmentsMutation, CreateAttachmentsMutationVariables>(CreateAttachmentsDocument, options);
      }
export type CreateAttachmentsMutationHookResult = ReturnType<typeof useCreateAttachmentsMutation>;
export type CreateAttachmentsMutationResult = Apollo.MutationResult<CreateAttachmentsMutation>;
export type CreateAttachmentsMutationOptions = Apollo.BaseMutationOptions<CreateAttachmentsMutation, CreateAttachmentsMutationVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($comment: comments_insert_input!) {
  comment: insert_comment(object: $comment) {
    ...CommentInfo
  }
}
    ${CommentInfoFragmentDoc}`;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const CreateCourseDocument = gql`
    mutation CreateCourse($course: courses_insert_input!, $includeStudentCourses: Boolean = true) {
  course: insert_course(object: $course) {
    ...CourseCardInfo
    ...CoursePlanCardInfo
    ...CourseOption
  }
}
    ${CourseCardInfoFragmentDoc}
${CoursePlanCardInfoFragmentDoc}
${CourseOptionFragmentDoc}`;
export type CreateCourseMutationFn = Apollo.MutationFunction<CreateCourseMutation, CreateCourseMutationVariables>;

/**
 * __useCreateCourseMutation__
 *
 * To run a mutation, you first call `useCreateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourseMutation, { data, loading, error }] = useCreateCourseMutation({
 *   variables: {
 *      course: // value for 'course'
 *      includeStudentCourses: // value for 'includeStudentCourses'
 *   },
 * });
 */
export function useCreateCourseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCourseMutation, CreateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCourseMutation, CreateCourseMutationVariables>(CreateCourseDocument, options);
      }
export type CreateCourseMutationHookResult = ReturnType<typeof useCreateCourseMutation>;
export type CreateCourseMutationResult = Apollo.MutationResult<CreateCourseMutation>;
export type CreateCourseMutationOptions = Apollo.BaseMutationOptions<CreateCourseMutation, CreateCourseMutationVariables>;
export const CreateCustomAssignmentTypeDocument = gql`
    mutation CreateCustomAssignmentType($customAssignmentType: custom_assignment_types_insert_input!) {
  customAssignmentType: insert_custom_assignment_type(
    object: $customAssignmentType
  ) {
    ...CustomAssignmentType
  }
}
    ${CustomAssignmentTypeFragmentDoc}`;
export type CreateCustomAssignmentTypeMutationFn = Apollo.MutationFunction<CreateCustomAssignmentTypeMutation, CreateCustomAssignmentTypeMutationVariables>;

/**
 * __useCreateCustomAssignmentTypeMutation__
 *
 * To run a mutation, you first call `useCreateCustomAssignmentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomAssignmentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomAssignmentTypeMutation, { data, loading, error }] = useCreateCustomAssignmentTypeMutation({
 *   variables: {
 *      customAssignmentType: // value for 'customAssignmentType'
 *   },
 * });
 */
export function useCreateCustomAssignmentTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomAssignmentTypeMutation, CreateCustomAssignmentTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomAssignmentTypeMutation, CreateCustomAssignmentTypeMutationVariables>(CreateCustomAssignmentTypeDocument, options);
      }
export type CreateCustomAssignmentTypeMutationHookResult = ReturnType<typeof useCreateCustomAssignmentTypeMutation>;
export type CreateCustomAssignmentTypeMutationResult = Apollo.MutationResult<CreateCustomAssignmentTypeMutation>;
export type CreateCustomAssignmentTypeMutationOptions = Apollo.BaseMutationOptions<CreateCustomAssignmentTypeMutation, CreateCustomAssignmentTypeMutationVariables>;
export const CreateCustomAssignmentTypesDocument = gql`
    mutation CreateCustomAssignmentTypes($customAssignmentTypes: [custom_assignment_types_insert_input!]!) {
  customAssignmentTypes: insert_custom_assignment_types(
    objects: $customAssignmentTypes
  ) {
    returning {
      ...CustomAssignmentType
    }
  }
}
    ${CustomAssignmentTypeFragmentDoc}`;
export type CreateCustomAssignmentTypesMutationFn = Apollo.MutationFunction<CreateCustomAssignmentTypesMutation, CreateCustomAssignmentTypesMutationVariables>;

/**
 * __useCreateCustomAssignmentTypesMutation__
 *
 * To run a mutation, you first call `useCreateCustomAssignmentTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomAssignmentTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomAssignmentTypesMutation, { data, loading, error }] = useCreateCustomAssignmentTypesMutation({
 *   variables: {
 *      customAssignmentTypes: // value for 'customAssignmentTypes'
 *   },
 * });
 */
export function useCreateCustomAssignmentTypesMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomAssignmentTypesMutation, CreateCustomAssignmentTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomAssignmentTypesMutation, CreateCustomAssignmentTypesMutationVariables>(CreateCustomAssignmentTypesDocument, options);
      }
export type CreateCustomAssignmentTypesMutationHookResult = ReturnType<typeof useCreateCustomAssignmentTypesMutation>;
export type CreateCustomAssignmentTypesMutationResult = Apollo.MutationResult<CreateCustomAssignmentTypesMutation>;
export type CreateCustomAssignmentTypesMutationOptions = Apollo.BaseMutationOptions<CreateCustomAssignmentTypesMutation, CreateCustomAssignmentTypesMutationVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($start: date!, $end: date!, $eventType: event_t_enum!, $teacherId: String!, $name: String, $studentEvents: [student_events_insert_input!]!, $studentAssignments: [student_assignments_insert_input!]!) {
  event: insert_event(
    object: {start: $start, end: $end, eventType: $eventType, teacherId: $teacherId, name: $name, studentEvents: {data: $studentEvents}}
  ) {
    ...EventInfo
  }
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [start, end]}
  ) {
    returning {
      id
      start
      end
    }
  }
}
    ${EventInfoFragmentDoc}`;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      eventType: // value for 'eventType'
 *      teacherId: // value for 'teacherId'
 *      name: // value for 'name'
 *      studentEvents: // value for 'studentEvents'
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const CreateParrotRequestDocument = gql`
    mutation CreateParrotRequest($teacherId: String!, $customerId: String!, $parrotRequestWeeksUsed: Int!, $courseId: uuid!, $startWeek: Int!, $endWeek: Int!, $status: parrot_request_status_enum!, $queuePosition: Int, $userNotes: String, $files: [files_insert_input!]!) {
  parrotRequest: insert_parrot_request(
    object: {teacherId: $teacherId, courseId: $courseId, startWeek: $startWeek, endWeek: $endWeek, status: $status, queuePosition: $queuePosition, userNotes: $userNotes, files: {data: $files}}
  ) {
    ...ParrotRequestInfo
  }
  customer: update_customer(
    pk_columns: {id: $customerId}
    _inc: {parrotCredits: $parrotRequestWeeksUsed}
  ) {
    id
    parrotCredits
  }
}
    ${ParrotRequestInfoFragmentDoc}`;
export type CreateParrotRequestMutationFn = Apollo.MutationFunction<CreateParrotRequestMutation, CreateParrotRequestMutationVariables>;

/**
 * __useCreateParrotRequestMutation__
 *
 * To run a mutation, you first call `useCreateParrotRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateParrotRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createParrotRequestMutation, { data, loading, error }] = useCreateParrotRequestMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      customerId: // value for 'customerId'
 *      parrotRequestWeeksUsed: // value for 'parrotRequestWeeksUsed'
 *      courseId: // value for 'courseId'
 *      startWeek: // value for 'startWeek'
 *      endWeek: // value for 'endWeek'
 *      status: // value for 'status'
 *      queuePosition: // value for 'queuePosition'
 *      userNotes: // value for 'userNotes'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useCreateParrotRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateParrotRequestMutation, CreateParrotRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateParrotRequestMutation, CreateParrotRequestMutationVariables>(CreateParrotRequestDocument, options);
      }
export type CreateParrotRequestMutationHookResult = ReturnType<typeof useCreateParrotRequestMutation>;
export type CreateParrotRequestMutationResult = Apollo.MutationResult<CreateParrotRequestMutation>;
export type CreateParrotRequestMutationOptions = Apollo.BaseMutationOptions<CreateParrotRequestMutation, CreateParrotRequestMutationVariables>;
export const CreateParrotRequestFilesDocument = gql`
    mutation CreateParrotRequestFiles($files: [files_insert_input!]!) {
  files: insert_files(objects: $files) {
    returning {
      id
      url
      size
      parrotRequestId
    }
  }
}
    `;
export type CreateParrotRequestFilesMutationFn = Apollo.MutationFunction<CreateParrotRequestFilesMutation, CreateParrotRequestFilesMutationVariables>;

/**
 * __useCreateParrotRequestFilesMutation__
 *
 * To run a mutation, you first call `useCreateParrotRequestFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateParrotRequestFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createParrotRequestFilesMutation, { data, loading, error }] = useCreateParrotRequestFilesMutation({
 *   variables: {
 *      files: // value for 'files'
 *   },
 * });
 */
export function useCreateParrotRequestFilesMutation(baseOptions?: Apollo.MutationHookOptions<CreateParrotRequestFilesMutation, CreateParrotRequestFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateParrotRequestFilesMutation, CreateParrotRequestFilesMutationVariables>(CreateParrotRequestFilesDocument, options);
      }
export type CreateParrotRequestFilesMutationHookResult = ReturnType<typeof useCreateParrotRequestFilesMutation>;
export type CreateParrotRequestFilesMutationResult = Apollo.MutationResult<CreateParrotRequestFilesMutation>;
export type CreateParrotRequestFilesMutationOptions = Apollo.BaseMutationOptions<CreateParrotRequestFilesMutation, CreateParrotRequestFilesMutationVariables>;
export const CreatePrintingJobDocument = gql`
    mutation CreatePrintingJob($teacherId: String, $studentAccountId: String, $printingJobType: printing_job_type_enum!, $data: jsonb!) {
  printingJob: insert_printing_job(
    object: {teacherId: $teacherId, studentAccountId: $studentAccountId, status: GENERATING, type: $printingJobType, data: $data}
  ) {
    id
  }
}
    `;
export type CreatePrintingJobMutationFn = Apollo.MutationFunction<CreatePrintingJobMutation, CreatePrintingJobMutationVariables>;

/**
 * __useCreatePrintingJobMutation__
 *
 * To run a mutation, you first call `useCreatePrintingJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrintingJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrintingJobMutation, { data, loading, error }] = useCreatePrintingJobMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      studentAccountId: // value for 'studentAccountId'
 *      printingJobType: // value for 'printingJobType'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePrintingJobMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrintingJobMutation, CreatePrintingJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrintingJobMutation, CreatePrintingJobMutationVariables>(CreatePrintingJobDocument, options);
      }
export type CreatePrintingJobMutationHookResult = ReturnType<typeof useCreatePrintingJobMutation>;
export type CreatePrintingJobMutationResult = Apollo.MutationResult<CreatePrintingJobMutation>;
export type CreatePrintingJobMutationOptions = Apollo.BaseMutationOptions<CreatePrintingJobMutation, CreatePrintingJobMutationVariables>;
export const CreateStudentDocument = gql`
    mutation CreateStudent($teacherId: String!, $name: String!, $schoolYear: school_year_enum, $picture: String) {
  student: insert_student(
    object: {teachers: {data: {teacherId: $teacherId}}, name: $name, schoolYear: $schoolYear, picture: $picture}
  ) {
    ...StudentInfo
  }
}
    ${StudentInfoFragmentDoc}`;
export type CreateStudentMutationFn = Apollo.MutationFunction<CreateStudentMutation, CreateStudentMutationVariables>;

/**
 * __useCreateStudentMutation__
 *
 * To run a mutation, you first call `useCreateStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStudentMutation, { data, loading, error }] = useCreateStudentMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      name: // value for 'name'
 *      schoolYear: // value for 'schoolYear'
 *      picture: // value for 'picture'
 *   },
 * });
 */
export function useCreateStudentMutation(baseOptions?: Apollo.MutationHookOptions<CreateStudentMutation, CreateStudentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStudentMutation, CreateStudentMutationVariables>(CreateStudentDocument, options);
      }
export type CreateStudentMutationHookResult = ReturnType<typeof useCreateStudentMutation>;
export type CreateStudentMutationResult = Apollo.MutationResult<CreateStudentMutation>;
export type CreateStudentMutationOptions = Apollo.BaseMutationOptions<CreateStudentMutation, CreateStudentMutationVariables>;
export const CreateSubmissionsDocument = gql`
    mutation CreateSubmissions($submissions: [files_insert_input!]!) {
  submissions: insert_files(objects: $submissions) {
    returning {
      id
      url
      size
      studentAssignmentId
    }
  }
}
    `;
export type CreateSubmissionsMutationFn = Apollo.MutationFunction<CreateSubmissionsMutation, CreateSubmissionsMutationVariables>;

/**
 * __useCreateSubmissionsMutation__
 *
 * To run a mutation, you first call `useCreateSubmissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubmissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubmissionsMutation, { data, loading, error }] = useCreateSubmissionsMutation({
 *   variables: {
 *      submissions: // value for 'submissions'
 *   },
 * });
 */
export function useCreateSubmissionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubmissionsMutation, CreateSubmissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubmissionsMutation, CreateSubmissionsMutationVariables>(CreateSubmissionsDocument, options);
      }
export type CreateSubmissionsMutationHookResult = ReturnType<typeof useCreateSubmissionsMutation>;
export type CreateSubmissionsMutationResult = Apollo.MutationResult<CreateSubmissionsMutation>;
export type CreateSubmissionsMutationOptions = Apollo.BaseMutationOptions<CreateSubmissionsMutation, CreateSubmissionsMutationVariables>;
export const DeleteAssignmentDocument = gql`
    mutation DeleteAssignment($assignmentId: uuid!) {
  assignment: delete_assignment(id: $assignmentId) {
    ...AssignmentInfo
  }
}
    ${AssignmentInfoFragmentDoc}`;
export type DeleteAssignmentMutationFn = Apollo.MutationFunction<DeleteAssignmentMutation, DeleteAssignmentMutationVariables>;

/**
 * __useDeleteAssignmentMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentMutation, { data, loading, error }] = useDeleteAssignmentMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useDeleteAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssignmentMutation, DeleteAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssignmentMutation, DeleteAssignmentMutationVariables>(DeleteAssignmentDocument, options);
      }
export type DeleteAssignmentMutationHookResult = ReturnType<typeof useDeleteAssignmentMutation>;
export type DeleteAssignmentMutationResult = Apollo.MutationResult<DeleteAssignmentMutation>;
export type DeleteAssignmentMutationOptions = Apollo.BaseMutationOptions<DeleteAssignmentMutation, DeleteAssignmentMutationVariables>;
export const DeleteAssignmentTypeWeightsDocument = gql`
    mutation DeleteAssignmentTypeWeights($courseId: uuid!) {
  assignmentTypeWeight: delete_assignment_type_weights(
    where: {course_id: {_eq: $courseId}}
  ) {
    returning {
      id
    }
  }
}
    `;
export type DeleteAssignmentTypeWeightsMutationFn = Apollo.MutationFunction<DeleteAssignmentTypeWeightsMutation, DeleteAssignmentTypeWeightsMutationVariables>;

/**
 * __useDeleteAssignmentTypeWeightsMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentTypeWeightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentTypeWeightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentTypeWeightsMutation, { data, loading, error }] = useDeleteAssignmentTypeWeightsMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useDeleteAssignmentTypeWeightsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssignmentTypeWeightsMutation, DeleteAssignmentTypeWeightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssignmentTypeWeightsMutation, DeleteAssignmentTypeWeightsMutationVariables>(DeleteAssignmentTypeWeightsDocument, options);
      }
export type DeleteAssignmentTypeWeightsMutationHookResult = ReturnType<typeof useDeleteAssignmentTypeWeightsMutation>;
export type DeleteAssignmentTypeWeightsMutationResult = Apollo.MutationResult<DeleteAssignmentTypeWeightsMutation>;
export type DeleteAssignmentTypeWeightsMutationOptions = Apollo.BaseMutationOptions<DeleteAssignmentTypeWeightsMutation, DeleteAssignmentTypeWeightsMutationVariables>;
export const DeleteAssignmentTypeWeightsByIdsDocument = gql`
    mutation DeleteAssignmentTypeWeightsByIds($assignmentTypeWeightsIds: [uuid!]) {
  assignmentTypeWeights: delete_assignment_type_weights(
    where: {id: {_in: $assignmentTypeWeightsIds}}
  ) {
    returning {
      id
    }
  }
}
    `;
export type DeleteAssignmentTypeWeightsByIdsMutationFn = Apollo.MutationFunction<DeleteAssignmentTypeWeightsByIdsMutation, DeleteAssignmentTypeWeightsByIdsMutationVariables>;

/**
 * __useDeleteAssignmentTypeWeightsByIdsMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentTypeWeightsByIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentTypeWeightsByIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentTypeWeightsByIdsMutation, { data, loading, error }] = useDeleteAssignmentTypeWeightsByIdsMutation({
 *   variables: {
 *      assignmentTypeWeightsIds: // value for 'assignmentTypeWeightsIds'
 *   },
 * });
 */
export function useDeleteAssignmentTypeWeightsByIdsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssignmentTypeWeightsByIdsMutation, DeleteAssignmentTypeWeightsByIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssignmentTypeWeightsByIdsMutation, DeleteAssignmentTypeWeightsByIdsMutationVariables>(DeleteAssignmentTypeWeightsByIdsDocument, options);
      }
export type DeleteAssignmentTypeWeightsByIdsMutationHookResult = ReturnType<typeof useDeleteAssignmentTypeWeightsByIdsMutation>;
export type DeleteAssignmentTypeWeightsByIdsMutationResult = Apollo.MutationResult<DeleteAssignmentTypeWeightsByIdsMutation>;
export type DeleteAssignmentTypeWeightsByIdsMutationOptions = Apollo.BaseMutationOptions<DeleteAssignmentTypeWeightsByIdsMutation, DeleteAssignmentTypeWeightsByIdsMutationVariables>;
export const DeleteAssignmentsDocument = gql`
    mutation DeleteAssignments($assignmentIds: [uuid!]) {
  assignments: delete_assignments(where: {id: {_in: $assignmentIds}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteAssignmentsMutationFn = Apollo.MutationFunction<DeleteAssignmentsMutation, DeleteAssignmentsMutationVariables>;

/**
 * __useDeleteAssignmentsMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentsMutation, { data, loading, error }] = useDeleteAssignmentsMutation({
 *   variables: {
 *      assignmentIds: // value for 'assignmentIds'
 *   },
 * });
 */
export function useDeleteAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssignmentsMutation, DeleteAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssignmentsMutation, DeleteAssignmentsMutationVariables>(DeleteAssignmentsDocument, options);
      }
export type DeleteAssignmentsMutationHookResult = ReturnType<typeof useDeleteAssignmentsMutation>;
export type DeleteAssignmentsMutationResult = Apollo.MutationResult<DeleteAssignmentsMutation>;
export type DeleteAssignmentsMutationOptions = Apollo.BaseMutationOptions<DeleteAssignmentsMutation, DeleteAssignmentsMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($commentId: uuid!) {
  comment: delete_comment(id: $commentId) {
    id
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const DeleteCourseDocument = gql`
    mutation DeleteCourse($courseId: uuid!) {
  course: delete_course(id: $courseId) {
    id
  }
}
    `;
export type DeleteCourseMutationFn = Apollo.MutationFunction<DeleteCourseMutation, DeleteCourseMutationVariables>;

/**
 * __useDeleteCourseMutation__
 *
 * To run a mutation, you first call `useDeleteCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCourseMutation, { data, loading, error }] = useDeleteCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useDeleteCourseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCourseMutation, DeleteCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCourseMutation, DeleteCourseMutationVariables>(DeleteCourseDocument, options);
      }
export type DeleteCourseMutationHookResult = ReturnType<typeof useDeleteCourseMutation>;
export type DeleteCourseMutationResult = Apollo.MutationResult<DeleteCourseMutation>;
export type DeleteCourseMutationOptions = Apollo.BaseMutationOptions<DeleteCourseMutation, DeleteCourseMutationVariables>;
export const DeleteCustomAssignmentTypeDocument = gql`
    mutation DeleteCustomAssignmentType($customAssignmentTypeId: uuid!) {
  customAssignmentType: delete_custom_assignment_type(id: $customAssignmentTypeId) {
    id
  }
}
    `;
export type DeleteCustomAssignmentTypeMutationFn = Apollo.MutationFunction<DeleteCustomAssignmentTypeMutation, DeleteCustomAssignmentTypeMutationVariables>;

/**
 * __useDeleteCustomAssignmentTypeMutation__
 *
 * To run a mutation, you first call `useDeleteCustomAssignmentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomAssignmentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomAssignmentTypeMutation, { data, loading, error }] = useDeleteCustomAssignmentTypeMutation({
 *   variables: {
 *      customAssignmentTypeId: // value for 'customAssignmentTypeId'
 *   },
 * });
 */
export function useDeleteCustomAssignmentTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomAssignmentTypeMutation, DeleteCustomAssignmentTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomAssignmentTypeMutation, DeleteCustomAssignmentTypeMutationVariables>(DeleteCustomAssignmentTypeDocument, options);
      }
export type DeleteCustomAssignmentTypeMutationHookResult = ReturnType<typeof useDeleteCustomAssignmentTypeMutation>;
export type DeleteCustomAssignmentTypeMutationResult = Apollo.MutationResult<DeleteCustomAssignmentTypeMutation>;
export type DeleteCustomAssignmentTypeMutationOptions = Apollo.BaseMutationOptions<DeleteCustomAssignmentTypeMutation, DeleteCustomAssignmentTypeMutationVariables>;
export const DeleteEventDocument = gql`
    mutation DeleteEvent($eventId: uuid!, $studentAssignments: [student_assignments_insert_input!]!) {
  event: delete_event(id: $eventId) {
    ...EventInfo
  }
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [start, end]}
  ) {
    returning {
      id
      start
      end
    }
  }
}
    ${EventInfoFragmentDoc}`;
export type DeleteEventMutationFn = Apollo.MutationFunction<DeleteEventMutation, DeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, options);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>;
export const DeleteFileDocument = gql`
    mutation DeleteFile($fileId: uuid!) {
  file: delete_file(id: $fileId) {
    id
    size
    parrotRequestId
  }
}
    `;
export type DeleteFileMutationFn = Apollo.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const DeleteOrganizationCodeDocument = gql`
    mutation DeleteOrganizationCode($id: uuid!) {
  delete_organization_code(id: $id) {
    id
  }
}
    `;
export type DeleteOrganizationCodeMutationFn = Apollo.MutationFunction<DeleteOrganizationCodeMutation, DeleteOrganizationCodeMutationVariables>;

/**
 * __useDeleteOrganizationCodeMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationCodeMutation, { data, loading, error }] = useDeleteOrganizationCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationCodeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationCodeMutation, DeleteOrganizationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationCodeMutation, DeleteOrganizationCodeMutationVariables>(DeleteOrganizationCodeDocument, options);
      }
export type DeleteOrganizationCodeMutationHookResult = ReturnType<typeof useDeleteOrganizationCodeMutation>;
export type DeleteOrganizationCodeMutationResult = Apollo.MutationResult<DeleteOrganizationCodeMutation>;
export type DeleteOrganizationCodeMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationCodeMutation, DeleteOrganizationCodeMutationVariables>;
export const DeleteParrotRequestDocument = gql`
    mutation DeleteParrotRequest($requestId: uuid!, $customerId: String!, $parrotCreditsToAdd: Int!) {
  parrotRequest: delete_parrot_request(id: $requestId) {
    id
  }
  customer: update_customer(
    pk_columns: {id: $customerId}
    _inc: {parrotCredits: $parrotCreditsToAdd}
  ) {
    id
    parrotCredits
  }
}
    `;
export type DeleteParrotRequestMutationFn = Apollo.MutationFunction<DeleteParrotRequestMutation, DeleteParrotRequestMutationVariables>;

/**
 * __useDeleteParrotRequestMutation__
 *
 * To run a mutation, you first call `useDeleteParrotRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteParrotRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteParrotRequestMutation, { data, loading, error }] = useDeleteParrotRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      customerId: // value for 'customerId'
 *      parrotCreditsToAdd: // value for 'parrotCreditsToAdd'
 *   },
 * });
 */
export function useDeleteParrotRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteParrotRequestMutation, DeleteParrotRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteParrotRequestMutation, DeleteParrotRequestMutationVariables>(DeleteParrotRequestDocument, options);
      }
export type DeleteParrotRequestMutationHookResult = ReturnType<typeof useDeleteParrotRequestMutation>;
export type DeleteParrotRequestMutationResult = Apollo.MutationResult<DeleteParrotRequestMutation>;
export type DeleteParrotRequestMutationOptions = Apollo.BaseMutationOptions<DeleteParrotRequestMutation, DeleteParrotRequestMutationVariables>;
export const DeleteStudentDocument = gql`
    mutation DeleteStudent($studentId: String!) {
  student: delete_student(id: $studentId) {
    id
  }
}
    `;
export type DeleteStudentMutationFn = Apollo.MutationFunction<DeleteStudentMutation, DeleteStudentMutationVariables>;

/**
 * __useDeleteStudentMutation__
 *
 * To run a mutation, you first call `useDeleteStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudentMutation, { data, loading, error }] = useDeleteStudentMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useDeleteStudentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStudentMutation, DeleteStudentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStudentMutation, DeleteStudentMutationVariables>(DeleteStudentDocument, options);
      }
export type DeleteStudentMutationHookResult = ReturnType<typeof useDeleteStudentMutation>;
export type DeleteStudentMutationResult = Apollo.MutationResult<DeleteStudentMutation>;
export type DeleteStudentMutationOptions = Apollo.BaseMutationOptions<DeleteStudentMutation, DeleteStudentMutationVariables>;
export const DeleteStudentAccountDocument = gql`
    mutation DeleteStudentAccount($studentAccountId: String!) {
  studentAccount: delete_student_account(id: $studentAccountId) {
    id
  }
}
    `;
export type DeleteStudentAccountMutationFn = Apollo.MutationFunction<DeleteStudentAccountMutation, DeleteStudentAccountMutationVariables>;

/**
 * __useDeleteStudentAccountMutation__
 *
 * To run a mutation, you first call `useDeleteStudentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudentAccountMutation, { data, loading, error }] = useDeleteStudentAccountMutation({
 *   variables: {
 *      studentAccountId: // value for 'studentAccountId'
 *   },
 * });
 */
export function useDeleteStudentAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStudentAccountMutation, DeleteStudentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStudentAccountMutation, DeleteStudentAccountMutationVariables>(DeleteStudentAccountDocument, options);
      }
export type DeleteStudentAccountMutationHookResult = ReturnType<typeof useDeleteStudentAccountMutation>;
export type DeleteStudentAccountMutationResult = Apollo.MutationResult<DeleteStudentAccountMutation>;
export type DeleteStudentAccountMutationOptions = Apollo.BaseMutationOptions<DeleteStudentAccountMutation, DeleteStudentAccountMutationVariables>;
export const DeleteStudentCourseDocument = gql`
    mutation DeleteStudentCourse($studentCourseId: uuid!) {
  studentCourse: delete_student_course(id: $studentCourseId) {
    id
  }
}
    `;
export type DeleteStudentCourseMutationFn = Apollo.MutationFunction<DeleteStudentCourseMutation, DeleteStudentCourseMutationVariables>;

/**
 * __useDeleteStudentCourseMutation__
 *
 * To run a mutation, you first call `useDeleteStudentCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudentCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudentCourseMutation, { data, loading, error }] = useDeleteStudentCourseMutation({
 *   variables: {
 *      studentCourseId: // value for 'studentCourseId'
 *   },
 * });
 */
export function useDeleteStudentCourseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStudentCourseMutation, DeleteStudentCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStudentCourseMutation, DeleteStudentCourseMutationVariables>(DeleteStudentCourseDocument, options);
      }
export type DeleteStudentCourseMutationHookResult = ReturnType<typeof useDeleteStudentCourseMutation>;
export type DeleteStudentCourseMutationResult = Apollo.MutationResult<DeleteStudentCourseMutation>;
export type DeleteStudentCourseMutationOptions = Apollo.BaseMutationOptions<DeleteStudentCourseMutation, DeleteStudentCourseMutationVariables>;
export const EnrollStudentInCourseDocument = gql`
    mutation EnrollStudentInCourse($studentId: String!, $courseId: uuid!, $start: date!, $end: date!, $daysOfTheWeek: jsonb!, $studentAssignments: [student_assignments_insert_input!]!) {
  studentCourse: insert_student_course(
    object: {studentId: $studentId, courseId: $courseId, start: $start, end: $end, daysOfTheWeek: $daysOfTheWeek, status: ENROLLED, studentAssignments: {data: $studentAssignments}}
  ) {
    ...StudentCourseInfo
    ...ActiveStudentCourseCardInfo
    ...ActiveStudentCoursesInfo
    ...CourseStudentCardInfo
    ...RequiredStudentCourseInfo
  }
}
    ${StudentCourseInfoFragmentDoc}
${ActiveStudentCourseCardInfoFragmentDoc}
${ActiveStudentCoursesInfoFragmentDoc}
${CourseStudentCardInfoFragmentDoc}
${RequiredStudentCourseInfoFragmentDoc}`;
export type EnrollStudentInCourseMutationFn = Apollo.MutationFunction<EnrollStudentInCourseMutation, EnrollStudentInCourseMutationVariables>;

/**
 * __useEnrollStudentInCourseMutation__
 *
 * To run a mutation, you first call `useEnrollStudentInCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollStudentInCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollStudentInCourseMutation, { data, loading, error }] = useEnrollStudentInCourseMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      courseId: // value for 'courseId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      daysOfTheWeek: // value for 'daysOfTheWeek'
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useEnrollStudentInCourseMutation(baseOptions?: Apollo.MutationHookOptions<EnrollStudentInCourseMutation, EnrollStudentInCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollStudentInCourseMutation, EnrollStudentInCourseMutationVariables>(EnrollStudentInCourseDocument, options);
      }
export type EnrollStudentInCourseMutationHookResult = ReturnType<typeof useEnrollStudentInCourseMutation>;
export type EnrollStudentInCourseMutationResult = Apollo.MutationResult<EnrollStudentInCourseMutation>;
export type EnrollStudentInCourseMutationOptions = Apollo.BaseMutationOptions<EnrollStudentInCourseMutation, EnrollStudentInCourseMutationVariables>;
export const RevokeOrganizationCodeDocument = gql`
    mutation RevokeOrganizationCode($organizationCodeId: uuid!, $teacherId: String!) {
  delete_organization_code(id: $organizationCodeId) {
    id
  }
  update_customers(
    where: {teacherId: {_eq: $teacherId}}
    _set: {subscriptionStatus: "expired_trial", organizationSubscriptionExpiration: null}
  ) {
    returning {
      id
      subscriptionStatus
      organizationSubscriptionExpiration
    }
  }
  update_teacher(pk_columns: {id: $teacherId}, _set: {organizationId: null}) {
    id
    organizationId
  }
}
    `;
export type RevokeOrganizationCodeMutationFn = Apollo.MutationFunction<RevokeOrganizationCodeMutation, RevokeOrganizationCodeMutationVariables>;

/**
 * __useRevokeOrganizationCodeMutation__
 *
 * To run a mutation, you first call `useRevokeOrganizationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeOrganizationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeOrganizationCodeMutation, { data, loading, error }] = useRevokeOrganizationCodeMutation({
 *   variables: {
 *      organizationCodeId: // value for 'organizationCodeId'
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useRevokeOrganizationCodeMutation(baseOptions?: Apollo.MutationHookOptions<RevokeOrganizationCodeMutation, RevokeOrganizationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeOrganizationCodeMutation, RevokeOrganizationCodeMutationVariables>(RevokeOrganizationCodeDocument, options);
      }
export type RevokeOrganizationCodeMutationHookResult = ReturnType<typeof useRevokeOrganizationCodeMutation>;
export type RevokeOrganizationCodeMutationResult = Apollo.MutationResult<RevokeOrganizationCodeMutation>;
export type RevokeOrganizationCodeMutationOptions = Apollo.BaseMutationOptions<RevokeOrganizationCodeMutation, RevokeOrganizationCodeMutationVariables>;
export const SetCourseArchiveStatusDocument = gql`
    mutation SetCourseArchiveStatus($courseId: uuid!, $archived: Boolean!) {
  course: update_course(_set: {archived: $archived}, pk_columns: {id: $courseId}) {
    id
    archived
    name
    color
    numberOfWeeks
    numberOfDaysPerWeek
    assignments {
      ...CoursePlanCardAssignment
    }
  }
}
    ${CoursePlanCardAssignmentFragmentDoc}`;
export type SetCourseArchiveStatusMutationFn = Apollo.MutationFunction<SetCourseArchiveStatusMutation, SetCourseArchiveStatusMutationVariables>;

/**
 * __useSetCourseArchiveStatusMutation__
 *
 * To run a mutation, you first call `useSetCourseArchiveStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCourseArchiveStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCourseArchiveStatusMutation, { data, loading, error }] = useSetCourseArchiveStatusMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useSetCourseArchiveStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetCourseArchiveStatusMutation, SetCourseArchiveStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCourseArchiveStatusMutation, SetCourseArchiveStatusMutationVariables>(SetCourseArchiveStatusDocument, options);
      }
export type SetCourseArchiveStatusMutationHookResult = ReturnType<typeof useSetCourseArchiveStatusMutation>;
export type SetCourseArchiveStatusMutationResult = Apollo.MutationResult<SetCourseArchiveStatusMutation>;
export type SetCourseArchiveStatusMutationOptions = Apollo.BaseMutationOptions<SetCourseArchiveStatusMutation, SetCourseArchiveStatusMutationVariables>;
export const SetTeacherHasDemoDataDocument = gql`
    mutation SetTeacherHasDemoData($teacherId: String!) {
  update_teacher(_set: {needsDemoData: false}, pk_columns: {id: $teacherId}) {
    id
    needsDemoData
  }
}
    `;
export type SetTeacherHasDemoDataMutationFn = Apollo.MutationFunction<SetTeacherHasDemoDataMutation, SetTeacherHasDemoDataMutationVariables>;

/**
 * __useSetTeacherHasDemoDataMutation__
 *
 * To run a mutation, you first call `useSetTeacherHasDemoDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTeacherHasDemoDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTeacherHasDemoDataMutation, { data, loading, error }] = useSetTeacherHasDemoDataMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useSetTeacherHasDemoDataMutation(baseOptions?: Apollo.MutationHookOptions<SetTeacherHasDemoDataMutation, SetTeacherHasDemoDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTeacherHasDemoDataMutation, SetTeacherHasDemoDataMutationVariables>(SetTeacherHasDemoDataDocument, options);
      }
export type SetTeacherHasDemoDataMutationHookResult = ReturnType<typeof useSetTeacherHasDemoDataMutation>;
export type SetTeacherHasDemoDataMutationResult = Apollo.MutationResult<SetTeacherHasDemoDataMutation>;
export type SetTeacherHasDemoDataMutationOptions = Apollo.BaseMutationOptions<SetTeacherHasDemoDataMutation, SetTeacherHasDemoDataMutationVariables>;
export const UnscheduleCourseAssignmentsDocument = gql`
    mutation UnscheduleCourseAssignments($assignments: [assignments_insert_input!]!, $courseId: uuid!, $maxDay: Int!, $maxWeek: Int!, $studentAssignments: [student_assignments_insert_input!]!, $studentCourses: [student_courses_insert_input!]!) {
  update_student_assignments(
    where: {_and: [{assignment: {courseId: {_eq: $courseId}}}, {freeForm: {_eq: false}}, {_or: [{assignment: {day: {_gt: $maxDay}}}, {assignment: {week: {_gt: $maxWeek}}}]}]}
    _set: {start: null, end: null, courseDayOffset: 0}
  ) {
    returning {
      id
      start
      end
      courseDayOffset
    }
  }
  insert_assignments(
    objects: $assignments
    on_conflict: {constraint: assignments_pkey, update_columns: [day, week]}
  ) {
    returning {
      id
      day
      week
    }
  }
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [start, end]}
  ) {
    returning {
      id
      start
      end
    }
  }
  insert_student_courses(
    objects: $studentCourses
    on_conflict: {constraint: student_courses_pkey, update_columns: [courseDayOffsets, daysOfTheWeek]}
  ) {
    returning {
      id
      courseDayOffsets
      daysOfTheWeek
    }
  }
}
    `;
export type UnscheduleCourseAssignmentsMutationFn = Apollo.MutationFunction<UnscheduleCourseAssignmentsMutation, UnscheduleCourseAssignmentsMutationVariables>;

/**
 * __useUnscheduleCourseAssignmentsMutation__
 *
 * To run a mutation, you first call `useUnscheduleCourseAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnscheduleCourseAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unscheduleCourseAssignmentsMutation, { data, loading, error }] = useUnscheduleCourseAssignmentsMutation({
 *   variables: {
 *      assignments: // value for 'assignments'
 *      courseId: // value for 'courseId'
 *      maxDay: // value for 'maxDay'
 *      maxWeek: // value for 'maxWeek'
 *      studentAssignments: // value for 'studentAssignments'
 *      studentCourses: // value for 'studentCourses'
 *   },
 * });
 */
export function useUnscheduleCourseAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<UnscheduleCourseAssignmentsMutation, UnscheduleCourseAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnscheduleCourseAssignmentsMutation, UnscheduleCourseAssignmentsMutationVariables>(UnscheduleCourseAssignmentsDocument, options);
      }
export type UnscheduleCourseAssignmentsMutationHookResult = ReturnType<typeof useUnscheduleCourseAssignmentsMutation>;
export type UnscheduleCourseAssignmentsMutationResult = Apollo.MutationResult<UnscheduleCourseAssignmentsMutation>;
export type UnscheduleCourseAssignmentsMutationOptions = Apollo.BaseMutationOptions<UnscheduleCourseAssignmentsMutation, UnscheduleCourseAssignmentsMutationVariables>;
export const UpdateAssignmentDocument = gql`
    mutation UpdateAssignment($assignmentId: uuid!, $name: String!, $description: String, $teachersNote: String, $duration: Int!, $graded: Boolean!, $day: Int, $week: Int, $customAssignmentTypeId: uuid) {
  assignment: update_assignment(
    _set: {name: $name, description: $description, teachersNote: $teachersNote, duration: $duration, graded: $graded, day: $day, week: $week, customAssignmentTypeId: $customAssignmentTypeId}
    pk_columns: {id: $assignmentId}
  ) {
    ...AssignmentInfo
  }
}
    ${AssignmentInfoFragmentDoc}`;
export type UpdateAssignmentMutationFn = Apollo.MutationFunction<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>;

/**
 * __useUpdateAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentMutation, { data, loading, error }] = useUpdateAssignmentMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      teachersNote: // value for 'teachersNote'
 *      duration: // value for 'duration'
 *      graded: // value for 'graded'
 *      day: // value for 'day'
 *      week: // value for 'week'
 *      customAssignmentTypeId: // value for 'customAssignmentTypeId'
 *   },
 * });
 */
export function useUpdateAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>(UpdateAssignmentDocument, options);
      }
export type UpdateAssignmentMutationHookResult = ReturnType<typeof useUpdateAssignmentMutation>;
export type UpdateAssignmentMutationResult = Apollo.MutationResult<UpdateAssignmentMutation>;
export type UpdateAssignmentMutationOptions = Apollo.BaseMutationOptions<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>;
export const UpdateAssignmentDayWeekDocument = gql`
    mutation UpdateAssignmentDayWeek($assignments: [assignments_insert_input!]!) {
  insert_assignments(
    objects: $assignments
    on_conflict: {constraint: assignments_pkey, update_columns: [day, week]}
  ) {
    returning {
      id
      day
      week
      studentAssignments {
        id
        student {
          id
        }
      }
    }
  }
}
    `;
export type UpdateAssignmentDayWeekMutationFn = Apollo.MutationFunction<UpdateAssignmentDayWeekMutation, UpdateAssignmentDayWeekMutationVariables>;

/**
 * __useUpdateAssignmentDayWeekMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentDayWeekMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentDayWeekMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentDayWeekMutation, { data, loading, error }] = useUpdateAssignmentDayWeekMutation({
 *   variables: {
 *      assignments: // value for 'assignments'
 *   },
 * });
 */
export function useUpdateAssignmentDayWeekMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssignmentDayWeekMutation, UpdateAssignmentDayWeekMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssignmentDayWeekMutation, UpdateAssignmentDayWeekMutationVariables>(UpdateAssignmentDayWeekDocument, options);
      }
export type UpdateAssignmentDayWeekMutationHookResult = ReturnType<typeof useUpdateAssignmentDayWeekMutation>;
export type UpdateAssignmentDayWeekMutationResult = Apollo.MutationResult<UpdateAssignmentDayWeekMutation>;
export type UpdateAssignmentDayWeekMutationOptions = Apollo.BaseMutationOptions<UpdateAssignmentDayWeekMutation, UpdateAssignmentDayWeekMutationVariables>;
export const UpdateCourseDocument = gql`
    mutation UpdateCourse($courseId: uuid!, $name: String, $subjects: jsonb, $gradeYears: jsonb, $numberOfWeeks: Int, $numberOfDaysPerWeek: Int, $defaultDaysOfTheWeek: jsonb, $description: String, $introduction: String, $gradingStyle: grading_style_enum!, $credits: numeric, $color: String!, $useAssignmentTypeWeights: Boolean, $assignmentTypeWeights: [assignment_type_weights_insert_input!]!) {
  update_course(
    _set: {name: $name, subjects: $subjects, gradeYears: $gradeYears, numberOfWeeks: $numberOfWeeks, numberOfDaysPerWeek: $numberOfDaysPerWeek, defaultDaysOfTheWeek: $defaultDaysOfTheWeek, description: $description, introduction: $introduction, gradingStyle: $gradingStyle, credits: $credits, color: $color, useAssignmentTypeWeights: $useAssignmentTypeWeights}
    pk_columns: {id: $courseId}
  ) {
    id
    name
    subjects
    gradeYears
    numberOfWeeks
    numberOfDaysPerWeek
    defaultDaysOfTheWeek
    description
    introduction
    gradingStyle
    credits
    color
    useAssignmentTypeWeights
  }
  insert_assignment_type_weights(
    objects: $assignmentTypeWeights
    on_conflict: {constraint: assignment_type_weights_pkey, update_columns: [weight, sortOrder]}
  ) {
    returning {
      ...AssignmentTypeWeightInfo
      course {
        id
      }
    }
  }
}
    ${AssignmentTypeWeightInfoFragmentDoc}`;
export type UpdateCourseMutationFn = Apollo.MutationFunction<UpdateCourseMutation, UpdateCourseMutationVariables>;

/**
 * __useUpdateCourseMutation__
 *
 * To run a mutation, you first call `useUpdateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseMutation, { data, loading, error }] = useUpdateCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      name: // value for 'name'
 *      subjects: // value for 'subjects'
 *      gradeYears: // value for 'gradeYears'
 *      numberOfWeeks: // value for 'numberOfWeeks'
 *      numberOfDaysPerWeek: // value for 'numberOfDaysPerWeek'
 *      defaultDaysOfTheWeek: // value for 'defaultDaysOfTheWeek'
 *      description: // value for 'description'
 *      introduction: // value for 'introduction'
 *      gradingStyle: // value for 'gradingStyle'
 *      credits: // value for 'credits'
 *      color: // value for 'color'
 *      useAssignmentTypeWeights: // value for 'useAssignmentTypeWeights'
 *      assignmentTypeWeights: // value for 'assignmentTypeWeights'
 *   },
 * });
 */
export function useUpdateCourseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourseMutation, UpdateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourseMutation, UpdateCourseMutationVariables>(UpdateCourseDocument, options);
      }
export type UpdateCourseMutationHookResult = ReturnType<typeof useUpdateCourseMutation>;
export type UpdateCourseMutationResult = Apollo.MutationResult<UpdateCourseMutation>;
export type UpdateCourseMutationOptions = Apollo.BaseMutationOptions<UpdateCourseMutation, UpdateCourseMutationVariables>;
export const UpdateCoursePictureDocument = gql`
    mutation UpdateCoursePicture($courseId: uuid!, $picture: String) {
  update_course(_set: {picture: $picture}, pk_columns: {id: $courseId}) {
    id
    picture
  }
}
    `;
export type UpdateCoursePictureMutationFn = Apollo.MutationFunction<UpdateCoursePictureMutation, UpdateCoursePictureMutationVariables>;

/**
 * __useUpdateCoursePictureMutation__
 *
 * To run a mutation, you first call `useUpdateCoursePictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoursePictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoursePictureMutation, { data, loading, error }] = useUpdateCoursePictureMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      picture: // value for 'picture'
 *   },
 * });
 */
export function useUpdateCoursePictureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoursePictureMutation, UpdateCoursePictureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoursePictureMutation, UpdateCoursePictureMutationVariables>(UpdateCoursePictureDocument, options);
      }
export type UpdateCoursePictureMutationHookResult = ReturnType<typeof useUpdateCoursePictureMutation>;
export type UpdateCoursePictureMutationResult = Apollo.MutationResult<UpdateCoursePictureMutation>;
export type UpdateCoursePictureMutationOptions = Apollo.BaseMutationOptions<UpdateCoursePictureMutation, UpdateCoursePictureMutationVariables>;
export const UpdateCustomAssignmentTypeDocument = gql`
    mutation UpdateCustomAssignmentType($customAssignmentTypeId: uuid!, $name: String!, $color: String!, $hidden: Boolean!) {
  customAssignmentType: update_custom_assignment_type(
    _set: {name: $name, color: $color, hidden: $hidden}
    pk_columns: {id: $customAssignmentTypeId}
  ) {
    ...CustomAssignmentType
  }
}
    ${CustomAssignmentTypeFragmentDoc}`;
export type UpdateCustomAssignmentTypeMutationFn = Apollo.MutationFunction<UpdateCustomAssignmentTypeMutation, UpdateCustomAssignmentTypeMutationVariables>;

/**
 * __useUpdateCustomAssignmentTypeMutation__
 *
 * To run a mutation, you first call `useUpdateCustomAssignmentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomAssignmentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomAssignmentTypeMutation, { data, loading, error }] = useUpdateCustomAssignmentTypeMutation({
 *   variables: {
 *      customAssignmentTypeId: // value for 'customAssignmentTypeId'
 *      name: // value for 'name'
 *      color: // value for 'color'
 *      hidden: // value for 'hidden'
 *   },
 * });
 */
export function useUpdateCustomAssignmentTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomAssignmentTypeMutation, UpdateCustomAssignmentTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomAssignmentTypeMutation, UpdateCustomAssignmentTypeMutationVariables>(UpdateCustomAssignmentTypeDocument, options);
      }
export type UpdateCustomAssignmentTypeMutationHookResult = ReturnType<typeof useUpdateCustomAssignmentTypeMutation>;
export type UpdateCustomAssignmentTypeMutationResult = Apollo.MutationResult<UpdateCustomAssignmentTypeMutation>;
export type UpdateCustomAssignmentTypeMutationOptions = Apollo.BaseMutationOptions<UpdateCustomAssignmentTypeMutation, UpdateCustomAssignmentTypeMutationVariables>;
export const UpdateCustomAssignmentTypesSortOrderDocument = gql`
    mutation UpdateCustomAssignmentTypesSortOrder($updates: [custom_assignment_types_updates!]!) {
  update_custom_assignment_types_many(updates: $updates) {
    affected_rows
    returning {
      ...CustomAssignmentType
    }
  }
}
    ${CustomAssignmentTypeFragmentDoc}`;
export type UpdateCustomAssignmentTypesSortOrderMutationFn = Apollo.MutationFunction<UpdateCustomAssignmentTypesSortOrderMutation, UpdateCustomAssignmentTypesSortOrderMutationVariables>;

/**
 * __useUpdateCustomAssignmentTypesSortOrderMutation__
 *
 * To run a mutation, you first call `useUpdateCustomAssignmentTypesSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomAssignmentTypesSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomAssignmentTypesSortOrderMutation, { data, loading, error }] = useUpdateCustomAssignmentTypesSortOrderMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateCustomAssignmentTypesSortOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomAssignmentTypesSortOrderMutation, UpdateCustomAssignmentTypesSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomAssignmentTypesSortOrderMutation, UpdateCustomAssignmentTypesSortOrderMutationVariables>(UpdateCustomAssignmentTypesSortOrderDocument, options);
      }
export type UpdateCustomAssignmentTypesSortOrderMutationHookResult = ReturnType<typeof useUpdateCustomAssignmentTypesSortOrderMutation>;
export type UpdateCustomAssignmentTypesSortOrderMutationResult = Apollo.MutationResult<UpdateCustomAssignmentTypesSortOrderMutation>;
export type UpdateCustomAssignmentTypesSortOrderMutationOptions = Apollo.BaseMutationOptions<UpdateCustomAssignmentTypesSortOrderMutation, UpdateCustomAssignmentTypesSortOrderMutationVariables>;
export const UpdateOrganizationAdminDocument = gql`
    mutation UpdateOrganizationAdmin($organizationAdminId: String!, $email: String!) {
  update_organization_admin(
    _set: {email: $email}
    pk_columns: {id: $organizationAdminId}
  ) {
    ...OrganizationAdminInfo
  }
}
    ${OrganizationAdminInfoFragmentDoc}`;
export type UpdateOrganizationAdminMutationFn = Apollo.MutationFunction<UpdateOrganizationAdminMutation, UpdateOrganizationAdminMutationVariables>;

/**
 * __useUpdateOrganizationAdminMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationAdminMutation, { data, loading, error }] = useUpdateOrganizationAdminMutation({
 *   variables: {
 *      organizationAdminId: // value for 'organizationAdminId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateOrganizationAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationAdminMutation, UpdateOrganizationAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationAdminMutation, UpdateOrganizationAdminMutationVariables>(UpdateOrganizationAdminDocument, options);
      }
export type UpdateOrganizationAdminMutationHookResult = ReturnType<typeof useUpdateOrganizationAdminMutation>;
export type UpdateOrganizationAdminMutationResult = Apollo.MutationResult<UpdateOrganizationAdminMutation>;
export type UpdateOrganizationAdminMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationAdminMutation, UpdateOrganizationAdminMutationVariables>;
export const UpdateParrotRequestDocument = gql`
    mutation UpdateParrotRequest($requestId: uuid!, $customerId: String!, $startWeek: Int!, $endWeek: Int!, $userNotes: String, $parrotCreditsDifference: Int!) {
  update_parrot_request(
    pk_columns: {id: $requestId}
    _set: {startWeek: $startWeek, endWeek: $endWeek, userNotes: $userNotes}
  ) {
    ...ParrotRequestInfo
  }
  update_customer(
    pk_columns: {id: $customerId}
    _inc: {parrotCredits: $parrotCreditsDifference}
  ) {
    id
    parrotCredits
  }
}
    ${ParrotRequestInfoFragmentDoc}`;
export type UpdateParrotRequestMutationFn = Apollo.MutationFunction<UpdateParrotRequestMutation, UpdateParrotRequestMutationVariables>;

/**
 * __useUpdateParrotRequestMutation__
 *
 * To run a mutation, you first call `useUpdateParrotRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParrotRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParrotRequestMutation, { data, loading, error }] = useUpdateParrotRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      customerId: // value for 'customerId'
 *      startWeek: // value for 'startWeek'
 *      endWeek: // value for 'endWeek'
 *      userNotes: // value for 'userNotes'
 *      parrotCreditsDifference: // value for 'parrotCreditsDifference'
 *   },
 * });
 */
export function useUpdateParrotRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateParrotRequestMutation, UpdateParrotRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateParrotRequestMutation, UpdateParrotRequestMutationVariables>(UpdateParrotRequestDocument, options);
      }
export type UpdateParrotRequestMutationHookResult = ReturnType<typeof useUpdateParrotRequestMutation>;
export type UpdateParrotRequestMutationResult = Apollo.MutationResult<UpdateParrotRequestMutation>;
export type UpdateParrotRequestMutationOptions = Apollo.BaseMutationOptions<UpdateParrotRequestMutation, UpdateParrotRequestMutationVariables>;
export const SetParrotRequestStatusDocument = gql`
    mutation SetParrotRequestStatus($requestId: uuid!, $status: parrot_request_status_enum!) {
  parrotRequest: update_parrot_request(
    pk_columns: {id: $requestId}
    _set: {status: $status}
  ) {
    id
    status
  }
}
    `;
export type SetParrotRequestStatusMutationFn = Apollo.MutationFunction<SetParrotRequestStatusMutation, SetParrotRequestStatusMutationVariables>;

/**
 * __useSetParrotRequestStatusMutation__
 *
 * To run a mutation, you first call `useSetParrotRequestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetParrotRequestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setParrotRequestStatusMutation, { data, loading, error }] = useSetParrotRequestStatusMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetParrotRequestStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetParrotRequestStatusMutation, SetParrotRequestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetParrotRequestStatusMutation, SetParrotRequestStatusMutationVariables>(SetParrotRequestStatusDocument, options);
      }
export type SetParrotRequestStatusMutationHookResult = ReturnType<typeof useSetParrotRequestStatusMutation>;
export type SetParrotRequestStatusMutationResult = Apollo.MutationResult<SetParrotRequestStatusMutation>;
export type SetParrotRequestStatusMutationOptions = Apollo.BaseMutationOptions<SetParrotRequestStatusMutation, SetParrotRequestStatusMutationVariables>;
export const CompleteParrotRequestDocument = gql`
    mutation CompleteParrotRequest($requestId: uuid!, $studentAssignments: [student_assignments_insert_input!]!) {
  parrotRequest: update_parrot_request(
    pk_columns: {id: $requestId}
    _set: {status: COMPLETE}
  ) {
    id
    status
  }
  update_assignments(
    where: {parrotRequestId: {_eq: $requestId}}
    _set: {visible: true}
  ) {
    returning {
      id
      visible
    }
  }
  insert_student_assignments(objects: $studentAssignments) {
    returning {
      id
    }
  }
}
    `;
export type CompleteParrotRequestMutationFn = Apollo.MutationFunction<CompleteParrotRequestMutation, CompleteParrotRequestMutationVariables>;

/**
 * __useCompleteParrotRequestMutation__
 *
 * To run a mutation, you first call `useCompleteParrotRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteParrotRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeParrotRequestMutation, { data, loading, error }] = useCompleteParrotRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useCompleteParrotRequestMutation(baseOptions?: Apollo.MutationHookOptions<CompleteParrotRequestMutation, CompleteParrotRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteParrotRequestMutation, CompleteParrotRequestMutationVariables>(CompleteParrotRequestDocument, options);
      }
export type CompleteParrotRequestMutationHookResult = ReturnType<typeof useCompleteParrotRequestMutation>;
export type CompleteParrotRequestMutationResult = Apollo.MutationResult<CompleteParrotRequestMutation>;
export type CompleteParrotRequestMutationOptions = Apollo.BaseMutationOptions<CompleteParrotRequestMutation, CompleteParrotRequestMutationVariables>;
export const ReopenParrotRequestDocument = gql`
    mutation ReopenParrotRequest($requestId: uuid!) {
  parrotRequest: update_parrot_request(
    pk_columns: {id: $requestId}
    _set: {status: IN_PROGRESS}
  ) {
    id
    status
  }
  update_assignments(
    where: {parrotRequestId: {_eq: $requestId}}
    _set: {visible: false}
  ) {
    returning {
      id
      visible
    }
  }
  deletedStudentAssignments: delete_student_assignments(
    where: {assignment: {parrotRequestId: {_eq: $requestId}}}
  ) {
    returning {
      id
    }
  }
}
    `;
export type ReopenParrotRequestMutationFn = Apollo.MutationFunction<ReopenParrotRequestMutation, ReopenParrotRequestMutationVariables>;

/**
 * __useReopenParrotRequestMutation__
 *
 * To run a mutation, you first call `useReopenParrotRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenParrotRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenParrotRequestMutation, { data, loading, error }] = useReopenParrotRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useReopenParrotRequestMutation(baseOptions?: Apollo.MutationHookOptions<ReopenParrotRequestMutation, ReopenParrotRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenParrotRequestMutation, ReopenParrotRequestMutationVariables>(ReopenParrotRequestDocument, options);
      }
export type ReopenParrotRequestMutationHookResult = ReturnType<typeof useReopenParrotRequestMutation>;
export type ReopenParrotRequestMutationResult = Apollo.MutationResult<ReopenParrotRequestMutation>;
export type ReopenParrotRequestMutationOptions = Apollo.BaseMutationOptions<ReopenParrotRequestMutation, ReopenParrotRequestMutationVariables>;
export const ClaimParrotRequestDocument = gql`
    mutation ClaimParrotRequest($requestId: uuid!, $claimerId: String!) {
  parrotRequest: update_parrot_request(
    pk_columns: {id: $requestId}
    _set: {queuePosition: null, status: IN_PROGRESS, claimerId: $claimerId}
  ) {
    ...ParrotRequestInfo
    course {
      ...ClaimedParrotRequestCourseInfo
      numberOfDaysPerWeek
      assignments {
        ...CoursePlanCardAssignment
      }
    }
    claimerId
  }
}
    ${ParrotRequestInfoFragmentDoc}
${ClaimedParrotRequestCourseInfoFragmentDoc}
${CoursePlanCardAssignmentFragmentDoc}`;
export type ClaimParrotRequestMutationFn = Apollo.MutationFunction<ClaimParrotRequestMutation, ClaimParrotRequestMutationVariables>;

/**
 * __useClaimParrotRequestMutation__
 *
 * To run a mutation, you first call `useClaimParrotRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimParrotRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimParrotRequestMutation, { data, loading, error }] = useClaimParrotRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      claimerId: // value for 'claimerId'
 *   },
 * });
 */
export function useClaimParrotRequestMutation(baseOptions?: Apollo.MutationHookOptions<ClaimParrotRequestMutation, ClaimParrotRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimParrotRequestMutation, ClaimParrotRequestMutationVariables>(ClaimParrotRequestDocument, options);
      }
export type ClaimParrotRequestMutationHookResult = ReturnType<typeof useClaimParrotRequestMutation>;
export type ClaimParrotRequestMutationResult = Apollo.MutationResult<ClaimParrotRequestMutation>;
export type ClaimParrotRequestMutationOptions = Apollo.BaseMutationOptions<ClaimParrotRequestMutation, ClaimParrotRequestMutationVariables>;
export const UpdateStudentDocument = gql`
    mutation UpdateStudent($studentId: String!, $name: String!, $schoolYear: school_year_enum) {
  update_student(
    _set: {name: $name, schoolYear: $schoolYear}
    pk_columns: {id: $studentId}
  ) {
    ...StudentInfo
  }
}
    ${StudentInfoFragmentDoc}`;
export type UpdateStudentMutationFn = Apollo.MutationFunction<UpdateStudentMutation, UpdateStudentMutationVariables>;

/**
 * __useUpdateStudentMutation__
 *
 * To run a mutation, you first call `useUpdateStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentMutation, { data, loading, error }] = useUpdateStudentMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      name: // value for 'name'
 *      schoolYear: // value for 'schoolYear'
 *   },
 * });
 */
export function useUpdateStudentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentMutation, UpdateStudentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentMutation, UpdateStudentMutationVariables>(UpdateStudentDocument, options);
      }
export type UpdateStudentMutationHookResult = ReturnType<typeof useUpdateStudentMutation>;
export type UpdateStudentMutationResult = Apollo.MutationResult<UpdateStudentMutation>;
export type UpdateStudentMutationOptions = Apollo.BaseMutationOptions<UpdateStudentMutation, UpdateStudentMutationVariables>;
export const UpdateStudentAccountDocument = gql`
    mutation UpdateStudentAccount($studentAccountId: String!, $email: String!, $name: String, $picture: String) {
  update_student_account(
    _set: {email: $email, name: $name, picture: $picture}
    pk_columns: {id: $studentAccountId}
  ) {
    id
    email
    name
    picture
  }
}
    `;
export type UpdateStudentAccountMutationFn = Apollo.MutationFunction<UpdateStudentAccountMutation, UpdateStudentAccountMutationVariables>;

/**
 * __useUpdateStudentAccountMutation__
 *
 * To run a mutation, you first call `useUpdateStudentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentAccountMutation, { data, loading, error }] = useUpdateStudentAccountMutation({
 *   variables: {
 *      studentAccountId: // value for 'studentAccountId'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      picture: // value for 'picture'
 *   },
 * });
 */
export function useUpdateStudentAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentAccountMutation, UpdateStudentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentAccountMutation, UpdateStudentAccountMutationVariables>(UpdateStudentAccountDocument, options);
      }
export type UpdateStudentAccountMutationHookResult = ReturnType<typeof useUpdateStudentAccountMutation>;
export type UpdateStudentAccountMutationResult = Apollo.MutationResult<UpdateStudentAccountMutation>;
export type UpdateStudentAccountMutationOptions = Apollo.BaseMutationOptions<UpdateStudentAccountMutation, UpdateStudentAccountMutationVariables>;
export const UpdateStudentAssignmentDatesDocument = gql`
    mutation UpdateStudentAssignmentDates($studentAssignmentId: uuid!, $start: date, $end: date, $courseDayOffset: Int) {
  update_student_assignment(
    _set: {start: $start, end: $end, courseDayOffset: $courseDayOffset}
    pk_columns: {id: $studentAssignmentId}
  ) {
    ...PlanningStudentAssignment
  }
}
    ${PlanningStudentAssignmentFragmentDoc}`;
export type UpdateStudentAssignmentDatesMutationFn = Apollo.MutationFunction<UpdateStudentAssignmentDatesMutation, UpdateStudentAssignmentDatesMutationVariables>;

/**
 * __useUpdateStudentAssignmentDatesMutation__
 *
 * To run a mutation, you first call `useUpdateStudentAssignmentDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentAssignmentDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentAssignmentDatesMutation, { data, loading, error }] = useUpdateStudentAssignmentDatesMutation({
 *   variables: {
 *      studentAssignmentId: // value for 'studentAssignmentId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      courseDayOffset: // value for 'courseDayOffset'
 *   },
 * });
 */
export function useUpdateStudentAssignmentDatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentAssignmentDatesMutation, UpdateStudentAssignmentDatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentAssignmentDatesMutation, UpdateStudentAssignmentDatesMutationVariables>(UpdateStudentAssignmentDatesDocument, options);
      }
export type UpdateStudentAssignmentDatesMutationHookResult = ReturnType<typeof useUpdateStudentAssignmentDatesMutation>;
export type UpdateStudentAssignmentDatesMutationResult = Apollo.MutationResult<UpdateStudentAssignmentDatesMutation>;
export type UpdateStudentAssignmentDatesMutationOptions = Apollo.BaseMutationOptions<UpdateStudentAssignmentDatesMutation, UpdateStudentAssignmentDatesMutationVariables>;
export const UpdateStudentAssignmentDatesOnRescheduleDocument = gql`
    mutation UpdateStudentAssignmentDatesOnReschedule($studentAssignmentId: uuid!, $start: date!, $end: date!, $freeForm: Boolean, $courseDayOffset: Int) {
  update_student_assignment(
    _set: {start: $start, end: $end, freeForm: $freeForm, courseDayOffset: $courseDayOffset}
    pk_columns: {id: $studentAssignmentId}
  ) {
    ...PlanningStudentAssignment
  }
}
    ${PlanningStudentAssignmentFragmentDoc}`;
export type UpdateStudentAssignmentDatesOnRescheduleMutationFn = Apollo.MutationFunction<UpdateStudentAssignmentDatesOnRescheduleMutation, UpdateStudentAssignmentDatesOnRescheduleMutationVariables>;

/**
 * __useUpdateStudentAssignmentDatesOnRescheduleMutation__
 *
 * To run a mutation, you first call `useUpdateStudentAssignmentDatesOnRescheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentAssignmentDatesOnRescheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentAssignmentDatesOnRescheduleMutation, { data, loading, error }] = useUpdateStudentAssignmentDatesOnRescheduleMutation({
 *   variables: {
 *      studentAssignmentId: // value for 'studentAssignmentId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      freeForm: // value for 'freeForm'
 *      courseDayOffset: // value for 'courseDayOffset'
 *   },
 * });
 */
export function useUpdateStudentAssignmentDatesOnRescheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentAssignmentDatesOnRescheduleMutation, UpdateStudentAssignmentDatesOnRescheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentAssignmentDatesOnRescheduleMutation, UpdateStudentAssignmentDatesOnRescheduleMutationVariables>(UpdateStudentAssignmentDatesOnRescheduleDocument, options);
      }
export type UpdateStudentAssignmentDatesOnRescheduleMutationHookResult = ReturnType<typeof useUpdateStudentAssignmentDatesOnRescheduleMutation>;
export type UpdateStudentAssignmentDatesOnRescheduleMutationResult = Apollo.MutationResult<UpdateStudentAssignmentDatesOnRescheduleMutation>;
export type UpdateStudentAssignmentDatesOnRescheduleMutationOptions = Apollo.BaseMutationOptions<UpdateStudentAssignmentDatesOnRescheduleMutation, UpdateStudentAssignmentDatesOnRescheduleMutationVariables>;
export const UpdateStudentAssignmentGradeDocument = gql`
    mutation UpdateStudentAssignmentGrade($studentAssignmentId: uuid!, $pointsEarned: numeric!, $pointsAvailable: numeric!) {
  update_student_assignment(
    _set: {pointsEarned: $pointsEarned, pointsAvailable: $pointsAvailable}
    pk_columns: {id: $studentAssignmentId}
  ) {
    id
    pointsEarned
    pointsAvailable
  }
}
    `;
export type UpdateStudentAssignmentGradeMutationFn = Apollo.MutationFunction<UpdateStudentAssignmentGradeMutation, UpdateStudentAssignmentGradeMutationVariables>;

/**
 * __useUpdateStudentAssignmentGradeMutation__
 *
 * To run a mutation, you first call `useUpdateStudentAssignmentGradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentAssignmentGradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentAssignmentGradeMutation, { data, loading, error }] = useUpdateStudentAssignmentGradeMutation({
 *   variables: {
 *      studentAssignmentId: // value for 'studentAssignmentId'
 *      pointsEarned: // value for 'pointsEarned'
 *      pointsAvailable: // value for 'pointsAvailable'
 *   },
 * });
 */
export function useUpdateStudentAssignmentGradeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentAssignmentGradeMutation, UpdateStudentAssignmentGradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentAssignmentGradeMutation, UpdateStudentAssignmentGradeMutationVariables>(UpdateStudentAssignmentGradeDocument, options);
      }
export type UpdateStudentAssignmentGradeMutationHookResult = ReturnType<typeof useUpdateStudentAssignmentGradeMutation>;
export type UpdateStudentAssignmentGradeMutationResult = Apollo.MutationResult<UpdateStudentAssignmentGradeMutation>;
export type UpdateStudentAssignmentGradeMutationOptions = Apollo.BaseMutationOptions<UpdateStudentAssignmentGradeMutation, UpdateStudentAssignmentGradeMutationVariables>;
export const UpdateStudentAssignmentStatusDocument = gql`
    mutation UpdateStudentAssignmentStatus($studentAssignmentId: uuid!, $status: student_assignment_status_enum!, $completed: timestamptz) {
  update_student_assignment(
    _set: {status: $status, completed: $completed}
    pk_columns: {id: $studentAssignmentId}
  ) {
    id
    status
    completed
  }
}
    `;
export type UpdateStudentAssignmentStatusMutationFn = Apollo.MutationFunction<UpdateStudentAssignmentStatusMutation, UpdateStudentAssignmentStatusMutationVariables>;

/**
 * __useUpdateStudentAssignmentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateStudentAssignmentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentAssignmentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentAssignmentStatusMutation, { data, loading, error }] = useUpdateStudentAssignmentStatusMutation({
 *   variables: {
 *      studentAssignmentId: // value for 'studentAssignmentId'
 *      status: // value for 'status'
 *      completed: // value for 'completed'
 *   },
 * });
 */
export function useUpdateStudentAssignmentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentAssignmentStatusMutation, UpdateStudentAssignmentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentAssignmentStatusMutation, UpdateStudentAssignmentStatusMutationVariables>(UpdateStudentAssignmentStatusDocument, options);
      }
export type UpdateStudentAssignmentStatusMutationHookResult = ReturnType<typeof useUpdateStudentAssignmentStatusMutation>;
export type UpdateStudentAssignmentStatusMutationResult = Apollo.MutationResult<UpdateStudentAssignmentStatusMutation>;
export type UpdateStudentAssignmentStatusMutationOptions = Apollo.BaseMutationOptions<UpdateStudentAssignmentStatusMutation, UpdateStudentAssignmentStatusMutationVariables>;
export const UpdateStudentAssignmentsStatusDocument = gql`
    mutation UpdateStudentAssignmentsStatus($studentAssignmentIds: [uuid!]!, $status: student_assignment_status_enum!, $completed: timestamptz) {
  update_student_assignments(
    _set: {status: $status, completed: $completed}
    where: {id: {_in: $studentAssignmentIds}}
  ) {
    returning {
      id
      status
      completed
    }
  }
}
    `;
export type UpdateStudentAssignmentsStatusMutationFn = Apollo.MutationFunction<UpdateStudentAssignmentsStatusMutation, UpdateStudentAssignmentsStatusMutationVariables>;

/**
 * __useUpdateStudentAssignmentsStatusMutation__
 *
 * To run a mutation, you first call `useUpdateStudentAssignmentsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentAssignmentsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentAssignmentsStatusMutation, { data, loading, error }] = useUpdateStudentAssignmentsStatusMutation({
 *   variables: {
 *      studentAssignmentIds: // value for 'studentAssignmentIds'
 *      status: // value for 'status'
 *      completed: // value for 'completed'
 *   },
 * });
 */
export function useUpdateStudentAssignmentsStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentAssignmentsStatusMutation, UpdateStudentAssignmentsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentAssignmentsStatusMutation, UpdateStudentAssignmentsStatusMutationVariables>(UpdateStudentAssignmentsStatusDocument, options);
      }
export type UpdateStudentAssignmentsStatusMutationHookResult = ReturnType<typeof useUpdateStudentAssignmentsStatusMutation>;
export type UpdateStudentAssignmentsStatusMutationResult = Apollo.MutationResult<UpdateStudentAssignmentsStatusMutation>;
export type UpdateStudentAssignmentsStatusMutationOptions = Apollo.BaseMutationOptions<UpdateStudentAssignmentsStatusMutation, UpdateStudentAssignmentsStatusMutationVariables>;
export const UpdateStudentCourseDayOffsetsDocument = gql`
    mutation UpdateStudentCourseDayOffsets($studentCourseId: uuid!, $studentCourseDayOffsets: jsonb!, $studentAssignments: [student_assignments_insert_input!]!) {
  update_student_course(
    _set: {courseDayOffsets: $studentCourseDayOffsets}
    pk_columns: {id: $studentCourseId}
  ) {
    id
    courseDayOffsets
  }
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [start, end, courseDayOffset]}
  ) {
    returning {
      id
      start
      end
      courseDayOffset
    }
  }
}
    `;
export type UpdateStudentCourseDayOffsetsMutationFn = Apollo.MutationFunction<UpdateStudentCourseDayOffsetsMutation, UpdateStudentCourseDayOffsetsMutationVariables>;

/**
 * __useUpdateStudentCourseDayOffsetsMutation__
 *
 * To run a mutation, you first call `useUpdateStudentCourseDayOffsetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentCourseDayOffsetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentCourseDayOffsetsMutation, { data, loading, error }] = useUpdateStudentCourseDayOffsetsMutation({
 *   variables: {
 *      studentCourseId: // value for 'studentCourseId'
 *      studentCourseDayOffsets: // value for 'studentCourseDayOffsets'
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useUpdateStudentCourseDayOffsetsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentCourseDayOffsetsMutation, UpdateStudentCourseDayOffsetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentCourseDayOffsetsMutation, UpdateStudentCourseDayOffsetsMutationVariables>(UpdateStudentCourseDayOffsetsDocument, options);
      }
export type UpdateStudentCourseDayOffsetsMutationHookResult = ReturnType<typeof useUpdateStudentCourseDayOffsetsMutation>;
export type UpdateStudentCourseDayOffsetsMutationResult = Apollo.MutationResult<UpdateStudentCourseDayOffsetsMutation>;
export type UpdateStudentCourseDayOffsetsMutationOptions = Apollo.BaseMutationOptions<UpdateStudentCourseDayOffsetsMutation, UpdateStudentCourseDayOffsetsMutationVariables>;
export const UpdateStudentCourseScheduleDocument = gql`
    mutation UpdateStudentCourseSchedule($studentCourseId: uuid!, $daysOfTheWeek: jsonb!, $start: date!, $studentAssignments: [student_assignments_insert_input!]!) {
  update_student_course(
    _set: {daysOfTheWeek: $daysOfTheWeek, start: $start}
    pk_columns: {id: $studentCourseId}
  ) {
    id
    daysOfTheWeek
  }
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [start, end]}
  ) {
    returning {
      id
      start
      end
    }
  }
}
    `;
export type UpdateStudentCourseScheduleMutationFn = Apollo.MutationFunction<UpdateStudentCourseScheduleMutation, UpdateStudentCourseScheduleMutationVariables>;

/**
 * __useUpdateStudentCourseScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateStudentCourseScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentCourseScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentCourseScheduleMutation, { data, loading, error }] = useUpdateStudentCourseScheduleMutation({
 *   variables: {
 *      studentCourseId: // value for 'studentCourseId'
 *      daysOfTheWeek: // value for 'daysOfTheWeek'
 *      start: // value for 'start'
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useUpdateStudentCourseScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentCourseScheduleMutation, UpdateStudentCourseScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentCourseScheduleMutation, UpdateStudentCourseScheduleMutationVariables>(UpdateStudentCourseScheduleDocument, options);
      }
export type UpdateStudentCourseScheduleMutationHookResult = ReturnType<typeof useUpdateStudentCourseScheduleMutation>;
export type UpdateStudentCourseScheduleMutationResult = Apollo.MutationResult<UpdateStudentCourseScheduleMutation>;
export type UpdateStudentCourseScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateStudentCourseScheduleMutation, UpdateStudentCourseScheduleMutationVariables>;
export const UpdateStudentCoursesDailyOrderDocument = gql`
    mutation UpdateStudentCoursesDailyOrder($studentCourses: [student_courses_insert_input!]!) {
  insert_student_courses(
    objects: $studentCourses
    on_conflict: {constraint: student_courses_pkey, update_columns: [dailySortOrder]}
  ) {
    returning {
      id
      dailySortOrder
    }
  }
}
    `;
export type UpdateStudentCoursesDailyOrderMutationFn = Apollo.MutationFunction<UpdateStudentCoursesDailyOrderMutation, UpdateStudentCoursesDailyOrderMutationVariables>;

/**
 * __useUpdateStudentCoursesDailyOrderMutation__
 *
 * To run a mutation, you first call `useUpdateStudentCoursesDailyOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentCoursesDailyOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentCoursesDailyOrderMutation, { data, loading, error }] = useUpdateStudentCoursesDailyOrderMutation({
 *   variables: {
 *      studentCourses: // value for 'studentCourses'
 *   },
 * });
 */
export function useUpdateStudentCoursesDailyOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentCoursesDailyOrderMutation, UpdateStudentCoursesDailyOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentCoursesDailyOrderMutation, UpdateStudentCoursesDailyOrderMutationVariables>(UpdateStudentCoursesDailyOrderDocument, options);
      }
export type UpdateStudentCoursesDailyOrderMutationHookResult = ReturnType<typeof useUpdateStudentCoursesDailyOrderMutation>;
export type UpdateStudentCoursesDailyOrderMutationResult = Apollo.MutationResult<UpdateStudentCoursesDailyOrderMutation>;
export type UpdateStudentCoursesDailyOrderMutationOptions = Apollo.BaseMutationOptions<UpdateStudentCoursesDailyOrderMutation, UpdateStudentCoursesDailyOrderMutationVariables>;
export const UpdateStudentPictureDocument = gql`
    mutation UpdateStudentPicture($studentId: String!, $picture: String) {
  update_student(_set: {picture: $picture}, pk_columns: {id: $studentId}) {
    id
    picture
  }
}
    `;
export type UpdateStudentPictureMutationFn = Apollo.MutationFunction<UpdateStudentPictureMutation, UpdateStudentPictureMutationVariables>;

/**
 * __useUpdateStudentPictureMutation__
 *
 * To run a mutation, you first call `useUpdateStudentPictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentPictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentPictureMutation, { data, loading, error }] = useUpdateStudentPictureMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      picture: // value for 'picture'
 *   },
 * });
 */
export function useUpdateStudentPictureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentPictureMutation, UpdateStudentPictureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentPictureMutation, UpdateStudentPictureMutationVariables>(UpdateStudentPictureDocument, options);
      }
export type UpdateStudentPictureMutationHookResult = ReturnType<typeof useUpdateStudentPictureMutation>;
export type UpdateStudentPictureMutationResult = Apollo.MutationResult<UpdateStudentPictureMutation>;
export type UpdateStudentPictureMutationOptions = Apollo.BaseMutationOptions<UpdateStudentPictureMutation, UpdateStudentPictureMutationVariables>;
export const UpdateTeacherDocument = gql`
    mutation UpdateTeacher($teacherId: String!, $email: String!, $name: String, $picture: String) {
  update_teacher(
    _set: {email: $email, name: $name, picture: $picture}
    pk_columns: {id: $teacherId}
  ) {
    ...TeacherInfo
  }
}
    ${TeacherInfoFragmentDoc}`;
export type UpdateTeacherMutationFn = Apollo.MutationFunction<UpdateTeacherMutation, UpdateTeacherMutationVariables>;

/**
 * __useUpdateTeacherMutation__
 *
 * To run a mutation, you first call `useUpdateTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeacherMutation, { data, loading, error }] = useUpdateTeacherMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      picture: // value for 'picture'
 *   },
 * });
 */
export function useUpdateTeacherMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeacherMutation, UpdateTeacherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeacherMutation, UpdateTeacherMutationVariables>(UpdateTeacherDocument, options);
      }
export type UpdateTeacherMutationHookResult = ReturnType<typeof useUpdateTeacherMutation>;
export type UpdateTeacherMutationResult = Apollo.MutationResult<UpdateTeacherMutation>;
export type UpdateTeacherMutationOptions = Apollo.BaseMutationOptions<UpdateTeacherMutation, UpdateTeacherMutationVariables>;
export const UpdateThemeDocument = gql`
    mutation UpdateTheme($themeId: uuid!, $headerBackground: String, $headerForeground: String, $headerForegroundActive: String, $primary: String, $appBackground: String, $contentBackground: String, $faintBorder: String, $mediumBorder: String, $elementBorder: String, $colorPalette: jsonb, $contentContrast: String, $contentPrimary: String, $contentSecondary: String, $contentTertiary: String, $positive: String, $negative: String, $info: String, $vacation: String, $logoUrl: String, $portalIconUrl: String) {
  update_themes_by_pk(
    pk_columns: {id: $themeId}
    _set: {headerBackground: $headerBackground, headerForeground: $headerForeground, headerForegroundActive: $headerForegroundActive, primary: $primary, appBackground: $appBackground, contentBackground: $contentBackground, faintBorder: $faintBorder, mediumBorder: $mediumBorder, elementBorder: $elementBorder, colorPalette: $colorPalette, contentContrast: $contentContrast, contentPrimary: $contentPrimary, contentSecondary: $contentSecondary, contentTertiary: $contentTertiary, positive: $positive, negative: $negative, info: $info, vacation: $vacation, logoUrl: $logoUrl, portalIconUrl: $portalIconUrl}
  ) {
    ...OrganizationTheme
  }
}
    ${OrganizationThemeFragmentDoc}`;
export type UpdateThemeMutationFn = Apollo.MutationFunction<UpdateThemeMutation, UpdateThemeMutationVariables>;

/**
 * __useUpdateThemeMutation__
 *
 * To run a mutation, you first call `useUpdateThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThemeMutation, { data, loading, error }] = useUpdateThemeMutation({
 *   variables: {
 *      themeId: // value for 'themeId'
 *      headerBackground: // value for 'headerBackground'
 *      headerForeground: // value for 'headerForeground'
 *      headerForegroundActive: // value for 'headerForegroundActive'
 *      primary: // value for 'primary'
 *      appBackground: // value for 'appBackground'
 *      contentBackground: // value for 'contentBackground'
 *      faintBorder: // value for 'faintBorder'
 *      mediumBorder: // value for 'mediumBorder'
 *      elementBorder: // value for 'elementBorder'
 *      colorPalette: // value for 'colorPalette'
 *      contentContrast: // value for 'contentContrast'
 *      contentPrimary: // value for 'contentPrimary'
 *      contentSecondary: // value for 'contentSecondary'
 *      contentTertiary: // value for 'contentTertiary'
 *      positive: // value for 'positive'
 *      negative: // value for 'negative'
 *      info: // value for 'info'
 *      vacation: // value for 'vacation'
 *      logoUrl: // value for 'logoUrl'
 *      portalIconUrl: // value for 'portalIconUrl'
 *   },
 * });
 */
export function useUpdateThemeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThemeMutation, UpdateThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThemeMutation, UpdateThemeMutationVariables>(UpdateThemeDocument, options);
      }
export type UpdateThemeMutationHookResult = ReturnType<typeof useUpdateThemeMutation>;
export type UpdateThemeMutationResult = Apollo.MutationResult<UpdateThemeMutation>;
export type UpdateThemeMutationOptions = Apollo.BaseMutationOptions<UpdateThemeMutation, UpdateThemeMutationVariables>;
export const UpdateVacationDocument = gql`
    mutation UpdateVacation($eventId: uuid!, $start: date!, $end: date!, $name: String, $studentEvents: [student_events_insert_input!]!, $studentAssignments: [student_assignments_insert_input!]!) {
  update_event(
    _set: {start: $start, end: $end, name: $name}
    pk_columns: {id: $eventId}
  ) {
    ...EventInfo
  }
  deletedStudentEvents: delete_student_events(where: {eventId: {_eq: $eventId}}) {
    returning {
      id
    }
  }
  newStudentEvents: insert_student_events(objects: $studentEvents) {
    returning {
      id
      student {
        id
        name
        picture
        ...StudentsEvents
      }
      event {
        id
        ...EventInfo
      }
    }
  }
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [start, end]}
  ) {
    returning {
      id
      start
      end
    }
  }
}
    ${EventInfoFragmentDoc}
${StudentsEventsFragmentDoc}`;
export type UpdateVacationMutationFn = Apollo.MutationFunction<UpdateVacationMutation, UpdateVacationMutationVariables>;

/**
 * __useUpdateVacationMutation__
 *
 * To run a mutation, you first call `useUpdateVacationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVacationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVacationMutation, { data, loading, error }] = useUpdateVacationMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      name: // value for 'name'
 *      studentEvents: // value for 'studentEvents'
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useUpdateVacationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVacationMutation, UpdateVacationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVacationMutation, UpdateVacationMutationVariables>(UpdateVacationDocument, options);
      }
export type UpdateVacationMutationHookResult = ReturnType<typeof useUpdateVacationMutation>;
export type UpdateVacationMutationResult = Apollo.MutationResult<UpdateVacationMutation>;
export type UpdateVacationMutationOptions = Apollo.BaseMutationOptions<UpdateVacationMutation, UpdateVacationMutationVariables>;
export const UpsertStudentAssignmentsDatesDocument = gql`
    mutation UpsertStudentAssignmentsDates($studentAssignments: [student_assignments_insert_input!]!) {
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [start, end, courseDayOffset]}
  ) {
    returning {
      id
      start
      end
      courseDayOffset
    }
  }
}
    `;
export type UpsertStudentAssignmentsDatesMutationFn = Apollo.MutationFunction<UpsertStudentAssignmentsDatesMutation, UpsertStudentAssignmentsDatesMutationVariables>;

/**
 * __useUpsertStudentAssignmentsDatesMutation__
 *
 * To run a mutation, you first call `useUpsertStudentAssignmentsDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertStudentAssignmentsDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertStudentAssignmentsDatesMutation, { data, loading, error }] = useUpsertStudentAssignmentsDatesMutation({
 *   variables: {
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useUpsertStudentAssignmentsDatesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertStudentAssignmentsDatesMutation, UpsertStudentAssignmentsDatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertStudentAssignmentsDatesMutation, UpsertStudentAssignmentsDatesMutationVariables>(UpsertStudentAssignmentsDatesDocument, options);
      }
export type UpsertStudentAssignmentsDatesMutationHookResult = ReturnType<typeof useUpsertStudentAssignmentsDatesMutation>;
export type UpsertStudentAssignmentsDatesMutationResult = Apollo.MutationResult<UpsertStudentAssignmentsDatesMutation>;
export type UpsertStudentAssignmentsDatesMutationOptions = Apollo.BaseMutationOptions<UpsertStudentAssignmentsDatesMutation, UpsertStudentAssignmentsDatesMutationVariables>;
export const UpsertStudentAssignmentsGradingStylesDocument = gql`
    mutation UpsertStudentAssignmentsGradingStyles($studentAssignments: [student_assignments_insert_input!]!) {
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [pointsEarned, pointsAvailable]}
  ) {
    returning {
      id
      pointsEarned
      pointsAvailable
    }
  }
}
    `;
export type UpsertStudentAssignmentsGradingStylesMutationFn = Apollo.MutationFunction<UpsertStudentAssignmentsGradingStylesMutation, UpsertStudentAssignmentsGradingStylesMutationVariables>;

/**
 * __useUpsertStudentAssignmentsGradingStylesMutation__
 *
 * To run a mutation, you first call `useUpsertStudentAssignmentsGradingStylesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertStudentAssignmentsGradingStylesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertStudentAssignmentsGradingStylesMutation, { data, loading, error }] = useUpsertStudentAssignmentsGradingStylesMutation({
 *   variables: {
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useUpsertStudentAssignmentsGradingStylesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertStudentAssignmentsGradingStylesMutation, UpsertStudentAssignmentsGradingStylesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertStudentAssignmentsGradingStylesMutation, UpsertStudentAssignmentsGradingStylesMutationVariables>(UpsertStudentAssignmentsGradingStylesDocument, options);
      }
export type UpsertStudentAssignmentsGradingStylesMutationHookResult = ReturnType<typeof useUpsertStudentAssignmentsGradingStylesMutation>;
export type UpsertStudentAssignmentsGradingStylesMutationResult = Apollo.MutationResult<UpsertStudentAssignmentsGradingStylesMutation>;
export type UpsertStudentAssignmentsGradingStylesMutationOptions = Apollo.BaseMutationOptions<UpsertStudentAssignmentsGradingStylesMutation, UpsertStudentAssignmentsGradingStylesMutationVariables>;
export const UpsertTeacherSettingsDocument = gql`
    mutation UpsertTeacherSettings($teacherId: String!, $userSettings: user_settings_insert_input!) {
  insert_teacher(
    object: {id: $teacherId, userSettings: {data: $userSettings, on_conflict: {constraint: user_settings_pkey, update_columns: [showEmptyAssignmentDays]}}}
    on_conflict: {constraint: teachers_pkey, update_columns: settingsId}
  ) {
    id
    userSettings {
      ...UserSettings
    }
  }
}
    ${UserSettingsFragmentDoc}`;
export type UpsertTeacherSettingsMutationFn = Apollo.MutationFunction<UpsertTeacherSettingsMutation, UpsertTeacherSettingsMutationVariables>;

/**
 * __useUpsertTeacherSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertTeacherSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTeacherSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTeacherSettingsMutation, { data, loading, error }] = useUpsertTeacherSettingsMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      userSettings: // value for 'userSettings'
 *   },
 * });
 */
export function useUpsertTeacherSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTeacherSettingsMutation, UpsertTeacherSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTeacherSettingsMutation, UpsertTeacherSettingsMutationVariables>(UpsertTeacherSettingsDocument, options);
      }
export type UpsertTeacherSettingsMutationHookResult = ReturnType<typeof useUpsertTeacherSettingsMutation>;
export type UpsertTeacherSettingsMutationResult = Apollo.MutationResult<UpsertTeacherSettingsMutation>;
export type UpsertTeacherSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertTeacherSettingsMutation, UpsertTeacherSettingsMutationVariables>;
export const UpsertStudentSettingsDocument = gql`
    mutation UpsertStudentSettings($userId: String!, $userSettings: user_settings_insert_input!) {
  insert_student_account(
    object: {id: $userId, studentId: "", email: "", userSettings: {data: $userSettings, on_conflict: {constraint: user_settings_pkey, update_columns: showEmptyAssignmentDays}}}
    on_conflict: {constraint: student_accounts_pkey, update_columns: settingsId}
  ) {
    id
    userSettings {
      ...UserSettings
    }
  }
}
    ${UserSettingsFragmentDoc}`;
export type UpsertStudentSettingsMutationFn = Apollo.MutationFunction<UpsertStudentSettingsMutation, UpsertStudentSettingsMutationVariables>;

/**
 * __useUpsertStudentSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertStudentSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertStudentSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertStudentSettingsMutation, { data, loading, error }] = useUpsertStudentSettingsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userSettings: // value for 'userSettings'
 *   },
 * });
 */
export function useUpsertStudentSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertStudentSettingsMutation, UpsertStudentSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertStudentSettingsMutation, UpsertStudentSettingsMutationVariables>(UpsertStudentSettingsDocument, options);
      }
export type UpsertStudentSettingsMutationHookResult = ReturnType<typeof useUpsertStudentSettingsMutation>;
export type UpsertStudentSettingsMutationResult = Apollo.MutationResult<UpsertStudentSettingsMutation>;
export type UpsertStudentSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertStudentSettingsMutation, UpsertStudentSettingsMutationVariables>;
export const GetActiveCourseStudentsDocument = gql`
    query GetActiveCourseStudents($courseId: uuid!) {
  course(id: $courseId) {
    id
    studentCourses(where: {status: {_eq: ENROLLED}}) {
      ...CourseStudentCardInfo
      student {
        id
        name
        picture
      }
      ...StudentCourseInfo
    }
  }
}
    ${CourseStudentCardInfoFragmentDoc}
${StudentCourseInfoFragmentDoc}`;

/**
 * __useGetActiveCourseStudentsQuery__
 *
 * To run a query within a React component, call `useGetActiveCourseStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCourseStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveCourseStudentsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetActiveCourseStudentsQuery(baseOptions: Apollo.QueryHookOptions<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables> & ({ variables: GetActiveCourseStudentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables>(GetActiveCourseStudentsDocument, options);
      }
export function useGetActiveCourseStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables>(GetActiveCourseStudentsDocument, options);
        }
export function useGetActiveCourseStudentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables>(GetActiveCourseStudentsDocument, options);
        }
export type GetActiveCourseStudentsQueryHookResult = ReturnType<typeof useGetActiveCourseStudentsQuery>;
export type GetActiveCourseStudentsLazyQueryHookResult = ReturnType<typeof useGetActiveCourseStudentsLazyQuery>;
export type GetActiveCourseStudentsSuspenseQueryHookResult = ReturnType<typeof useGetActiveCourseStudentsSuspenseQuery>;
export type GetActiveCourseStudentsQueryResult = Apollo.QueryResult<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables>;
export const GetActiveCourseOptionsDocument = gql`
    query GetActiveCourseOptions {
  courses(where: {archived: {_eq: false}}, order_by: {name: asc}) {
    ...CourseOption
  }
}
    ${CourseOptionFragmentDoc}`;

/**
 * __useGetActiveCourseOptionsQuery__
 *
 * To run a query within a React component, call `useGetActiveCourseOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCourseOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveCourseOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveCourseOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>(GetActiveCourseOptionsDocument, options);
      }
export function useGetActiveCourseOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>(GetActiveCourseOptionsDocument, options);
        }
export function useGetActiveCourseOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>(GetActiveCourseOptionsDocument, options);
        }
export type GetActiveCourseOptionsQueryHookResult = ReturnType<typeof useGetActiveCourseOptionsQuery>;
export type GetActiveCourseOptionsLazyQueryHookResult = ReturnType<typeof useGetActiveCourseOptionsLazyQuery>;
export type GetActiveCourseOptionsSuspenseQueryHookResult = ReturnType<typeof useGetActiveCourseOptionsSuspenseQuery>;
export type GetActiveCourseOptionsQueryResult = Apollo.QueryResult<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>;
export const GetActiveStudentCoursesDocument = gql`
    query GetActiveStudentCourses($studentId: String!) {
  student(id: $studentId) {
    id
    name
    picture
    ...StudentsEvents
    studentCourses(where: {status: {_eq: ENROLLED}}) {
      ...ActiveStudentCourseCardInfo
    }
  }
}
    ${StudentsEventsFragmentDoc}
${ActiveStudentCourseCardInfoFragmentDoc}`;

/**
 * __useGetActiveStudentCoursesQuery__
 *
 * To run a query within a React component, call `useGetActiveStudentCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveStudentCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveStudentCoursesQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetActiveStudentCoursesQuery(baseOptions: Apollo.QueryHookOptions<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables> & ({ variables: GetActiveStudentCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables>(GetActiveStudentCoursesDocument, options);
      }
export function useGetActiveStudentCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables>(GetActiveStudentCoursesDocument, options);
        }
export function useGetActiveStudentCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables>(GetActiveStudentCoursesDocument, options);
        }
export type GetActiveStudentCoursesQueryHookResult = ReturnType<typeof useGetActiveStudentCoursesQuery>;
export type GetActiveStudentCoursesLazyQueryHookResult = ReturnType<typeof useGetActiveStudentCoursesLazyQuery>;
export type GetActiveStudentCoursesSuspenseQueryHookResult = ReturnType<typeof useGetActiveStudentCoursesSuspenseQuery>;
export type GetActiveStudentCoursesQueryResult = Apollo.QueryResult<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables>;
export const GetActiveStudentCoursesForTranscriptDocument = gql`
    query GetActiveStudentCoursesForTranscript($studentId: String!) {
  student(id: $studentId) {
    id
    studentCourses(where: {status: {_eq: ENROLLED}}) {
      ...ActiveStudentTranscriptCourse
    }
  }
}
    ${ActiveStudentTranscriptCourseFragmentDoc}`;

/**
 * __useGetActiveStudentCoursesForTranscriptQuery__
 *
 * To run a query within a React component, call `useGetActiveStudentCoursesForTranscriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveStudentCoursesForTranscriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveStudentCoursesForTranscriptQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetActiveStudentCoursesForTranscriptQuery(baseOptions: Apollo.QueryHookOptions<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables> & ({ variables: GetActiveStudentCoursesForTranscriptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables>(GetActiveStudentCoursesForTranscriptDocument, options);
      }
export function useGetActiveStudentCoursesForTranscriptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables>(GetActiveStudentCoursesForTranscriptDocument, options);
        }
export function useGetActiveStudentCoursesForTranscriptSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables>(GetActiveStudentCoursesForTranscriptDocument, options);
        }
export type GetActiveStudentCoursesForTranscriptQueryHookResult = ReturnType<typeof useGetActiveStudentCoursesForTranscriptQuery>;
export type GetActiveStudentCoursesForTranscriptLazyQueryHookResult = ReturnType<typeof useGetActiveStudentCoursesForTranscriptLazyQuery>;
export type GetActiveStudentCoursesForTranscriptSuspenseQueryHookResult = ReturnType<typeof useGetActiveStudentCoursesForTranscriptSuspenseQuery>;
export type GetActiveStudentCoursesForTranscriptQueryResult = Apollo.QueryResult<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables>;
export const GetAllActiveStudentCoursesDocument = gql`
    query GetAllActiveStudentCourses {
  studentCourses: student_courses(where: {status: {_eq: ENROLLED}}) {
    id
    start
    daysOfTheWeek
    courseDayOffsets
    course {
      id
      numberOfWeeks
      numberOfDaysPerWeek
    }
    student {
      id
      ...StudentsEvents
    }
  }
}
    ${StudentsEventsFragmentDoc}`;

/**
 * __useGetAllActiveStudentCoursesQuery__
 *
 * To run a query within a React component, call `useGetAllActiveStudentCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllActiveStudentCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllActiveStudentCoursesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllActiveStudentCoursesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>(GetAllActiveStudentCoursesDocument, options);
      }
export function useGetAllActiveStudentCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>(GetAllActiveStudentCoursesDocument, options);
        }
export function useGetAllActiveStudentCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>(GetAllActiveStudentCoursesDocument, options);
        }
export type GetAllActiveStudentCoursesQueryHookResult = ReturnType<typeof useGetAllActiveStudentCoursesQuery>;
export type GetAllActiveStudentCoursesLazyQueryHookResult = ReturnType<typeof useGetAllActiveStudentCoursesLazyQuery>;
export type GetAllActiveStudentCoursesSuspenseQueryHookResult = ReturnType<typeof useGetAllActiveStudentCoursesSuspenseQuery>;
export type GetAllActiveStudentCoursesQueryResult = Apollo.QueryResult<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>;
export const GetAllEventsInfoDocument = gql`
    query GetAllEventsInfo {
  events(order_by: {start: desc}) {
    ...EventInfo
  }
}
    ${EventInfoFragmentDoc}`;

/**
 * __useGetAllEventsInfoQuery__
 *
 * To run a query within a React component, call `useGetAllEventsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEventsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEventsInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEventsInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>(GetAllEventsInfoDocument, options);
      }
export function useGetAllEventsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>(GetAllEventsInfoDocument, options);
        }
export function useGetAllEventsInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>(GetAllEventsInfoDocument, options);
        }
export type GetAllEventsInfoQueryHookResult = ReturnType<typeof useGetAllEventsInfoQuery>;
export type GetAllEventsInfoLazyQueryHookResult = ReturnType<typeof useGetAllEventsInfoLazyQuery>;
export type GetAllEventsInfoSuspenseQueryHookResult = ReturnType<typeof useGetAllEventsInfoSuspenseQuery>;
export type GetAllEventsInfoQueryResult = Apollo.QueryResult<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>;
export const GetAllParrotRequestsInfoDocument = gql`
    query GetAllParrotRequestsInfo {
  parrotRequests: parrot_requests(order_by: {updated: desc}) {
    ...ParrotRequestInfo
  }
}
    ${ParrotRequestInfoFragmentDoc}`;

/**
 * __useGetAllParrotRequestsInfoQuery__
 *
 * To run a query within a React component, call `useGetAllParrotRequestsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllParrotRequestsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllParrotRequestsInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllParrotRequestsInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>(GetAllParrotRequestsInfoDocument, options);
      }
export function useGetAllParrotRequestsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>(GetAllParrotRequestsInfoDocument, options);
        }
export function useGetAllParrotRequestsInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>(GetAllParrotRequestsInfoDocument, options);
        }
export type GetAllParrotRequestsInfoQueryHookResult = ReturnType<typeof useGetAllParrotRequestsInfoQuery>;
export type GetAllParrotRequestsInfoLazyQueryHookResult = ReturnType<typeof useGetAllParrotRequestsInfoLazyQuery>;
export type GetAllParrotRequestsInfoSuspenseQueryHookResult = ReturnType<typeof useGetAllParrotRequestsInfoSuspenseQuery>;
export type GetAllParrotRequestsInfoQueryResult = Apollo.QueryResult<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>;
export const GetAllParrotRequestsByClaimerIdDocument = gql`
    query GetAllParrotRequestsByClaimerId($claimerId: String!) {
  parrotRequests: parrot_requests(
    order_by: {updated: desc}
    where: {claimerId: {_eq: $claimerId}}
  ) {
    ...ParrotRequestInfo
    course {
      ...ClaimedParrotRequestCourseInfo
    }
  }
}
    ${ParrotRequestInfoFragmentDoc}
${ClaimedParrotRequestCourseInfoFragmentDoc}`;

/**
 * __useGetAllParrotRequestsByClaimerIdQuery__
 *
 * To run a query within a React component, call `useGetAllParrotRequestsByClaimerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllParrotRequestsByClaimerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllParrotRequestsByClaimerIdQuery({
 *   variables: {
 *      claimerId: // value for 'claimerId'
 *   },
 * });
 */
export function useGetAllParrotRequestsByClaimerIdQuery(baseOptions: Apollo.QueryHookOptions<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables> & ({ variables: GetAllParrotRequestsByClaimerIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables>(GetAllParrotRequestsByClaimerIdDocument, options);
      }
export function useGetAllParrotRequestsByClaimerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables>(GetAllParrotRequestsByClaimerIdDocument, options);
        }
export function useGetAllParrotRequestsByClaimerIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables>(GetAllParrotRequestsByClaimerIdDocument, options);
        }
export type GetAllParrotRequestsByClaimerIdQueryHookResult = ReturnType<typeof useGetAllParrotRequestsByClaimerIdQuery>;
export type GetAllParrotRequestsByClaimerIdLazyQueryHookResult = ReturnType<typeof useGetAllParrotRequestsByClaimerIdLazyQuery>;
export type GetAllParrotRequestsByClaimerIdSuspenseQueryHookResult = ReturnType<typeof useGetAllParrotRequestsByClaimerIdSuspenseQuery>;
export type GetAllParrotRequestsByClaimerIdQueryResult = Apollo.QueryResult<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables>;
export const GetAllStudentsInfoDocument = gql`
    query GetAllStudentsInfo {
  students(order_by: {name: asc}) {
    ...StudentInfo
    studentCourses {
      id
      status
    }
  }
}
    ${StudentInfoFragmentDoc}`;

/**
 * __useGetAllStudentsInfoQuery__
 *
 * To run a query within a React component, call `useGetAllStudentsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStudentsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStudentsInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStudentsInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>(GetAllStudentsInfoDocument, options);
      }
export function useGetAllStudentsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>(GetAllStudentsInfoDocument, options);
        }
export function useGetAllStudentsInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>(GetAllStudentsInfoDocument, options);
        }
export type GetAllStudentsInfoQueryHookResult = ReturnType<typeof useGetAllStudentsInfoQuery>;
export type GetAllStudentsInfoLazyQueryHookResult = ReturnType<typeof useGetAllStudentsInfoLazyQuery>;
export type GetAllStudentsInfoSuspenseQueryHookResult = ReturnType<typeof useGetAllStudentsInfoSuspenseQuery>;
export type GetAllStudentsInfoQueryResult = Apollo.QueryResult<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>;
export const GetAssignmentTypesDocument = gql`
    query GetAssignmentTypes {
  assignmentTypes: assignment_type {
    value
  }
}
    `;

/**
 * __useGetAssignmentTypesQuery__
 *
 * To run a query within a React component, call `useGetAssignmentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssignmentTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>(GetAssignmentTypesDocument, options);
      }
export function useGetAssignmentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>(GetAssignmentTypesDocument, options);
        }
export function useGetAssignmentTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>(GetAssignmentTypesDocument, options);
        }
export type GetAssignmentTypesQueryHookResult = ReturnType<typeof useGetAssignmentTypesQuery>;
export type GetAssignmentTypesLazyQueryHookResult = ReturnType<typeof useGetAssignmentTypesLazyQuery>;
export type GetAssignmentTypesSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentTypesSuspenseQuery>;
export type GetAssignmentTypesQueryResult = Apollo.QueryResult<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>;
export const GetAttendanceDayCountDocument = gql`
    query GetAttendanceDayCount($studentId: String!) {
  student_assignments_aggregate(
    where: {_and: [{completed: {_is_null: false}}, {studentId: {_eq: $studentId}}, {studentCourse: {status: {_eq: ENROLLED}}}]}
    distinct_on: end
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetAttendanceDayCountQuery__
 *
 * To run a query within a React component, call `useGetAttendanceDayCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendanceDayCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendanceDayCountQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetAttendanceDayCountQuery(baseOptions: Apollo.QueryHookOptions<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables> & ({ variables: GetAttendanceDayCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables>(GetAttendanceDayCountDocument, options);
      }
export function useGetAttendanceDayCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables>(GetAttendanceDayCountDocument, options);
        }
export function useGetAttendanceDayCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables>(GetAttendanceDayCountDocument, options);
        }
export type GetAttendanceDayCountQueryHookResult = ReturnType<typeof useGetAttendanceDayCountQuery>;
export type GetAttendanceDayCountLazyQueryHookResult = ReturnType<typeof useGetAttendanceDayCountLazyQuery>;
export type GetAttendanceDayCountSuspenseQueryHookResult = ReturnType<typeof useGetAttendanceDayCountSuspenseQuery>;
export type GetAttendanceDayCountQueryResult = Apollo.QueryResult<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables>;
export const GetCalendarStudentAssignmentsDocument = gql`
    query GetCalendarStudentAssignments($day: date!) {
  courses(where: {studentCourses: {status: {_eq: ENROLLED}}}) {
    ...CalendarCourse
  }
}
    ${CalendarCourseFragmentDoc}`;

/**
 * __useGetCalendarStudentAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetCalendarStudentAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarStudentAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarStudentAssignmentsQuery({
 *   variables: {
 *      day: // value for 'day'
 *   },
 * });
 */
export function useGetCalendarStudentAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables> & ({ variables: GetCalendarStudentAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables>(GetCalendarStudentAssignmentsDocument, options);
      }
export function useGetCalendarStudentAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables>(GetCalendarStudentAssignmentsDocument, options);
        }
export function useGetCalendarStudentAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables>(GetCalendarStudentAssignmentsDocument, options);
        }
export type GetCalendarStudentAssignmentsQueryHookResult = ReturnType<typeof useGetCalendarStudentAssignmentsQuery>;
export type GetCalendarStudentAssignmentsLazyQueryHookResult = ReturnType<typeof useGetCalendarStudentAssignmentsLazyQuery>;
export type GetCalendarStudentAssignmentsSuspenseQueryHookResult = ReturnType<typeof useGetCalendarStudentAssignmentsSuspenseQuery>;
export type GetCalendarStudentAssignmentsQueryResult = Apollo.QueryResult<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables>;
export const GetStudentOptionsDocument = gql`
    query GetStudentOptions {
  students(order_by: {name: asc}) {
    ...StudentOption
  }
}
    ${StudentOptionFragmentDoc}`;

/**
 * __useGetStudentOptionsQuery__
 *
 * To run a query within a React component, call `useGetStudentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStudentOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>(GetStudentOptionsDocument, options);
      }
export function useGetStudentOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>(GetStudentOptionsDocument, options);
        }
export function useGetStudentOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>(GetStudentOptionsDocument, options);
        }
export type GetStudentOptionsQueryHookResult = ReturnType<typeof useGetStudentOptionsQuery>;
export type GetStudentOptionsLazyQueryHookResult = ReturnType<typeof useGetStudentOptionsLazyQuery>;
export type GetStudentOptionsSuspenseQueryHookResult = ReturnType<typeof useGetStudentOptionsSuspenseQuery>;
export type GetStudentOptionsQueryResult = Apollo.QueryResult<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>;
export const GetCalendarVacationsDocument = gql`
    query GetCalendarVacations($day: date!) {
  events(
    where: {_and: [{eventType: {_eq: VACATION}}, {_and: [{start: {_lte: $day}}, {end: {_gte: $day}}]}]}
  ) {
    ...CalendarVacation
  }
}
    ${CalendarVacationFragmentDoc}`;

/**
 * __useGetCalendarVacationsQuery__
 *
 * To run a query within a React component, call `useGetCalendarVacationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarVacationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarVacationsQuery({
 *   variables: {
 *      day: // value for 'day'
 *   },
 * });
 */
export function useGetCalendarVacationsQuery(baseOptions: Apollo.QueryHookOptions<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables> & ({ variables: GetCalendarVacationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables>(GetCalendarVacationsDocument, options);
      }
export function useGetCalendarVacationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables>(GetCalendarVacationsDocument, options);
        }
export function useGetCalendarVacationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables>(GetCalendarVacationsDocument, options);
        }
export type GetCalendarVacationsQueryHookResult = ReturnType<typeof useGetCalendarVacationsQuery>;
export type GetCalendarVacationsLazyQueryHookResult = ReturnType<typeof useGetCalendarVacationsLazyQuery>;
export type GetCalendarVacationsSuspenseQueryHookResult = ReturnType<typeof useGetCalendarVacationsSuspenseQuery>;
export type GetCalendarVacationsQueryResult = Apollo.QueryResult<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables>;
export const GetCompletedCourseStudentsDocument = gql`
    query GetCompletedCourseStudents($courseId: uuid!) {
  studentCourses: student_courses(
    where: {_and: [{status: {_eq: COMPLETED}}, {courseSnapshot: {_contains: {course: {id: $courseId}}}}]}
  ) {
    id
    student {
      id
      name
      picture
    }
    ...CompletedStudentCourseCardInfo
  }
}
    ${CompletedStudentCourseCardInfoFragmentDoc}`;

/**
 * __useGetCompletedCourseStudentsQuery__
 *
 * To run a query within a React component, call `useGetCompletedCourseStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedCourseStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedCourseStudentsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCompletedCourseStudentsQuery(baseOptions: Apollo.QueryHookOptions<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables> & ({ variables: GetCompletedCourseStudentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables>(GetCompletedCourseStudentsDocument, options);
      }
export function useGetCompletedCourseStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables>(GetCompletedCourseStudentsDocument, options);
        }
export function useGetCompletedCourseStudentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables>(GetCompletedCourseStudentsDocument, options);
        }
export type GetCompletedCourseStudentsQueryHookResult = ReturnType<typeof useGetCompletedCourseStudentsQuery>;
export type GetCompletedCourseStudentsLazyQueryHookResult = ReturnType<typeof useGetCompletedCourseStudentsLazyQuery>;
export type GetCompletedCourseStudentsSuspenseQueryHookResult = ReturnType<typeof useGetCompletedCourseStudentsSuspenseQuery>;
export type GetCompletedCourseStudentsQueryResult = Apollo.QueryResult<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables>;
export const GetCompletedStudentCourseInfoDocument = gql`
    query GetCompletedStudentCourseInfo($studentCourseId: uuid!) {
  studentCourse: student_course(id: $studentCourseId) {
    id
    ...CourseSnapshot
  }
}
    ${CourseSnapshotFragmentDoc}`;

/**
 * __useGetCompletedStudentCourseInfoQuery__
 *
 * To run a query within a React component, call `useGetCompletedStudentCourseInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedStudentCourseInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedStudentCourseInfoQuery({
 *   variables: {
 *      studentCourseId: // value for 'studentCourseId'
 *   },
 * });
 */
export function useGetCompletedStudentCourseInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables> & ({ variables: GetCompletedStudentCourseInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables>(GetCompletedStudentCourseInfoDocument, options);
      }
export function useGetCompletedStudentCourseInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables>(GetCompletedStudentCourseInfoDocument, options);
        }
export function useGetCompletedStudentCourseInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables>(GetCompletedStudentCourseInfoDocument, options);
        }
export type GetCompletedStudentCourseInfoQueryHookResult = ReturnType<typeof useGetCompletedStudentCourseInfoQuery>;
export type GetCompletedStudentCourseInfoLazyQueryHookResult = ReturnType<typeof useGetCompletedStudentCourseInfoLazyQuery>;
export type GetCompletedStudentCourseInfoSuspenseQueryHookResult = ReturnType<typeof useGetCompletedStudentCourseInfoSuspenseQuery>;
export type GetCompletedStudentCourseInfoQueryResult = Apollo.QueryResult<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables>;
export const GetCompletedStudentCoursesDocument = gql`
    query GetCompletedStudentCourses($studentId: String!) {
  student(id: $studentId) {
    id
    name
    picture
    studentCourses(where: {status: {_eq: COMPLETED}}) {
      ...CompletedStudentCourseCardInfo
    }
  }
}
    ${CompletedStudentCourseCardInfoFragmentDoc}`;

/**
 * __useGetCompletedStudentCoursesQuery__
 *
 * To run a query within a React component, call `useGetCompletedStudentCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedStudentCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedStudentCoursesQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetCompletedStudentCoursesQuery(baseOptions: Apollo.QueryHookOptions<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables> & ({ variables: GetCompletedStudentCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables>(GetCompletedStudentCoursesDocument, options);
      }
export function useGetCompletedStudentCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables>(GetCompletedStudentCoursesDocument, options);
        }
export function useGetCompletedStudentCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables>(GetCompletedStudentCoursesDocument, options);
        }
export type GetCompletedStudentCoursesQueryHookResult = ReturnType<typeof useGetCompletedStudentCoursesQuery>;
export type GetCompletedStudentCoursesLazyQueryHookResult = ReturnType<typeof useGetCompletedStudentCoursesLazyQuery>;
export type GetCompletedStudentCoursesSuspenseQueryHookResult = ReturnType<typeof useGetCompletedStudentCoursesSuspenseQuery>;
export type GetCompletedStudentCoursesQueryResult = Apollo.QueryResult<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables>;
export const GetCompletedStudentCoursesForYearDocument = gql`
    query GetCompletedStudentCoursesForYear($studentId: String!, $calendarYears: [String!]!) {
  student(id: $studentId) {
    id
    studentCourses(
      where: {status: {_eq: COMPLETED}, calendarYear: {_in: $calendarYears}}
    ) {
      ...CompletedStudentTranscriptCourse
    }
  }
}
    ${CompletedStudentTranscriptCourseFragmentDoc}`;

/**
 * __useGetCompletedStudentCoursesForYearQuery__
 *
 * To run a query within a React component, call `useGetCompletedStudentCoursesForYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedStudentCoursesForYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedStudentCoursesForYearQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      calendarYears: // value for 'calendarYears'
 *   },
 * });
 */
export function useGetCompletedStudentCoursesForYearQuery(baseOptions: Apollo.QueryHookOptions<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables> & ({ variables: GetCompletedStudentCoursesForYearQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables>(GetCompletedStudentCoursesForYearDocument, options);
      }
export function useGetCompletedStudentCoursesForYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables>(GetCompletedStudentCoursesForYearDocument, options);
        }
export function useGetCompletedStudentCoursesForYearSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables>(GetCompletedStudentCoursesForYearDocument, options);
        }
export type GetCompletedStudentCoursesForYearQueryHookResult = ReturnType<typeof useGetCompletedStudentCoursesForYearQuery>;
export type GetCompletedStudentCoursesForYearLazyQueryHookResult = ReturnType<typeof useGetCompletedStudentCoursesForYearLazyQuery>;
export type GetCompletedStudentCoursesForYearSuspenseQueryHookResult = ReturnType<typeof useGetCompletedStudentCoursesForYearSuspenseQuery>;
export type GetCompletedStudentCoursesForYearQueryResult = Apollo.QueryResult<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables>;
export const GetCourseAssignmentsScheduleDocument = gql`
    query GetCourseAssignmentsSchedule($courseId: uuid!) {
  course(id: $courseId) {
    id
    assignments {
      ...CourseAssignmentSchedule
    }
  }
}
    ${CourseAssignmentScheduleFragmentDoc}`;

/**
 * __useGetCourseAssignmentsScheduleQuery__
 *
 * To run a query within a React component, call `useGetCourseAssignmentsScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseAssignmentsScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseAssignmentsScheduleQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseAssignmentsScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables> & ({ variables: GetCourseAssignmentsScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables>(GetCourseAssignmentsScheduleDocument, options);
      }
export function useGetCourseAssignmentsScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables>(GetCourseAssignmentsScheduleDocument, options);
        }
export function useGetCourseAssignmentsScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables>(GetCourseAssignmentsScheduleDocument, options);
        }
export type GetCourseAssignmentsScheduleQueryHookResult = ReturnType<typeof useGetCourseAssignmentsScheduleQuery>;
export type GetCourseAssignmentsScheduleLazyQueryHookResult = ReturnType<typeof useGetCourseAssignmentsScheduleLazyQuery>;
export type GetCourseAssignmentsScheduleSuspenseQueryHookResult = ReturnType<typeof useGetCourseAssignmentsScheduleSuspenseQuery>;
export type GetCourseAssignmentsScheduleQueryResult = Apollo.QueryResult<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables>;
export const GetCoursesAssignmentsScheduleDocument = gql`
    query GetCoursesAssignmentsSchedule($courseIds: [uuid!]!) {
  courses(where: {id: {_in: $courseIds}}) {
    id
    numberOfDaysPerWeek
    numberOfWeeks
    assignments {
      ...CourseAssignmentSchedule
    }
  }
}
    ${CourseAssignmentScheduleFragmentDoc}`;

/**
 * __useGetCoursesAssignmentsScheduleQuery__
 *
 * To run a query within a React component, call `useGetCoursesAssignmentsScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesAssignmentsScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesAssignmentsScheduleQuery({
 *   variables: {
 *      courseIds: // value for 'courseIds'
 *   },
 * });
 */
export function useGetCoursesAssignmentsScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables> & ({ variables: GetCoursesAssignmentsScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables>(GetCoursesAssignmentsScheduleDocument, options);
      }
export function useGetCoursesAssignmentsScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables>(GetCoursesAssignmentsScheduleDocument, options);
        }
export function useGetCoursesAssignmentsScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables>(GetCoursesAssignmentsScheduleDocument, options);
        }
export type GetCoursesAssignmentsScheduleQueryHookResult = ReturnType<typeof useGetCoursesAssignmentsScheduleQuery>;
export type GetCoursesAssignmentsScheduleLazyQueryHookResult = ReturnType<typeof useGetCoursesAssignmentsScheduleLazyQuery>;
export type GetCoursesAssignmentsScheduleSuspenseQueryHookResult = ReturnType<typeof useGetCoursesAssignmentsScheduleSuspenseQuery>;
export type GetCoursesAssignmentsScheduleQueryResult = Apollo.QueryResult<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables>;
export const GetCourseCardsDocument = gql`
    query GetCourseCards($includeStudentCourses: Boolean = true) {
  courses(order_by: {name: asc}) {
    ...CourseCardInfo
  }
}
    ${CourseCardInfoFragmentDoc}`;

/**
 * __useGetCourseCardsQuery__
 *
 * To run a query within a React component, call `useGetCourseCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseCardsQuery({
 *   variables: {
 *      includeStudentCourses: // value for 'includeStudentCourses'
 *   },
 * });
 */
export function useGetCourseCardsQuery(baseOptions?: Apollo.QueryHookOptions<GetCourseCardsQuery, GetCourseCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseCardsQuery, GetCourseCardsQueryVariables>(GetCourseCardsDocument, options);
      }
export function useGetCourseCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseCardsQuery, GetCourseCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseCardsQuery, GetCourseCardsQueryVariables>(GetCourseCardsDocument, options);
        }
export function useGetCourseCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseCardsQuery, GetCourseCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseCardsQuery, GetCourseCardsQueryVariables>(GetCourseCardsDocument, options);
        }
export type GetCourseCardsQueryHookResult = ReturnType<typeof useGetCourseCardsQuery>;
export type GetCourseCardsLazyQueryHookResult = ReturnType<typeof useGetCourseCardsLazyQuery>;
export type GetCourseCardsSuspenseQueryHookResult = ReturnType<typeof useGetCourseCardsSuspenseQuery>;
export type GetCourseCardsQueryResult = Apollo.QueryResult<GetCourseCardsQuery, GetCourseCardsQueryVariables>;
export const GetCourseInfoDocument = gql`
    query GetCourseInfo($courseId: uuid!, $includeStudentCourses: Boolean = true) {
  course(id: $courseId) {
    ...CourseInfo
  }
}
    ${CourseInfoFragmentDoc}`;

/**
 * __useGetCourseInfoQuery__
 *
 * To run a query within a React component, call `useGetCourseInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseInfoQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      includeStudentCourses: // value for 'includeStudentCourses'
 *   },
 * });
 */
export function useGetCourseInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCourseInfoQuery, GetCourseInfoQueryVariables> & ({ variables: GetCourseInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseInfoQuery, GetCourseInfoQueryVariables>(GetCourseInfoDocument, options);
      }
export function useGetCourseInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseInfoQuery, GetCourseInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseInfoQuery, GetCourseInfoQueryVariables>(GetCourseInfoDocument, options);
        }
export function useGetCourseInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseInfoQuery, GetCourseInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseInfoQuery, GetCourseInfoQueryVariables>(GetCourseInfoDocument, options);
        }
export type GetCourseInfoQueryHookResult = ReturnType<typeof useGetCourseInfoQuery>;
export type GetCourseInfoLazyQueryHookResult = ReturnType<typeof useGetCourseInfoLazyQuery>;
export type GetCourseInfoSuspenseQueryHookResult = ReturnType<typeof useGetCourseInfoSuspenseQuery>;
export type GetCourseInfoQueryResult = Apollo.QueryResult<GetCourseInfoQuery, GetCourseInfoQueryVariables>;
export const GetCoursePlanCardDocument = gql`
    query GetCoursePlanCard($courseId: uuid!) {
  course(id: $courseId) {
    id
    name
    color
    numberOfWeeks
    numberOfDaysPerWeek
    assignments {
      ...CoursePlanCardAssignment
    }
  }
}
    ${CoursePlanCardAssignmentFragmentDoc}`;

/**
 * __useGetCoursePlanCardQuery__
 *
 * To run a query within a React component, call `useGetCoursePlanCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursePlanCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursePlanCardQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCoursePlanCardQuery(baseOptions: Apollo.QueryHookOptions<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables> & ({ variables: GetCoursePlanCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables>(GetCoursePlanCardDocument, options);
      }
export function useGetCoursePlanCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables>(GetCoursePlanCardDocument, options);
        }
export function useGetCoursePlanCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables>(GetCoursePlanCardDocument, options);
        }
export type GetCoursePlanCardQueryHookResult = ReturnType<typeof useGetCoursePlanCardQuery>;
export type GetCoursePlanCardLazyQueryHookResult = ReturnType<typeof useGetCoursePlanCardLazyQuery>;
export type GetCoursePlanCardSuspenseQueryHookResult = ReturnType<typeof useGetCoursePlanCardSuspenseQuery>;
export type GetCoursePlanCardQueryResult = Apollo.QueryResult<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables>;
export const GetCoursePlanCardsDocument = gql`
    query GetCoursePlanCards {
  courses(where: {archived: {_eq: false}}, order_by: {name: asc}) {
    ...CoursePlanCardInfo
  }
}
    ${CoursePlanCardInfoFragmentDoc}`;

/**
 * __useGetCoursePlanCardsQuery__
 *
 * To run a query within a React component, call `useGetCoursePlanCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursePlanCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursePlanCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCoursePlanCardsQuery(baseOptions?: Apollo.QueryHookOptions<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>(GetCoursePlanCardsDocument, options);
      }
export function useGetCoursePlanCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>(GetCoursePlanCardsDocument, options);
        }
export function useGetCoursePlanCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>(GetCoursePlanCardsDocument, options);
        }
export type GetCoursePlanCardsQueryHookResult = ReturnType<typeof useGetCoursePlanCardsQuery>;
export type GetCoursePlanCardsLazyQueryHookResult = ReturnType<typeof useGetCoursePlanCardsLazyQuery>;
export type GetCoursePlanCardsSuspenseQueryHookResult = ReturnType<typeof useGetCoursePlanCardsSuspenseQuery>;
export type GetCoursePlanCardsQueryResult = Apollo.QueryResult<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>;
export const GetCoursePlanCardsFromParrotRequestsDocument = gql`
    query GetCoursePlanCardsFromParrotRequests($userId: String!) {
  parrotRequests: parrot_requests(
    order_by: {created: asc}
    where: {_and: [{claimerId: {_eq: $userId}}, {status: {_neq: COMPLETE}}, {status: {_neq: BLOCKED}}]}
  ) {
    id
    status
    course {
      id
      name
      color
      numberOfWeeks
      numberOfDaysPerWeek
      assignments {
        ...CoursePlanCardAssignment
      }
    }
  }
}
    ${CoursePlanCardAssignmentFragmentDoc}`;

/**
 * __useGetCoursePlanCardsFromParrotRequestsQuery__
 *
 * To run a query within a React component, call `useGetCoursePlanCardsFromParrotRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursePlanCardsFromParrotRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursePlanCardsFromParrotRequestsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCoursePlanCardsFromParrotRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables> & ({ variables: GetCoursePlanCardsFromParrotRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables>(GetCoursePlanCardsFromParrotRequestsDocument, options);
      }
export function useGetCoursePlanCardsFromParrotRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables>(GetCoursePlanCardsFromParrotRequestsDocument, options);
        }
export function useGetCoursePlanCardsFromParrotRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables>(GetCoursePlanCardsFromParrotRequestsDocument, options);
        }
export type GetCoursePlanCardsFromParrotRequestsQueryHookResult = ReturnType<typeof useGetCoursePlanCardsFromParrotRequestsQuery>;
export type GetCoursePlanCardsFromParrotRequestsLazyQueryHookResult = ReturnType<typeof useGetCoursePlanCardsFromParrotRequestsLazyQuery>;
export type GetCoursePlanCardsFromParrotRequestsSuspenseQueryHookResult = ReturnType<typeof useGetCoursePlanCardsFromParrotRequestsSuspenseQuery>;
export type GetCoursePlanCardsFromParrotRequestsQueryResult = Apollo.QueryResult<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables>;
export const GetCourseRescheduleInfoDocument = gql`
    query GetCourseRescheduleInfo($courseId: uuid!, $studentCourseIds: [uuid!] = []) {
  course(id: $courseId) {
    id
    assignments {
      ...CourseInfoAssignment
    }
    studentCourses(where: {id: {_in: $studentCourseIds}, status: {_eq: ENROLLED}}) {
      id
      ...RequiredStudentCourseInfo
      studentAssignments {
        ...CourseInfoStudentAssignment
      }
      student {
        id
        name
        picture
        studentEvents {
          id
          event {
            id
            start
            end
          }
        }
      }
    }
  }
}
    ${CourseInfoAssignmentFragmentDoc}
${RequiredStudentCourseInfoFragmentDoc}
${CourseInfoStudentAssignmentFragmentDoc}`;

/**
 * __useGetCourseRescheduleInfoQuery__
 *
 * To run a query within a React component, call `useGetCourseRescheduleInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseRescheduleInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseRescheduleInfoQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      studentCourseIds: // value for 'studentCourseIds'
 *   },
 * });
 */
export function useGetCourseRescheduleInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables> & ({ variables: GetCourseRescheduleInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables>(GetCourseRescheduleInfoDocument, options);
      }
export function useGetCourseRescheduleInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables>(GetCourseRescheduleInfoDocument, options);
        }
export function useGetCourseRescheduleInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables>(GetCourseRescheduleInfoDocument, options);
        }
export type GetCourseRescheduleInfoQueryHookResult = ReturnType<typeof useGetCourseRescheduleInfoQuery>;
export type GetCourseRescheduleInfoLazyQueryHookResult = ReturnType<typeof useGetCourseRescheduleInfoLazyQuery>;
export type GetCourseRescheduleInfoSuspenseQueryHookResult = ReturnType<typeof useGetCourseRescheduleInfoSuspenseQuery>;
export type GetCourseRescheduleInfoQueryResult = Apollo.QueryResult<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables>;
export const GetCourseSubjectsDocument = gql`
    query GetCourseSubjects {
  courses {
    id
    subjects
  }
}
    `;

/**
 * __useGetCourseSubjectsQuery__
 *
 * To run a query within a React component, call `useGetCourseSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseSubjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCourseSubjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>(GetCourseSubjectsDocument, options);
      }
export function useGetCourseSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>(GetCourseSubjectsDocument, options);
        }
export function useGetCourseSubjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>(GetCourseSubjectsDocument, options);
        }
export type GetCourseSubjectsQueryHookResult = ReturnType<typeof useGetCourseSubjectsQuery>;
export type GetCourseSubjectsLazyQueryHookResult = ReturnType<typeof useGetCourseSubjectsLazyQuery>;
export type GetCourseSubjectsSuspenseQueryHookResult = ReturnType<typeof useGetCourseSubjectsSuspenseQuery>;
export type GetCourseSubjectsQueryResult = Apollo.QueryResult<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>;
export const GetCoursesByAssignmentTypeDocument = gql`
    query GetCoursesByAssignmentType($customAssignmentTypeId: uuid!) {
  courses(
    where: {assignmentTypeWeights: {customAssignmentTypeId: {_eq: $customAssignmentTypeId}}}
  ) {
    id
    assignmentTypeWeights {
      id
      customAssignmentTypeId
    }
  }
}
    `;

/**
 * __useGetCoursesByAssignmentTypeQuery__
 *
 * To run a query within a React component, call `useGetCoursesByAssignmentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesByAssignmentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesByAssignmentTypeQuery({
 *   variables: {
 *      customAssignmentTypeId: // value for 'customAssignmentTypeId'
 *   },
 * });
 */
export function useGetCoursesByAssignmentTypeQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables> & ({ variables: GetCoursesByAssignmentTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables>(GetCoursesByAssignmentTypeDocument, options);
      }
export function useGetCoursesByAssignmentTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables>(GetCoursesByAssignmentTypeDocument, options);
        }
export function useGetCoursesByAssignmentTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables>(GetCoursesByAssignmentTypeDocument, options);
        }
export type GetCoursesByAssignmentTypeQueryHookResult = ReturnType<typeof useGetCoursesByAssignmentTypeQuery>;
export type GetCoursesByAssignmentTypeLazyQueryHookResult = ReturnType<typeof useGetCoursesByAssignmentTypeLazyQuery>;
export type GetCoursesByAssignmentTypeSuspenseQueryHookResult = ReturnType<typeof useGetCoursesByAssignmentTypeSuspenseQuery>;
export type GetCoursesByAssignmentTypeQueryResult = Apollo.QueryResult<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables>;
export const GetCustomAssignmentTypesDocument = gql`
    query GetCustomAssignmentTypes {
  customAssignmentTypes: custom_assignment_types(order_by: {sortOrder: asc}) {
    ...CustomAssignmentType
  }
}
    ${CustomAssignmentTypeFragmentDoc}`;

/**
 * __useGetCustomAssignmentTypesQuery__
 *
 * To run a query within a React component, call `useGetCustomAssignmentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomAssignmentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomAssignmentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomAssignmentTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>(GetCustomAssignmentTypesDocument, options);
      }
export function useGetCustomAssignmentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>(GetCustomAssignmentTypesDocument, options);
        }
export function useGetCustomAssignmentTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>(GetCustomAssignmentTypesDocument, options);
        }
export type GetCustomAssignmentTypesQueryHookResult = ReturnType<typeof useGetCustomAssignmentTypesQuery>;
export type GetCustomAssignmentTypesLazyQueryHookResult = ReturnType<typeof useGetCustomAssignmentTypesLazyQuery>;
export type GetCustomAssignmentTypesSuspenseQueryHookResult = ReturnType<typeof useGetCustomAssignmentTypesSuspenseQuery>;
export type GetCustomAssignmentTypesQueryResult = Apollo.QueryResult<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>;
export const GetCustomerInfoDocument = gql`
    query GetCustomerInfo($teacherId: String!) {
  teacher(id: $teacherId) {
    id
    needsDemoData
    customer {
      id
      subscriptionStatus
      freeTrialEnd
      planTier
      parrotCredits
      extendedTrial
    }
  }
}
    `;

/**
 * __useGetCustomerInfoQuery__
 *
 * To run a query within a React component, call `useGetCustomerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerInfoQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useGetCustomerInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerInfoQuery, GetCustomerInfoQueryVariables> & ({ variables: GetCustomerInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>(GetCustomerInfoDocument, options);
      }
export function useGetCustomerInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>(GetCustomerInfoDocument, options);
        }
export function useGetCustomerInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>(GetCustomerInfoDocument, options);
        }
export type GetCustomerInfoQueryHookResult = ReturnType<typeof useGetCustomerInfoQuery>;
export type GetCustomerInfoLazyQueryHookResult = ReturnType<typeof useGetCustomerInfoLazyQuery>;
export type GetCustomerInfoSuspenseQueryHookResult = ReturnType<typeof useGetCustomerInfoSuspenseQuery>;
export type GetCustomerInfoQueryResult = Apollo.QueryResult<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>;
export const GetCustomerInfoByStudentDocument = gql`
    query GetCustomerInfoByStudent($studentId: String!) {
  student(id: $studentId) {
    id
    teachers {
      teacher {
        id
        customer {
          id
          subscriptionStatus
          planTier
        }
      }
    }
  }
}
    `;

/**
 * __useGetCustomerInfoByStudentQuery__
 *
 * To run a query within a React component, call `useGetCustomerInfoByStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerInfoByStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerInfoByStudentQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetCustomerInfoByStudentQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables> & ({ variables: GetCustomerInfoByStudentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables>(GetCustomerInfoByStudentDocument, options);
      }
export function useGetCustomerInfoByStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables>(GetCustomerInfoByStudentDocument, options);
        }
export function useGetCustomerInfoByStudentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables>(GetCustomerInfoByStudentDocument, options);
        }
export type GetCustomerInfoByStudentQueryHookResult = ReturnType<typeof useGetCustomerInfoByStudentQuery>;
export type GetCustomerInfoByStudentLazyQueryHookResult = ReturnType<typeof useGetCustomerInfoByStudentLazyQuery>;
export type GetCustomerInfoByStudentSuspenseQueryHookResult = ReturnType<typeof useGetCustomerInfoByStudentSuspenseQuery>;
export type GetCustomerInfoByStudentQueryResult = Apollo.QueryResult<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables>;
export const GetEventsInfoDocument = gql`
    query GetEventsInfo($studentIds: [String!]) {
  events(
    where: {studentEvents: {student: {id: {_in: $studentIds}}}}
    order_by: {start: desc}
  ) {
    ...EventInfo
  }
}
    ${EventInfoFragmentDoc}`;

/**
 * __useGetEventsInfoQuery__
 *
 * To run a query within a React component, call `useGetEventsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsInfoQuery({
 *   variables: {
 *      studentIds: // value for 'studentIds'
 *   },
 * });
 */
export function useGetEventsInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetEventsInfoQuery, GetEventsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsInfoQuery, GetEventsInfoQueryVariables>(GetEventsInfoDocument, options);
      }
export function useGetEventsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsInfoQuery, GetEventsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsInfoQuery, GetEventsInfoQueryVariables>(GetEventsInfoDocument, options);
        }
export function useGetEventsInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventsInfoQuery, GetEventsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventsInfoQuery, GetEventsInfoQueryVariables>(GetEventsInfoDocument, options);
        }
export type GetEventsInfoQueryHookResult = ReturnType<typeof useGetEventsInfoQuery>;
export type GetEventsInfoLazyQueryHookResult = ReturnType<typeof useGetEventsInfoLazyQuery>;
export type GetEventsInfoSuspenseQueryHookResult = ReturnType<typeof useGetEventsInfoSuspenseQuery>;
export type GetEventsInfoQueryResult = Apollo.QueryResult<GetEventsInfoQuery, GetEventsInfoQueryVariables>;
export const GetHomeSidebarDocument = gql`
    query GetHomeSidebar {
  students(order_by: {name: asc}) {
    ...StudentOption
  }
  courses(where: {archived: {_eq: false}}, order_by: {name: asc}) {
    ...CourseOption
  }
  customAssignmentTypes: custom_assignment_types {
    ...CustomAssignmentType
  }
}
    ${StudentOptionFragmentDoc}
${CourseOptionFragmentDoc}
${CustomAssignmentTypeFragmentDoc}`;

/**
 * __useGetHomeSidebarQuery__
 *
 * To run a query within a React component, call `useGetHomeSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeSidebarQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHomeSidebarQuery(baseOptions?: Apollo.QueryHookOptions<GetHomeSidebarQuery, GetHomeSidebarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomeSidebarQuery, GetHomeSidebarQueryVariables>(GetHomeSidebarDocument, options);
      }
export function useGetHomeSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeSidebarQuery, GetHomeSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomeSidebarQuery, GetHomeSidebarQueryVariables>(GetHomeSidebarDocument, options);
        }
export function useGetHomeSidebarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHomeSidebarQuery, GetHomeSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHomeSidebarQuery, GetHomeSidebarQueryVariables>(GetHomeSidebarDocument, options);
        }
export type GetHomeSidebarQueryHookResult = ReturnType<typeof useGetHomeSidebarQuery>;
export type GetHomeSidebarLazyQueryHookResult = ReturnType<typeof useGetHomeSidebarLazyQuery>;
export type GetHomeSidebarSuspenseQueryHookResult = ReturnType<typeof useGetHomeSidebarSuspenseQuery>;
export type GetHomeSidebarQueryResult = Apollo.QueryResult<GetHomeSidebarQuery, GetHomeSidebarQueryVariables>;
export const GetHomeStudentAssignmentsDocument = gql`
    query GetHomeStudentAssignments($day: date!, $isStudent: Boolean!) {
  studentAssignments: student_assignments(
    where: {_or: [{_and: [{end: {_lt: $day}}, {status: {_eq: INCOMPLETE}}]}, {end: {_eq: $day}}, {_and: [{start: {_lte: $day}}, {end: {_gt: $day}}]}]}
  ) {
    ...StudentAssignmentDetails
  }
  studentAssignmentsForGrading: student_assignments(
    where: {_and: [{pointsEarned: {_is_null: true}}, {assignment: {graded: {_eq: true}}}, {status: {_eq: COMPLETE}}]}
  ) {
    ...StudentAssignmentDetails
  }
}
    ${StudentAssignmentDetailsFragmentDoc}`;

/**
 * __useGetHomeStudentAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetHomeStudentAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeStudentAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeStudentAssignmentsQuery({
 *   variables: {
 *      day: // value for 'day'
 *      isStudent: // value for 'isStudent'
 *   },
 * });
 */
export function useGetHomeStudentAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables> & ({ variables: GetHomeStudentAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables>(GetHomeStudentAssignmentsDocument, options);
      }
export function useGetHomeStudentAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables>(GetHomeStudentAssignmentsDocument, options);
        }
export function useGetHomeStudentAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables>(GetHomeStudentAssignmentsDocument, options);
        }
export type GetHomeStudentAssignmentsQueryHookResult = ReturnType<typeof useGetHomeStudentAssignmentsQuery>;
export type GetHomeStudentAssignmentsLazyQueryHookResult = ReturnType<typeof useGetHomeStudentAssignmentsLazyQuery>;
export type GetHomeStudentAssignmentsSuspenseQueryHookResult = ReturnType<typeof useGetHomeStudentAssignmentsSuspenseQuery>;
export type GetHomeStudentAssignmentsQueryResult = Apollo.QueryResult<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables>;
export const GetOrganizationAdminInfoDocument = gql`
    query GetOrganizationAdminInfo($organizationAdminId: String!) {
  organizationAdmin: organization_admin(id: $organizationAdminId) {
    ...OrganizationAdminInfo
  }
}
    ${OrganizationAdminInfoFragmentDoc}`;

/**
 * __useGetOrganizationAdminInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAdminInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAdminInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAdminInfoQuery({
 *   variables: {
 *      organizationAdminId: // value for 'organizationAdminId'
 *   },
 * });
 */
export function useGetOrganizationAdminInfoQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables> & ({ variables: GetOrganizationAdminInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables>(GetOrganizationAdminInfoDocument, options);
      }
export function useGetOrganizationAdminInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables>(GetOrganizationAdminInfoDocument, options);
        }
export function useGetOrganizationAdminInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables>(GetOrganizationAdminInfoDocument, options);
        }
export type GetOrganizationAdminInfoQueryHookResult = ReturnType<typeof useGetOrganizationAdminInfoQuery>;
export type GetOrganizationAdminInfoLazyQueryHookResult = ReturnType<typeof useGetOrganizationAdminInfoLazyQuery>;
export type GetOrganizationAdminInfoSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationAdminInfoSuspenseQuery>;
export type GetOrganizationAdminInfoQueryResult = Apollo.QueryResult<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables>;
export const GetOrganizationCourseCardsDocument = gql`
    query GetOrganizationCourseCards($organizationId: uuid!) {
  organizationCourses(organizationId: $organizationId) {
    ...OrganizationCourseCardInfo
  }
}
    ${OrganizationCourseCardInfoFragmentDoc}`;

/**
 * __useGetOrganizationCourseCardsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationCourseCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationCourseCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationCourseCardsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationCourseCardsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables> & ({ variables: GetOrganizationCourseCardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables>(GetOrganizationCourseCardsDocument, options);
      }
export function useGetOrganizationCourseCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables>(GetOrganizationCourseCardsDocument, options);
        }
export function useGetOrganizationCourseCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables>(GetOrganizationCourseCardsDocument, options);
        }
export type GetOrganizationCourseCardsQueryHookResult = ReturnType<typeof useGetOrganizationCourseCardsQuery>;
export type GetOrganizationCourseCardsLazyQueryHookResult = ReturnType<typeof useGetOrganizationCourseCardsLazyQuery>;
export type GetOrganizationCourseCardsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationCourseCardsSuspenseQuery>;
export type GetOrganizationCourseCardsQueryResult = Apollo.QueryResult<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables>;
export const GetOrganizationCourseInfoDocument = gql`
    query GetOrganizationCourseInfo($organizationId: uuid!, $courseId: uuid!) {
  organizationCourse(courseId: $courseId, organizationId: $organizationId) {
    ...OrganizationCourseInfo
  }
}
    ${OrganizationCourseInfoFragmentDoc}`;

/**
 * __useGetOrganizationCourseInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganizationCourseInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationCourseInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationCourseInfoQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetOrganizationCourseInfoQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables> & ({ variables: GetOrganizationCourseInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables>(GetOrganizationCourseInfoDocument, options);
      }
export function useGetOrganizationCourseInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables>(GetOrganizationCourseInfoDocument, options);
        }
export function useGetOrganizationCourseInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables>(GetOrganizationCourseInfoDocument, options);
        }
export type GetOrganizationCourseInfoQueryHookResult = ReturnType<typeof useGetOrganizationCourseInfoQuery>;
export type GetOrganizationCourseInfoLazyQueryHookResult = ReturnType<typeof useGetOrganizationCourseInfoLazyQuery>;
export type GetOrganizationCourseInfoSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationCourseInfoSuspenseQuery>;
export type GetOrganizationCourseInfoQueryResult = Apollo.QueryResult<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables>;
export const GetOrganizationCourseSubjectsDocument = gql`
    query GetOrganizationCourseSubjects($organizationId: uuid!) {
  organizationCourses(organizationId: $organizationId) {
    id
    subjects
  }
}
    `;

/**
 * __useGetOrganizationCourseSubjectsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationCourseSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationCourseSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationCourseSubjectsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationCourseSubjectsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables> & ({ variables: GetOrganizationCourseSubjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables>(GetOrganizationCourseSubjectsDocument, options);
      }
export function useGetOrganizationCourseSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables>(GetOrganizationCourseSubjectsDocument, options);
        }
export function useGetOrganizationCourseSubjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables>(GetOrganizationCourseSubjectsDocument, options);
        }
export type GetOrganizationCourseSubjectsQueryHookResult = ReturnType<typeof useGetOrganizationCourseSubjectsQuery>;
export type GetOrganizationCourseSubjectsLazyQueryHookResult = ReturnType<typeof useGetOrganizationCourseSubjectsLazyQuery>;
export type GetOrganizationCourseSubjectsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationCourseSubjectsSuspenseQuery>;
export type GetOrganizationCourseSubjectsQueryResult = Apollo.QueryResult<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables>;
export const GetOrganizationInfoDocument = gql`
    query GetOrganizationInfo($organizationId: uuid!) {
  organization(id: $organizationId) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __useGetOrganizationInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganizationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationInfoQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationInfoQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables> & ({ variables: GetOrganizationInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>(GetOrganizationInfoDocument, options);
      }
export function useGetOrganizationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>(GetOrganizationInfoDocument, options);
        }
export function useGetOrganizationInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>(GetOrganizationInfoDocument, options);
        }
export type GetOrganizationInfoQueryHookResult = ReturnType<typeof useGetOrganizationInfoQuery>;
export type GetOrganizationInfoLazyQueryHookResult = ReturnType<typeof useGetOrganizationInfoLazyQuery>;
export type GetOrganizationInfoSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationInfoSuspenseQuery>;
export type GetOrganizationInfoQueryResult = Apollo.QueryResult<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>;
export const GetOrganizationThemeForOrganizationAdminDocument = gql`
    query GetOrganizationThemeForOrganizationAdmin($organizationAdminId: String!) {
  organizationAdmin: organization_admin(id: $organizationAdminId) {
    id
    organization {
      id
      theme {
        ...OrganizationTheme
      }
    }
  }
}
    ${OrganizationThemeFragmentDoc}`;

/**
 * __useGetOrganizationThemeForOrganizationAdminQuery__
 *
 * To run a query within a React component, call `useGetOrganizationThemeForOrganizationAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationThemeForOrganizationAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationThemeForOrganizationAdminQuery({
 *   variables: {
 *      organizationAdminId: // value for 'organizationAdminId'
 *   },
 * });
 */
export function useGetOrganizationThemeForOrganizationAdminQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables> & ({ variables: GetOrganizationThemeForOrganizationAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables>(GetOrganizationThemeForOrganizationAdminDocument, options);
      }
export function useGetOrganizationThemeForOrganizationAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables>(GetOrganizationThemeForOrganizationAdminDocument, options);
        }
export function useGetOrganizationThemeForOrganizationAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables>(GetOrganizationThemeForOrganizationAdminDocument, options);
        }
export type GetOrganizationThemeForOrganizationAdminQueryHookResult = ReturnType<typeof useGetOrganizationThemeForOrganizationAdminQuery>;
export type GetOrganizationThemeForOrganizationAdminLazyQueryHookResult = ReturnType<typeof useGetOrganizationThemeForOrganizationAdminLazyQuery>;
export type GetOrganizationThemeForOrganizationAdminSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationThemeForOrganizationAdminSuspenseQuery>;
export type GetOrganizationThemeForOrganizationAdminQueryResult = Apollo.QueryResult<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables>;
export const GetOrganizationThemeForStudentDocument = gql`
    query GetOrganizationThemeForStudent($studentAccountId: String!) {
  studentAccount: student_account(id: $studentAccountId) {
    id
    student {
      id
      teachers {
        teacher {
          id
          organization {
            id
            theme {
              ...OrganizationTheme
            }
          }
        }
      }
    }
  }
}
    ${OrganizationThemeFragmentDoc}`;

/**
 * __useGetOrganizationThemeForStudentQuery__
 *
 * To run a query within a React component, call `useGetOrganizationThemeForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationThemeForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationThemeForStudentQuery({
 *   variables: {
 *      studentAccountId: // value for 'studentAccountId'
 *   },
 * });
 */
export function useGetOrganizationThemeForStudentQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables> & ({ variables: GetOrganizationThemeForStudentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables>(GetOrganizationThemeForStudentDocument, options);
      }
export function useGetOrganizationThemeForStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables>(GetOrganizationThemeForStudentDocument, options);
        }
export function useGetOrganizationThemeForStudentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables>(GetOrganizationThemeForStudentDocument, options);
        }
export type GetOrganizationThemeForStudentQueryHookResult = ReturnType<typeof useGetOrganizationThemeForStudentQuery>;
export type GetOrganizationThemeForStudentLazyQueryHookResult = ReturnType<typeof useGetOrganizationThemeForStudentLazyQuery>;
export type GetOrganizationThemeForStudentSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationThemeForStudentSuspenseQuery>;
export type GetOrganizationThemeForStudentQueryResult = Apollo.QueryResult<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables>;
export const GetOrganizationThemeForTeacherDocument = gql`
    query GetOrganizationThemeForTeacher($teacherId: String!) {
  teacher(id: $teacherId) {
    id
    organization {
      id
      theme {
        ...OrganizationTheme
      }
    }
  }
}
    ${OrganizationThemeFragmentDoc}`;

/**
 * __useGetOrganizationThemeForTeacherQuery__
 *
 * To run a query within a React component, call `useGetOrganizationThemeForTeacherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationThemeForTeacherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationThemeForTeacherQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useGetOrganizationThemeForTeacherQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables> & ({ variables: GetOrganizationThemeForTeacherQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables>(GetOrganizationThemeForTeacherDocument, options);
      }
export function useGetOrganizationThemeForTeacherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables>(GetOrganizationThemeForTeacherDocument, options);
        }
export function useGetOrganizationThemeForTeacherSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables>(GetOrganizationThemeForTeacherDocument, options);
        }
export type GetOrganizationThemeForTeacherQueryHookResult = ReturnType<typeof useGetOrganizationThemeForTeacherQuery>;
export type GetOrganizationThemeForTeacherLazyQueryHookResult = ReturnType<typeof useGetOrganizationThemeForTeacherLazyQuery>;
export type GetOrganizationThemeForTeacherSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationThemeForTeacherSuspenseQuery>;
export type GetOrganizationThemeForTeacherQueryResult = Apollo.QueryResult<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables>;
export const GetOrganizationWithCodesDocument = gql`
    query GetOrganizationWithCodes($adminId: String!) {
  organization_admins(where: {id: {_eq: $adminId}}) {
    organization {
      id
      ignoredEmails
      freeEmails
      numberOfSeatsAvailable
      organizationCodes {
        id
        code
        originalUserEmail
        subscriptionExpiration
        teacher {
          id
          email
          name
          customer {
            id
            subscriptionStatus
            organizationSubscriptionExpiration
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationWithCodesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationWithCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationWithCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationWithCodesQuery({
 *   variables: {
 *      adminId: // value for 'adminId'
 *   },
 * });
 */
export function useGetOrganizationWithCodesQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationWithCodesQuery, GetOrganizationWithCodesQueryVariables> & ({ variables: GetOrganizationWithCodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationWithCodesQuery, GetOrganizationWithCodesQueryVariables>(GetOrganizationWithCodesDocument, options);
      }
export function useGetOrganizationWithCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationWithCodesQuery, GetOrganizationWithCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationWithCodesQuery, GetOrganizationWithCodesQueryVariables>(GetOrganizationWithCodesDocument, options);
        }
export function useGetOrganizationWithCodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationWithCodesQuery, GetOrganizationWithCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationWithCodesQuery, GetOrganizationWithCodesQueryVariables>(GetOrganizationWithCodesDocument, options);
        }
export type GetOrganizationWithCodesQueryHookResult = ReturnType<typeof useGetOrganizationWithCodesQuery>;
export type GetOrganizationWithCodesLazyQueryHookResult = ReturnType<typeof useGetOrganizationWithCodesLazyQuery>;
export type GetOrganizationWithCodesSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationWithCodesSuspenseQuery>;
export type GetOrganizationWithCodesQueryResult = Apollo.QueryResult<GetOrganizationWithCodesQuery, GetOrganizationWithCodesQueryVariables>;
export const GetParrotRequestQueueDocument = gql`
    query GetParrotRequestQueue {
  parrotRequests: parrot_requests(
    order_by: {queuePosition: asc}
    where: {status: {_eq: PENDING}}
  ) {
    ...ParrotRequestInfo
    teacher {
      id
      email
    }
  }
}
    ${ParrotRequestInfoFragmentDoc}`;

/**
 * __useGetParrotRequestQueueQuery__
 *
 * To run a query within a React component, call `useGetParrotRequestQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParrotRequestQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParrotRequestQueueQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetParrotRequestQueueQuery(baseOptions?: Apollo.QueryHookOptions<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>(GetParrotRequestQueueDocument, options);
      }
export function useGetParrotRequestQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>(GetParrotRequestQueueDocument, options);
        }
export function useGetParrotRequestQueueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>(GetParrotRequestQueueDocument, options);
        }
export type GetParrotRequestQueueQueryHookResult = ReturnType<typeof useGetParrotRequestQueueQuery>;
export type GetParrotRequestQueueLazyQueryHookResult = ReturnType<typeof useGetParrotRequestQueueLazyQuery>;
export type GetParrotRequestQueueSuspenseQueryHookResult = ReturnType<typeof useGetParrotRequestQueueSuspenseQuery>;
export type GetParrotRequestQueueQueryResult = Apollo.QueryResult<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>;
export const GetPlanningAssignmentDocument = gql`
    query GetPlanningAssignment($assignmentId: uuid!) {
  assignment(id: $assignmentId) {
    ...PlanningAssignment
  }
}
    ${PlanningAssignmentFragmentDoc}`;

/**
 * __useGetPlanningAssignmentQuery__
 *
 * To run a query within a React component, call `useGetPlanningAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanningAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanningAssignmentQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useGetPlanningAssignmentQuery(baseOptions: Apollo.QueryHookOptions<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables> & ({ variables: GetPlanningAssignmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables>(GetPlanningAssignmentDocument, options);
      }
export function useGetPlanningAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables>(GetPlanningAssignmentDocument, options);
        }
export function useGetPlanningAssignmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables>(GetPlanningAssignmentDocument, options);
        }
export type GetPlanningAssignmentQueryHookResult = ReturnType<typeof useGetPlanningAssignmentQuery>;
export type GetPlanningAssignmentLazyQueryHookResult = ReturnType<typeof useGetPlanningAssignmentLazyQuery>;
export type GetPlanningAssignmentSuspenseQueryHookResult = ReturnType<typeof useGetPlanningAssignmentSuspenseQuery>;
export type GetPlanningAssignmentQueryResult = Apollo.QueryResult<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables>;
export const GetPlanningCourseDocument = gql`
    query GetPlanningCourse($courseId: uuid!) {
  course(id: $courseId) {
    id
    name
    color
    numberOfWeeks
    numberOfDaysPerWeek
    assignments(order_by: {created: asc}) {
      ...PlanningAssignment
    }
    studentCourses {
      ...PlanningStudentCourse
    }
    ...AssignmentTypeWeightsInfo
  }
}
    ${PlanningAssignmentFragmentDoc}
${PlanningStudentCourseFragmentDoc}
${AssignmentTypeWeightsInfoFragmentDoc}`;

/**
 * __useGetPlanningCourseQuery__
 *
 * To run a query within a React component, call `useGetPlanningCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanningCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanningCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetPlanningCourseQuery(baseOptions: Apollo.QueryHookOptions<GetPlanningCourseQuery, GetPlanningCourseQueryVariables> & ({ variables: GetPlanningCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanningCourseQuery, GetPlanningCourseQueryVariables>(GetPlanningCourseDocument, options);
      }
export function useGetPlanningCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanningCourseQuery, GetPlanningCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanningCourseQuery, GetPlanningCourseQueryVariables>(GetPlanningCourseDocument, options);
        }
export function useGetPlanningCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlanningCourseQuery, GetPlanningCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanningCourseQuery, GetPlanningCourseQueryVariables>(GetPlanningCourseDocument, options);
        }
export type GetPlanningCourseQueryHookResult = ReturnType<typeof useGetPlanningCourseQuery>;
export type GetPlanningCourseLazyQueryHookResult = ReturnType<typeof useGetPlanningCourseLazyQuery>;
export type GetPlanningCourseSuspenseQueryHookResult = ReturnType<typeof useGetPlanningCourseSuspenseQuery>;
export type GetPlanningCourseQueryResult = Apollo.QueryResult<GetPlanningCourseQuery, GetPlanningCourseQueryVariables>;
export const GetPlanningCourseForParrotDocument = gql`
    query GetPlanningCourseForParrot($courseId: uuid!, $parrotRequestId: uuid!) {
  course(id: $courseId) {
    id
    name
    color
    numberOfWeeks
    numberOfDaysPerWeek
    assignments(
      where: {_and: [{parrotRequestId: {_is_null: false}}, {parrotRequestId: {_eq: $parrotRequestId}}]}
    ) {
      ...PlanningAssignment
    }
    studentCourses {
      ...PlanningStudentCourse
    }
    ...AssignmentTypeWeightsInfo
  }
}
    ${PlanningAssignmentFragmentDoc}
${PlanningStudentCourseFragmentDoc}
${AssignmentTypeWeightsInfoFragmentDoc}`;

/**
 * __useGetPlanningCourseForParrotQuery__
 *
 * To run a query within a React component, call `useGetPlanningCourseForParrotQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanningCourseForParrotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanningCourseForParrotQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      parrotRequestId: // value for 'parrotRequestId'
 *   },
 * });
 */
export function useGetPlanningCourseForParrotQuery(baseOptions: Apollo.QueryHookOptions<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables> & ({ variables: GetPlanningCourseForParrotQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables>(GetPlanningCourseForParrotDocument, options);
      }
export function useGetPlanningCourseForParrotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables>(GetPlanningCourseForParrotDocument, options);
        }
export function useGetPlanningCourseForParrotSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables>(GetPlanningCourseForParrotDocument, options);
        }
export type GetPlanningCourseForParrotQueryHookResult = ReturnType<typeof useGetPlanningCourseForParrotQuery>;
export type GetPlanningCourseForParrotLazyQueryHookResult = ReturnType<typeof useGetPlanningCourseForParrotLazyQuery>;
export type GetPlanningCourseForParrotSuspenseQueryHookResult = ReturnType<typeof useGetPlanningCourseForParrotSuspenseQuery>;
export type GetPlanningCourseForParrotQueryResult = Apollo.QueryResult<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables>;
export const GetPreviousPrintingJobsDocument = gql`
    query GetPreviousPrintingJobs($printingJobType: printing_job_type_enum) {
  exports: printing_jobs(
    where: {_and: [{status: {_eq: COMPLETE}}, {type: {_eq: $printingJobType}}]}
    limit: 10
    order_by: {created: desc}
  ) {
    id
    file {
      id
      url
    }
  }
}
    `;

/**
 * __useGetPreviousPrintingJobsQuery__
 *
 * To run a query within a React component, call `useGetPreviousPrintingJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviousPrintingJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviousPrintingJobsQuery({
 *   variables: {
 *      printingJobType: // value for 'printingJobType'
 *   },
 * });
 */
export function useGetPreviousPrintingJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>(GetPreviousPrintingJobsDocument, options);
      }
export function useGetPreviousPrintingJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>(GetPreviousPrintingJobsDocument, options);
        }
export function useGetPreviousPrintingJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>(GetPreviousPrintingJobsDocument, options);
        }
export type GetPreviousPrintingJobsQueryHookResult = ReturnType<typeof useGetPreviousPrintingJobsQuery>;
export type GetPreviousPrintingJobsLazyQueryHookResult = ReturnType<typeof useGetPreviousPrintingJobsLazyQuery>;
export type GetPreviousPrintingJobsSuspenseQueryHookResult = ReturnType<typeof useGetPreviousPrintingJobsSuspenseQuery>;
export type GetPreviousPrintingJobsQueryResult = Apollo.QueryResult<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>;
export const GetQuotasUsageDocument = gql`
    query GetQuotasUsage($teacherId: String!) {
  files: files_aggregate(where: {parrotRequestId: {_is_null: true}}) {
    aggregate {
      sum {
        size
      }
    }
  }
  teacher(id: $teacherId) {
    id
    customer {
      id
      parrotCredits
    }
  }
}
    `;

/**
 * __useGetQuotasUsageQuery__
 *
 * To run a query within a React component, call `useGetQuotasUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotasUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotasUsageQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useGetQuotasUsageQuery(baseOptions: Apollo.QueryHookOptions<GetQuotasUsageQuery, GetQuotasUsageQueryVariables> & ({ variables: GetQuotasUsageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotasUsageQuery, GetQuotasUsageQueryVariables>(GetQuotasUsageDocument, options);
      }
export function useGetQuotasUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotasUsageQuery, GetQuotasUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotasUsageQuery, GetQuotasUsageQueryVariables>(GetQuotasUsageDocument, options);
        }
export function useGetQuotasUsageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuotasUsageQuery, GetQuotasUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuotasUsageQuery, GetQuotasUsageQueryVariables>(GetQuotasUsageDocument, options);
        }
export type GetQuotasUsageQueryHookResult = ReturnType<typeof useGetQuotasUsageQuery>;
export type GetQuotasUsageLazyQueryHookResult = ReturnType<typeof useGetQuotasUsageLazyQuery>;
export type GetQuotasUsageSuspenseQueryHookResult = ReturnType<typeof useGetQuotasUsageSuspenseQuery>;
export type GetQuotasUsageQueryResult = Apollo.QueryResult<GetQuotasUsageQuery, GetQuotasUsageQueryVariables>;
export const GetStorageUsageDocument = gql`
    query GetStorageUsage {
  files: files_aggregate(where: {parrotRequestId: {_is_null: true}}) {
    aggregate {
      sum {
        size
      }
    }
  }
}
    `;

/**
 * __useGetStorageUsageQuery__
 *
 * To run a query within a React component, call `useGetStorageUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStorageUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStorageUsageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStorageUsageQuery(baseOptions?: Apollo.QueryHookOptions<GetStorageUsageQuery, GetStorageUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStorageUsageQuery, GetStorageUsageQueryVariables>(GetStorageUsageDocument, options);
      }
export function useGetStorageUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStorageUsageQuery, GetStorageUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStorageUsageQuery, GetStorageUsageQueryVariables>(GetStorageUsageDocument, options);
        }
export function useGetStorageUsageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStorageUsageQuery, GetStorageUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStorageUsageQuery, GetStorageUsageQueryVariables>(GetStorageUsageDocument, options);
        }
export type GetStorageUsageQueryHookResult = ReturnType<typeof useGetStorageUsageQuery>;
export type GetStorageUsageLazyQueryHookResult = ReturnType<typeof useGetStorageUsageLazyQuery>;
export type GetStorageUsageSuspenseQueryHookResult = ReturnType<typeof useGetStorageUsageSuspenseQuery>;
export type GetStorageUsageQueryResult = Apollo.QueryResult<GetStorageUsageQuery, GetStorageUsageQueryVariables>;
export const GetStudentAccountInfoDocument = gql`
    query GetStudentAccountInfo($studentAccountId: String!) {
  studentAccount: student_account(id: $studentAccountId) {
    id
    email
    name
    picture
    userSettings {
      ...UserSettings
    }
    student {
      teachers {
        teacher {
          id
          organization {
            ...Organization
          }
        }
      }
    }
  }
}
    ${UserSettingsFragmentDoc}
${OrganizationFragmentDoc}`;

/**
 * __useGetStudentAccountInfoQuery__
 *
 * To run a query within a React component, call `useGetStudentAccountInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentAccountInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentAccountInfoQuery({
 *   variables: {
 *      studentAccountId: // value for 'studentAccountId'
 *   },
 * });
 */
export function useGetStudentAccountInfoQuery(baseOptions: Apollo.QueryHookOptions<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables> & ({ variables: GetStudentAccountInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables>(GetStudentAccountInfoDocument, options);
      }
export function useGetStudentAccountInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables>(GetStudentAccountInfoDocument, options);
        }
export function useGetStudentAccountInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables>(GetStudentAccountInfoDocument, options);
        }
export type GetStudentAccountInfoQueryHookResult = ReturnType<typeof useGetStudentAccountInfoQuery>;
export type GetStudentAccountInfoLazyQueryHookResult = ReturnType<typeof useGetStudentAccountInfoLazyQuery>;
export type GetStudentAccountInfoSuspenseQueryHookResult = ReturnType<typeof useGetStudentAccountInfoSuspenseQuery>;
export type GetStudentAccountInfoQueryResult = Apollo.QueryResult<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables>;
export const GetStudentAssignmentDocument = gql`
    query GetStudentAssignment($studentAssignmentId: uuid!, $isStudent: Boolean!) {
  studentAssignment: student_assignment(id: $studentAssignmentId) {
    ...StudentAssignmentDetails
  }
}
    ${StudentAssignmentDetailsFragmentDoc}`;

/**
 * __useGetStudentAssignmentQuery__
 *
 * To run a query within a React component, call `useGetStudentAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentAssignmentQuery({
 *   variables: {
 *      studentAssignmentId: // value for 'studentAssignmentId'
 *      isStudent: // value for 'isStudent'
 *   },
 * });
 */
export function useGetStudentAssignmentQuery(baseOptions: Apollo.QueryHookOptions<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables> & ({ variables: GetStudentAssignmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables>(GetStudentAssignmentDocument, options);
      }
export function useGetStudentAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables>(GetStudentAssignmentDocument, options);
        }
export function useGetStudentAssignmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables>(GetStudentAssignmentDocument, options);
        }
export type GetStudentAssignmentQueryHookResult = ReturnType<typeof useGetStudentAssignmentQuery>;
export type GetStudentAssignmentLazyQueryHookResult = ReturnType<typeof useGetStudentAssignmentLazyQuery>;
export type GetStudentAssignmentSuspenseQueryHookResult = ReturnType<typeof useGetStudentAssignmentSuspenseQuery>;
export type GetStudentAssignmentQueryResult = Apollo.QueryResult<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables>;
export const GetStudentCardsDocument = gql`
    query GetStudentCards {
  students(order_by: {name: asc}) {
    ...StudentInfo
  }
}
    ${StudentInfoFragmentDoc}`;

/**
 * __useGetStudentCardsQuery__
 *
 * To run a query within a React component, call `useGetStudentCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStudentCardsQuery(baseOptions?: Apollo.QueryHookOptions<GetStudentCardsQuery, GetStudentCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentCardsQuery, GetStudentCardsQueryVariables>(GetStudentCardsDocument, options);
      }
export function useGetStudentCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentCardsQuery, GetStudentCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentCardsQuery, GetStudentCardsQueryVariables>(GetStudentCardsDocument, options);
        }
export function useGetStudentCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentCardsQuery, GetStudentCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentCardsQuery, GetStudentCardsQueryVariables>(GetStudentCardsDocument, options);
        }
export type GetStudentCardsQueryHookResult = ReturnType<typeof useGetStudentCardsQuery>;
export type GetStudentCardsLazyQueryHookResult = ReturnType<typeof useGetStudentCardsLazyQuery>;
export type GetStudentCardsSuspenseQueryHookResult = ReturnType<typeof useGetStudentCardsSuspenseQuery>;
export type GetStudentCardsQueryResult = Apollo.QueryResult<GetStudentCardsQuery, GetStudentCardsQueryVariables>;
export const GetStudentCourseDocument = gql`
    query GetStudentCourse($studentCourseId: uuid!) {
  studentCourse: student_course(id: $studentCourseId) {
    student {
      id
      name
      picture
    }
    ...StudentCourseInfo
  }
}
    ${StudentCourseInfoFragmentDoc}`;

/**
 * __useGetStudentCourseQuery__
 *
 * To run a query within a React component, call `useGetStudentCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentCourseQuery({
 *   variables: {
 *      studentCourseId: // value for 'studentCourseId'
 *   },
 * });
 */
export function useGetStudentCourseQuery(baseOptions: Apollo.QueryHookOptions<GetStudentCourseQuery, GetStudentCourseQueryVariables> & ({ variables: GetStudentCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentCourseQuery, GetStudentCourseQueryVariables>(GetStudentCourseDocument, options);
      }
export function useGetStudentCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentCourseQuery, GetStudentCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentCourseQuery, GetStudentCourseQueryVariables>(GetStudentCourseDocument, options);
        }
export function useGetStudentCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentCourseQuery, GetStudentCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentCourseQuery, GetStudentCourseQueryVariables>(GetStudentCourseDocument, options);
        }
export type GetStudentCourseQueryHookResult = ReturnType<typeof useGetStudentCourseQuery>;
export type GetStudentCourseLazyQueryHookResult = ReturnType<typeof useGetStudentCourseLazyQuery>;
export type GetStudentCourseSuspenseQueryHookResult = ReturnType<typeof useGetStudentCourseSuspenseQuery>;
export type GetStudentCourseQueryResult = Apollo.QueryResult<GetStudentCourseQuery, GetStudentCourseQueryVariables>;
export const GetStudentCourseToRescheduleForCourseShiftDocument = gql`
    query GetStudentCourseToRescheduleForCourseShift($date: date!, $week: Int!, $day: Int!, $courseId: uuid!, $studentAssignmentId: uuid!) {
  studentCourseToReschedule: student_course(id: $courseId) {
    ...StudentCourseToReschedule
  }
  studentCourseToReoffset: student_course(id: $courseId) {
    ...StudentCourseToReoffset
  }
}
    ${StudentCourseToRescheduleFragmentDoc}
${StudentCourseToReoffsetFragmentDoc}`;

/**
 * __useGetStudentCourseToRescheduleForCourseShiftQuery__
 *
 * To run a query within a React component, call `useGetStudentCourseToRescheduleForCourseShiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentCourseToRescheduleForCourseShiftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentCourseToRescheduleForCourseShiftQuery({
 *   variables: {
 *      date: // value for 'date'
 *      week: // value for 'week'
 *      day: // value for 'day'
 *      courseId: // value for 'courseId'
 *      studentAssignmentId: // value for 'studentAssignmentId'
 *   },
 * });
 */
export function useGetStudentCourseToRescheduleForCourseShiftQuery(baseOptions: Apollo.QueryHookOptions<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables> & ({ variables: GetStudentCourseToRescheduleForCourseShiftQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables>(GetStudentCourseToRescheduleForCourseShiftDocument, options);
      }
export function useGetStudentCourseToRescheduleForCourseShiftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables>(GetStudentCourseToRescheduleForCourseShiftDocument, options);
        }
export function useGetStudentCourseToRescheduleForCourseShiftSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables>(GetStudentCourseToRescheduleForCourseShiftDocument, options);
        }
export type GetStudentCourseToRescheduleForCourseShiftQueryHookResult = ReturnType<typeof useGetStudentCourseToRescheduleForCourseShiftQuery>;
export type GetStudentCourseToRescheduleForCourseShiftLazyQueryHookResult = ReturnType<typeof useGetStudentCourseToRescheduleForCourseShiftLazyQuery>;
export type GetStudentCourseToRescheduleForCourseShiftSuspenseQueryHookResult = ReturnType<typeof useGetStudentCourseToRescheduleForCourseShiftSuspenseQuery>;
export type GetStudentCourseToRescheduleForCourseShiftQueryResult = Apollo.QueryResult<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables>;
export const GetStudentCoursesToConvertGradingStyleDocument = gql`
    query GetStudentCoursesToConvertGradingStyle($courseId: uuid!) {
  studentCourses: student_courses(where: {courseId: {_eq: $courseId}}) {
    ...StudentCoursesToUpdateGradingStyle
  }
}
    ${StudentCoursesToUpdateGradingStyleFragmentDoc}`;

/**
 * __useGetStudentCoursesToConvertGradingStyleQuery__
 *
 * To run a query within a React component, call `useGetStudentCoursesToConvertGradingStyleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentCoursesToConvertGradingStyleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentCoursesToConvertGradingStyleQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetStudentCoursesToConvertGradingStyleQuery(baseOptions: Apollo.QueryHookOptions<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables> & ({ variables: GetStudentCoursesToConvertGradingStyleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables>(GetStudentCoursesToConvertGradingStyleDocument, options);
      }
export function useGetStudentCoursesToConvertGradingStyleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables>(GetStudentCoursesToConvertGradingStyleDocument, options);
        }
export function useGetStudentCoursesToConvertGradingStyleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables>(GetStudentCoursesToConvertGradingStyleDocument, options);
        }
export type GetStudentCoursesToConvertGradingStyleQueryHookResult = ReturnType<typeof useGetStudentCoursesToConvertGradingStyleQuery>;
export type GetStudentCoursesToConvertGradingStyleLazyQueryHookResult = ReturnType<typeof useGetStudentCoursesToConvertGradingStyleLazyQuery>;
export type GetStudentCoursesToConvertGradingStyleSuspenseQueryHookResult = ReturnType<typeof useGetStudentCoursesToConvertGradingStyleSuspenseQuery>;
export type GetStudentCoursesToConvertGradingStyleQueryResult = Apollo.QueryResult<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables>;
export const GetStudentCoursesToRescheduleDocument = gql`
    query GetStudentCoursesToReschedule($date: date!, $studentIds: [String!]) {
  studentCourses: student_courses(where: {student: {id: {_in: $studentIds}}}) {
    ...StudentCourseToReschedule
  }
}
    ${StudentCourseToRescheduleFragmentDoc}`;

/**
 * __useGetStudentCoursesToRescheduleQuery__
 *
 * To run a query within a React component, call `useGetStudentCoursesToRescheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentCoursesToRescheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentCoursesToRescheduleQuery({
 *   variables: {
 *      date: // value for 'date'
 *      studentIds: // value for 'studentIds'
 *   },
 * });
 */
export function useGetStudentCoursesToRescheduleQuery(baseOptions: Apollo.QueryHookOptions<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables> & ({ variables: GetStudentCoursesToRescheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables>(GetStudentCoursesToRescheduleDocument, options);
      }
export function useGetStudentCoursesToRescheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables>(GetStudentCoursesToRescheduleDocument, options);
        }
export function useGetStudentCoursesToRescheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables>(GetStudentCoursesToRescheduleDocument, options);
        }
export type GetStudentCoursesToRescheduleQueryHookResult = ReturnType<typeof useGetStudentCoursesToRescheduleQuery>;
export type GetStudentCoursesToRescheduleLazyQueryHookResult = ReturnType<typeof useGetStudentCoursesToRescheduleLazyQuery>;
export type GetStudentCoursesToRescheduleSuspenseQueryHookResult = ReturnType<typeof useGetStudentCoursesToRescheduleSuspenseQuery>;
export type GetStudentCoursesToRescheduleQueryResult = Apollo.QueryResult<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables>;
export const GetStudentInfoDocument = gql`
    query GetStudentInfo($studentId: String!) {
  student(id: $studentId) {
    ...StudentInfo
  }
}
    ${StudentInfoFragmentDoc}`;

/**
 * __useGetStudentInfoQuery__
 *
 * To run a query within a React component, call `useGetStudentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentInfoQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetStudentInfoQuery(baseOptions: Apollo.QueryHookOptions<GetStudentInfoQuery, GetStudentInfoQueryVariables> & ({ variables: GetStudentInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentInfoQuery, GetStudentInfoQueryVariables>(GetStudentInfoDocument, options);
      }
export function useGetStudentInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentInfoQuery, GetStudentInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentInfoQuery, GetStudentInfoQueryVariables>(GetStudentInfoDocument, options);
        }
export function useGetStudentInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentInfoQuery, GetStudentInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentInfoQuery, GetStudentInfoQueryVariables>(GetStudentInfoDocument, options);
        }
export type GetStudentInfoQueryHookResult = ReturnType<typeof useGetStudentInfoQuery>;
export type GetStudentInfoLazyQueryHookResult = ReturnType<typeof useGetStudentInfoLazyQuery>;
export type GetStudentInfoSuspenseQueryHookResult = ReturnType<typeof useGetStudentInfoSuspenseQuery>;
export type GetStudentInfoQueryResult = Apollo.QueryResult<GetStudentInfoQuery, GetStudentInfoQueryVariables>;
export const GetStudentInfoForStudentAccountDocument = gql`
    query GetStudentInfoForStudentAccount($studentAccountId: String!) {
  student_account(id: $studentAccountId) {
    student {
      ...StudentInfo
    }
  }
}
    ${StudentInfoFragmentDoc}`;

/**
 * __useGetStudentInfoForStudentAccountQuery__
 *
 * To run a query within a React component, call `useGetStudentInfoForStudentAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentInfoForStudentAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentInfoForStudentAccountQuery({
 *   variables: {
 *      studentAccountId: // value for 'studentAccountId'
 *   },
 * });
 */
export function useGetStudentInfoForStudentAccountQuery(baseOptions: Apollo.QueryHookOptions<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables> & ({ variables: GetStudentInfoForStudentAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables>(GetStudentInfoForStudentAccountDocument, options);
      }
export function useGetStudentInfoForStudentAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables>(GetStudentInfoForStudentAccountDocument, options);
        }
export function useGetStudentInfoForStudentAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables>(GetStudentInfoForStudentAccountDocument, options);
        }
export type GetStudentInfoForStudentAccountQueryHookResult = ReturnType<typeof useGetStudentInfoForStudentAccountQuery>;
export type GetStudentInfoForStudentAccountLazyQueryHookResult = ReturnType<typeof useGetStudentInfoForStudentAccountLazyQuery>;
export type GetStudentInfoForStudentAccountSuspenseQueryHookResult = ReturnType<typeof useGetStudentInfoForStudentAccountSuspenseQuery>;
export type GetStudentInfoForStudentAccountQueryResult = Apollo.QueryResult<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables>;
export const GetTeacherInfoDocument = gql`
    query GetTeacherInfo($teacherId: String!) {
  teacher(id: $teacherId) {
    ...TeacherInfo
    userSettings {
      ...UserSettings
    }
    customer {
      id
      subscriptionStatus
      freeTrialEnd
      planTier
    }
  }
}
    ${TeacherInfoFragmentDoc}
${UserSettingsFragmentDoc}`;

/**
 * __useGetTeacherInfoQuery__
 *
 * To run a query within a React component, call `useGetTeacherInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherInfoQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useGetTeacherInfoQuery(baseOptions: Apollo.QueryHookOptions<GetTeacherInfoQuery, GetTeacherInfoQueryVariables> & ({ variables: GetTeacherInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>(GetTeacherInfoDocument, options);
      }
export function useGetTeacherInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>(GetTeacherInfoDocument, options);
        }
export function useGetTeacherInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>(GetTeacherInfoDocument, options);
        }
export type GetTeacherInfoQueryHookResult = ReturnType<typeof useGetTeacherInfoQuery>;
export type GetTeacherInfoLazyQueryHookResult = ReturnType<typeof useGetTeacherInfoLazyQuery>;
export type GetTeacherInfoSuspenseQueryHookResult = ReturnType<typeof useGetTeacherInfoSuspenseQuery>;
export type GetTeacherInfoQueryResult = Apollo.QueryResult<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>;
export const GetPrintingJobsByIdsDocument = gql`
    subscription GetPrintingJobsByIds($ids: [uuid!]!) {
  printingJobs: printing_jobs(where: {id: {_in: $ids}}) {
    ...PrintingJobInfo
  }
}
    ${PrintingJobInfoFragmentDoc}`;

/**
 * __useGetPrintingJobsByIdsSubscription__
 *
 * To run a query within a React component, call `useGetPrintingJobsByIdsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetPrintingJobsByIdsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrintingJobsByIdsSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetPrintingJobsByIdsSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetPrintingJobsByIdsSubscription, GetPrintingJobsByIdsSubscriptionVariables> & ({ variables: GetPrintingJobsByIdsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetPrintingJobsByIdsSubscription, GetPrintingJobsByIdsSubscriptionVariables>(GetPrintingJobsByIdsDocument, options);
      }
export type GetPrintingJobsByIdsSubscriptionHookResult = ReturnType<typeof useGetPrintingJobsByIdsSubscription>;
export type GetPrintingJobsByIdsSubscriptionResult = Apollo.SubscriptionResult<GetPrintingJobsByIdsSubscription>;